function cc(i, e) {
  return e.forEach(function(t) {
    t && typeof t != "string" && !Array.isArray(t) && Object.keys(t).forEach(function(n) {
      if (n !== "default" && !(n in i)) {
        var r = Object.getOwnPropertyDescriptor(t, n);
        Object.defineProperty(i, n, r.get ? r : {
          enumerable: !0,
          get: function() {
            return t[n];
          }
        });
      }
    });
  }), Object.freeze(i);
}
var dc = Object.defineProperty, uc = (i, e, t) => e in i ? dc(i, e, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: t
}) : i[e] = t, Fr = (i, e, t) => uc(i, typeof e != "symbol" ? e + "" : e, t);
class ge {
  constructor() {
    Fr(this, "_locking"), Fr(this, "_locks"), this._locking = Promise.resolve(), this._locks = 0;
  }
  isLocked() {
    return this._locks > 0;
  }
  lock() {
    this._locks += 1;
    let e;
    const t = new Promise((r) => e = () => {
      this._locks -= 1, r();
    }), n = this._locking.then(() => e);
    return this._locking = this._locking.then(() => t), n;
  }
}
function ie(i, e) {
  if (!i)
    throw new Error(e);
}
const lc = 34028234663852886e22, hc = -34028234663852886e22, fc = 4294967295, pc = 2147483647, mc = -2147483648;
function gi(i) {
  if (typeof i != "number") throw new Error("invalid int 32: " + typeof i);
  if (!Number.isInteger(i) || i > pc || i < mc) throw new Error("invalid int 32: " + i);
}
function kn(i) {
  if (typeof i != "number") throw new Error("invalid uint 32: " + typeof i);
  if (!Number.isInteger(i) || i > fc || i < 0) throw new Error("invalid uint 32: " + i);
}
function Qs(i) {
  if (typeof i != "number") throw new Error("invalid float 32: " + typeof i);
  if (Number.isFinite(i) && (i > lc || i < hc))
    throw new Error("invalid float 32: " + i);
}
const Ys = Symbol("@bufbuild/protobuf/enum-type");
function gc(i) {
  const e = i[Ys];
  return ie(e, "missing enum type on enum object"), e;
}
function Xs(i, e, t, n) {
  i[Ys] = $s(e, t.map((r) => ({
    no: r.no,
    name: r.name,
    localName: i[r.no]
  })));
}
function $s(i, e, t) {
  const n = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null), s = [];
  for (const a of e) {
    const o = Zs(a);
    s.push(o), n[a.name] = o, r[a.no] = o;
  }
  return {
    typeName: i,
    values: s,
    // We do not surface options at this time
    // options: opt?.options ?? Object.create(null),
    findName(a) {
      return n[a];
    },
    findNumber(a) {
      return r[a];
    }
  };
}
function vc(i, e, t) {
  const n = {};
  for (const r of e) {
    const s = Zs(r);
    n[s.localName] = s.no, n[s.no] = s.localName;
  }
  return Xs(n, i, e), n;
}
function Zs(i) {
  return "localName" in i ? i : Object.assign(Object.assign({}, i), {
    localName: i.name
  });
}
class rr {
  /**
   * Compare with a message of the same type.
   * Note that this function disregards extensions and unknown fields.
   */
  equals(e) {
    return this.getType().runtime.util.equals(this.getType(), this, e);
  }
  /**
   * Create a deep copy.
   */
  clone() {
    return this.getType().runtime.util.clone(this);
  }
  /**
   * Parse from binary data, merging fields.
   *
   * Repeated fields are appended. Map entries are added, overwriting
   * existing keys.
   *
   * If a message field is already present, it will be merged with the
   * new data.
   */
  fromBinary(e, t) {
    const n = this.getType(), r = n.runtime.bin, s = r.makeReadOptions(t);
    return r.readMessage(this, s.readerFactory(e), e.byteLength, s), this;
  }
  /**
   * Parse a message from a JSON value.
   */
  fromJson(e, t) {
    const n = this.getType(), r = n.runtime.json, s = r.makeReadOptions(t);
    return r.readMessage(n, e, s, this), this;
  }
  /**
   * Parse a message from a JSON string.
   */
  fromJsonString(e, t) {
    let n;
    try {
      n = JSON.parse(e);
    } catch (r) {
      throw new Error("cannot decode ".concat(this.getType().typeName, " from JSON: ").concat(r instanceof Error ? r.message : String(r)));
    }
    return this.fromJson(n, t);
  }
  /**
   * Serialize the message to binary data.
   */
  toBinary(e) {
    const t = this.getType(), n = t.runtime.bin, r = n.makeWriteOptions(e), s = r.writerFactory();
    return n.writeMessage(this, s, r), s.finish();
  }
  /**
   * Serialize the message to a JSON value, a JavaScript value that can be
   * passed to JSON.stringify().
   */
  toJson(e) {
    const t = this.getType(), n = t.runtime.json, r = n.makeWriteOptions(e);
    return n.writeMessage(this, r);
  }
  /**
   * Serialize the message to a JSON string.
   */
  toJsonString(e) {
    var t;
    const n = this.toJson(e);
    return JSON.stringify(n, null, (t = e == null ? void 0 : e.prettySpaces) !== null && t !== void 0 ? t : 0);
  }
  /**
   * Override for serialization behavior. This will be invoked when calling
   * JSON.stringify on this message (i.e. JSON.stringify(msg)).
   *
   * Note that this will not serialize google.protobuf.Any with a packed
   * message because the protobuf JSON format specifies that it needs to be
   * unpacked, and this is only possible with a type registry to look up the
   * message type.  As a result, attempting to serialize a message with this
   * type will throw an Error.
   *
   * This method is protected because you should not need to invoke it
   * directly -- instead use JSON.stringify or toJsonString for
   * stringified JSON.  Alternatively, if actual JSON is desired, you should
   * use toJson.
   */
  toJSON() {
    return this.toJson({
      emitDefaultValues: !0
    });
  }
  /**
   * Retrieve the MessageType of this message - a singleton that represents
   * the protobuf message declaration and provides metadata for reflection-
   * based operations.
   */
  getType() {
    return Object.getPrototypeOf(this).constructor;
  }
}
function bc(i, e, t, n) {
  var r;
  const s = (r = n == null ? void 0 : n.localName) !== null && r !== void 0 ? r : e.substring(e.lastIndexOf(".") + 1), a = {
    [s]: function(o) {
      i.util.initFields(this), i.util.initPartial(o, this);
    }
  }[s];
  return Object.setPrototypeOf(a.prototype, new rr()), Object.assign(a, {
    runtime: i,
    typeName: e,
    fields: i.util.newFieldList(t),
    fromBinary(o, c) {
      return new a().fromBinary(o, c);
    },
    fromJson(o, c) {
      return new a().fromJson(o, c);
    },
    fromJsonString(o, c) {
      return new a().fromJsonString(o, c);
    },
    equals(o, c) {
      return i.util.equals(a, o, c);
    }
  }), a;
}
function yc() {
  let i = 0, e = 0;
  for (let n = 0; n < 28; n += 7) {
    let r = this.buf[this.pos++];
    if (i |= (r & 127) << n, (r & 128) == 0)
      return this.assertBounds(), [i, e];
  }
  let t = this.buf[this.pos++];
  if (i |= (t & 15) << 28, e = (t & 112) >> 4, (t & 128) == 0)
    return this.assertBounds(), [i, e];
  for (let n = 3; n <= 31; n += 7) {
    let r = this.buf[this.pos++];
    if (e |= (r & 127) << n, (r & 128) == 0)
      return this.assertBounds(), [i, e];
  }
  throw new Error("invalid varint");
}
function en(i, e, t) {
  for (let s = 0; s < 28; s = s + 7) {
    const a = i >>> s, o = !(!(a >>> 7) && e == 0), c = (o ? a | 128 : a) & 255;
    if (t.push(c), !o)
      return;
  }
  const n = i >>> 28 & 15 | (e & 7) << 4, r = e >> 3 != 0;
  if (t.push((r ? n | 128 : n) & 255), !!r) {
    for (let s = 3; s < 31; s = s + 7) {
      const a = e >>> s, o = !!(a >>> 7), c = (o ? a | 128 : a) & 255;
      if (t.push(c), !o)
        return;
    }
    t.push(e >>> 31 & 1);
  }
}
const vi = 4294967296;
function jr(i) {
  const e = i[0] === "-";
  e && (i = i.slice(1));
  const t = 1e6;
  let n = 0, r = 0;
  function s(a, o) {
    const c = Number(i.slice(a, o));
    r *= t, n = n * t + c, n >= vi && (r = r + (n / vi | 0), n = n % vi);
  }
  return s(-24, -18), s(-18, -12), s(-12, -6), s(-6), e ? ta(n, r) : sr(n, r);
}
function kc(i, e) {
  let t = sr(i, e);
  const n = t.hi & 2147483648;
  n && (t = ta(t.lo, t.hi));
  const r = ea(t.lo, t.hi);
  return n ? "-" + r : r;
}
function ea(i, e) {
  if ({
    lo: i,
    hi: e
  } = Tc(i, e), e <= 2097151)
    return String(vi * e + i);
  const t = i & 16777215, n = (i >>> 24 | e << 8) & 16777215, r = e >> 16 & 65535;
  let s = t + n * 6777216 + r * 6710656, a = n + r * 8147497, o = r * 2;
  const c = 1e7;
  return s >= c && (a += Math.floor(s / c), s %= c), a >= c && (o += Math.floor(a / c), a %= c), o.toString() + Br(a) + Br(s);
}
function Tc(i, e) {
  return {
    lo: i >>> 0,
    hi: e >>> 0
  };
}
function sr(i, e) {
  return {
    lo: i | 0,
    hi: e | 0
  };
}
function ta(i, e) {
  return e = ~e, i ? i = ~i + 1 : e += 1, sr(i, e);
}
const Br = (i) => {
  const e = String(i);
  return "0000000".slice(e.length) + e;
};
function Vr(i, e) {
  if (i >= 0) {
    for (; i > 127; )
      e.push(i & 127 | 128), i = i >>> 7;
    e.push(i);
  } else {
    for (let t = 0; t < 9; t++)
      e.push(i & 127 | 128), i = i >> 7;
    e.push(1);
  }
}
function Sc() {
  let i = this.buf[this.pos++], e = i & 127;
  if ((i & 128) == 0)
    return this.assertBounds(), e;
  if (i = this.buf[this.pos++], e |= (i & 127) << 7, (i & 128) == 0)
    return this.assertBounds(), e;
  if (i = this.buf[this.pos++], e |= (i & 127) << 14, (i & 128) == 0)
    return this.assertBounds(), e;
  if (i = this.buf[this.pos++], e |= (i & 127) << 21, (i & 128) == 0)
    return this.assertBounds(), e;
  i = this.buf[this.pos++], e |= (i & 15) << 28;
  for (let t = 5; (i & 128) !== 0 && t < 10; t++) i = this.buf[this.pos++];
  if ((i & 128) != 0) throw new Error("invalid varint");
  return this.assertBounds(), e >>> 0;
}
function Cc() {
  const i = new DataView(new ArrayBuffer(8));
  if (typeof BigInt == "function" && typeof i.getBigInt64 == "function" && typeof i.getBigUint64 == "function" && typeof i.setBigInt64 == "function" && typeof i.setBigUint64 == "function" && (typeof process != "object" || typeof process.env != "object" || process.env.BUF_BIGINT_DISABLE !== "1")) {
    const r = BigInt("-9223372036854775808"), s = BigInt("9223372036854775807"), a = BigInt("0"), o = BigInt("18446744073709551615");
    return {
      zero: BigInt(0),
      supported: !0,
      parse(c) {
        const d = typeof c == "bigint" ? c : BigInt(c);
        if (d > s || d < r)
          throw new Error("int64 invalid: ".concat(c));
        return d;
      },
      uParse(c) {
        const d = typeof c == "bigint" ? c : BigInt(c);
        if (d > o || d < a)
          throw new Error("uint64 invalid: ".concat(c));
        return d;
      },
      enc(c) {
        return i.setBigInt64(0, this.parse(c), !0), {
          lo: i.getInt32(0, !0),
          hi: i.getInt32(4, !0)
        };
      },
      uEnc(c) {
        return i.setBigInt64(0, this.uParse(c), !0), {
          lo: i.getInt32(0, !0),
          hi: i.getInt32(4, !0)
        };
      },
      dec(c, d) {
        return i.setInt32(0, c, !0), i.setInt32(4, d, !0), i.getBigInt64(0, !0);
      },
      uDec(c, d) {
        return i.setInt32(0, c, !0), i.setInt32(4, d, !0), i.getBigUint64(0, !0);
      }
    };
  }
  const t = (r) => ie(/^-?[0-9]+$/.test(r), "int64 invalid: ".concat(r)), n = (r) => ie(/^[0-9]+$/.test(r), "uint64 invalid: ".concat(r));
  return {
    zero: "0",
    supported: !1,
    parse(r) {
      return typeof r != "string" && (r = r.toString()), t(r), r;
    },
    uParse(r) {
      return typeof r != "string" && (r = r.toString()), n(r), r;
    },
    enc(r) {
      return typeof r != "string" && (r = r.toString()), t(r), jr(r);
    },
    uEnc(r) {
      return typeof r != "string" && (r = r.toString()), n(r), jr(r);
    },
    dec(r, s) {
      return kc(r, s);
    },
    uDec(r, s) {
      return ea(r, s);
    }
  };
}
const Z = Cc();
var R;
(function(i) {
  i[i.DOUBLE = 1] = "DOUBLE", i[i.FLOAT = 2] = "FLOAT", i[i.INT64 = 3] = "INT64", i[i.UINT64 = 4] = "UINT64", i[i.INT32 = 5] = "INT32", i[i.FIXED64 = 6] = "FIXED64", i[i.FIXED32 = 7] = "FIXED32", i[i.BOOL = 8] = "BOOL", i[i.STRING = 9] = "STRING", i[i.BYTES = 12] = "BYTES", i[i.UINT32 = 13] = "UINT32", i[i.SFIXED32 = 15] = "SFIXED32", i[i.SFIXED64 = 16] = "SFIXED64", i[i.SINT32 = 17] = "SINT32", i[i.SINT64 = 18] = "SINT64";
})(R || (R = {}));
var ht;
(function(i) {
  i[i.BIGINT = 0] = "BIGINT", i[i.STRING = 1] = "STRING";
})(ht || (ht = {}));
function st(i, e, t) {
  if (e === t)
    return !0;
  if (i == R.BYTES) {
    if (!(e instanceof Uint8Array) || !(t instanceof Uint8Array) || e.length !== t.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (e[n] !== t[n])
        return !1;
    return !0;
  }
  switch (i) {
    case R.UINT64:
    case R.FIXED64:
    case R.INT64:
    case R.SFIXED64:
    case R.SINT64:
      return e == t;
  }
  return !1;
}
function jt(i, e) {
  switch (i) {
    case R.BOOL:
      return !1;
    case R.UINT64:
    case R.FIXED64:
    case R.INT64:
    case R.SFIXED64:
    case R.SINT64:
      return e == 0 ? Z.zero : "0";
    case R.DOUBLE:
    case R.FLOAT:
      return 0;
    case R.BYTES:
      return new Uint8Array(0);
    case R.STRING:
      return "";
    default:
      return 0;
  }
}
function ia(i, e) {
  switch (i) {
    case R.BOOL:
      return e === !1;
    case R.STRING:
      return e === "";
    case R.BYTES:
      return e instanceof Uint8Array && !e.byteLength;
    default:
      return e == 0;
  }
}
var re;
(function(i) {
  i[i.Varint = 0] = "Varint", i[i.Bit64 = 1] = "Bit64", i[i.LengthDelimited = 2] = "LengthDelimited", i[i.StartGroup = 3] = "StartGroup", i[i.EndGroup = 4] = "EndGroup", i[i.Bit32 = 5] = "Bit32";
})(re || (re = {}));
class Pc {
  constructor(e) {
    this.stack = [], this.textEncoder = e != null ? e : new TextEncoder(), this.chunks = [], this.buf = [];
  }
  /**
   * Return all bytes written and reset this writer.
   */
  finish() {
    this.chunks.push(new Uint8Array(this.buf));
    let e = 0;
    for (let r = 0; r < this.chunks.length; r++) e += this.chunks[r].length;
    let t = new Uint8Array(e), n = 0;
    for (let r = 0; r < this.chunks.length; r++)
      t.set(this.chunks[r], n), n += this.chunks[r].length;
    return this.chunks = [], t;
  }
  /**
   * Start a new fork for length-delimited data like a message
   * or a packed repeated field.
   *
   * Must be joined later with `join()`.
   */
  fork() {
    return this.stack.push({
      chunks: this.chunks,
      buf: this.buf
    }), this.chunks = [], this.buf = [], this;
  }
  /**
   * Join the last fork. Write its length and bytes, then
   * return to the previous state.
   */
  join() {
    let e = this.finish(), t = this.stack.pop();
    if (!t) throw new Error("invalid state, fork stack empty");
    return this.chunks = t.chunks, this.buf = t.buf, this.uint32(e.byteLength), this.raw(e);
  }
  /**
   * Writes a tag (field number and wire type).
   *
   * Equivalent to `uint32( (fieldNo << 3 | type) >>> 0 )`.
   *
   * Generated code should compute the tag ahead of time and call `uint32()`.
   */
  tag(e, t) {
    return this.uint32((e << 3 | t) >>> 0);
  }
  /**
   * Write a chunk of raw bytes.
   */
  raw(e) {
    return this.buf.length && (this.chunks.push(new Uint8Array(this.buf)), this.buf = []), this.chunks.push(e), this;
  }
  /**
   * Write a `uint32` value, an unsigned 32 bit varint.
   */
  uint32(e) {
    for (kn(e); e > 127; )
      this.buf.push(e & 127 | 128), e = e >>> 7;
    return this.buf.push(e), this;
  }
  /**
   * Write a `int32` value, a signed 32 bit varint.
   */
  int32(e) {
    return gi(e), Vr(e, this.buf), this;
  }
  /**
   * Write a `bool` value, a variant.
   */
  bool(e) {
    return this.buf.push(e ? 1 : 0), this;
  }
  /**
   * Write a `bytes` value, length-delimited arbitrary data.
   */
  bytes(e) {
    return this.uint32(e.byteLength), this.raw(e);
  }
  /**
   * Write a `string` value, length-delimited data converted to UTF-8 text.
   */
  string(e) {
    let t = this.textEncoder.encode(e);
    return this.uint32(t.byteLength), this.raw(t);
  }
  /**
   * Write a `float` value, 32-bit floating point number.
   */
  float(e) {
    Qs(e);
    let t = new Uint8Array(4);
    return new DataView(t.buffer).setFloat32(0, e, !0), this.raw(t);
  }
  /**
   * Write a `double` value, a 64-bit floating point number.
   */
  double(e) {
    let t = new Uint8Array(8);
    return new DataView(t.buffer).setFloat64(0, e, !0), this.raw(t);
  }
  /**
   * Write a `fixed32` value, an unsigned, fixed-length 32-bit integer.
   */
  fixed32(e) {
    kn(e);
    let t = new Uint8Array(4);
    return new DataView(t.buffer).setUint32(0, e, !0), this.raw(t);
  }
  /**
   * Write a `sfixed32` value, a signed, fixed-length 32-bit integer.
   */
  sfixed32(e) {
    gi(e);
    let t = new Uint8Array(4);
    return new DataView(t.buffer).setInt32(0, e, !0), this.raw(t);
  }
  /**
   * Write a `sint32` value, a signed, zigzag-encoded 32-bit varint.
   */
  sint32(e) {
    return gi(e), e = (e << 1 ^ e >> 31) >>> 0, Vr(e, this.buf), this;
  }
  /**
   * Write a `fixed64` value, a signed, fixed-length 64-bit integer.
   */
  sfixed64(e) {
    let t = new Uint8Array(8), n = new DataView(t.buffer), r = Z.enc(e);
    return n.setInt32(0, r.lo, !0), n.setInt32(4, r.hi, !0), this.raw(t);
  }
  /**
   * Write a `fixed64` value, an unsigned, fixed-length 64 bit integer.
   */
  fixed64(e) {
    let t = new Uint8Array(8), n = new DataView(t.buffer), r = Z.uEnc(e);
    return n.setInt32(0, r.lo, !0), n.setInt32(4, r.hi, !0), this.raw(t);
  }
  /**
   * Write a `int64` value, a signed 64-bit varint.
   */
  int64(e) {
    let t = Z.enc(e);
    return en(t.lo, t.hi, this.buf), this;
  }
  /**
   * Write a `sint64` value, a signed, zig-zag-encoded 64-bit varint.
   */
  sint64(e) {
    let t = Z.enc(e), n = t.hi >> 31, r = t.lo << 1 ^ n, s = (t.hi << 1 | t.lo >>> 31) ^ n;
    return en(r, s, this.buf), this;
  }
  /**
   * Write a `uint64` value, an unsigned 64-bit varint.
   */
  uint64(e) {
    let t = Z.uEnc(e);
    return en(t.lo, t.hi, this.buf), this;
  }
}
class Ec {
  constructor(e, t) {
    this.varint64 = yc, this.uint32 = Sc, this.buf = e, this.len = e.length, this.pos = 0, this.view = new DataView(e.buffer, e.byteOffset, e.byteLength), this.textDecoder = t != null ? t : new TextDecoder();
  }
  /**
   * Reads a tag - field number and wire type.
   */
  tag() {
    let e = this.uint32(), t = e >>> 3, n = e & 7;
    if (t <= 0 || n < 0 || n > 5) throw new Error("illegal tag: field no " + t + " wire type " + n);
    return [t, n];
  }
  /**
   * Skip one element and return the skipped data.
   *
   * When skipping StartGroup, provide the tags field number to check for
   * matching field number in the EndGroup tag.
   */
  skip(e, t) {
    let n = this.pos;
    switch (e) {
      case re.Varint:
        for (; this.buf[this.pos++] & 128; )
          ;
        break;
      // eslint-disable-next-line
      // @ts-ignore TS7029: Fallthrough case in switch
      case re.Bit64:
        this.pos += 4;
      // eslint-disable-next-line
      // @ts-ignore TS7029: Fallthrough case in switch
      case re.Bit32:
        this.pos += 4;
        break;
      case re.LengthDelimited:
        let r = this.uint32();
        this.pos += r;
        break;
      case re.StartGroup:
        for (; ; ) {
          const [s, a] = this.tag();
          if (a === re.EndGroup) {
            if (t !== void 0 && s !== t)
              throw new Error("invalid end group tag");
            break;
          }
          this.skip(a, s);
        }
        break;
      default:
        throw new Error("cant skip wire type " + e);
    }
    return this.assertBounds(), this.buf.subarray(n, this.pos);
  }
  /**
   * Throws error if position in byte array is out of range.
   */
  assertBounds() {
    if (this.pos > this.len) throw new RangeError("premature EOF");
  }
  /**
   * Read a `int32` field, a signed 32 bit varint.
   */
  int32() {
    return this.uint32() | 0;
  }
  /**
   * Read a `sint32` field, a signed, zigzag-encoded 32-bit varint.
   */
  sint32() {
    let e = this.uint32();
    return e >>> 1 ^ -(e & 1);
  }
  /**
   * Read a `int64` field, a signed 64-bit varint.
   */
  int64() {
    return Z.dec(...this.varint64());
  }
  /**
   * Read a `uint64` field, an unsigned 64-bit varint.
   */
  uint64() {
    return Z.uDec(...this.varint64());
  }
  /**
   * Read a `sint64` field, a signed, zig-zag-encoded 64-bit varint.
   */
  sint64() {
    let [e, t] = this.varint64(), n = -(e & 1);
    return e = (e >>> 1 | (t & 1) << 31) ^ n, t = t >>> 1 ^ n, Z.dec(e, t);
  }
  /**
   * Read a `bool` field, a variant.
   */
  bool() {
    let [e, t] = this.varint64();
    return e !== 0 || t !== 0;
  }
  /**
   * Read a `fixed32` field, an unsigned, fixed-length 32-bit integer.
   */
  fixed32() {
    return this.view.getUint32((this.pos += 4) - 4, !0);
  }
  /**
   * Read a `sfixed32` field, a signed, fixed-length 32-bit integer.
   */
  sfixed32() {
    return this.view.getInt32((this.pos += 4) - 4, !0);
  }
  /**
   * Read a `fixed64` field, an unsigned, fixed-length 64 bit integer.
   */
  fixed64() {
    return Z.uDec(this.sfixed32(), this.sfixed32());
  }
  /**
   * Read a `fixed64` field, a signed, fixed-length 64-bit integer.
   */
  sfixed64() {
    return Z.dec(this.sfixed32(), this.sfixed32());
  }
  /**
   * Read a `float` field, 32-bit floating point number.
   */
  float() {
    return this.view.getFloat32((this.pos += 4) - 4, !0);
  }
  /**
   * Read a `double` field, a 64-bit floating point number.
   */
  double() {
    return this.view.getFloat64((this.pos += 8) - 8, !0);
  }
  /**
   * Read a `bytes` field, length-delimited arbitrary data.
   */
  bytes() {
    let e = this.uint32(), t = this.pos;
    return this.pos += e, this.assertBounds(), this.buf.subarray(t, t + e);
  }
  /**
   * Read a `string` field, length-delimited data converted to UTF-8 text.
   */
  string() {
    return this.textDecoder.decode(this.bytes());
  }
}
function Rc(i, e, t, n) {
  let r;
  return {
    typeName: e,
    extendee: t,
    get field() {
      if (!r) {
        const s = typeof n == "function" ? n() : n;
        s.name = e.split(".").pop(), s.jsonName = "[".concat(e, "]"), r = i.util.newFieldList([s]).list()[0];
      }
      return r;
    },
    runtime: i
  };
}
function na(i) {
  const e = i.field.localName, t = /* @__PURE__ */ Object.create(null);
  return t[e] = wc(i), [t, () => t[e]];
}
function wc(i) {
  const e = i.field;
  if (e.repeated)
    return [];
  if (e.default !== void 0)
    return e.default;
  switch (e.kind) {
    case "enum":
      return e.T.values[0].no;
    case "scalar":
      return jt(e.T, e.L);
    case "message":
      const t = e.T, n = new t();
      return t.fieldWrapper ? t.fieldWrapper.unwrapField(n) : n;
    case "map":
      throw "map fields are not allowed to be extensions";
  }
}
function _c(i, e) {
  if (!e.repeated && (e.kind == "enum" || e.kind == "scalar")) {
    for (let t = i.length - 1; t >= 0; --t)
      if (i[t].no == e.no)
        return [i[t]];
    return [];
  }
  return i.filter((t) => t.no === e.no);
}
let $e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split(""), qi = [];
for (let i = 0; i < $e.length; i++) qi[$e[i].charCodeAt(0)] = i;
qi[45] = $e.indexOf("+");
qi[95] = $e.indexOf("/");
const ra = {
  /**
   * Decodes a base64 string to a byte array.
   *
   * - ignores white-space, including line breaks and tabs
   * - allows inner padding (can decode concatenated base64 strings)
   * - does not require padding
   * - understands base64url encoding:
   *   "-" instead of "+",
   *   "_" instead of "/",
   *   no padding
   */
  dec(i) {
    let e = i.length * 3 / 4;
    i[i.length - 2] == "=" ? e -= 2 : i[i.length - 1] == "=" && (e -= 1);
    let t = new Uint8Array(e), n = 0, r = 0, s, a = 0;
    for (let o = 0; o < i.length; o++) {
      if (s = qi[i.charCodeAt(o)], s === void 0)
        switch (i[o]) {
          // @ts-ignore TS7029: Fallthrough case in switch
          case "=":
            r = 0;
          // reset state when padding found
          // @ts-ignore TS7029: Fallthrough case in switch
          case `
`:
          case "\r":
          case "	":
          case " ":
            continue;
          // skip white-space, and padding
          default:
            throw Error("invalid base64 string.");
        }
      switch (r) {
        case 0:
          a = s, r = 1;
          break;
        case 1:
          t[n++] = a << 2 | (s & 48) >> 4, a = s, r = 2;
          break;
        case 2:
          t[n++] = (a & 15) << 4 | (s & 60) >> 2, a = s, r = 3;
          break;
        case 3:
          t[n++] = (a & 3) << 6 | s, r = 0;
          break;
      }
    }
    if (r == 1) throw Error("invalid base64 string.");
    return t.subarray(0, n);
  },
  /**
   * Encode a byte array to a base64 string.
   */
  enc(i) {
    let e = "", t = 0, n, r = 0;
    for (let s = 0; s < i.length; s++)
      switch (n = i[s], t) {
        case 0:
          e += $e[n >> 2], r = (n & 3) << 4, t = 1;
          break;
        case 1:
          e += $e[r | n >> 4], r = (n & 15) << 2, t = 2;
          break;
        case 2:
          e += $e[r | n >> 6], e += $e[n & 63], t = 0;
          break;
      }
    return t && (e += $e[r], e += "=", t == 1 && (e += "=")), e;
  }
};
function Ic(i, e, t) {
  aa(e, i);
  const n = e.runtime.bin.makeReadOptions(t), r = _c(i.getType().runtime.bin.listUnknownFields(i), e.field), [s, a] = na(e);
  for (const o of r)
    e.runtime.bin.readField(s, n.readerFactory(o.data), e.field, o.wireType, n);
  return a();
}
function Oc(i, e, t, n) {
  aa(e, i);
  const r = e.runtime.bin.makeReadOptions(n), s = e.runtime.bin.makeWriteOptions(n);
  if (sa(i, e)) {
    const d = i.getType().runtime.bin.listUnknownFields(i).filter((u) => u.no != e.field.no);
    i.getType().runtime.bin.discardUnknownFields(i);
    for (const u of d)
      i.getType().runtime.bin.onUnknownField(i, u.no, u.wireType, u.data);
  }
  const a = s.writerFactory();
  let o = e.field;
  !o.opt && !o.repeated && (o.kind == "enum" || o.kind == "scalar") && (o = Object.assign(Object.assign({}, e.field), {
    opt: !0
  })), e.runtime.bin.writeField(o, t, a, s);
  const c = r.readerFactory(a.finish());
  for (; c.pos < c.len; ) {
    const [d, u] = c.tag(), l = c.skip(u, d);
    i.getType().runtime.bin.onUnknownField(i, d, u, l);
  }
}
function sa(i, e) {
  const t = i.getType();
  return e.extendee.typeName === t.typeName && !!t.runtime.bin.listUnknownFields(i).find((n) => n.no == e.field.no);
}
function aa(i, e) {
  ie(i.extendee.typeName == e.getType().typeName, "extension ".concat(i.typeName, " can only be applied to message ").concat(i.extendee.typeName));
}
function oa(i, e) {
  const t = i.localName;
  if (i.repeated)
    return e[t].length > 0;
  if (i.oneof)
    return e[i.oneof.localName].case === t;
  switch (i.kind) {
    case "enum":
    case "scalar":
      return i.opt || i.req ? e[t] !== void 0 : i.kind == "enum" ? e[t] !== i.T.values[0].no : !ia(i.T, e[t]);
    case "message":
      return e[t] !== void 0;
    case "map":
      return Object.keys(e[t]).length > 0;
  }
}
function qr(i, e) {
  const t = i.localName, n = !i.opt && !i.req;
  if (i.repeated)
    e[t] = [];
  else if (i.oneof)
    e[i.oneof.localName] = {
      case: void 0
    };
  else
    switch (i.kind) {
      case "map":
        e[t] = {};
        break;
      case "enum":
        e[t] = n ? i.T.values[0].no : void 0;
        break;
      case "scalar":
        e[t] = n ? jt(i.T, i.L) : void 0;
        break;
      case "message":
        e[t] = void 0;
        break;
    }
}
function Ze(i, e) {
  if (i === null || typeof i != "object" || !Object.getOwnPropertyNames(rr.prototype).every((n) => n in i && typeof i[n] == "function"))
    return !1;
  const t = i.getType();
  return t === null || typeof t != "function" || !("typeName" in t) || typeof t.typeName != "string" ? !1 : e === void 0 ? !0 : t.typeName == e.typeName;
}
function ca(i, e) {
  return Ze(e) || !i.fieldWrapper ? e : i.fieldWrapper.wrapField(e);
}
R.DOUBLE, R.FLOAT, R.INT64, R.UINT64, R.INT32, R.UINT32, R.BOOL, R.STRING, R.BYTES;
const Wr = {
  ignoreUnknownFields: !1
}, Gr = {
  emitDefaultValues: !1,
  enumAsInteger: !1,
  useProtoFieldName: !1,
  prettySpaces: 0
};
function xc(i) {
  return i ? Object.assign(Object.assign({}, Wr), i) : Wr;
}
function Mc(i) {
  return i ? Object.assign(Object.assign({}, Gr), i) : Gr;
}
const Mi = Symbol(), bi = Symbol();
function Dc() {
  return {
    makeReadOptions: xc,
    makeWriteOptions: Mc,
    readMessage(i, e, t, n) {
      if (e == null || Array.isArray(e) || typeof e != "object")
        throw new Error("cannot decode message ".concat(i.typeName, " from JSON: ").concat(Ve(e)));
      n = n != null ? n : new i();
      const r = /* @__PURE__ */ new Map(), s = t.typeRegistry;
      for (const [a, o] of Object.entries(e)) {
        const c = i.fields.findJsonName(a);
        if (c) {
          if (c.oneof) {
            if (o === null && c.kind == "scalar")
              continue;
            const d = r.get(c.oneof);
            if (d !== void 0)
              throw new Error("cannot decode message ".concat(i.typeName, ' from JSON: multiple keys for oneof "').concat(c.oneof.name, '" present: "').concat(d, '", "').concat(a, '"'));
            r.set(c.oneof, a);
          }
          Kr(n, o, c, t, i);
        } else {
          let d = !1;
          if (s != null && s.findExtension && a.startsWith("[") && a.endsWith("]")) {
            const u = s.findExtension(a.substring(1, a.length - 1));
            if (u && u.extendee.typeName == i.typeName) {
              d = !0;
              const [l, h] = na(u);
              Kr(l, o, u.field, t, u), Oc(n, u, h(), t);
            }
          }
          if (!d && !t.ignoreUnknownFields)
            throw new Error("cannot decode message ".concat(i.typeName, ' from JSON: key "').concat(a, '" is unknown'));
        }
      }
      return n;
    },
    writeMessage(i, e) {
      const t = i.getType(), n = {};
      let r;
      try {
        for (r of t.fields.byNumber()) {
          if (!oa(r, i)) {
            if (r.req)
              throw "required field not set";
            if (!e.emitDefaultValues || !Lc(r))
              continue;
          }
          const a = r.oneof ? i[r.oneof.localName].value : i[r.localName], o = Hr(r, a, e);
          o !== void 0 && (n[e.useProtoFieldName ? r.name : r.jsonName] = o);
        }
        const s = e.typeRegistry;
        if (s != null && s.findExtensionFor)
          for (const a of t.runtime.bin.listUnknownFields(i)) {
            const o = s.findExtensionFor(t.typeName, a.no);
            if (o && sa(i, o)) {
              const c = Ic(i, o, e), d = Hr(o.field, c, e);
              d !== void 0 && (n[o.field.jsonName] = d);
            }
          }
      } catch (s) {
        const a = r ? "cannot encode field ".concat(t.typeName, ".").concat(r.name, " to JSON") : "cannot encode message ".concat(t.typeName, " to JSON"), o = s instanceof Error ? s.message : String(s);
        throw new Error(a + (o.length > 0 ? ": ".concat(o) : ""));
      }
      return n;
    },
    readScalar(i, e, t) {
      return ni(i, e, t != null ? t : ht.BIGINT, !0);
    },
    writeScalar(i, e, t) {
      if (e !== void 0 && (t || ia(i, e)))
        return yi(i, e);
    },
    debug: Ve
  };
}
function Ve(i) {
  if (i === null)
    return "null";
  switch (typeof i) {
    case "object":
      return Array.isArray(i) ? "array" : "object";
    case "string":
      return i.length > 100 ? "string" : '"'.concat(i.split('"').join('\\"'), '"');
    default:
      return String(i);
  }
}
function Kr(i, e, t, n, r) {
  let s = t.localName;
  if (t.repeated) {
    if (ie(t.kind != "map"), e === null)
      return;
    if (!Array.isArray(e))
      throw new Error("cannot decode field ".concat(r.typeName, ".").concat(t.name, " from JSON: ").concat(Ve(e)));
    const a = i[s];
    for (const o of e) {
      if (o === null)
        throw new Error("cannot decode field ".concat(r.typeName, ".").concat(t.name, " from JSON: ").concat(Ve(o)));
      switch (t.kind) {
        case "message":
          a.push(t.T.fromJson(o, n));
          break;
        case "enum":
          const c = tn(t.T, o, n.ignoreUnknownFields, !0);
          c !== bi && a.push(c);
          break;
        case "scalar":
          try {
            a.push(ni(t.T, o, t.L, !0));
          } catch (d) {
            let u = "cannot decode field ".concat(r.typeName, ".").concat(t.name, " from JSON: ").concat(Ve(o));
            throw d instanceof Error && d.message.length > 0 && (u += ": ".concat(d.message)), new Error(u);
          }
          break;
      }
    }
  } else if (t.kind == "map") {
    if (e === null)
      return;
    if (typeof e != "object" || Array.isArray(e))
      throw new Error("cannot decode field ".concat(r.typeName, ".").concat(t.name, " from JSON: ").concat(Ve(e)));
    const a = i[s];
    for (const [o, c] of Object.entries(e)) {
      if (c === null)
        throw new Error("cannot decode field ".concat(r.typeName, ".").concat(t.name, " from JSON: map value null"));
      let d;
      try {
        d = Ac(t.K, o);
      } catch (u) {
        let l = "cannot decode map key for field ".concat(r.typeName, ".").concat(t.name, " from JSON: ").concat(Ve(e));
        throw u instanceof Error && u.message.length > 0 && (l += ": ".concat(u.message)), new Error(l);
      }
      switch (t.V.kind) {
        case "message":
          a[d] = t.V.T.fromJson(c, n);
          break;
        case "enum":
          const u = tn(t.V.T, c, n.ignoreUnknownFields, !0);
          u !== bi && (a[d] = u);
          break;
        case "scalar":
          try {
            a[d] = ni(t.V.T, c, ht.BIGINT, !0);
          } catch (l) {
            let h = "cannot decode map value for field ".concat(r.typeName, ".").concat(t.name, " from JSON: ").concat(Ve(e));
            throw l instanceof Error && l.message.length > 0 && (h += ": ".concat(l.message)), new Error(h);
          }
          break;
      }
    }
  } else
    switch (t.oneof && (i = i[t.oneof.localName] = {
      case: s
    }, s = "value"), t.kind) {
      case "message":
        const a = t.T;
        if (e === null && a.typeName != "google.protobuf.Value")
          return;
        let o = i[s];
        Ze(o) ? o.fromJson(e, n) : (i[s] = o = a.fromJson(e, n), a.fieldWrapper && !t.oneof && (i[s] = a.fieldWrapper.unwrapField(o)));
        break;
      case "enum":
        const c = tn(t.T, e, n.ignoreUnknownFields, !1);
        switch (c) {
          case Mi:
            qr(t, i);
            break;
          case bi:
            break;
          default:
            i[s] = c;
            break;
        }
        break;
      case "scalar":
        try {
          const d = ni(t.T, e, t.L, !1);
          switch (d) {
            case Mi:
              qr(t, i);
              break;
            default:
              i[s] = d;
              break;
          }
        } catch (d) {
          let u = "cannot decode field ".concat(r.typeName, ".").concat(t.name, " from JSON: ").concat(Ve(e));
          throw d instanceof Error && d.message.length > 0 && (u += ": ".concat(d.message)), new Error(u);
        }
        break;
    }
}
function Ac(i, e) {
  if (i === R.BOOL)
    switch (e) {
      case "true":
        e = !0;
        break;
      case "false":
        e = !1;
        break;
    }
  return ni(i, e, ht.BIGINT, !0).toString();
}
function ni(i, e, t, n) {
  if (e === null)
    return n ? jt(i, t) : Mi;
  switch (i) {
    // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
    // Either numbers or strings are accepted. Exponent notation is also accepted.
    case R.DOUBLE:
    case R.FLOAT:
      if (e === "NaN") return Number.NaN;
      if (e === "Infinity") return Number.POSITIVE_INFINITY;
      if (e === "-Infinity") return Number.NEGATIVE_INFINITY;
      if (e === "" || typeof e == "string" && e.trim().length !== e.length || typeof e != "string" && typeof e != "number")
        break;
      const r = Number(e);
      if (Number.isNaN(r) || !Number.isFinite(r))
        break;
      return i == R.FLOAT && Qs(r), r;
    // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.
    case R.INT32:
    case R.FIXED32:
    case R.SFIXED32:
    case R.SINT32:
    case R.UINT32:
      let s;
      if (typeof e == "number" ? s = e : typeof e == "string" && e.length > 0 && e.trim().length === e.length && (s = Number(e)), s === void 0) break;
      return i == R.UINT32 || i == R.FIXED32 ? kn(s) : gi(s), s;
    // int64, fixed64, uint64: JSON value will be a decimal string. Either numbers or strings are accepted.
    case R.INT64:
    case R.SFIXED64:
    case R.SINT64:
      if (typeof e != "number" && typeof e != "string") break;
      const a = Z.parse(e);
      return t ? a.toString() : a;
    case R.FIXED64:
    case R.UINT64:
      if (typeof e != "number" && typeof e != "string") break;
      const o = Z.uParse(e);
      return t ? o.toString() : o;
    // bool:
    case R.BOOL:
      if (typeof e != "boolean") break;
      return e;
    // string:
    case R.STRING:
      if (typeof e != "string")
        break;
      try {
        encodeURIComponent(e);
      } catch (c) {
        throw new Error("invalid UTF8");
      }
      return e;
    // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
    // Either standard or URL-safe base64 encoding with/without paddings are accepted.
    case R.BYTES:
      if (e === "") return new Uint8Array(0);
      if (typeof e != "string") break;
      return ra.dec(e);
  }
  throw new Error();
}
function tn(i, e, t, n) {
  if (e === null)
    return i.typeName == "google.protobuf.NullValue" ? 0 : n ? i.values[0].no : Mi;
  switch (typeof e) {
    case "number":
      if (Number.isInteger(e))
        return e;
      break;
    case "string":
      const r = i.findName(e);
      if (r !== void 0)
        return r.no;
      if (t)
        return bi;
      break;
  }
  throw new Error("cannot decode enum ".concat(i.typeName, " from JSON: ").concat(Ve(e)));
}
function Lc(i) {
  return i.repeated || i.kind == "map" ? !0 : !(i.oneof || i.kind == "message" || i.opt || i.req);
}
function Hr(i, e, t) {
  if (i.kind == "map") {
    ie(typeof e == "object" && e != null);
    const n = {}, r = Object.entries(e);
    switch (i.V.kind) {
      case "scalar":
        for (const [a, o] of r)
          n[a.toString()] = yi(i.V.T, o);
        break;
      case "message":
        for (const [a, o] of r)
          n[a.toString()] = o.toJson(t);
        break;
      case "enum":
        const s = i.V.T;
        for (const [a, o] of r)
          n[a.toString()] = nn(s, o, t.enumAsInteger);
        break;
    }
    return t.emitDefaultValues || r.length > 0 ? n : void 0;
  }
  if (i.repeated) {
    ie(Array.isArray(e));
    const n = [];
    switch (i.kind) {
      case "scalar":
        for (let r = 0; r < e.length; r++)
          n.push(yi(i.T, e[r]));
        break;
      case "enum":
        for (let r = 0; r < e.length; r++)
          n.push(nn(i.T, e[r], t.enumAsInteger));
        break;
      case "message":
        for (let r = 0; r < e.length; r++)
          n.push(e[r].toJson(t));
        break;
    }
    return t.emitDefaultValues || n.length > 0 ? n : void 0;
  }
  switch (i.kind) {
    case "scalar":
      return yi(i.T, e);
    case "enum":
      return nn(i.T, e, t.enumAsInteger);
    case "message":
      return ca(i.T, e).toJson(t);
  }
}
function nn(i, e, t) {
  var n;
  if (ie(typeof e == "number"), i.typeName == "google.protobuf.NullValue")
    return null;
  if (t)
    return e;
  const r = i.findNumber(e);
  return (n = r == null ? void 0 : r.name) !== null && n !== void 0 ? n : e;
}
function yi(i, e) {
  switch (i) {
    // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.
    case R.INT32:
    case R.SFIXED32:
    case R.SINT32:
    case R.FIXED32:
    case R.UINT32:
      return ie(typeof e == "number"), e;
    // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
    // Either numbers or strings are accepted. Exponent notation is also accepted.
    case R.FLOAT:
    // assertFloat32(value);
    case R.DOUBLE:
      return ie(typeof e == "number"), Number.isNaN(e) ? "NaN" : e === Number.POSITIVE_INFINITY ? "Infinity" : e === Number.NEGATIVE_INFINITY ? "-Infinity" : e;
    // string:
    case R.STRING:
      return ie(typeof e == "string"), e;
    // bool:
    case R.BOOL:
      return ie(typeof e == "boolean"), e;
    // JSON value will be a decimal string. Either numbers or strings are accepted.
    case R.UINT64:
    case R.FIXED64:
    case R.INT64:
    case R.SFIXED64:
    case R.SINT64:
      return ie(typeof e == "bigint" || typeof e == "string" || typeof e == "number"), e.toString();
    // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
    // Either standard or URL-safe base64 encoding with/without paddings are accepted.
    case R.BYTES:
      return ie(e instanceof Uint8Array), ra.enc(e);
  }
}
const Rt = Symbol("@bufbuild/protobuf/unknown-fields"), zr = {
  readUnknownFields: !0,
  readerFactory: (i) => new Ec(i)
}, Jr = {
  writeUnknownFields: !0,
  writerFactory: () => new Pc()
};
function Nc(i) {
  return i ? Object.assign(Object.assign({}, zr), i) : zr;
}
function Uc(i) {
  return i ? Object.assign(Object.assign({}, Jr), i) : Jr;
}
function Fc() {
  return {
    makeReadOptions: Nc,
    makeWriteOptions: Uc,
    listUnknownFields(i) {
      var e;
      return (e = i[Rt]) !== null && e !== void 0 ? e : [];
    },
    discardUnknownFields(i) {
      delete i[Rt];
    },
    writeUnknownFields(i, e) {
      const n = i[Rt];
      if (n)
        for (const r of n)
          e.tag(r.no, r.wireType).raw(r.data);
    },
    onUnknownField(i, e, t, n) {
      const r = i;
      Array.isArray(r[Rt]) || (r[Rt] = []), r[Rt].push({
        no: e,
        wireType: t,
        data: n
      });
    },
    readMessage(i, e, t, n, r) {
      const s = i.getType(), a = r ? e.len : e.pos + t;
      let o, c;
      for (; e.pos < a && ([o, c] = e.tag(), !(r === !0 && c == re.EndGroup)); ) {
        const d = s.fields.find(o);
        if (!d) {
          const u = e.skip(c, o);
          n.readUnknownFields && this.onUnknownField(i, o, c, u);
          continue;
        }
        Qr(i, e, d, c, n);
      }
      if (r && // eslint-disable-line @typescript-eslint/strict-boolean-expressions
      (c != re.EndGroup || o !== t))
        throw new Error("invalid end group tag");
    },
    readField: Qr,
    writeMessage(i, e, t) {
      const n = i.getType();
      for (const r of n.fields.byNumber()) {
        if (!oa(r, i)) {
          if (r.req)
            throw new Error("cannot encode field ".concat(n.typeName, ".").concat(r.name, " to binary: required field not set"));
          continue;
        }
        const s = r.oneof ? i[r.oneof.localName].value : i[r.localName];
        Yr(r, s, e, t);
      }
      return t.writeUnknownFields && this.writeUnknownFields(i, e), e;
    },
    writeField(i, e, t, n) {
      e !== void 0 && Yr(i, e, t, n);
    }
  };
}
function Qr(i, e, t, n, r) {
  let {
    repeated: s,
    localName: a
  } = t;
  switch (t.oneof && (i = i[t.oneof.localName], i.case != a && delete i.value, i.case = a, a = "value"), t.kind) {
    case "scalar":
    case "enum":
      const o = t.kind == "enum" ? R.INT32 : t.T;
      let c = Di;
      if (t.kind == "scalar" && t.L > 0 && (c = Bc), s) {
        let h = i[a];
        if (n == re.LengthDelimited && o != R.STRING && o != R.BYTES) {
          let v = e.uint32() + e.pos;
          for (; e.pos < v; )
            h.push(c(e, o));
        } else
          h.push(c(e, o));
      } else
        i[a] = c(e, o);
      break;
    case "message":
      const d = t.T;
      s ? i[a].push(ki(e, new d(), r, t)) : Ze(i[a]) ? ki(e, i[a], r, t) : (i[a] = ki(e, new d(), r, t), d.fieldWrapper && !t.oneof && !t.repeated && (i[a] = d.fieldWrapper.unwrapField(i[a])));
      break;
    case "map":
      let [u, l] = jc(t, e, r);
      i[a][u] = l;
      break;
  }
}
function ki(i, e, t, n) {
  const r = e.getType().runtime.bin, s = n == null ? void 0 : n.delimited;
  return r.readMessage(
    e,
    i,
    s ? n.no : i.uint32(),
    // eslint-disable-line @typescript-eslint/strict-boolean-expressions
    t,
    s
  ), e;
}
function jc(i, e, t) {
  const n = e.uint32(), r = e.pos + n;
  let s, a;
  for (; e.pos < r; ) {
    const [o] = e.tag();
    switch (o) {
      case 1:
        s = Di(e, i.K);
        break;
      case 2:
        switch (i.V.kind) {
          case "scalar":
            a = Di(e, i.V.T);
            break;
          case "enum":
            a = e.int32();
            break;
          case "message":
            a = ki(e, new i.V.T(), t, void 0);
            break;
        }
        break;
    }
  }
  if (s === void 0 && (s = jt(i.K, ht.BIGINT)), typeof s != "string" && typeof s != "number" && (s = s.toString()), a === void 0)
    switch (i.V.kind) {
      case "scalar":
        a = jt(i.V.T, ht.BIGINT);
        break;
      case "enum":
        a = i.V.T.values[0].no;
        break;
      case "message":
        a = new i.V.T();
        break;
    }
  return [s, a];
}
function Bc(i, e) {
  const t = Di(i, e);
  return typeof t == "bigint" ? t.toString() : t;
}
function Di(i, e) {
  switch (e) {
    case R.STRING:
      return i.string();
    case R.BOOL:
      return i.bool();
    case R.DOUBLE:
      return i.double();
    case R.FLOAT:
      return i.float();
    case R.INT32:
      return i.int32();
    case R.INT64:
      return i.int64();
    case R.UINT64:
      return i.uint64();
    case R.FIXED64:
      return i.fixed64();
    case R.BYTES:
      return i.bytes();
    case R.FIXED32:
      return i.fixed32();
    case R.SFIXED32:
      return i.sfixed32();
    case R.SFIXED64:
      return i.sfixed64();
    case R.SINT64:
      return i.sint64();
    case R.UINT32:
      return i.uint32();
    case R.SINT32:
      return i.sint32();
  }
}
function Yr(i, e, t, n) {
  ie(e !== void 0);
  const r = i.repeated;
  switch (i.kind) {
    case "scalar":
    case "enum":
      let s = i.kind == "enum" ? R.INT32 : i.T;
      if (r)
        if (ie(Array.isArray(e)), i.packed)
          qc(t, s, i.no, e);
        else
          for (const a of e)
            ri(t, s, i.no, a);
      else
        ri(t, s, i.no, e);
      break;
    case "message":
      if (r) {
        ie(Array.isArray(e));
        for (const a of e)
          Xr(t, n, i, a);
      } else
        Xr(t, n, i, e);
      break;
    case "map":
      ie(typeof e == "object" && e != null);
      for (const [a, o] of Object.entries(e))
        Vc(t, n, i, a, o);
      break;
  }
}
function Vc(i, e, t, n, r) {
  i.tag(t.no, re.LengthDelimited), i.fork();
  let s = n;
  switch (t.K) {
    case R.INT32:
    case R.FIXED32:
    case R.UINT32:
    case R.SFIXED32:
    case R.SINT32:
      s = Number.parseInt(n);
      break;
    case R.BOOL:
      ie(n == "true" || n == "false"), s = n == "true";
      break;
  }
  switch (ri(i, t.K, 1, s), t.V.kind) {
    case "scalar":
      ri(i, t.V.T, 2, r);
      break;
    case "enum":
      ri(i, R.INT32, 2, r);
      break;
    case "message":
      ie(r !== void 0), i.tag(2, re.LengthDelimited).bytes(r.toBinary(e));
      break;
  }
  i.join();
}
function Xr(i, e, t, n) {
  const r = ca(t.T, n);
  t.delimited ? i.tag(t.no, re.StartGroup).raw(r.toBinary(e)).tag(t.no, re.EndGroup) : i.tag(t.no, re.LengthDelimited).bytes(r.toBinary(e));
}
function ri(i, e, t, n) {
  ie(n !== void 0);
  let [r, s] = da(e);
  i.tag(t, r)[s](n);
}
function qc(i, e, t, n) {
  if (!n.length)
    return;
  i.tag(t, re.LengthDelimited).fork();
  let [, r] = da(e);
  for (let s = 0; s < n.length; s++)
    i[r](n[s]);
  i.join();
}
function da(i) {
  let e = re.Varint;
  switch (i) {
    case R.BYTES:
    case R.STRING:
      e = re.LengthDelimited;
      break;
    case R.DOUBLE:
    case R.FIXED64:
    case R.SFIXED64:
      e = re.Bit64;
      break;
    case R.FIXED32:
    case R.SFIXED32:
    case R.FLOAT:
      e = re.Bit32;
      break;
  }
  const t = R[i].toLowerCase();
  return [e, t];
}
function Wc() {
  return {
    setEnumType: Xs,
    initPartial(i, e) {
      if (i === void 0)
        return;
      const t = e.getType();
      for (const n of t.fields.byMember()) {
        const r = n.localName, s = e, a = i;
        if (a[r] != null)
          switch (n.kind) {
            case "oneof":
              const o = a[r].case;
              if (o === void 0)
                continue;
              const c = n.findField(o);
              let d = a[r].value;
              c && c.kind == "message" && !Ze(d, c.T) ? d = new c.T(d) : c && c.kind === "scalar" && c.T === R.BYTES && (d = Qt(d)), s[r] = {
                case: o,
                value: d
              };
              break;
            case "scalar":
            case "enum":
              let u = a[r];
              n.T === R.BYTES && (u = n.repeated ? u.map(Qt) : Qt(u)), s[r] = u;
              break;
            case "map":
              switch (n.V.kind) {
                case "scalar":
                case "enum":
                  if (n.V.T === R.BYTES)
                    for (const [p, v] of Object.entries(a[r]))
                      s[r][p] = Qt(v);
                  else
                    Object.assign(s[r], a[r]);
                  break;
                case "message":
                  const h = n.V.T;
                  for (const p of Object.keys(a[r])) {
                    let v = a[r][p];
                    h.fieldWrapper || (v = new h(v)), s[r][p] = v;
                  }
                  break;
              }
              break;
            case "message":
              const l = n.T;
              if (n.repeated)
                s[r] = a[r].map((h) => Ze(h, l) ? h : new l(h));
              else {
                const h = a[r];
                l.fieldWrapper ? /* We can't use BytesValue.typeName as that will create a circular import */ l.typeName === "google.protobuf.BytesValue" ? s[r] = Qt(h) : s[r] = h : s[r] = Ze(h, l) ? h : new l(h);
              }
              break;
          }
      }
    },
    // TODO use isFieldSet() here to support future field presence
    equals(i, e, t) {
      return e === t ? !0 : !e || !t ? !1 : i.fields.byMember().every((n) => {
        const r = e[n.localName], s = t[n.localName];
        if (n.repeated) {
          if (r.length !== s.length)
            return !1;
          switch (n.kind) {
            case "message":
              return r.every((a, o) => n.T.equals(a, s[o]));
            case "scalar":
              return r.every((a, o) => st(n.T, a, s[o]));
            case "enum":
              return r.every((a, o) => st(R.INT32, a, s[o]));
          }
          throw new Error("repeated cannot contain ".concat(n.kind));
        }
        switch (n.kind) {
          case "message":
            let a = r, o = s;
            return n.T.fieldWrapper && (a !== void 0 && !Ze(a) && (a = n.T.fieldWrapper.wrapField(a)), o !== void 0 && !Ze(o) && (o = n.T.fieldWrapper.wrapField(o))), n.T.equals(a, o);
          case "enum":
            return st(R.INT32, r, s);
          case "scalar":
            return st(n.T, r, s);
          case "oneof":
            if (r.case !== s.case)
              return !1;
            const c = n.findField(r.case);
            if (c === void 0)
              return !0;
            switch (c.kind) {
              case "message":
                return c.T.equals(r.value, s.value);
              case "enum":
                return st(R.INT32, r.value, s.value);
              case "scalar":
                return st(c.T, r.value, s.value);
            }
            throw new Error("oneof cannot contain ".concat(c.kind));
          case "map":
            const d = Object.keys(r).concat(Object.keys(s));
            switch (n.V.kind) {
              case "message":
                const u = n.V.T;
                return d.every((h) => u.equals(r[h], s[h]));
              case "enum":
                return d.every((h) => st(R.INT32, r[h], s[h]));
              case "scalar":
                const l = n.V.T;
                return d.every((h) => st(l, r[h], s[h]));
            }
            break;
        }
      });
    },
    // TODO use isFieldSet() here to support future field presence
    clone(i) {
      const e = i.getType(), t = new e(), n = t;
      for (const r of e.fields.byMember()) {
        const s = i[r.localName];
        let a;
        if (r.repeated)
          a = s.map(fi);
        else if (r.kind == "map") {
          a = n[r.localName];
          for (const [o, c] of Object.entries(s))
            a[o] = fi(c);
        } else r.kind == "oneof" ? a = r.findField(s.case) ? {
          case: s.case,
          value: fi(s.value)
        } : {
          case: void 0
        } : a = fi(s);
        n[r.localName] = a;
      }
      for (const r of e.runtime.bin.listUnknownFields(i))
        e.runtime.bin.onUnknownField(n, r.no, r.wireType, r.data);
      return t;
    }
  };
}
function fi(i) {
  if (i === void 0)
    return i;
  if (Ze(i))
    return i.clone();
  if (i instanceof Uint8Array) {
    const e = new Uint8Array(i.byteLength);
    return e.set(i), e;
  }
  return i;
}
function Qt(i) {
  return i instanceof Uint8Array ? i : new Uint8Array(i);
}
function Gc(i, e, t) {
  return {
    syntax: i,
    json: Dc(),
    bin: Fc(),
    util: Object.assign(Object.assign({}, Wc()), {
      newFieldList: e,
      initFields: t
    }),
    makeMessageType(n, r, s) {
      return bc(this, n, r, s);
    },
    makeEnum: vc,
    makeEnumType: $s,
    getEnumType: gc,
    makeExtension(n, r, s) {
      return Rc(this, n, r, s);
    }
  };
}
class Kc {
  constructor(e, t) {
    this._fields = e, this._normalizer = t;
  }
  findJsonName(e) {
    if (!this.jsonNames) {
      const t = {};
      for (const n of this.list())
        t[n.jsonName] = t[n.name] = n;
      this.jsonNames = t;
    }
    return this.jsonNames[e];
  }
  find(e) {
    if (!this.numbers) {
      const t = {};
      for (const n of this.list())
        t[n.no] = n;
      this.numbers = t;
    }
    return this.numbers[e];
  }
  list() {
    return this.all || (this.all = this._normalizer(this._fields)), this.all;
  }
  byNumber() {
    return this.numbersAsc || (this.numbersAsc = this.list().concat().sort((e, t) => e.no - t.no)), this.numbersAsc;
  }
  byMember() {
    if (!this.members) {
      this.members = [];
      const e = this.members;
      let t;
      for (const n of this.list())
        n.oneof ? n.oneof !== t && (t = n.oneof, e.push(t)) : e.push(n);
    }
    return this.members;
  }
}
function ua(i, e) {
  const t = la(i);
  return e ? t : Xc(Yc(t));
}
function Hc(i) {
  return ua(i, !1);
}
const zc = la;
function la(i) {
  let e = !1;
  const t = [];
  for (let n = 0; n < i.length; n++) {
    let r = i.charAt(n);
    switch (r) {
      case "_":
        e = !0;
        break;
      case "0":
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        t.push(r), e = !1;
        break;
      default:
        e && (e = !1, r = r.toUpperCase()), t.push(r);
        break;
    }
  }
  return t.join("");
}
const Jc = /* @__PURE__ */ new Set([
  // names reserved by JavaScript
  "constructor",
  "toString",
  "toJSON",
  "valueOf"
]), Qc = /* @__PURE__ */ new Set([
  // names reserved by the runtime
  "getType",
  "clone",
  "equals",
  "fromBinary",
  "fromJson",
  "fromJsonString",
  "toBinary",
  "toJson",
  "toJsonString",
  // names reserved by the runtime for the future
  "toObject"
]), ha = (i) => "".concat(i, "$"), Yc = (i) => Qc.has(i) ? ha(i) : i, Xc = (i) => Jc.has(i) ? ha(i) : i;
class $c {
  constructor(e) {
    this.kind = "oneof", this.repeated = !1, this.packed = !1, this.opt = !1, this.req = !1, this.default = void 0, this.fields = [], this.name = e, this.localName = Hc(e);
  }
  addField(e) {
    ie(e.oneof === this, "field ".concat(e.name, " not one of ").concat(this.name)), this.fields.push(e);
  }
  findField(e) {
    if (!this._lookup) {
      this._lookup = /* @__PURE__ */ Object.create(null);
      for (let t = 0; t < this.fields.length; t++)
        this._lookup[this.fields[t].localName] = this.fields[t];
    }
    return this._lookup[e];
  }
}
function Zc(i, e) {
  var t, n, r, s, a, o;
  const c = [];
  let d;
  for (const u of typeof i == "function" ? i() : i) {
    const l = u;
    if (l.localName = ua(u.name, u.oneof !== void 0), l.jsonName = (t = u.jsonName) !== null && t !== void 0 ? t : zc(u.name), l.repeated = (n = u.repeated) !== null && n !== void 0 ? n : !1, u.kind == "scalar" && (l.L = (r = u.L) !== null && r !== void 0 ? r : ht.BIGINT), l.delimited = (s = u.delimited) !== null && s !== void 0 ? s : !1, l.req = (a = u.req) !== null && a !== void 0 ? a : !1, l.opt = (o = u.opt) !== null && o !== void 0 ? o : !1, u.packed === void 0 && (l.packed = u.kind == "enum" || u.kind == "scalar" && u.T != R.BYTES && u.T != R.STRING), u.oneof !== void 0) {
      const h = typeof u.oneof == "string" ? u.oneof : u.oneof.name;
      (!d || d.name != h) && (d = new $c(h)), l.oneof = d, d.addField(l);
    }
    c.push(l);
  }
  return c;
}
const k = Gc(
  "proto3",
  (i) => new Kc(i, (e) => Zc(e)),
  // TODO merge with proto2 and initExtensionField, also see initPartial, equals, clone
  (i) => {
    for (const e of i.getType().fields.byMember()) {
      if (e.opt)
        continue;
      const t = e.localName, n = i;
      if (e.repeated) {
        n[t] = [];
        continue;
      }
      switch (e.kind) {
        case "oneof":
          n[t] = {
            case: void 0
          };
          break;
        case "enum":
          n[t] = 0;
          break;
        case "map":
          n[t] = {};
          break;
        case "scalar":
          n[t] = jt(e.T, e.L);
          break;
      }
    }
  }
);
class Te extends rr {
  constructor(e) {
    super(), this.seconds = Z.zero, this.nanos = 0, k.util.initPartial(e, this);
  }
  fromJson(e, t) {
    if (typeof e != "string")
      throw new Error("cannot decode google.protobuf.Timestamp from JSON: ".concat(k.json.debug(e)));
    const n = e.match(/^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2})(?:Z|\.([0-9]{3,9})Z|([+-][0-9][0-9]:[0-9][0-9]))$/);
    if (!n)
      throw new Error("cannot decode google.protobuf.Timestamp from JSON: invalid RFC 3339 string");
    const r = Date.parse(n[1] + "-" + n[2] + "-" + n[3] + "T" + n[4] + ":" + n[5] + ":" + n[6] + (n[8] ? n[8] : "Z"));
    if (Number.isNaN(r))
      throw new Error("cannot decode google.protobuf.Timestamp from JSON: invalid RFC 3339 string");
    if (r < Date.parse("0001-01-01T00:00:00Z") || r > Date.parse("9999-12-31T23:59:59Z"))
      throw new Error("cannot decode message google.protobuf.Timestamp from JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive");
    return this.seconds = Z.parse(r / 1e3), this.nanos = 0, n[7] && (this.nanos = parseInt("1" + n[7] + "0".repeat(9 - n[7].length)) - 1e9), this;
  }
  toJson(e) {
    const t = Number(this.seconds) * 1e3;
    if (t < Date.parse("0001-01-01T00:00:00Z") || t > Date.parse("9999-12-31T23:59:59Z"))
      throw new Error("cannot encode google.protobuf.Timestamp to JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive");
    if (this.nanos < 0)
      throw new Error("cannot encode google.protobuf.Timestamp to JSON: nanos must not be negative");
    let n = "Z";
    if (this.nanos > 0) {
      const r = (this.nanos + 1e9).toString().substring(1);
      r.substring(3) === "000000" ? n = "." + r.substring(0, 3) + "Z" : r.substring(6) === "000" ? n = "." + r.substring(0, 6) + "Z" : n = "." + r + "Z";
    }
    return new Date(t).toISOString().replace(".000Z", n);
  }
  toDate() {
    return new Date(Number(this.seconds) * 1e3 + Math.ceil(this.nanos / 1e6));
  }
  static now() {
    return Te.fromDate(/* @__PURE__ */ new Date());
  }
  static fromDate(e) {
    const t = e.getTime();
    return new Te({
      seconds: Z.parse(Math.floor(t / 1e3)),
      nanos: t % 1e3 * 1e6
    });
  }
  static fromBinary(e, t) {
    return new Te().fromBinary(e, t);
  }
  static fromJson(e, t) {
    return new Te().fromJson(e, t);
  }
  static fromJsonString(e, t) {
    return new Te().fromJsonString(e, t);
  }
  static equals(e, t) {
    return k.util.equals(Te, e, t);
  }
}
Te.runtime = k;
Te.typeName = "google.protobuf.Timestamp";
Te.fields = k.util.newFieldList(() => [{
  no: 1,
  name: "seconds",
  kind: "scalar",
  T: 3
  /* ScalarType.INT64 */
}, {
  no: 2,
  name: "nanos",
  kind: "scalar",
  T: 5
  /* ScalarType.INT32 */
}]);
const ed = /* @__PURE__ */ k.makeMessageType("livekit.MetricsBatch", () => [{
  no: 1,
  name: "timestamp_ms",
  kind: "scalar",
  T: 3
  /* ScalarType.INT64 */
}, {
  no: 2,
  name: "normalized_timestamp",
  kind: "message",
  T: Te
}, {
  no: 3,
  name: "str_data",
  kind: "scalar",
  T: 9,
  repeated: !0
}, {
  no: 4,
  name: "time_series",
  kind: "message",
  T: td,
  repeated: !0
}, {
  no: 5,
  name: "events",
  kind: "message",
  T: nd,
  repeated: !0
}]), td = /* @__PURE__ */ k.makeMessageType("livekit.TimeSeriesMetric", () => [{
  no: 1,
  name: "label",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 2,
  name: "participant_identity",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 3,
  name: "track_sid",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 4,
  name: "samples",
  kind: "message",
  T: id,
  repeated: !0
}, {
  no: 5,
  name: "rid",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}]), id = /* @__PURE__ */ k.makeMessageType("livekit.MetricSample", () => [{
  no: 1,
  name: "timestamp_ms",
  kind: "scalar",
  T: 3
  /* ScalarType.INT64 */
}, {
  no: 2,
  name: "normalized_timestamp",
  kind: "message",
  T: Te
}, {
  no: 3,
  name: "value",
  kind: "scalar",
  T: 2
  /* ScalarType.FLOAT */
}]), nd = /* @__PURE__ */ k.makeMessageType("livekit.EventMetric", () => [{
  no: 1,
  name: "label",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 2,
  name: "participant_identity",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 3,
  name: "track_sid",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 4,
  name: "start_timestamp_ms",
  kind: "scalar",
  T: 3
  /* ScalarType.INT64 */
}, {
  no: 5,
  name: "end_timestamp_ms",
  kind: "scalar",
  T: 3,
  opt: !0
}, {
  no: 6,
  name: "normalized_start_timestamp",
  kind: "message",
  T: Te
}, {
  no: 7,
  name: "normalized_end_timestamp",
  kind: "message",
  T: Te,
  opt: !0
}, {
  no: 8,
  name: "metadata",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 9,
  name: "rid",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}]), fa = /* @__PURE__ */ k.makeEnum("livekit.BackupCodecPolicy", [{
  no: 0,
  name: "PREFER_REGRESSION"
}, {
  no: 1,
  name: "SIMULCAST"
}, {
  no: 2,
  name: "REGRESSION"
}]), De = /* @__PURE__ */ k.makeEnum("livekit.TrackType", [{
  no: 0,
  name: "AUDIO"
}, {
  no: 1,
  name: "VIDEO"
}, {
  no: 2,
  name: "DATA"
}]), ae = /* @__PURE__ */ k.makeEnum("livekit.TrackSource", [{
  no: 0,
  name: "UNKNOWN"
}, {
  no: 1,
  name: "CAMERA"
}, {
  no: 2,
  name: "MICROPHONE"
}, {
  no: 3,
  name: "SCREEN_SHARE"
}, {
  no: 4,
  name: "SCREEN_SHARE_AUDIO"
}]), ar = /* @__PURE__ */ k.makeEnum("livekit.VideoQuality", [{
  no: 0,
  name: "LOW"
}, {
  no: 1,
  name: "MEDIUM"
}, {
  no: 2,
  name: "HIGH"
}, {
  no: 3,
  name: "OFF"
}]), ti = /* @__PURE__ */ k.makeEnum("livekit.ConnectionQuality", [{
  no: 0,
  name: "POOR"
}, {
  no: 1,
  name: "GOOD"
}, {
  no: 2,
  name: "EXCELLENT"
}, {
  no: 3,
  name: "LOST"
}]), ai = /* @__PURE__ */ k.makeEnum("livekit.ClientConfigSetting", [{
  no: 0,
  name: "UNSET"
}, {
  no: 1,
  name: "DISABLED"
}, {
  no: 2,
  name: "ENABLED"
}]), Le = /* @__PURE__ */ k.makeEnum("livekit.DisconnectReason", [{
  no: 0,
  name: "UNKNOWN_REASON"
}, {
  no: 1,
  name: "CLIENT_INITIATED"
}, {
  no: 2,
  name: "DUPLICATE_IDENTITY"
}, {
  no: 3,
  name: "SERVER_SHUTDOWN"
}, {
  no: 4,
  name: "PARTICIPANT_REMOVED"
}, {
  no: 5,
  name: "ROOM_DELETED"
}, {
  no: 6,
  name: "STATE_MISMATCH"
}, {
  no: 7,
  name: "JOIN_FAILURE"
}, {
  no: 8,
  name: "MIGRATION"
}, {
  no: 9,
  name: "SIGNAL_CLOSE"
}, {
  no: 10,
  name: "ROOM_CLOSED"
}, {
  no: 11,
  name: "USER_UNAVAILABLE"
}, {
  no: 12,
  name: "USER_REJECTED"
}, {
  no: 13,
  name: "SIP_TRUNK_FAILURE"
}, {
  no: 14,
  name: "CONNECTION_TIMEOUT"
}, {
  no: 15,
  name: "MEDIA_FAILURE"
}]), wt = /* @__PURE__ */ k.makeEnum("livekit.ReconnectReason", [{
  no: 0,
  name: "RR_UNKNOWN"
}, {
  no: 1,
  name: "RR_SIGNAL_DISCONNECTED"
}, {
  no: 2,
  name: "RR_PUBLISHER_FAILED"
}, {
  no: 3,
  name: "RR_SUBSCRIBER_FAILED"
}, {
  no: 4,
  name: "RR_SWITCH_CANDIDATE"
}]), rd = /* @__PURE__ */ k.makeEnum("livekit.SubscriptionError", [{
  no: 0,
  name: "SE_UNKNOWN"
}, {
  no: 1,
  name: "SE_CODEC_UNSUPPORTED"
}, {
  no: 2,
  name: "SE_TRACK_NOTFOUND"
}]), le = /* @__PURE__ */ k.makeEnum("livekit.AudioTrackFeature", [{
  no: 0,
  name: "TF_STEREO"
}, {
  no: 1,
  name: "TF_NO_DTX"
}, {
  no: 2,
  name: "TF_AUTO_GAIN_CONTROL"
}, {
  no: 3,
  name: "TF_ECHO_CANCELLATION"
}, {
  no: 4,
  name: "TF_NOISE_SUPPRESSION"
}, {
  no: 5,
  name: "TF_ENHANCED_NOISE_CANCELLATION"
}, {
  no: 6,
  name: "TF_PRECONNECT_BUFFER"
}]), Wi = /* @__PURE__ */ k.makeMessageType("livekit.Room", () => [{
  no: 1,
  name: "sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "name",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 3,
  name: "empty_timeout",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 14,
  name: "departure_timeout",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 4,
  name: "max_participants",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 5,
  name: "creation_time",
  kind: "scalar",
  T: 3
  /* ScalarType.INT64 */
}, {
  no: 15,
  name: "creation_time_ms",
  kind: "scalar",
  T: 3
  /* ScalarType.INT64 */
}, {
  no: 6,
  name: "turn_password",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 7,
  name: "enabled_codecs",
  kind: "message",
  T: Ai,
  repeated: !0
}, {
  no: 8,
  name: "metadata",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 9,
  name: "num_participants",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 11,
  name: "num_publishers",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 10,
  name: "active_recording",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 13,
  name: "version",
  kind: "message",
  T: Ra
}]), Ai = /* @__PURE__ */ k.makeMessageType("livekit.Codec", () => [{
  no: 1,
  name: "mime",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "fmtp_line",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}]), sd = /* @__PURE__ */ k.makeMessageType("livekit.ParticipantPermission", () => [{
  no: 1,
  name: "can_subscribe",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 2,
  name: "can_publish",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 3,
  name: "can_publish_data",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 9,
  name: "can_publish_sources",
  kind: "enum",
  T: k.getEnumType(ae),
  repeated: !0
}, {
  no: 7,
  name: "hidden",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 8,
  name: "recorder",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 10,
  name: "can_update_metadata",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 11,
  name: "agent",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 12,
  name: "can_subscribe_metrics",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}]), Tt = /* @__PURE__ */ k.makeMessageType("livekit.ParticipantInfo", () => [{
  no: 1,
  name: "sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "identity",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 3,
  name: "state",
  kind: "enum",
  T: k.getEnumType(Mt)
}, {
  no: 4,
  name: "tracks",
  kind: "message",
  T: It,
  repeated: !0
}, {
  no: 5,
  name: "metadata",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 6,
  name: "joined_at",
  kind: "scalar",
  T: 3
  /* ScalarType.INT64 */
}, {
  no: 17,
  name: "joined_at_ms",
  kind: "scalar",
  T: 3
  /* ScalarType.INT64 */
}, {
  no: 9,
  name: "name",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 10,
  name: "version",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 11,
  name: "permission",
  kind: "message",
  T: sd
}, {
  no: 12,
  name: "region",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 13,
  name: "is_publisher",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 14,
  name: "kind",
  kind: "enum",
  T: k.getEnumType(oi)
}, {
  no: 15,
  name: "attributes",
  kind: "map",
  K: 9,
  V: {
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
}, {
  no: 16,
  name: "disconnect_reason",
  kind: "enum",
  T: k.getEnumType(Le)
}, {
  no: 18,
  name: "kind_details",
  kind: "enum",
  T: k.getEnumType(ad),
  repeated: !0
}]), Mt = /* @__PURE__ */ k.makeEnum("livekit.ParticipantInfo.State", [{
  no: 0,
  name: "JOINING"
}, {
  no: 1,
  name: "JOINED"
}, {
  no: 2,
  name: "ACTIVE"
}, {
  no: 3,
  name: "DISCONNECTED"
}]), oi = /* @__PURE__ */ k.makeEnum("livekit.ParticipantInfo.Kind", [{
  no: 0,
  name: "STANDARD"
}, {
  no: 1,
  name: "INGRESS"
}, {
  no: 2,
  name: "EGRESS"
}, {
  no: 3,
  name: "SIP"
}, {
  no: 4,
  name: "AGENT"
}]), ad = /* @__PURE__ */ k.makeEnum("livekit.ParticipantInfo.KindDetail", [{
  no: 0,
  name: "CLOUD_AGENT"
}, {
  no: 1,
  name: "FORWARDED"
}]), Pe = /* @__PURE__ */ k.makeEnum("livekit.Encryption.Type", [{
  no: 0,
  name: "NONE"
}, {
  no: 1,
  name: "GCM"
}, {
  no: 2,
  name: "CUSTOM"
}]), od = /* @__PURE__ */ k.makeMessageType("livekit.SimulcastCodecInfo", () => [{
  no: 1,
  name: "mime_type",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "mid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 3,
  name: "cid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 4,
  name: "layers",
  kind: "message",
  T: yt,
  repeated: !0
}]), It = /* @__PURE__ */ k.makeMessageType("livekit.TrackInfo", () => [{
  no: 1,
  name: "sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "type",
  kind: "enum",
  T: k.getEnumType(De)
}, {
  no: 3,
  name: "name",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 4,
  name: "muted",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 5,
  name: "width",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 6,
  name: "height",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 7,
  name: "simulcast",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 8,
  name: "disable_dtx",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 9,
  name: "source",
  kind: "enum",
  T: k.getEnumType(ae)
}, {
  no: 10,
  name: "layers",
  kind: "message",
  T: yt,
  repeated: !0
}, {
  no: 11,
  name: "mime_type",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 12,
  name: "mid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 13,
  name: "codecs",
  kind: "message",
  T: od,
  repeated: !0
}, {
  no: 14,
  name: "stereo",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 15,
  name: "disable_red",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 16,
  name: "encryption",
  kind: "enum",
  T: k.getEnumType(Pe)
}, {
  no: 17,
  name: "stream",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 18,
  name: "version",
  kind: "message",
  T: Ra
}, {
  no: 19,
  name: "audio_features",
  kind: "enum",
  T: k.getEnumType(le),
  repeated: !0
}, {
  no: 20,
  name: "backup_codec_policy",
  kind: "enum",
  T: k.getEnumType(fa)
}]), yt = /* @__PURE__ */ k.makeMessageType("livekit.VideoLayer", () => [{
  no: 1,
  name: "quality",
  kind: "enum",
  T: k.getEnumType(ar)
}, {
  no: 2,
  name: "width",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 3,
  name: "height",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 4,
  name: "bitrate",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 5,
  name: "ssrc",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 6,
  name: "spatial_layer",
  kind: "scalar",
  T: 5
  /* ScalarType.INT32 */
}, {
  no: 7,
  name: "rid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}]), ke = /* @__PURE__ */ k.makeMessageType("livekit.DataPacket", () => [{
  no: 1,
  name: "kind",
  kind: "enum",
  T: k.getEnumType(q)
}, {
  no: 4,
  name: "participant_identity",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 5,
  name: "destination_identities",
  kind: "scalar",
  T: 9,
  repeated: !0
}, {
  no: 2,
  name: "user",
  kind: "message",
  T: ma,
  oneof: "value"
}, {
  no: 3,
  name: "speaker",
  kind: "message",
  T: cd,
  oneof: "value"
}, {
  no: 6,
  name: "sip_dtmf",
  kind: "message",
  T: ga,
  oneof: "value"
}, {
  no: 7,
  name: "transcription",
  kind: "message",
  T: dd,
  oneof: "value"
}, {
  no: 8,
  name: "metrics",
  kind: "message",
  T: ed,
  oneof: "value"
}, {
  no: 9,
  name: "chat_message",
  kind: "message",
  T: Tn,
  oneof: "value"
}, {
  no: 10,
  name: "rpc_request",
  kind: "message",
  T: va,
  oneof: "value"
}, {
  no: 11,
  name: "rpc_ack",
  kind: "message",
  T: ba,
  oneof: "value"
}, {
  no: 12,
  name: "rpc_response",
  kind: "message",
  T: ya,
  oneof: "value"
}, {
  no: 13,
  name: "stream_header",
  kind: "message",
  T: Cn,
  oneof: "value"
}, {
  no: 14,
  name: "stream_chunk",
  kind: "message",
  T: Pn,
  oneof: "value"
}, {
  no: 15,
  name: "stream_trailer",
  kind: "message",
  T: En,
  oneof: "value"
}, {
  no: 16,
  name: "sequence",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 17,
  name: "participant_sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}]), q = /* @__PURE__ */ k.makeEnum("livekit.DataPacket.Kind", [{
  no: 0,
  name: "RELIABLE"
}, {
  no: 1,
  name: "LOSSY"
}]), cd = /* @__PURE__ */ k.makeMessageType("livekit.ActiveSpeakerUpdate", () => [{
  no: 1,
  name: "speakers",
  kind: "message",
  T: pa,
  repeated: !0
}]), pa = /* @__PURE__ */ k.makeMessageType("livekit.SpeakerInfo", () => [{
  no: 1,
  name: "sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "level",
  kind: "scalar",
  T: 2
  /* ScalarType.FLOAT */
}, {
  no: 3,
  name: "active",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}]), ma = /* @__PURE__ */ k.makeMessageType("livekit.UserPacket", () => [{
  no: 1,
  name: "participant_sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 5,
  name: "participant_identity",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "payload",
  kind: "scalar",
  T: 12
  /* ScalarType.BYTES */
}, {
  no: 3,
  name: "destination_sids",
  kind: "scalar",
  T: 9,
  repeated: !0
}, {
  no: 6,
  name: "destination_identities",
  kind: "scalar",
  T: 9,
  repeated: !0
}, {
  no: 4,
  name: "topic",
  kind: "scalar",
  T: 9,
  opt: !0
}, {
  no: 8,
  name: "id",
  kind: "scalar",
  T: 9,
  opt: !0
}, {
  no: 9,
  name: "start_time",
  kind: "scalar",
  T: 4,
  opt: !0
}, {
  no: 10,
  name: "end_time",
  kind: "scalar",
  T: 4,
  opt: !0
}, {
  no: 11,
  name: "nonce",
  kind: "scalar",
  T: 12
  /* ScalarType.BYTES */
}]), ga = /* @__PURE__ */ k.makeMessageType("livekit.SipDTMF", () => [{
  no: 3,
  name: "code",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 4,
  name: "digit",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}]), dd = /* @__PURE__ */ k.makeMessageType("livekit.Transcription", () => [{
  no: 2,
  name: "transcribed_participant_identity",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 3,
  name: "track_id",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 4,
  name: "segments",
  kind: "message",
  T: ud,
  repeated: !0
}]), ud = /* @__PURE__ */ k.makeMessageType("livekit.TranscriptionSegment", () => [{
  no: 1,
  name: "id",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "text",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 3,
  name: "start_time",
  kind: "scalar",
  T: 4
  /* ScalarType.UINT64 */
}, {
  no: 4,
  name: "end_time",
  kind: "scalar",
  T: 4
  /* ScalarType.UINT64 */
}, {
  no: 5,
  name: "final",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 6,
  name: "language",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}]), Tn = /* @__PURE__ */ k.makeMessageType("livekit.ChatMessage", () => [{
  no: 1,
  name: "id",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "timestamp",
  kind: "scalar",
  T: 3
  /* ScalarType.INT64 */
}, {
  no: 3,
  name: "edit_timestamp",
  kind: "scalar",
  T: 3,
  opt: !0
}, {
  no: 4,
  name: "message",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 5,
  name: "deleted",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 6,
  name: "generated",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}]), va = /* @__PURE__ */ k.makeMessageType("livekit.RpcRequest", () => [{
  no: 1,
  name: "id",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "method",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 3,
  name: "payload",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 4,
  name: "response_timeout_ms",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 5,
  name: "version",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}]), ba = /* @__PURE__ */ k.makeMessageType("livekit.RpcAck", () => [{
  no: 1,
  name: "request_id",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}]), ya = /* @__PURE__ */ k.makeMessageType("livekit.RpcResponse", () => [{
  no: 1,
  name: "request_id",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "payload",
  kind: "scalar",
  T: 9,
  oneof: "value"
}, {
  no: 3,
  name: "error",
  kind: "message",
  T: ka,
  oneof: "value"
}]), ka = /* @__PURE__ */ k.makeMessageType("livekit.RpcError", () => [{
  no: 1,
  name: "code",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 2,
  name: "message",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 3,
  name: "data",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}]), Ta = /* @__PURE__ */ k.makeMessageType("livekit.ParticipantTracks", () => [{
  no: 1,
  name: "participant_sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "track_sids",
  kind: "scalar",
  T: 9,
  repeated: !0
}]), Sa = /* @__PURE__ */ k.makeMessageType("livekit.ServerInfo", () => [{
  no: 1,
  name: "edition",
  kind: "enum",
  T: k.getEnumType(Ca)
}, {
  no: 2,
  name: "version",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 3,
  name: "protocol",
  kind: "scalar",
  T: 5
  /* ScalarType.INT32 */
}, {
  no: 4,
  name: "region",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 5,
  name: "node_id",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 6,
  name: "debug_info",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 7,
  name: "agent_protocol",
  kind: "scalar",
  T: 5
  /* ScalarType.INT32 */
}]), Ca = /* @__PURE__ */ k.makeEnum("livekit.ServerInfo.Edition", [{
  no: 0,
  name: "Standard"
}, {
  no: 1,
  name: "Cloud"
}]), ld = /* @__PURE__ */ k.makeMessageType("livekit.ClientInfo", () => [{
  no: 1,
  name: "sdk",
  kind: "enum",
  T: k.getEnumType(Pa)
}, {
  no: 2,
  name: "version",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 3,
  name: "protocol",
  kind: "scalar",
  T: 5
  /* ScalarType.INT32 */
}, {
  no: 4,
  name: "os",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 5,
  name: "os_version",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 6,
  name: "device_model",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 7,
  name: "browser",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 8,
  name: "browser_version",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 9,
  name: "address",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 10,
  name: "network",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 11,
  name: "other_sdks",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}]), Pa = /* @__PURE__ */ k.makeEnum("livekit.ClientInfo.SDK", [{
  no: 0,
  name: "UNKNOWN"
}, {
  no: 1,
  name: "JS"
}, {
  no: 2,
  name: "SWIFT"
}, {
  no: 3,
  name: "ANDROID"
}, {
  no: 4,
  name: "FLUTTER"
}, {
  no: 5,
  name: "GO"
}, {
  no: 6,
  name: "UNITY"
}, {
  no: 7,
  name: "REACT_NATIVE"
}, {
  no: 8,
  name: "RUST"
}, {
  no: 9,
  name: "PYTHON"
}, {
  no: 10,
  name: "CPP"
}, {
  no: 11,
  name: "UNITY_WEB"
}, {
  no: 12,
  name: "NODE"
}, {
  no: 13,
  name: "UNREAL"
}, {
  no: 14,
  name: "ESP32"
}]), Ea = /* @__PURE__ */ k.makeMessageType("livekit.ClientConfiguration", () => [{
  no: 1,
  name: "video",
  kind: "message",
  T: $r
}, {
  no: 2,
  name: "screen",
  kind: "message",
  T: $r
}, {
  no: 3,
  name: "resume_connection",
  kind: "enum",
  T: k.getEnumType(ai)
}, {
  no: 4,
  name: "disabled_codecs",
  kind: "message",
  T: hd
}, {
  no: 5,
  name: "force_relay",
  kind: "enum",
  T: k.getEnumType(ai)
}]), $r = /* @__PURE__ */ k.makeMessageType("livekit.VideoConfiguration", () => [{
  no: 1,
  name: "hardware_encoder",
  kind: "enum",
  T: k.getEnumType(ai)
}]), hd = /* @__PURE__ */ k.makeMessageType("livekit.DisabledCodecs", () => [{
  no: 1,
  name: "codecs",
  kind: "message",
  T: Ai,
  repeated: !0
}, {
  no: 2,
  name: "publish",
  kind: "message",
  T: Ai,
  repeated: !0
}]), Ra = /* @__PURE__ */ k.makeMessageType("livekit.TimedVersion", () => [{
  no: 1,
  name: "unix_micro",
  kind: "scalar",
  T: 3
  /* ScalarType.INT64 */
}, {
  no: 2,
  name: "ticks",
  kind: "scalar",
  T: 5
  /* ScalarType.INT32 */
}]), Sn = /* @__PURE__ */ k.makeEnum("livekit.DataStream.OperationType", [{
  no: 0,
  name: "CREATE"
}, {
  no: 1,
  name: "UPDATE"
}, {
  no: 2,
  name: "DELETE"
}, {
  no: 3,
  name: "REACTION"
}]), wa = /* @__PURE__ */ k.makeMessageType("livekit.DataStream.TextHeader", () => [{
  no: 1,
  name: "operation_type",
  kind: "enum",
  T: k.getEnumType(Sn)
}, {
  no: 2,
  name: "version",
  kind: "scalar",
  T: 5
  /* ScalarType.INT32 */
}, {
  no: 3,
  name: "reply_to_stream_id",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 4,
  name: "attached_stream_ids",
  kind: "scalar",
  T: 9,
  repeated: !0
}, {
  no: 5,
  name: "generated",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}], {
  localName: "DataStream_TextHeader"
}), _a = /* @__PURE__ */ k.makeMessageType("livekit.DataStream.ByteHeader", () => [{
  no: 1,
  name: "name",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}], {
  localName: "DataStream_ByteHeader"
}), Cn = /* @__PURE__ */ k.makeMessageType("livekit.DataStream.Header", () => [{
  no: 1,
  name: "stream_id",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "timestamp",
  kind: "scalar",
  T: 3
  /* ScalarType.INT64 */
}, {
  no: 3,
  name: "topic",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 4,
  name: "mime_type",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 5,
  name: "total_length",
  kind: "scalar",
  T: 4,
  opt: !0
}, {
  no: 7,
  name: "encryption_type",
  kind: "enum",
  T: k.getEnumType(Pe)
}, {
  no: 8,
  name: "attributes",
  kind: "map",
  K: 9,
  V: {
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
}, {
  no: 9,
  name: "text_header",
  kind: "message",
  T: wa,
  oneof: "content_header"
}, {
  no: 10,
  name: "byte_header",
  kind: "message",
  T: _a,
  oneof: "content_header"
}], {
  localName: "DataStream_Header"
}), Pn = /* @__PURE__ */ k.makeMessageType("livekit.DataStream.Chunk", () => [{
  no: 1,
  name: "stream_id",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "chunk_index",
  kind: "scalar",
  T: 4
  /* ScalarType.UINT64 */
}, {
  no: 3,
  name: "content",
  kind: "scalar",
  T: 12
  /* ScalarType.BYTES */
}, {
  no: 4,
  name: "version",
  kind: "scalar",
  T: 5
  /* ScalarType.INT32 */
}, {
  no: 5,
  name: "iv",
  kind: "scalar",
  T: 12,
  opt: !0
}], {
  localName: "DataStream_Chunk"
}), En = /* @__PURE__ */ k.makeMessageType("livekit.DataStream.Trailer", () => [{
  no: 1,
  name: "stream_id",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "reason",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 3,
  name: "attributes",
  kind: "map",
  K: 9,
  V: {
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
}], {
  localName: "DataStream_Trailer"
}), Ae = /* @__PURE__ */ k.makeEnum("livekit.SignalTarget", [{
  no: 0,
  name: "PUBLISHER"
}, {
  no: 1,
  name: "SUBSCRIBER"
}]), Rn = /* @__PURE__ */ k.makeEnum("livekit.StreamState", [{
  no: 0,
  name: "ACTIVE"
}, {
  no: 1,
  name: "PAUSED"
}]), fd = /* @__PURE__ */ k.makeEnum("livekit.CandidateProtocol", [{
  no: 0,
  name: "UDP"
}, {
  no: 1,
  name: "TCP"
}, {
  no: 2,
  name: "TLS"
}]), pd = /* @__PURE__ */ k.makeMessageType("livekit.SignalRequest", () => [{
  no: 1,
  name: "offer",
  kind: "message",
  T: St,
  oneof: "message"
}, {
  no: 2,
  name: "answer",
  kind: "message",
  T: St,
  oneof: "message"
}, {
  no: 3,
  name: "trickle",
  kind: "message",
  T: or,
  oneof: "message"
}, {
  no: 4,
  name: "add_track",
  kind: "message",
  T: _n,
  oneof: "message"
}, {
  no: 5,
  name: "mute",
  kind: "message",
  T: cr,
  oneof: "message"
}, {
  no: 6,
  name: "subscription",
  kind: "message",
  T: Gi,
  oneof: "message"
}, {
  no: 7,
  name: "track_setting",
  kind: "message",
  T: Ia,
  oneof: "message"
}, {
  no: 8,
  name: "leave",
  kind: "message",
  T: Ki,
  oneof: "message"
}, {
  no: 10,
  name: "update_layers",
  kind: "message",
  T: xa,
  oneof: "message"
}, {
  no: 11,
  name: "subscription_permission",
  kind: "message",
  T: La,
  oneof: "message"
}, {
  no: 12,
  name: "sync_state",
  kind: "message",
  T: Na,
  oneof: "message"
}, {
  no: 13,
  name: "simulate",
  kind: "message",
  T: Be,
  oneof: "message"
}, {
  no: 14,
  name: "ping",
  kind: "scalar",
  T: 3,
  oneof: "message"
}, {
  no: 15,
  name: "update_metadata",
  kind: "message",
  T: Ma,
  oneof: "message"
}, {
  no: 16,
  name: "ping_req",
  kind: "message",
  T: ja,
  oneof: "message"
}, {
  no: 17,
  name: "update_audio_track",
  kind: "message",
  T: Oa,
  oneof: "message"
}, {
  no: 18,
  name: "update_video_track",
  kind: "message",
  T: yd,
  oneof: "message"
}]), Zr = /* @__PURE__ */ k.makeMessageType("livekit.SignalResponse", () => [{
  no: 1,
  name: "join",
  kind: "message",
  T: md,
  oneof: "message"
}, {
  no: 2,
  name: "answer",
  kind: "message",
  T: St,
  oneof: "message"
}, {
  no: 3,
  name: "offer",
  kind: "message",
  T: St,
  oneof: "message"
}, {
  no: 4,
  name: "trickle",
  kind: "message",
  T: or,
  oneof: "message"
}, {
  no: 5,
  name: "update",
  kind: "message",
  T: bd,
  oneof: "message"
}, {
  no: 6,
  name: "track_published",
  kind: "message",
  T: dr,
  oneof: "message"
}, {
  no: 8,
  name: "leave",
  kind: "message",
  T: Ki,
  oneof: "message"
}, {
  no: 9,
  name: "mute",
  kind: "message",
  T: cr,
  oneof: "message"
}, {
  no: 10,
  name: "speakers_changed",
  kind: "message",
  T: kd,
  oneof: "message"
}, {
  no: 11,
  name: "room_update",
  kind: "message",
  T: Td,
  oneof: "message"
}, {
  no: 12,
  name: "connection_quality",
  kind: "message",
  T: Cd,
  oneof: "message"
}, {
  no: 13,
  name: "stream_state_update",
  kind: "message",
  T: Ed,
  oneof: "message"
}, {
  no: 14,
  name: "subscribed_quality_update",
  kind: "message",
  T: wd,
  oneof: "message"
}, {
  no: 15,
  name: "subscription_permission_update",
  kind: "message",
  T: _d,
  oneof: "message"
}, {
  no: 16,
  name: "refresh_token",
  kind: "scalar",
  T: 9,
  oneof: "message"
}, {
  no: 17,
  name: "track_unpublished",
  kind: "message",
  T: vd,
  oneof: "message"
}, {
  no: 18,
  name: "pong",
  kind: "scalar",
  T: 3,
  oneof: "message"
}, {
  no: 19,
  name: "reconnect",
  kind: "message",
  T: gd,
  oneof: "message"
}, {
  no: 20,
  name: "pong_resp",
  kind: "message",
  T: Od,
  oneof: "message"
}, {
  no: 21,
  name: "subscription_response",
  kind: "message",
  T: Dd,
  oneof: "message"
}, {
  no: 22,
  name: "request_response",
  kind: "message",
  T: Ad,
  oneof: "message"
}, {
  no: 23,
  name: "track_subscribed",
  kind: "message",
  T: Ld,
  oneof: "message"
}, {
  no: 24,
  name: "room_moved",
  kind: "message",
  T: Id,
  oneof: "message"
}]), wn = /* @__PURE__ */ k.makeMessageType("livekit.SimulcastCodec", () => [{
  no: 1,
  name: "codec",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "cid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}]), _n = /* @__PURE__ */ k.makeMessageType("livekit.AddTrackRequest", () => [{
  no: 1,
  name: "cid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "name",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 3,
  name: "type",
  kind: "enum",
  T: k.getEnumType(De)
}, {
  no: 4,
  name: "width",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 5,
  name: "height",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 6,
  name: "muted",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 7,
  name: "disable_dtx",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 8,
  name: "source",
  kind: "enum",
  T: k.getEnumType(ae)
}, {
  no: 9,
  name: "layers",
  kind: "message",
  T: yt,
  repeated: !0
}, {
  no: 10,
  name: "simulcast_codecs",
  kind: "message",
  T: wn,
  repeated: !0
}, {
  no: 11,
  name: "sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 12,
  name: "stereo",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 13,
  name: "disable_red",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 14,
  name: "encryption",
  kind: "enum",
  T: k.getEnumType(Pe)
}, {
  no: 15,
  name: "stream",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 16,
  name: "backup_codec_policy",
  kind: "enum",
  T: k.getEnumType(fa)
}, {
  no: 17,
  name: "audio_features",
  kind: "enum",
  T: k.getEnumType(le),
  repeated: !0
}]), or = /* @__PURE__ */ k.makeMessageType("livekit.TrickleRequest", () => [{
  no: 1,
  name: "candidateInit",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "target",
  kind: "enum",
  T: k.getEnumType(Ae)
}, {
  no: 3,
  name: "final",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}]), cr = /* @__PURE__ */ k.makeMessageType("livekit.MuteTrackRequest", () => [{
  no: 1,
  name: "sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "muted",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}]), md = /* @__PURE__ */ k.makeMessageType("livekit.JoinResponse", () => [{
  no: 1,
  name: "room",
  kind: "message",
  T: Wi
}, {
  no: 2,
  name: "participant",
  kind: "message",
  T: Tt
}, {
  no: 3,
  name: "other_participants",
  kind: "message",
  T: Tt,
  repeated: !0
}, {
  no: 4,
  name: "server_version",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 5,
  name: "ice_servers",
  kind: "message",
  T: Da,
  repeated: !0
}, {
  no: 6,
  name: "subscriber_primary",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 7,
  name: "alternative_url",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 8,
  name: "client_configuration",
  kind: "message",
  T: Ea
}, {
  no: 9,
  name: "server_region",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 10,
  name: "ping_timeout",
  kind: "scalar",
  T: 5
  /* ScalarType.INT32 */
}, {
  no: 11,
  name: "ping_interval",
  kind: "scalar",
  T: 5
  /* ScalarType.INT32 */
}, {
  no: 12,
  name: "server_info",
  kind: "message",
  T: Sa
}, {
  no: 13,
  name: "sif_trailer",
  kind: "scalar",
  T: 12
  /* ScalarType.BYTES */
}, {
  no: 14,
  name: "enabled_publish_codecs",
  kind: "message",
  T: Ai,
  repeated: !0
}, {
  no: 15,
  name: "fast_publish",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}]), gd = /* @__PURE__ */ k.makeMessageType("livekit.ReconnectResponse", () => [{
  no: 1,
  name: "ice_servers",
  kind: "message",
  T: Da,
  repeated: !0
}, {
  no: 2,
  name: "client_configuration",
  kind: "message",
  T: Ea
}, {
  no: 3,
  name: "server_info",
  kind: "message",
  T: Sa
}, {
  no: 4,
  name: "last_message_seq",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}]), dr = /* @__PURE__ */ k.makeMessageType("livekit.TrackPublishedResponse", () => [{
  no: 1,
  name: "cid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "track",
  kind: "message",
  T: It
}]), vd = /* @__PURE__ */ k.makeMessageType("livekit.TrackUnpublishedResponse", () => [{
  no: 1,
  name: "track_sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}]), St = /* @__PURE__ */ k.makeMessageType("livekit.SessionDescription", () => [{
  no: 1,
  name: "type",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "sdp",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 3,
  name: "id",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}]), bd = /* @__PURE__ */ k.makeMessageType("livekit.ParticipantUpdate", () => [{
  no: 1,
  name: "participants",
  kind: "message",
  T: Tt,
  repeated: !0
}]), Gi = /* @__PURE__ */ k.makeMessageType("livekit.UpdateSubscription", () => [{
  no: 1,
  name: "track_sids",
  kind: "scalar",
  T: 9,
  repeated: !0
}, {
  no: 2,
  name: "subscribe",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 3,
  name: "participant_tracks",
  kind: "message",
  T: Ta,
  repeated: !0
}]), Ia = /* @__PURE__ */ k.makeMessageType("livekit.UpdateTrackSettings", () => [{
  no: 1,
  name: "track_sids",
  kind: "scalar",
  T: 9,
  repeated: !0
}, {
  no: 3,
  name: "disabled",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 4,
  name: "quality",
  kind: "enum",
  T: k.getEnumType(ar)
}, {
  no: 5,
  name: "width",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 6,
  name: "height",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 7,
  name: "fps",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 8,
  name: "priority",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}]), Oa = /* @__PURE__ */ k.makeMessageType("livekit.UpdateLocalAudioTrack", () => [{
  no: 1,
  name: "track_sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "features",
  kind: "enum",
  T: k.getEnumType(le),
  repeated: !0
}]), yd = /* @__PURE__ */ k.makeMessageType("livekit.UpdateLocalVideoTrack", () => [{
  no: 1,
  name: "track_sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "width",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 3,
  name: "height",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}]), Ki = /* @__PURE__ */ k.makeMessageType("livekit.LeaveRequest", () => [{
  no: 1,
  name: "can_reconnect",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 2,
  name: "reason",
  kind: "enum",
  T: k.getEnumType(Le)
}, {
  no: 3,
  name: "action",
  kind: "enum",
  T: k.getEnumType(Dt)
}, {
  no: 4,
  name: "regions",
  kind: "message",
  T: xd
}]), Dt = /* @__PURE__ */ k.makeEnum("livekit.LeaveRequest.Action", [{
  no: 0,
  name: "DISCONNECT"
}, {
  no: 1,
  name: "RESUME"
}, {
  no: 2,
  name: "RECONNECT"
}]), xa = /* @__PURE__ */ k.makeMessageType("livekit.UpdateVideoLayers", () => [{
  no: 1,
  name: "track_sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "layers",
  kind: "message",
  T: yt,
  repeated: !0
}]), Ma = /* @__PURE__ */ k.makeMessageType("livekit.UpdateParticipantMetadata", () => [{
  no: 1,
  name: "metadata",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "name",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 3,
  name: "attributes",
  kind: "map",
  K: 9,
  V: {
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
}, {
  no: 4,
  name: "request_id",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}]), Da = /* @__PURE__ */ k.makeMessageType("livekit.ICEServer", () => [{
  no: 1,
  name: "urls",
  kind: "scalar",
  T: 9,
  repeated: !0
}, {
  no: 2,
  name: "username",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 3,
  name: "credential",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}]), kd = /* @__PURE__ */ k.makeMessageType("livekit.SpeakersChanged", () => [{
  no: 1,
  name: "speakers",
  kind: "message",
  T: pa,
  repeated: !0
}]), Td = /* @__PURE__ */ k.makeMessageType("livekit.RoomUpdate", () => [{
  no: 1,
  name: "room",
  kind: "message",
  T: Wi
}]), Sd = /* @__PURE__ */ k.makeMessageType("livekit.ConnectionQualityInfo", () => [{
  no: 1,
  name: "participant_sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "quality",
  kind: "enum",
  T: k.getEnumType(ti)
}, {
  no: 3,
  name: "score",
  kind: "scalar",
  T: 2
  /* ScalarType.FLOAT */
}]), Cd = /* @__PURE__ */ k.makeMessageType("livekit.ConnectionQualityUpdate", () => [{
  no: 1,
  name: "updates",
  kind: "message",
  T: Sd,
  repeated: !0
}]), Pd = /* @__PURE__ */ k.makeMessageType("livekit.StreamStateInfo", () => [{
  no: 1,
  name: "participant_sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "track_sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 3,
  name: "state",
  kind: "enum",
  T: k.getEnumType(Rn)
}]), Ed = /* @__PURE__ */ k.makeMessageType("livekit.StreamStateUpdate", () => [{
  no: 1,
  name: "stream_states",
  kind: "message",
  T: Pd,
  repeated: !0
}]), ur = /* @__PURE__ */ k.makeMessageType("livekit.SubscribedQuality", () => [{
  no: 1,
  name: "quality",
  kind: "enum",
  T: k.getEnumType(ar)
}, {
  no: 2,
  name: "enabled",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}]), Rd = /* @__PURE__ */ k.makeMessageType("livekit.SubscribedCodec", () => [{
  no: 1,
  name: "codec",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "qualities",
  kind: "message",
  T: ur,
  repeated: !0
}]), wd = /* @__PURE__ */ k.makeMessageType("livekit.SubscribedQualityUpdate", () => [{
  no: 1,
  name: "track_sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "subscribed_qualities",
  kind: "message",
  T: ur,
  repeated: !0
}, {
  no: 3,
  name: "subscribed_codecs",
  kind: "message",
  T: Rd,
  repeated: !0
}]), Aa = /* @__PURE__ */ k.makeMessageType("livekit.TrackPermission", () => [{
  no: 1,
  name: "participant_sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "all_tracks",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 3,
  name: "track_sids",
  kind: "scalar",
  T: 9,
  repeated: !0
}, {
  no: 4,
  name: "participant_identity",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}]), La = /* @__PURE__ */ k.makeMessageType("livekit.SubscriptionPermission", () => [{
  no: 1,
  name: "all_participants",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}, {
  no: 2,
  name: "track_permissions",
  kind: "message",
  T: Aa,
  repeated: !0
}]), _d = /* @__PURE__ */ k.makeMessageType("livekit.SubscriptionPermissionUpdate", () => [{
  no: 1,
  name: "participant_sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "track_sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 3,
  name: "allowed",
  kind: "scalar",
  T: 8
  /* ScalarType.BOOL */
}]), Id = /* @__PURE__ */ k.makeMessageType("livekit.RoomMovedResponse", () => [{
  no: 1,
  name: "room",
  kind: "message",
  T: Wi
}, {
  no: 2,
  name: "token",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 3,
  name: "participant",
  kind: "message",
  T: Tt
}, {
  no: 4,
  name: "other_participants",
  kind: "message",
  T: Tt,
  repeated: !0
}]), Na = /* @__PURE__ */ k.makeMessageType("livekit.SyncState", () => [{
  no: 1,
  name: "answer",
  kind: "message",
  T: St
}, {
  no: 2,
  name: "subscription",
  kind: "message",
  T: Gi
}, {
  no: 3,
  name: "publish_tracks",
  kind: "message",
  T: dr,
  repeated: !0
}, {
  no: 4,
  name: "data_channels",
  kind: "message",
  T: Fa,
  repeated: !0
}, {
  no: 5,
  name: "offer",
  kind: "message",
  T: St
}, {
  no: 6,
  name: "track_sids_disabled",
  kind: "scalar",
  T: 9,
  repeated: !0
}, {
  no: 7,
  name: "datachannel_receive_states",
  kind: "message",
  T: Ua,
  repeated: !0
}]), Ua = /* @__PURE__ */ k.makeMessageType("livekit.DataChannelReceiveState", () => [{
  no: 1,
  name: "publisher_sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "last_seq",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}]), Fa = /* @__PURE__ */ k.makeMessageType("livekit.DataChannelInfo", () => [{
  no: 1,
  name: "label",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "id",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 3,
  name: "target",
  kind: "enum",
  T: k.getEnumType(Ae)
}]), Be = /* @__PURE__ */ k.makeMessageType("livekit.SimulateScenario", () => [{
  no: 1,
  name: "speaker_update",
  kind: "scalar",
  T: 5,
  oneof: "scenario"
}, {
  no: 2,
  name: "node_failure",
  kind: "scalar",
  T: 8,
  oneof: "scenario"
}, {
  no: 3,
  name: "migration",
  kind: "scalar",
  T: 8,
  oneof: "scenario"
}, {
  no: 4,
  name: "server_leave",
  kind: "scalar",
  T: 8,
  oneof: "scenario"
}, {
  no: 5,
  name: "switch_candidate_protocol",
  kind: "enum",
  T: k.getEnumType(fd),
  oneof: "scenario"
}, {
  no: 6,
  name: "subscriber_bandwidth",
  kind: "scalar",
  T: 3,
  oneof: "scenario"
}, {
  no: 7,
  name: "disconnect_signal_on_resume",
  kind: "scalar",
  T: 8,
  oneof: "scenario"
}, {
  no: 8,
  name: "disconnect_signal_on_resume_no_messages",
  kind: "scalar",
  T: 8,
  oneof: "scenario"
}, {
  no: 9,
  name: "leave_request_full_reconnect",
  kind: "scalar",
  T: 8,
  oneof: "scenario"
}]), ja = /* @__PURE__ */ k.makeMessageType("livekit.Ping", () => [{
  no: 1,
  name: "timestamp",
  kind: "scalar",
  T: 3
  /* ScalarType.INT64 */
}, {
  no: 2,
  name: "rtt",
  kind: "scalar",
  T: 3
  /* ScalarType.INT64 */
}]), Od = /* @__PURE__ */ k.makeMessageType("livekit.Pong", () => [{
  no: 1,
  name: "last_ping_timestamp",
  kind: "scalar",
  T: 3
  /* ScalarType.INT64 */
}, {
  no: 2,
  name: "timestamp",
  kind: "scalar",
  T: 3
  /* ScalarType.INT64 */
}]), xd = /* @__PURE__ */ k.makeMessageType("livekit.RegionSettings", () => [{
  no: 1,
  name: "regions",
  kind: "message",
  T: Md,
  repeated: !0
}]), Md = /* @__PURE__ */ k.makeMessageType("livekit.RegionInfo", () => [{
  no: 1,
  name: "region",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "url",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 3,
  name: "distance",
  kind: "scalar",
  T: 3
  /* ScalarType.INT64 */
}]), Dd = /* @__PURE__ */ k.makeMessageType("livekit.SubscriptionResponse", () => [{
  no: 1,
  name: "track_sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}, {
  no: 2,
  name: "err",
  kind: "enum",
  T: k.getEnumType(rd)
}]), Ad = /* @__PURE__ */ k.makeMessageType("livekit.RequestResponse", () => [{
  no: 1,
  name: "request_id",
  kind: "scalar",
  T: 13
  /* ScalarType.UINT32 */
}, {
  no: 2,
  name: "reason",
  kind: "enum",
  T: k.getEnumType(lr)
}, {
  no: 3,
  name: "message",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}]), lr = /* @__PURE__ */ k.makeEnum("livekit.RequestResponse.Reason", [{
  no: 0,
  name: "OK"
}, {
  no: 1,
  name: "NOT_FOUND"
}, {
  no: 2,
  name: "NOT_ALLOWED"
}, {
  no: 3,
  name: "LIMIT_EXCEEDED"
}]), Ld = /* @__PURE__ */ k.makeMessageType("livekit.TrackSubscribed", () => [{
  no: 1,
  name: "track_sid",
  kind: "scalar",
  T: 9
  /* ScalarType.STRING */
}]);
function Nd(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
var Ti = { exports: {} }, Ud = Ti.exports, es;
function Fd() {
  return es || (es = 1, function(i) {
    (function(e, t) {
      i.exports ? i.exports = t() : e.log = t();
    })(Ud, function() {
      var e = function() {
      }, t = "undefined", n = typeof window !== t && typeof window.navigator !== t && /Trident\/|MSIE /.test(window.navigator.userAgent), r = ["trace", "debug", "info", "warn", "error"], s = {}, a = null;
      function o(f, T) {
        var g = f[T];
        if (typeof g.bind == "function")
          return g.bind(f);
        try {
          return Function.prototype.bind.call(g, f);
        } catch (O) {
          return function() {
            return Function.prototype.apply.apply(g, [f, arguments]);
          };
        }
      }
      function c() {
        console.log && (console.log.apply || Function.prototype.apply.apply(console.log, [console, arguments]));
      }
      function d(f) {
        return f === "debug" && (f = "log"), typeof console === t ? !1 : f === "trace" && n ? c : console[f] !== void 0 ? o(console, f) : console.log !== void 0 ? o(console, "log") : e;
      }
      function u() {
        for (var f = this.getLevel(), T = 0; T < r.length; T++) {
          var g = r[T];
          this[g] = T < f ? e : this.methodFactory(g, f, this.name);
        }
        if (this.log = this.debug, typeof console === t && f < this.levels.SILENT)
          return "No console available for logging";
      }
      function l(f) {
        return function() {
          typeof console !== t && (u.call(this), this[f].apply(this, arguments));
        };
      }
      function h(f, T, g) {
        return d(f) || l.apply(this, arguments);
      }
      function p(f, T) {
        var g = this, O, w, b, y = "loglevel";
        typeof f == "string" ? y += ":" + f : typeof f == "symbol" && (y = void 0);
        function P(_) {
          var U = (r[_] || "silent").toUpperCase();
          if (!(typeof window === t || !y)) {
            try {
              window.localStorage[y] = U;
              return;
            } catch (V) {
            }
            try {
              window.document.cookie = encodeURIComponent(y) + "=" + U + ";";
            } catch (V) {
            }
          }
        }
        function D() {
          var _;
          if (!(typeof window === t || !y)) {
            try {
              _ = window.localStorage[y];
            } catch (N) {
            }
            if (typeof _ === t)
              try {
                var U = window.document.cookie, V = encodeURIComponent(y), oe = U.indexOf(V + "=");
                oe !== -1 && (_ = /^([^;]+)/.exec(U.slice(oe + V.length + 1))[1]);
              } catch (N) {
              }
            return g.levels[_] === void 0 && (_ = void 0), _;
          }
        }
        function A() {
          if (!(typeof window === t || !y)) {
            try {
              window.localStorage.removeItem(y);
            } catch (_) {
            }
            try {
              window.document.cookie = encodeURIComponent(y) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch (_) {
            }
          }
        }
        function x(_) {
          var U = _;
          if (typeof U == "string" && g.levels[U.toUpperCase()] !== void 0 && (U = g.levels[U.toUpperCase()]), typeof U == "number" && U >= 0 && U <= g.levels.SILENT)
            return U;
          throw new TypeError("log.setLevel() called with invalid level: " + _);
        }
        g.name = f, g.levels = {
          TRACE: 0,
          DEBUG: 1,
          INFO: 2,
          WARN: 3,
          ERROR: 4,
          SILENT: 5
        }, g.methodFactory = T || h, g.getLevel = function() {
          return b != null ? b : w != null ? w : O;
        }, g.setLevel = function(_, U) {
          return b = x(_), U !== !1 && P(b), u.call(g);
        }, g.setDefaultLevel = function(_) {
          w = x(_), D() || g.setLevel(_, !1);
        }, g.resetLevel = function() {
          b = null, A(), u.call(g);
        }, g.enableAll = function(_) {
          g.setLevel(g.levels.TRACE, _);
        }, g.disableAll = function(_) {
          g.setLevel(g.levels.SILENT, _);
        }, g.rebuild = function() {
          if (a !== g && (O = x(a.getLevel())), u.call(g), a === g)
            for (var _ in s)
              s[_].rebuild();
        }, O = x(a ? a.getLevel() : "WARN");
        var L = D();
        L != null && (b = x(L)), u.call(g);
      }
      a = new p(), a.getLogger = function(T) {
        if (typeof T != "symbol" && typeof T != "string" || T === "")
          throw new TypeError("You must supply a name when creating a logger.");
        var g = s[T];
        return g || (g = s[T] = new p(T, a.methodFactory)), g;
      };
      var v = typeof window !== t ? window.log : void 0;
      return a.noConflict = function() {
        return typeof window !== t && window.log === a && (window.log = v), a;
      }, a.getLoggers = function() {
        return s;
      }, a.default = a, a;
    });
  }(Ti)), Ti.exports;
}
var Hi = Fd(), In;
(function(i) {
  i[i.trace = 0] = "trace", i[i.debug = 1] = "debug", i[i.info = 2] = "info", i[i.warn = 3] = "warn", i[i.error = 4] = "error", i[i.silent = 5] = "silent";
})(In || (In = {}));
var Ne;
(function(i) {
  i.Default = "livekit", i.Room = "livekit-room", i.Participant = "livekit-participant", i.Track = "livekit-track", i.Publication = "livekit-track-publication", i.Engine = "livekit-engine", i.Signal = "livekit-signal", i.PCManager = "livekit-pc-manager", i.PCTransport = "livekit-pc-transport", i.E2EE = "lk-e2ee";
})(Ne || (Ne = {}));
let G = Hi.getLogger("livekit");
Object.values(Ne).map((i) => Hi.getLogger(i));
G.setDefaultLevel(In.info);
function it(i) {
  const e = Hi.getLogger(i);
  return e.setDefaultLevel(G.getLevel()), e;
}
const jd = Hi.getLogger("lk-e2ee"), Yt = 7e3, Bd = [0, 300, 2 * 2 * 300, 3 * 3 * 300, 4 * 4 * 300, Yt, Yt, Yt, Yt, Yt];
class Vd {
  constructor(e) {
    this._retryDelays = e !== void 0 ? [...e] : Bd;
  }
  nextRetryDelayInMs(e) {
    if (e.retryCount >= this._retryDelays.length) return null;
    const t = this._retryDelays[e.retryCount];
    return e.retryCount <= 1 ? t : t + Math.random() * 1e3;
  }
}
function qd(i, e) {
  var t = {};
  for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && e.indexOf(n) < 0 && (t[n] = i[n]);
  if (i != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, n = Object.getOwnPropertySymbols(i); r < n.length; r++)
      e.indexOf(n[r]) < 0 && Object.prototype.propertyIsEnumerable.call(i, n[r]) && (t[n[r]] = i[n[r]]);
  return t;
}
function m(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(a) {
      a(s);
    });
  }
  return new (t || (t = Promise))(function(s, a) {
    function o(u) {
      try {
        d(n.next(u));
      } catch (l) {
        a(l);
      }
    }
    function c(u) {
      try {
        d(n.throw(u));
      } catch (l) {
        a(l);
      }
    }
    function d(u) {
      u.done ? s(u.value) : r(u.value).then(o, c);
    }
    d((n = n.apply(i, e || [])).next());
  });
}
function ts(i) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && i[e], n = 0;
  if (t) return t.call(i);
  if (i && typeof i.length == "number") return {
    next: function() {
      return i && n >= i.length && (i = void 0), { value: i && i[n++], done: !i };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function et(i) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = i[Symbol.asyncIterator], t;
  return e ? e.call(i) : (i = typeof ts == "function" ? ts(i) : i[Symbol.iterator](), t = {}, n("next"), n("throw"), n("return"), t[Symbol.asyncIterator] = function() {
    return this;
  }, t);
  function n(s) {
    t[s] = i[s] && function(a) {
      return new Promise(function(o, c) {
        a = i[s](a), r(o, c, a.done, a.value);
      });
    };
  }
  function r(s, a, o, c) {
    Promise.resolve(c).then(function(d) {
      s({ value: d, done: o });
    }, a);
  }
}
var pi = { exports: {} }, is;
function Wd() {
  if (is) return pi.exports;
  is = 1;
  var i = typeof Reflect == "object" ? Reflect : null, e = i && typeof i.apply == "function" ? i.apply : function(y, P, D) {
    return Function.prototype.apply.call(y, P, D);
  }, t;
  i && typeof i.ownKeys == "function" ? t = i.ownKeys : Object.getOwnPropertySymbols ? t = function(y) {
    return Object.getOwnPropertyNames(y).concat(Object.getOwnPropertySymbols(y));
  } : t = function(y) {
    return Object.getOwnPropertyNames(y);
  };
  function n(b) {
  }
  var r = Number.isNaN || function(y) {
    return y !== y;
  };
  function s() {
    s.init.call(this);
  }
  pi.exports = s, pi.exports.once = g, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
  var a = 10;
  function o(b) {
    if (typeof b != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof b);
  }
  Object.defineProperty(s, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return a;
    },
    set: function(b) {
      if (typeof b != "number" || b < 0 || r(b))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + b + ".");
      a = b;
    }
  }), s.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, s.prototype.setMaxListeners = function(y) {
    if (typeof y != "number" || y < 0 || r(y))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + y + ".");
    return this._maxListeners = y, this;
  };
  function c(b) {
    return b._maxListeners === void 0 ? s.defaultMaxListeners : b._maxListeners;
  }
  s.prototype.getMaxListeners = function() {
    return c(this);
  }, s.prototype.emit = function(y) {
    for (var P = [], D = 1; D < arguments.length; D++) P.push(arguments[D]);
    var A = y === "error", x = this._events;
    if (x !== void 0) A = A && x.error === void 0;
    else if (!A) return !1;
    if (A) {
      var L;
      if (P.length > 0 && (L = P[0]), L instanceof Error)
        throw L;
      var _ = new Error("Unhandled error." + (L ? " (" + L.message + ")" : ""));
      throw _.context = L, _;
    }
    var U = x[y];
    if (U === void 0) return !1;
    if (typeof U == "function")
      e(U, this, P);
    else
      for (var V = U.length, oe = v(U, V), D = 0; D < V; ++D) e(oe[D], this, P);
    return !0;
  };
  function d(b, y, P, D) {
    var A, x, L;
    if (o(P), x = b._events, x === void 0 ? (x = b._events = /* @__PURE__ */ Object.create(null), b._eventsCount = 0) : (x.newListener !== void 0 && (b.emit("newListener", y, P.listener ? P.listener : P), x = b._events), L = x[y]), L === void 0)
      L = x[y] = P, ++b._eventsCount;
    else if (typeof L == "function" ? L = x[y] = D ? [P, L] : [L, P] : D ? L.unshift(P) : L.push(P), A = c(b), A > 0 && L.length > A && !L.warned) {
      L.warned = !0;
      var _ = new Error("Possible EventEmitter memory leak detected. " + L.length + " " + String(y) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      _.name = "MaxListenersExceededWarning", _.emitter = b, _.type = y, _.count = L.length;
    }
    return b;
  }
  s.prototype.addListener = function(y, P) {
    return d(this, y, P, !1);
  }, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function(y, P) {
    return d(this, y, P, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function l(b, y, P) {
    var D = {
      fired: !1,
      wrapFn: void 0,
      target: b,
      type: y,
      listener: P
    }, A = u.bind(D);
    return A.listener = P, D.wrapFn = A, A;
  }
  s.prototype.once = function(y, P) {
    return o(P), this.on(y, l(this, y, P)), this;
  }, s.prototype.prependOnceListener = function(y, P) {
    return o(P), this.prependListener(y, l(this, y, P)), this;
  }, s.prototype.removeListener = function(y, P) {
    var D, A, x, L, _;
    if (o(P), A = this._events, A === void 0) return this;
    if (D = A[y], D === void 0) return this;
    if (D === P || D.listener === P)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete A[y], A.removeListener && this.emit("removeListener", y, D.listener || P));
    else if (typeof D != "function") {
      for (x = -1, L = D.length - 1; L >= 0; L--)
        if (D[L] === P || D[L].listener === P) {
          _ = D[L].listener, x = L;
          break;
        }
      if (x < 0) return this;
      x === 0 ? D.shift() : f(D, x), D.length === 1 && (A[y] = D[0]), A.removeListener !== void 0 && this.emit("removeListener", y, _ || P);
    }
    return this;
  }, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function(y) {
    var P, D, A;
    if (D = this._events, D === void 0) return this;
    if (D.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : D[y] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete D[y]), this;
    if (arguments.length === 0) {
      var x = Object.keys(D), L;
      for (A = 0; A < x.length; ++A)
        L = x[A], L !== "removeListener" && this.removeAllListeners(L);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (P = D[y], typeof P == "function")
      this.removeListener(y, P);
    else if (P !== void 0)
      for (A = P.length - 1; A >= 0; A--)
        this.removeListener(y, P[A]);
    return this;
  };
  function h(b, y, P) {
    var D = b._events;
    if (D === void 0) return [];
    var A = D[y];
    return A === void 0 ? [] : typeof A == "function" ? P ? [A.listener || A] : [A] : P ? T(A) : v(A, A.length);
  }
  s.prototype.listeners = function(y) {
    return h(this, y, !0);
  }, s.prototype.rawListeners = function(y) {
    return h(this, y, !1);
  }, s.listenerCount = function(b, y) {
    return typeof b.listenerCount == "function" ? b.listenerCount(y) : p.call(b, y);
  }, s.prototype.listenerCount = p;
  function p(b) {
    var y = this._events;
    if (y !== void 0) {
      var P = y[b];
      if (typeof P == "function")
        return 1;
      if (P !== void 0)
        return P.length;
    }
    return 0;
  }
  s.prototype.eventNames = function() {
    return this._eventsCount > 0 ? t(this._events) : [];
  };
  function v(b, y) {
    for (var P = new Array(y), D = 0; D < y; ++D) P[D] = b[D];
    return P;
  }
  function f(b, y) {
    for (; y + 1 < b.length; y++) b[y] = b[y + 1];
    b.pop();
  }
  function T(b) {
    for (var y = new Array(b.length), P = 0; P < y.length; ++P)
      y[P] = b[P].listener || b[P];
    return y;
  }
  function g(b, y) {
    return new Promise(function(P, D) {
      function A(L) {
        b.removeListener(y, x), D(L);
      }
      function x() {
        typeof b.removeListener == "function" && b.removeListener("error", A), P([].slice.call(arguments));
      }
      w(b, y, x, {
        once: !0
      }), y !== "error" && O(b, A, {
        once: !0
      });
    });
  }
  function O(b, y, P) {
    typeof b.on == "function" && w(b, "error", y, P);
  }
  function w(b, y, P, D) {
    if (typeof b.on == "function")
      D.once ? b.once(y, P) : b.on(y, P);
    else if (typeof b.addEventListener == "function")
      b.addEventListener(y, function A(x) {
        D.once && b.removeEventListener(y, A), P(x);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof b);
  }
  return pi.exports;
}
var He = Wd();
let Ba = !0, Gd = !0;
function ii(i, e, t) {
  const n = i.match(e);
  return n && n.length >= t && parseFloat(n[t], 10);
}
function Pt(i, e, t) {
  if (!i.RTCPeerConnection)
    return;
  const n = i.RTCPeerConnection.prototype, r = n.addEventListener;
  n.addEventListener = function(a, o) {
    if (a !== e)
      return r.apply(this, arguments);
    const c = (d) => {
      const u = t(d);
      u && (o.handleEvent ? o.handleEvent(u) : o(u));
    };
    return this._eventMap = this._eventMap || {}, this._eventMap[e] || (this._eventMap[e] = /* @__PURE__ */ new Map()), this._eventMap[e].set(o, c), r.apply(this, [a, c]);
  };
  const s = n.removeEventListener;
  n.removeEventListener = function(a, o) {
    if (a !== e || !this._eventMap || !this._eventMap[e])
      return s.apply(this, arguments);
    if (!this._eventMap[e].has(o))
      return s.apply(this, arguments);
    const c = this._eventMap[e].get(o);
    return this._eventMap[e].delete(o), this._eventMap[e].size === 0 && delete this._eventMap[e], Object.keys(this._eventMap).length === 0 && delete this._eventMap, s.apply(this, [a, c]);
  }, Object.defineProperty(n, "on" + e, {
    get() {
      return this["_on" + e];
    },
    set(a) {
      this["_on" + e] && (this.removeEventListener(e, this["_on" + e]), delete this["_on" + e]), a && this.addEventListener(e, this["_on" + e] = a);
    },
    enumerable: !0,
    configurable: !0
  });
}
function Kd(i) {
  return typeof i != "boolean" ? new Error("Argument type: " + typeof i + ". Please use a boolean.") : (Ba = i, i ? "adapter.js logging disabled" : "adapter.js logging enabled");
}
function Hd(i) {
  return typeof i != "boolean" ? new Error("Argument type: " + typeof i + ". Please use a boolean.") : (Gd = !i, "adapter.js deprecation warnings " + (i ? "disabled" : "enabled"));
}
function Va() {
}
function zd(i) {
  const e = {
    browser: null,
    version: null
  };
  if (typeof i == "undefined" || !i.navigator || !i.navigator.userAgent)
    return e.browser = "Not a browser.", e;
  const {
    navigator: t
  } = i;
  if (t.userAgentData && t.userAgentData.brands) {
    const n = t.userAgentData.brands.find((r) => r.brand === "Chromium");
    if (n)
      return {
        browser: "chrome",
        version: parseInt(n.version, 10)
      };
  }
  if (t.mozGetUserMedia)
    e.browser = "firefox", e.version = parseInt(ii(t.userAgent, /Firefox\/(\d+)\./, 1));
  else if (t.webkitGetUserMedia || i.isSecureContext === !1 && i.webkitRTCPeerConnection)
    e.browser = "chrome", e.version = parseInt(ii(t.userAgent, /Chrom(e|ium)\/(\d+)\./, 2));
  else if (i.RTCPeerConnection && t.userAgent.match(/AppleWebKit\/(\d+)\./))
    e.browser = "safari", e.version = parseInt(ii(t.userAgent, /AppleWebKit\/(\d+)\./, 1)), e.supportsUnifiedPlan = i.RTCRtpTransceiver && "currentDirection" in i.RTCRtpTransceiver.prototype, e._safariVersion = ii(t.userAgent, /Version\/(\d+(\.?\d+))/, 1);
  else
    return e.browser = "Not a supported browser.", e;
  return e;
}
function ns(i) {
  return Object.prototype.toString.call(i) === "[object Object]";
}
function qa(i) {
  return ns(i) ? Object.keys(i).reduce(function(e, t) {
    const n = ns(i[t]), r = n ? qa(i[t]) : i[t], s = n && !Object.keys(r).length;
    return r === void 0 || s ? e : Object.assign(e, {
      [t]: r
    });
  }, {}) : i;
}
function On(i, e, t) {
  !e || t.has(e.id) || (t.set(e.id, e), Object.keys(e).forEach((n) => {
    n.endsWith("Id") ? On(i, i.get(e[n]), t) : n.endsWith("Ids") && e[n].forEach((r) => {
      On(i, i.get(r), t);
    });
  }));
}
function rs(i, e, t) {
  const n = t ? "outbound-rtp" : "inbound-rtp", r = /* @__PURE__ */ new Map();
  if (e === null)
    return r;
  const s = [];
  return i.forEach((a) => {
    a.type === "track" && a.trackIdentifier === e.id && s.push(a);
  }), s.forEach((a) => {
    i.forEach((o) => {
      o.type === n && o.trackId === a.id && On(i, o, r);
    });
  }), r;
}
const ss = Va;
function Wa(i, e) {
  const t = i && i.navigator;
  if (!t.mediaDevices)
    return;
  const n = function(o) {
    if (typeof o != "object" || o.mandatory || o.optional)
      return o;
    const c = {};
    return Object.keys(o).forEach((d) => {
      if (d === "require" || d === "advanced" || d === "mediaSource")
        return;
      const u = typeof o[d] == "object" ? o[d] : {
        ideal: o[d]
      };
      u.exact !== void 0 && typeof u.exact == "number" && (u.min = u.max = u.exact);
      const l = function(h, p) {
        return h ? h + p.charAt(0).toUpperCase() + p.slice(1) : p === "deviceId" ? "sourceId" : p;
      };
      if (u.ideal !== void 0) {
        c.optional = c.optional || [];
        let h = {};
        typeof u.ideal == "number" ? (h[l("min", d)] = u.ideal, c.optional.push(h), h = {}, h[l("max", d)] = u.ideal, c.optional.push(h)) : (h[l("", d)] = u.ideal, c.optional.push(h));
      }
      u.exact !== void 0 && typeof u.exact != "number" ? (c.mandatory = c.mandatory || {}, c.mandatory[l("", d)] = u.exact) : ["min", "max"].forEach((h) => {
        u[h] !== void 0 && (c.mandatory = c.mandatory || {}, c.mandatory[l(h, d)] = u[h]);
      });
    }), o.advanced && (c.optional = (c.optional || []).concat(o.advanced)), c;
  }, r = function(o, c) {
    if (e.version >= 61)
      return c(o);
    if (o = JSON.parse(JSON.stringify(o)), o && typeof o.audio == "object") {
      const d = function(u, l, h) {
        l in u && !(h in u) && (u[h] = u[l], delete u[l]);
      };
      o = JSON.parse(JSON.stringify(o)), d(o.audio, "autoGainControl", "googAutoGainControl"), d(o.audio, "noiseSuppression", "googNoiseSuppression"), o.audio = n(o.audio);
    }
    if (o && typeof o.video == "object") {
      let d = o.video.facingMode;
      d = d && (typeof d == "object" ? d : {
        ideal: d
      });
      const u = e.version < 66;
      if (d && (d.exact === "user" || d.exact === "environment" || d.ideal === "user" || d.ideal === "environment") && !(t.mediaDevices.getSupportedConstraints && t.mediaDevices.getSupportedConstraints().facingMode && !u)) {
        delete o.video.facingMode;
        let l;
        if (d.exact === "environment" || d.ideal === "environment" ? l = ["back", "rear"] : (d.exact === "user" || d.ideal === "user") && (l = ["front"]), l)
          return t.mediaDevices.enumerateDevices().then((h) => {
            h = h.filter((v) => v.kind === "videoinput");
            let p = h.find((v) => l.some((f) => v.label.toLowerCase().includes(f)));
            return !p && h.length && l.includes("back") && (p = h[h.length - 1]), p && (o.video.deviceId = d.exact ? {
              exact: p.deviceId
            } : {
              ideal: p.deviceId
            }), o.video = n(o.video), ss("chrome: " + JSON.stringify(o)), c(o);
          });
      }
      o.video = n(o.video);
    }
    return ss("chrome: " + JSON.stringify(o)), c(o);
  }, s = function(o) {
    return e.version >= 64 ? o : {
      name: {
        PermissionDeniedError: "NotAllowedError",
        PermissionDismissedError: "NotAllowedError",
        InvalidStateError: "NotAllowedError",
        DevicesNotFoundError: "NotFoundError",
        ConstraintNotSatisfiedError: "OverconstrainedError",
        TrackStartError: "NotReadableError",
        MediaDeviceFailedDueToShutdown: "NotAllowedError",
        MediaDeviceKillSwitchOn: "NotAllowedError",
        TabCaptureError: "AbortError",
        ScreenCaptureError: "AbortError",
        DeviceCaptureError: "AbortError"
      }[o.name] || o.name,
      message: o.message,
      constraint: o.constraint || o.constraintName,
      toString() {
        return this.name + (this.message && ": ") + this.message;
      }
    };
  }, a = function(o, c, d) {
    r(o, (u) => {
      t.webkitGetUserMedia(u, c, (l) => {
        d && d(s(l));
      });
    });
  };
  if (t.getUserMedia = a.bind(t), t.mediaDevices.getUserMedia) {
    const o = t.mediaDevices.getUserMedia.bind(t.mediaDevices);
    t.mediaDevices.getUserMedia = function(c) {
      return r(c, (d) => o(d).then((u) => {
        if (d.audio && !u.getAudioTracks().length || d.video && !u.getVideoTracks().length)
          throw u.getTracks().forEach((l) => {
            l.stop();
          }), new DOMException("", "NotFoundError");
        return u;
      }, (u) => Promise.reject(s(u))));
    };
  }
}
function Ga(i) {
  i.MediaStream = i.MediaStream || i.webkitMediaStream;
}
function Ka(i) {
  if (typeof i == "object" && i.RTCPeerConnection && !("ontrack" in i.RTCPeerConnection.prototype)) {
    Object.defineProperty(i.RTCPeerConnection.prototype, "ontrack", {
      get() {
        return this._ontrack;
      },
      set(t) {
        this._ontrack && this.removeEventListener("track", this._ontrack), this.addEventListener("track", this._ontrack = t);
      },
      enumerable: !0,
      configurable: !0
    });
    const e = i.RTCPeerConnection.prototype.setRemoteDescription;
    i.RTCPeerConnection.prototype.setRemoteDescription = function() {
      return this._ontrackpoly || (this._ontrackpoly = (n) => {
        n.stream.addEventListener("addtrack", (r) => {
          let s;
          i.RTCPeerConnection.prototype.getReceivers ? s = this.getReceivers().find((o) => o.track && o.track.id === r.track.id) : s = {
            track: r.track
          };
          const a = new Event("track");
          a.track = r.track, a.receiver = s, a.transceiver = {
            receiver: s
          }, a.streams = [n.stream], this.dispatchEvent(a);
        }), n.stream.getTracks().forEach((r) => {
          let s;
          i.RTCPeerConnection.prototype.getReceivers ? s = this.getReceivers().find((o) => o.track && o.track.id === r.id) : s = {
            track: r
          };
          const a = new Event("track");
          a.track = r, a.receiver = s, a.transceiver = {
            receiver: s
          }, a.streams = [n.stream], this.dispatchEvent(a);
        });
      }, this.addEventListener("addstream", this._ontrackpoly)), e.apply(this, arguments);
    };
  } else
    Pt(i, "track", (e) => (e.transceiver || Object.defineProperty(e, "transceiver", {
      value: {
        receiver: e.receiver
      }
    }), e));
}
function Ha(i) {
  if (typeof i == "object" && i.RTCPeerConnection && !("getSenders" in i.RTCPeerConnection.prototype) && "createDTMFSender" in i.RTCPeerConnection.prototype) {
    const e = function(r, s) {
      return {
        track: s,
        get dtmf() {
          return this._dtmf === void 0 && (s.kind === "audio" ? this._dtmf = r.createDTMFSender(s) : this._dtmf = null), this._dtmf;
        },
        _pc: r
      };
    };
    if (!i.RTCPeerConnection.prototype.getSenders) {
      i.RTCPeerConnection.prototype.getSenders = function() {
        return this._senders = this._senders || [], this._senders.slice();
      };
      const r = i.RTCPeerConnection.prototype.addTrack;
      i.RTCPeerConnection.prototype.addTrack = function(o, c) {
        let d = r.apply(this, arguments);
        return d || (d = e(this, o), this._senders.push(d)), d;
      };
      const s = i.RTCPeerConnection.prototype.removeTrack;
      i.RTCPeerConnection.prototype.removeTrack = function(o) {
        s.apply(this, arguments);
        const c = this._senders.indexOf(o);
        c !== -1 && this._senders.splice(c, 1);
      };
    }
    const t = i.RTCPeerConnection.prototype.addStream;
    i.RTCPeerConnection.prototype.addStream = function(s) {
      this._senders = this._senders || [], t.apply(this, [s]), s.getTracks().forEach((a) => {
        this._senders.push(e(this, a));
      });
    };
    const n = i.RTCPeerConnection.prototype.removeStream;
    i.RTCPeerConnection.prototype.removeStream = function(s) {
      this._senders = this._senders || [], n.apply(this, [s]), s.getTracks().forEach((a) => {
        const o = this._senders.find((c) => c.track === a);
        o && this._senders.splice(this._senders.indexOf(o), 1);
      });
    };
  } else if (typeof i == "object" && i.RTCPeerConnection && "getSenders" in i.RTCPeerConnection.prototype && "createDTMFSender" in i.RTCPeerConnection.prototype && i.RTCRtpSender && !("dtmf" in i.RTCRtpSender.prototype)) {
    const e = i.RTCPeerConnection.prototype.getSenders;
    i.RTCPeerConnection.prototype.getSenders = function() {
      const n = e.apply(this, []);
      return n.forEach((r) => r._pc = this), n;
    }, Object.defineProperty(i.RTCRtpSender.prototype, "dtmf", {
      get() {
        return this._dtmf === void 0 && (this.track.kind === "audio" ? this._dtmf = this._pc.createDTMFSender(this.track) : this._dtmf = null), this._dtmf;
      }
    });
  }
}
function za(i) {
  if (!(typeof i == "object" && i.RTCPeerConnection && i.RTCRtpSender && i.RTCRtpReceiver))
    return;
  if (!("getStats" in i.RTCRtpSender.prototype)) {
    const t = i.RTCPeerConnection.prototype.getSenders;
    t && (i.RTCPeerConnection.prototype.getSenders = function() {
      const s = t.apply(this, []);
      return s.forEach((a) => a._pc = this), s;
    });
    const n = i.RTCPeerConnection.prototype.addTrack;
    n && (i.RTCPeerConnection.prototype.addTrack = function() {
      const s = n.apply(this, arguments);
      return s._pc = this, s;
    }), i.RTCRtpSender.prototype.getStats = function() {
      const s = this;
      return this._pc.getStats().then((a) => (
        /* Note: this will include stats of all senders that
         *   send a track with the same id as sender.track as
         *   it is not possible to identify the RTCRtpSender.
         */
        rs(a, s.track, !0)
      ));
    };
  }
  if (!("getStats" in i.RTCRtpReceiver.prototype)) {
    const t = i.RTCPeerConnection.prototype.getReceivers;
    t && (i.RTCPeerConnection.prototype.getReceivers = function() {
      const r = t.apply(this, []);
      return r.forEach((s) => s._pc = this), r;
    }), Pt(i, "track", (n) => (n.receiver._pc = n.srcElement, n)), i.RTCRtpReceiver.prototype.getStats = function() {
      const r = this;
      return this._pc.getStats().then((s) => rs(s, r.track, !1));
    };
  }
  if (!("getStats" in i.RTCRtpSender.prototype && "getStats" in i.RTCRtpReceiver.prototype))
    return;
  const e = i.RTCPeerConnection.prototype.getStats;
  i.RTCPeerConnection.prototype.getStats = function() {
    if (arguments.length > 0 && arguments[0] instanceof i.MediaStreamTrack) {
      const n = arguments[0];
      let r, s, a;
      return this.getSenders().forEach((o) => {
        o.track === n && (r ? a = !0 : r = o);
      }), this.getReceivers().forEach((o) => (o.track === n && (s ? a = !0 : s = o), o.track === n)), a || r && s ? Promise.reject(new DOMException("There are more than one sender or receiver for the track.", "InvalidAccessError")) : r ? r.getStats() : s ? s.getStats() : Promise.reject(new DOMException("There is no sender or receiver for the track.", "InvalidAccessError"));
    }
    return e.apply(this, arguments);
  };
}
function Ja(i) {
  i.RTCPeerConnection.prototype.getLocalStreams = function() {
    return this._shimmedLocalStreams = this._shimmedLocalStreams || {}, Object.keys(this._shimmedLocalStreams).map((a) => this._shimmedLocalStreams[a][0]);
  };
  const e = i.RTCPeerConnection.prototype.addTrack;
  i.RTCPeerConnection.prototype.addTrack = function(a, o) {
    if (!o)
      return e.apply(this, arguments);
    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
    const c = e.apply(this, arguments);
    return this._shimmedLocalStreams[o.id] ? this._shimmedLocalStreams[o.id].indexOf(c) === -1 && this._shimmedLocalStreams[o.id].push(c) : this._shimmedLocalStreams[o.id] = [o, c], c;
  };
  const t = i.RTCPeerConnection.prototype.addStream;
  i.RTCPeerConnection.prototype.addStream = function(a) {
    this._shimmedLocalStreams = this._shimmedLocalStreams || {}, a.getTracks().forEach((d) => {
      if (this.getSenders().find((l) => l.track === d))
        throw new DOMException("Track already exists.", "InvalidAccessError");
    });
    const o = this.getSenders();
    t.apply(this, arguments);
    const c = this.getSenders().filter((d) => o.indexOf(d) === -1);
    this._shimmedLocalStreams[a.id] = [a].concat(c);
  };
  const n = i.RTCPeerConnection.prototype.removeStream;
  i.RTCPeerConnection.prototype.removeStream = function(a) {
    return this._shimmedLocalStreams = this._shimmedLocalStreams || {}, delete this._shimmedLocalStreams[a.id], n.apply(this, arguments);
  };
  const r = i.RTCPeerConnection.prototype.removeTrack;
  i.RTCPeerConnection.prototype.removeTrack = function(a) {
    return this._shimmedLocalStreams = this._shimmedLocalStreams || {}, a && Object.keys(this._shimmedLocalStreams).forEach((o) => {
      const c = this._shimmedLocalStreams[o].indexOf(a);
      c !== -1 && this._shimmedLocalStreams[o].splice(c, 1), this._shimmedLocalStreams[o].length === 1 && delete this._shimmedLocalStreams[o];
    }), r.apply(this, arguments);
  };
}
function Qa(i, e) {
  if (!i.RTCPeerConnection)
    return;
  if (i.RTCPeerConnection.prototype.addTrack && e.version >= 65)
    return Ja(i);
  const t = i.RTCPeerConnection.prototype.getLocalStreams;
  i.RTCPeerConnection.prototype.getLocalStreams = function() {
    const u = t.apply(this);
    return this._reverseStreams = this._reverseStreams || {}, u.map((l) => this._reverseStreams[l.id]);
  };
  const n = i.RTCPeerConnection.prototype.addStream;
  i.RTCPeerConnection.prototype.addStream = function(u) {
    if (this._streams = this._streams || {}, this._reverseStreams = this._reverseStreams || {}, u.getTracks().forEach((l) => {
      if (this.getSenders().find((p) => p.track === l))
        throw new DOMException("Track already exists.", "InvalidAccessError");
    }), !this._reverseStreams[u.id]) {
      const l = new i.MediaStream(u.getTracks());
      this._streams[u.id] = l, this._reverseStreams[l.id] = u, u = l;
    }
    n.apply(this, [u]);
  };
  const r = i.RTCPeerConnection.prototype.removeStream;
  i.RTCPeerConnection.prototype.removeStream = function(u) {
    this._streams = this._streams || {}, this._reverseStreams = this._reverseStreams || {}, r.apply(this, [this._streams[u.id] || u]), delete this._reverseStreams[this._streams[u.id] ? this._streams[u.id].id : u.id], delete this._streams[u.id];
  }, i.RTCPeerConnection.prototype.addTrack = function(u, l) {
    if (this.signalingState === "closed")
      throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.", "InvalidStateError");
    const h = [].slice.call(arguments, 1);
    if (h.length !== 1 || !h[0].getTracks().find((f) => f === u))
      throw new DOMException("The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.", "NotSupportedError");
    if (this.getSenders().find((f) => f.track === u))
      throw new DOMException("Track already exists.", "InvalidAccessError");
    this._streams = this._streams || {}, this._reverseStreams = this._reverseStreams || {};
    const v = this._streams[l.id];
    if (v)
      v.addTrack(u), Promise.resolve().then(() => {
        this.dispatchEvent(new Event("negotiationneeded"));
      });
    else {
      const f = new i.MediaStream([u]);
      this._streams[l.id] = f, this._reverseStreams[f.id] = l, this.addStream(f);
    }
    return this.getSenders().find((f) => f.track === u);
  };
  function s(d, u) {
    let l = u.sdp;
    return Object.keys(d._reverseStreams || []).forEach((h) => {
      const p = d._reverseStreams[h], v = d._streams[p.id];
      l = l.replace(new RegExp(v.id, "g"), p.id);
    }), new RTCSessionDescription({
      type: u.type,
      sdp: l
    });
  }
  function a(d, u) {
    let l = u.sdp;
    return Object.keys(d._reverseStreams || []).forEach((h) => {
      const p = d._reverseStreams[h], v = d._streams[p.id];
      l = l.replace(new RegExp(p.id, "g"), v.id);
    }), new RTCSessionDescription({
      type: u.type,
      sdp: l
    });
  }
  ["createOffer", "createAnswer"].forEach(function(d) {
    const u = i.RTCPeerConnection.prototype[d], l = {
      [d]() {
        const h = arguments;
        return arguments.length && typeof arguments[0] == "function" ? u.apply(this, [(v) => {
          const f = s(this, v);
          h[0].apply(null, [f]);
        }, (v) => {
          h[1] && h[1].apply(null, v);
        }, arguments[2]]) : u.apply(this, arguments).then((v) => s(this, v));
      }
    };
    i.RTCPeerConnection.prototype[d] = l[d];
  });
  const o = i.RTCPeerConnection.prototype.setLocalDescription;
  i.RTCPeerConnection.prototype.setLocalDescription = function() {
    return !arguments.length || !arguments[0].type ? o.apply(this, arguments) : (arguments[0] = a(this, arguments[0]), o.apply(this, arguments));
  };
  const c = Object.getOwnPropertyDescriptor(i.RTCPeerConnection.prototype, "localDescription");
  Object.defineProperty(i.RTCPeerConnection.prototype, "localDescription", {
    get() {
      const d = c.get.apply(this);
      return d.type === "" ? d : s(this, d);
    }
  }), i.RTCPeerConnection.prototype.removeTrack = function(u) {
    if (this.signalingState === "closed")
      throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.", "InvalidStateError");
    if (!u._pc)
      throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.", "TypeError");
    if (!(u._pc === this))
      throw new DOMException("Sender was not created by this connection.", "InvalidAccessError");
    this._streams = this._streams || {};
    let h;
    Object.keys(this._streams).forEach((p) => {
      this._streams[p].getTracks().find((f) => u.track === f) && (h = this._streams[p]);
    }), h && (h.getTracks().length === 1 ? this.removeStream(this._reverseStreams[h.id]) : h.removeTrack(u.track), this.dispatchEvent(new Event("negotiationneeded")));
  };
}
function xn(i, e) {
  !i.RTCPeerConnection && i.webkitRTCPeerConnection && (i.RTCPeerConnection = i.webkitRTCPeerConnection), i.RTCPeerConnection && e.version < 53 && ["setLocalDescription", "setRemoteDescription", "addIceCandidate"].forEach(function(t) {
    const n = i.RTCPeerConnection.prototype[t], r = {
      [t]() {
        return arguments[0] = new (t === "addIceCandidate" ? i.RTCIceCandidate : i.RTCSessionDescription)(arguments[0]), n.apply(this, arguments);
      }
    };
    i.RTCPeerConnection.prototype[t] = r[t];
  });
}
function Ya(i, e) {
  Pt(i, "negotiationneeded", (t) => {
    const n = t.target;
    if (!((e.version < 72 || n.getConfiguration && n.getConfiguration().sdpSemantics === "plan-b") && n.signalingState !== "stable"))
      return t;
  });
}
var as = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  fixNegotiationNeeded: Ya,
  shimAddTrackRemoveTrack: Qa,
  shimAddTrackRemoveTrackWithNative: Ja,
  shimGetSendersWithDtmf: Ha,
  shimGetUserMedia: Wa,
  shimMediaStream: Ga,
  shimOnTrack: Ka,
  shimPeerConnection: xn,
  shimSenderReceiverGetStats: za
});
function Xa(i, e) {
  const t = i && i.navigator, n = i && i.MediaStreamTrack;
  if (t.getUserMedia = function(r, s, a) {
    t.mediaDevices.getUserMedia(r).then(s, a);
  }, !(e.version > 55 && "autoGainControl" in t.mediaDevices.getSupportedConstraints())) {
    const r = function(a, o, c) {
      o in a && !(c in a) && (a[c] = a[o], delete a[o]);
    }, s = t.mediaDevices.getUserMedia.bind(t.mediaDevices);
    if (t.mediaDevices.getUserMedia = function(a) {
      return typeof a == "object" && typeof a.audio == "object" && (a = JSON.parse(JSON.stringify(a)), r(a.audio, "autoGainControl", "mozAutoGainControl"), r(a.audio, "noiseSuppression", "mozNoiseSuppression")), s(a);
    }, n && n.prototype.getSettings) {
      const a = n.prototype.getSettings;
      n.prototype.getSettings = function() {
        const o = a.apply(this, arguments);
        return r(o, "mozAutoGainControl", "autoGainControl"), r(o, "mozNoiseSuppression", "noiseSuppression"), o;
      };
    }
    if (n && n.prototype.applyConstraints) {
      const a = n.prototype.applyConstraints;
      n.prototype.applyConstraints = function(o) {
        return this.kind === "audio" && typeof o == "object" && (o = JSON.parse(JSON.stringify(o)), r(o, "autoGainControl", "mozAutoGainControl"), r(o, "noiseSuppression", "mozNoiseSuppression")), a.apply(this, [o]);
      };
    }
  }
}
function Jd(i, e) {
  i.navigator.mediaDevices && "getDisplayMedia" in i.navigator.mediaDevices || i.navigator.mediaDevices && (i.navigator.mediaDevices.getDisplayMedia = function(n) {
    if (!(n && n.video)) {
      const r = new DOMException("getDisplayMedia without video constraints is undefined");
      return r.name = "NotFoundError", r.code = 8, Promise.reject(r);
    }
    return n.video === !0 ? n.video = {
      mediaSource: e
    } : n.video.mediaSource = e, i.navigator.mediaDevices.getUserMedia(n);
  });
}
function $a(i) {
  typeof i == "object" && i.RTCTrackEvent && "receiver" in i.RTCTrackEvent.prototype && !("transceiver" in i.RTCTrackEvent.prototype) && Object.defineProperty(i.RTCTrackEvent.prototype, "transceiver", {
    get() {
      return {
        receiver: this.receiver
      };
    }
  });
}
function Mn(i, e) {
  if (typeof i != "object" || !(i.RTCPeerConnection || i.mozRTCPeerConnection))
    return;
  !i.RTCPeerConnection && i.mozRTCPeerConnection && (i.RTCPeerConnection = i.mozRTCPeerConnection), e.version < 53 && ["setLocalDescription", "setRemoteDescription", "addIceCandidate"].forEach(function(r) {
    const s = i.RTCPeerConnection.prototype[r], a = {
      [r]() {
        return arguments[0] = new (r === "addIceCandidate" ? i.RTCIceCandidate : i.RTCSessionDescription)(arguments[0]), s.apply(this, arguments);
      }
    };
    i.RTCPeerConnection.prototype[r] = a[r];
  });
  const t = {
    inboundrtp: "inbound-rtp",
    outboundrtp: "outbound-rtp",
    candidatepair: "candidate-pair",
    localcandidate: "local-candidate",
    remotecandidate: "remote-candidate"
  }, n = i.RTCPeerConnection.prototype.getStats;
  i.RTCPeerConnection.prototype.getStats = function() {
    const [s, a, o] = arguments;
    return n.apply(this, [s || null]).then((c) => {
      if (e.version < 53 && !a)
        try {
          c.forEach((d) => {
            d.type = t[d.type] || d.type;
          });
        } catch (d) {
          if (d.name !== "TypeError")
            throw d;
          c.forEach((u, l) => {
            c.set(l, Object.assign({}, u, {
              type: t[u.type] || u.type
            }));
          });
        }
      return c;
    }).then(a, o);
  };
}
function Za(i) {
  if (!(typeof i == "object" && i.RTCPeerConnection && i.RTCRtpSender) || i.RTCRtpSender && "getStats" in i.RTCRtpSender.prototype)
    return;
  const e = i.RTCPeerConnection.prototype.getSenders;
  e && (i.RTCPeerConnection.prototype.getSenders = function() {
    const r = e.apply(this, []);
    return r.forEach((s) => s._pc = this), r;
  });
  const t = i.RTCPeerConnection.prototype.addTrack;
  t && (i.RTCPeerConnection.prototype.addTrack = function() {
    const r = t.apply(this, arguments);
    return r._pc = this, r;
  }), i.RTCRtpSender.prototype.getStats = function() {
    return this.track ? this._pc.getStats(this.track) : Promise.resolve(/* @__PURE__ */ new Map());
  };
}
function eo(i) {
  if (!(typeof i == "object" && i.RTCPeerConnection && i.RTCRtpSender) || i.RTCRtpSender && "getStats" in i.RTCRtpReceiver.prototype)
    return;
  const e = i.RTCPeerConnection.prototype.getReceivers;
  e && (i.RTCPeerConnection.prototype.getReceivers = function() {
    const n = e.apply(this, []);
    return n.forEach((r) => r._pc = this), n;
  }), Pt(i, "track", (t) => (t.receiver._pc = t.srcElement, t)), i.RTCRtpReceiver.prototype.getStats = function() {
    return this._pc.getStats(this.track);
  };
}
function to(i) {
  !i.RTCPeerConnection || "removeStream" in i.RTCPeerConnection.prototype || (i.RTCPeerConnection.prototype.removeStream = function(t) {
    this.getSenders().forEach((n) => {
      n.track && t.getTracks().includes(n.track) && this.removeTrack(n);
    });
  });
}
function io(i) {
  i.DataChannel && !i.RTCDataChannel && (i.RTCDataChannel = i.DataChannel);
}
function no(i) {
  if (!(typeof i == "object" && i.RTCPeerConnection))
    return;
  const e = i.RTCPeerConnection.prototype.addTransceiver;
  e && (i.RTCPeerConnection.prototype.addTransceiver = function() {
    this.setParametersPromises = [];
    let n = arguments[1] && arguments[1].sendEncodings;
    n === void 0 && (n = []), n = [...n];
    const r = n.length > 0;
    r && n.forEach((a) => {
      if ("rid" in a && !/^[a-z0-9]{0,16}$/i.test(a.rid))
        throw new TypeError("Invalid RID value provided.");
      if ("scaleResolutionDownBy" in a && !(parseFloat(a.scaleResolutionDownBy) >= 1))
        throw new RangeError("scale_resolution_down_by must be >= 1.0");
      if ("maxFramerate" in a && !(parseFloat(a.maxFramerate) >= 0))
        throw new RangeError("max_framerate must be >= 0.0");
    });
    const s = e.apply(this, arguments);
    if (r) {
      const {
        sender: a
      } = s, o = a.getParameters();
      (!("encodings" in o) || // Avoid being fooled by patched getParameters() below.
      o.encodings.length === 1 && Object.keys(o.encodings[0]).length === 0) && (o.encodings = n, a.sendEncodings = n, this.setParametersPromises.push(a.setParameters(o).then(() => {
        delete a.sendEncodings;
      }).catch(() => {
        delete a.sendEncodings;
      })));
    }
    return s;
  });
}
function ro(i) {
  if (!(typeof i == "object" && i.RTCRtpSender))
    return;
  const e = i.RTCRtpSender.prototype.getParameters;
  e && (i.RTCRtpSender.prototype.getParameters = function() {
    const n = e.apply(this, arguments);
    return "encodings" in n || (n.encodings = [].concat(this.sendEncodings || [{}])), n;
  });
}
function so(i) {
  if (!(typeof i == "object" && i.RTCPeerConnection))
    return;
  const e = i.RTCPeerConnection.prototype.createOffer;
  i.RTCPeerConnection.prototype.createOffer = function() {
    return this.setParametersPromises && this.setParametersPromises.length ? Promise.all(this.setParametersPromises).then(() => e.apply(this, arguments)).finally(() => {
      this.setParametersPromises = [];
    }) : e.apply(this, arguments);
  };
}
function ao(i) {
  if (!(typeof i == "object" && i.RTCPeerConnection))
    return;
  const e = i.RTCPeerConnection.prototype.createAnswer;
  i.RTCPeerConnection.prototype.createAnswer = function() {
    return this.setParametersPromises && this.setParametersPromises.length ? Promise.all(this.setParametersPromises).then(() => e.apply(this, arguments)).finally(() => {
      this.setParametersPromises = [];
    }) : e.apply(this, arguments);
  };
}
var os = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  shimAddTransceiver: no,
  shimCreateAnswer: ao,
  shimCreateOffer: so,
  shimGetDisplayMedia: Jd,
  shimGetParameters: ro,
  shimGetUserMedia: Xa,
  shimOnTrack: $a,
  shimPeerConnection: Mn,
  shimRTCDataChannel: io,
  shimReceiverGetStats: eo,
  shimRemoveStream: to,
  shimSenderGetStats: Za
});
function oo(i) {
  if (!(typeof i != "object" || !i.RTCPeerConnection)) {
    if ("getLocalStreams" in i.RTCPeerConnection.prototype || (i.RTCPeerConnection.prototype.getLocalStreams = function() {
      return this._localStreams || (this._localStreams = []), this._localStreams;
    }), !("addStream" in i.RTCPeerConnection.prototype)) {
      const e = i.RTCPeerConnection.prototype.addTrack;
      i.RTCPeerConnection.prototype.addStream = function(n) {
        this._localStreams || (this._localStreams = []), this._localStreams.includes(n) || this._localStreams.push(n), n.getAudioTracks().forEach((r) => e.call(this, r, n)), n.getVideoTracks().forEach((r) => e.call(this, r, n));
      }, i.RTCPeerConnection.prototype.addTrack = function(n) {
        for (var r = arguments.length, s = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
          s[a - 1] = arguments[a];
        return s && s.forEach((o) => {
          this._localStreams ? this._localStreams.includes(o) || this._localStreams.push(o) : this._localStreams = [o];
        }), e.apply(this, arguments);
      };
    }
    "removeStream" in i.RTCPeerConnection.prototype || (i.RTCPeerConnection.prototype.removeStream = function(t) {
      this._localStreams || (this._localStreams = []);
      const n = this._localStreams.indexOf(t);
      if (n === -1)
        return;
      this._localStreams.splice(n, 1);
      const r = t.getTracks();
      this.getSenders().forEach((s) => {
        r.includes(s.track) && this.removeTrack(s);
      });
    });
  }
}
function co(i) {
  if (!(typeof i != "object" || !i.RTCPeerConnection) && ("getRemoteStreams" in i.RTCPeerConnection.prototype || (i.RTCPeerConnection.prototype.getRemoteStreams = function() {
    return this._remoteStreams ? this._remoteStreams : [];
  }), !("onaddstream" in i.RTCPeerConnection.prototype))) {
    Object.defineProperty(i.RTCPeerConnection.prototype, "onaddstream", {
      get() {
        return this._onaddstream;
      },
      set(t) {
        this._onaddstream && (this.removeEventListener("addstream", this._onaddstream), this.removeEventListener("track", this._onaddstreampoly)), this.addEventListener("addstream", this._onaddstream = t), this.addEventListener("track", this._onaddstreampoly = (n) => {
          n.streams.forEach((r) => {
            if (this._remoteStreams || (this._remoteStreams = []), this._remoteStreams.includes(r))
              return;
            this._remoteStreams.push(r);
            const s = new Event("addstream");
            s.stream = r, this.dispatchEvent(s);
          });
        });
      }
    });
    const e = i.RTCPeerConnection.prototype.setRemoteDescription;
    i.RTCPeerConnection.prototype.setRemoteDescription = function() {
      const n = this;
      return this._onaddstreampoly || this.addEventListener("track", this._onaddstreampoly = function(r) {
        r.streams.forEach((s) => {
          if (n._remoteStreams || (n._remoteStreams = []), n._remoteStreams.indexOf(s) >= 0)
            return;
          n._remoteStreams.push(s);
          const a = new Event("addstream");
          a.stream = s, n.dispatchEvent(a);
        });
      }), e.apply(n, arguments);
    };
  }
}
function uo(i) {
  if (typeof i != "object" || !i.RTCPeerConnection)
    return;
  const e = i.RTCPeerConnection.prototype, t = e.createOffer, n = e.createAnswer, r = e.setLocalDescription, s = e.setRemoteDescription, a = e.addIceCandidate;
  e.createOffer = function(d, u) {
    const l = arguments.length >= 2 ? arguments[2] : arguments[0], h = t.apply(this, [l]);
    return u ? (h.then(d, u), Promise.resolve()) : h;
  }, e.createAnswer = function(d, u) {
    const l = arguments.length >= 2 ? arguments[2] : arguments[0], h = n.apply(this, [l]);
    return u ? (h.then(d, u), Promise.resolve()) : h;
  };
  let o = function(c, d, u) {
    const l = r.apply(this, [c]);
    return u ? (l.then(d, u), Promise.resolve()) : l;
  };
  e.setLocalDescription = o, o = function(c, d, u) {
    const l = s.apply(this, [c]);
    return u ? (l.then(d, u), Promise.resolve()) : l;
  }, e.setRemoteDescription = o, o = function(c, d, u) {
    const l = a.apply(this, [c]);
    return u ? (l.then(d, u), Promise.resolve()) : l;
  }, e.addIceCandidate = o;
}
function lo(i) {
  const e = i && i.navigator;
  if (e.mediaDevices && e.mediaDevices.getUserMedia) {
    const t = e.mediaDevices, n = t.getUserMedia.bind(t);
    e.mediaDevices.getUserMedia = (r) => n(ho(r));
  }
  !e.getUserMedia && e.mediaDevices && e.mediaDevices.getUserMedia && (e.getUserMedia = function(n, r, s) {
    e.mediaDevices.getUserMedia(n).then(r, s);
  }.bind(e));
}
function ho(i) {
  return i && i.video !== void 0 ? Object.assign({}, i, {
    video: qa(i.video)
  }) : i;
}
function fo(i) {
  if (!i.RTCPeerConnection)
    return;
  const e = i.RTCPeerConnection;
  i.RTCPeerConnection = function(n, r) {
    if (n && n.iceServers) {
      const s = [];
      for (let a = 0; a < n.iceServers.length; a++) {
        let o = n.iceServers[a];
        o.urls === void 0 && o.url ? (o = JSON.parse(JSON.stringify(o)), o.urls = o.url, delete o.url, s.push(o)) : s.push(n.iceServers[a]);
      }
      n.iceServers = s;
    }
    return new e(n, r);
  }, i.RTCPeerConnection.prototype = e.prototype, "generateCertificate" in e && Object.defineProperty(i.RTCPeerConnection, "generateCertificate", {
    get() {
      return e.generateCertificate;
    }
  });
}
function po(i) {
  typeof i == "object" && i.RTCTrackEvent && "receiver" in i.RTCTrackEvent.prototype && !("transceiver" in i.RTCTrackEvent.prototype) && Object.defineProperty(i.RTCTrackEvent.prototype, "transceiver", {
    get() {
      return {
        receiver: this.receiver
      };
    }
  });
}
function mo(i) {
  const e = i.RTCPeerConnection.prototype.createOffer;
  i.RTCPeerConnection.prototype.createOffer = function(n) {
    if (n) {
      typeof n.offerToReceiveAudio != "undefined" && (n.offerToReceiveAudio = !!n.offerToReceiveAudio);
      const r = this.getTransceivers().find((a) => a.receiver.track.kind === "audio");
      n.offerToReceiveAudio === !1 && r ? r.direction === "sendrecv" ? r.setDirection ? r.setDirection("sendonly") : r.direction = "sendonly" : r.direction === "recvonly" && (r.setDirection ? r.setDirection("inactive") : r.direction = "inactive") : n.offerToReceiveAudio === !0 && !r && this.addTransceiver("audio", {
        direction: "recvonly"
      }), typeof n.offerToReceiveVideo != "undefined" && (n.offerToReceiveVideo = !!n.offerToReceiveVideo);
      const s = this.getTransceivers().find((a) => a.receiver.track.kind === "video");
      n.offerToReceiveVideo === !1 && s ? s.direction === "sendrecv" ? s.setDirection ? s.setDirection("sendonly") : s.direction = "sendonly" : s.direction === "recvonly" && (s.setDirection ? s.setDirection("inactive") : s.direction = "inactive") : n.offerToReceiveVideo === !0 && !s && this.addTransceiver("video", {
        direction: "recvonly"
      });
    }
    return e.apply(this, arguments);
  };
}
function go(i) {
  typeof i != "object" || i.AudioContext || (i.AudioContext = i.webkitAudioContext);
}
var cs = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  shimAudioContext: go,
  shimCallbacksAPI: uo,
  shimConstraints: ho,
  shimCreateOfferLegacy: mo,
  shimGetUserMedia: lo,
  shimLocalStreamsAPI: oo,
  shimRTCIceServerUrls: fo,
  shimRemoteStreamsAPI: co,
  shimTrackEventTransceiver: po
}), rn = { exports: {} }, ds;
function Qd() {
  return ds || (ds = 1, function(i) {
    const e = {};
    e.generateIdentifier = function() {
      return Math.random().toString(36).substring(2, 12);
    }, e.localCName = e.generateIdentifier(), e.splitLines = function(t) {
      return t.trim().split(`
`).map((n) => n.trim());
    }, e.splitSections = function(t) {
      return t.split(`
m=`).map((r, s) => (s > 0 ? "m=" + r : r).trim() + `\r
`);
    }, e.getDescription = function(t) {
      const n = e.splitSections(t);
      return n && n[0];
    }, e.getMediaSections = function(t) {
      const n = e.splitSections(t);
      return n.shift(), n;
    }, e.matchPrefix = function(t, n) {
      return e.splitLines(t).filter((r) => r.indexOf(n) === 0);
    }, e.parseCandidate = function(t) {
      let n;
      t.indexOf("a=candidate:") === 0 ? n = t.substring(12).split(" ") : n = t.substring(10).split(" ");
      const r = {
        foundation: n[0],
        component: {
          1: "rtp",
          2: "rtcp"
        }[n[1]] || n[1],
        protocol: n[2].toLowerCase(),
        priority: parseInt(n[3], 10),
        ip: n[4],
        address: n[4],
        // address is an alias for ip.
        port: parseInt(n[5], 10),
        // skip parts[6] == 'typ'
        type: n[7]
      };
      for (let s = 8; s < n.length; s += 2)
        switch (n[s]) {
          case "raddr":
            r.relatedAddress = n[s + 1];
            break;
          case "rport":
            r.relatedPort = parseInt(n[s + 1], 10);
            break;
          case "tcptype":
            r.tcpType = n[s + 1];
            break;
          case "ufrag":
            r.ufrag = n[s + 1], r.usernameFragment = n[s + 1];
            break;
          default:
            r[n[s]] === void 0 && (r[n[s]] = n[s + 1]);
            break;
        }
      return r;
    }, e.writeCandidate = function(t) {
      const n = [];
      n.push(t.foundation);
      const r = t.component;
      r === "rtp" ? n.push(1) : r === "rtcp" ? n.push(2) : n.push(r), n.push(t.protocol.toUpperCase()), n.push(t.priority), n.push(t.address || t.ip), n.push(t.port);
      const s = t.type;
      return n.push("typ"), n.push(s), s !== "host" && t.relatedAddress && t.relatedPort && (n.push("raddr"), n.push(t.relatedAddress), n.push("rport"), n.push(t.relatedPort)), t.tcpType && t.protocol.toLowerCase() === "tcp" && (n.push("tcptype"), n.push(t.tcpType)), (t.usernameFragment || t.ufrag) && (n.push("ufrag"), n.push(t.usernameFragment || t.ufrag)), "candidate:" + n.join(" ");
    }, e.parseIceOptions = function(t) {
      return t.substring(14).split(" ");
    }, e.parseRtpMap = function(t) {
      let n = t.substring(9).split(" ");
      const r = {
        payloadType: parseInt(n.shift(), 10)
        // was: id
      };
      return n = n[0].split("/"), r.name = n[0], r.clockRate = parseInt(n[1], 10), r.channels = n.length === 3 ? parseInt(n[2], 10) : 1, r.numChannels = r.channels, r;
    }, e.writeRtpMap = function(t) {
      let n = t.payloadType;
      t.preferredPayloadType !== void 0 && (n = t.preferredPayloadType);
      const r = t.channels || t.numChannels || 1;
      return "a=rtpmap:" + n + " " + t.name + "/" + t.clockRate + (r !== 1 ? "/" + r : "") + `\r
`;
    }, e.parseExtmap = function(t) {
      const n = t.substring(9).split(" ");
      return {
        id: parseInt(n[0], 10),
        direction: n[0].indexOf("/") > 0 ? n[0].split("/")[1] : "sendrecv",
        uri: n[1],
        attributes: n.slice(2).join(" ")
      };
    }, e.writeExtmap = function(t) {
      return "a=extmap:" + (t.id || t.preferredId) + (t.direction && t.direction !== "sendrecv" ? "/" + t.direction : "") + " " + t.uri + (t.attributes ? " " + t.attributes : "") + `\r
`;
    }, e.parseFmtp = function(t) {
      const n = {};
      let r;
      const s = t.substring(t.indexOf(" ") + 1).split(";");
      for (let a = 0; a < s.length; a++)
        r = s[a].trim().split("="), n[r[0].trim()] = r[1];
      return n;
    }, e.writeFmtp = function(t) {
      let n = "", r = t.payloadType;
      if (t.preferredPayloadType !== void 0 && (r = t.preferredPayloadType), t.parameters && Object.keys(t.parameters).length) {
        const s = [];
        Object.keys(t.parameters).forEach((a) => {
          t.parameters[a] !== void 0 ? s.push(a + "=" + t.parameters[a]) : s.push(a);
        }), n += "a=fmtp:" + r + " " + s.join(";") + `\r
`;
      }
      return n;
    }, e.parseRtcpFb = function(t) {
      const n = t.substring(t.indexOf(" ") + 1).split(" ");
      return {
        type: n.shift(),
        parameter: n.join(" ")
      };
    }, e.writeRtcpFb = function(t) {
      let n = "", r = t.payloadType;
      return t.preferredPayloadType !== void 0 && (r = t.preferredPayloadType), t.rtcpFeedback && t.rtcpFeedback.length && t.rtcpFeedback.forEach((s) => {
        n += "a=rtcp-fb:" + r + " " + s.type + (s.parameter && s.parameter.length ? " " + s.parameter : "") + `\r
`;
      }), n;
    }, e.parseSsrcMedia = function(t) {
      const n = t.indexOf(" "), r = {
        ssrc: parseInt(t.substring(7, n), 10)
      }, s = t.indexOf(":", n);
      return s > -1 ? (r.attribute = t.substring(n + 1, s), r.value = t.substring(s + 1)) : r.attribute = t.substring(n + 1), r;
    }, e.parseSsrcGroup = function(t) {
      const n = t.substring(13).split(" ");
      return {
        semantics: n.shift(),
        ssrcs: n.map((r) => parseInt(r, 10))
      };
    }, e.getMid = function(t) {
      const n = e.matchPrefix(t, "a=mid:")[0];
      if (n)
        return n.substring(6);
    }, e.parseFingerprint = function(t) {
      const n = t.substring(14).split(" ");
      return {
        algorithm: n[0].toLowerCase(),
        // algorithm is case-sensitive in Edge.
        value: n[1].toUpperCase()
        // the definition is upper-case in RFC 4572.
      };
    }, e.getDtlsParameters = function(t, n) {
      return {
        role: "auto",
        fingerprints: e.matchPrefix(t + n, "a=fingerprint:").map(e.parseFingerprint)
      };
    }, e.writeDtlsParameters = function(t, n) {
      let r = "a=setup:" + n + `\r
`;
      return t.fingerprints.forEach((s) => {
        r += "a=fingerprint:" + s.algorithm + " " + s.value + `\r
`;
      }), r;
    }, e.parseCryptoLine = function(t) {
      const n = t.substring(9).split(" ");
      return {
        tag: parseInt(n[0], 10),
        cryptoSuite: n[1],
        keyParams: n[2],
        sessionParams: n.slice(3)
      };
    }, e.writeCryptoLine = function(t) {
      return "a=crypto:" + t.tag + " " + t.cryptoSuite + " " + (typeof t.keyParams == "object" ? e.writeCryptoKeyParams(t.keyParams) : t.keyParams) + (t.sessionParams ? " " + t.sessionParams.join(" ") : "") + `\r
`;
    }, e.parseCryptoKeyParams = function(t) {
      if (t.indexOf("inline:") !== 0)
        return null;
      const n = t.substring(7).split("|");
      return {
        keyMethod: "inline",
        keySalt: n[0],
        lifeTime: n[1],
        mkiValue: n[2] ? n[2].split(":")[0] : void 0,
        mkiLength: n[2] ? n[2].split(":")[1] : void 0
      };
    }, e.writeCryptoKeyParams = function(t) {
      return t.keyMethod + ":" + t.keySalt + (t.lifeTime ? "|" + t.lifeTime : "") + (t.mkiValue && t.mkiLength ? "|" + t.mkiValue + ":" + t.mkiLength : "");
    }, e.getCryptoParameters = function(t, n) {
      return e.matchPrefix(t + n, "a=crypto:").map(e.parseCryptoLine);
    }, e.getIceParameters = function(t, n) {
      const r = e.matchPrefix(t + n, "a=ice-ufrag:")[0], s = e.matchPrefix(t + n, "a=ice-pwd:")[0];
      return r && s ? {
        usernameFragment: r.substring(12),
        password: s.substring(10)
      } : null;
    }, e.writeIceParameters = function(t) {
      let n = "a=ice-ufrag:" + t.usernameFragment + `\r
a=ice-pwd:` + t.password + `\r
`;
      return t.iceLite && (n += `a=ice-lite\r
`), n;
    }, e.parseRtpParameters = function(t) {
      const n = {
        codecs: [],
        headerExtensions: [],
        fecMechanisms: [],
        rtcp: []
      }, s = e.splitLines(t)[0].split(" ");
      n.profile = s[2];
      for (let o = 3; o < s.length; o++) {
        const c = s[o], d = e.matchPrefix(t, "a=rtpmap:" + c + " ")[0];
        if (d) {
          const u = e.parseRtpMap(d), l = e.matchPrefix(t, "a=fmtp:" + c + " ");
          switch (u.parameters = l.length ? e.parseFmtp(l[0]) : {}, u.rtcpFeedback = e.matchPrefix(t, "a=rtcp-fb:" + c + " ").map(e.parseRtcpFb), n.codecs.push(u), u.name.toUpperCase()) {
            case "RED":
            case "ULPFEC":
              n.fecMechanisms.push(u.name.toUpperCase());
              break;
          }
        }
      }
      e.matchPrefix(t, "a=extmap:").forEach((o) => {
        n.headerExtensions.push(e.parseExtmap(o));
      });
      const a = e.matchPrefix(t, "a=rtcp-fb:* ").map(e.parseRtcpFb);
      return n.codecs.forEach((o) => {
        a.forEach((c) => {
          o.rtcpFeedback.find((u) => u.type === c.type && u.parameter === c.parameter) || o.rtcpFeedback.push(c);
        });
      }), n;
    }, e.writeRtpDescription = function(t, n) {
      let r = "";
      r += "m=" + t + " ", r += n.codecs.length > 0 ? "9" : "0", r += " " + (n.profile || "UDP/TLS/RTP/SAVPF") + " ", r += n.codecs.map((a) => a.preferredPayloadType !== void 0 ? a.preferredPayloadType : a.payloadType).join(" ") + `\r
`, r += `c=IN IP4 0.0.0.0\r
`, r += `a=rtcp:9 IN IP4 0.0.0.0\r
`, n.codecs.forEach((a) => {
        r += e.writeRtpMap(a), r += e.writeFmtp(a), r += e.writeRtcpFb(a);
      });
      let s = 0;
      return n.codecs.forEach((a) => {
        a.maxptime > s && (s = a.maxptime);
      }), s > 0 && (r += "a=maxptime:" + s + `\r
`), n.headerExtensions && n.headerExtensions.forEach((a) => {
        r += e.writeExtmap(a);
      }), r;
    }, e.parseRtpEncodingParameters = function(t) {
      const n = [], r = e.parseRtpParameters(t), s = r.fecMechanisms.indexOf("RED") !== -1, a = r.fecMechanisms.indexOf("ULPFEC") !== -1, o = e.matchPrefix(t, "a=ssrc:").map((h) => e.parseSsrcMedia(h)).filter((h) => h.attribute === "cname"), c = o.length > 0 && o[0].ssrc;
      let d;
      const u = e.matchPrefix(t, "a=ssrc-group:FID").map((h) => h.substring(17).split(" ").map((v) => parseInt(v, 10)));
      u.length > 0 && u[0].length > 1 && u[0][0] === c && (d = u[0][1]), r.codecs.forEach((h) => {
        if (h.name.toUpperCase() === "RTX" && h.parameters.apt) {
          let p = {
            ssrc: c,
            codecPayloadType: parseInt(h.parameters.apt, 10)
          };
          c && d && (p.rtx = {
            ssrc: d
          }), n.push(p), s && (p = JSON.parse(JSON.stringify(p)), p.fec = {
            ssrc: c,
            mechanism: a ? "red+ulpfec" : "red"
          }, n.push(p));
        }
      }), n.length === 0 && c && n.push({
        ssrc: c
      });
      let l = e.matchPrefix(t, "b=");
      return l.length && (l[0].indexOf("b=TIAS:") === 0 ? l = parseInt(l[0].substring(7), 10) : l[0].indexOf("b=AS:") === 0 ? l = parseInt(l[0].substring(5), 10) * 1e3 * 0.95 - 50 * 40 * 8 : l = void 0, n.forEach((h) => {
        h.maxBitrate = l;
      })), n;
    }, e.parseRtcpParameters = function(t) {
      const n = {}, r = e.matchPrefix(t, "a=ssrc:").map((o) => e.parseSsrcMedia(o)).filter((o) => o.attribute === "cname")[0];
      r && (n.cname = r.value, n.ssrc = r.ssrc);
      const s = e.matchPrefix(t, "a=rtcp-rsize");
      n.reducedSize = s.length > 0, n.compound = s.length === 0;
      const a = e.matchPrefix(t, "a=rtcp-mux");
      return n.mux = a.length > 0, n;
    }, e.writeRtcpParameters = function(t) {
      let n = "";
      return t.reducedSize && (n += `a=rtcp-rsize\r
`), t.mux && (n += `a=rtcp-mux\r
`), t.ssrc !== void 0 && t.cname && (n += "a=ssrc:" + t.ssrc + " cname:" + t.cname + `\r
`), n;
    }, e.parseMsid = function(t) {
      let n;
      const r = e.matchPrefix(t, "a=msid:");
      if (r.length === 1)
        return n = r[0].substring(7).split(" "), {
          stream: n[0],
          track: n[1]
        };
      const s = e.matchPrefix(t, "a=ssrc:").map((a) => e.parseSsrcMedia(a)).filter((a) => a.attribute === "msid");
      if (s.length > 0)
        return n = s[0].value.split(" "), {
          stream: n[0],
          track: n[1]
        };
    }, e.parseSctpDescription = function(t) {
      const n = e.parseMLine(t), r = e.matchPrefix(t, "a=max-message-size:");
      let s;
      r.length > 0 && (s = parseInt(r[0].substring(19), 10)), isNaN(s) && (s = 65536);
      const a = e.matchPrefix(t, "a=sctp-port:");
      if (a.length > 0)
        return {
          port: parseInt(a[0].substring(12), 10),
          protocol: n.fmt,
          maxMessageSize: s
        };
      const o = e.matchPrefix(t, "a=sctpmap:");
      if (o.length > 0) {
        const c = o[0].substring(10).split(" ");
        return {
          port: parseInt(c[0], 10),
          protocol: c[1],
          maxMessageSize: s
        };
      }
    }, e.writeSctpDescription = function(t, n) {
      let r = [];
      return t.protocol !== "DTLS/SCTP" ? r = ["m=" + t.kind + " 9 " + t.protocol + " " + n.protocol + `\r
`, `c=IN IP4 0.0.0.0\r
`, "a=sctp-port:" + n.port + `\r
`] : r = ["m=" + t.kind + " 9 " + t.protocol + " " + n.port + `\r
`, `c=IN IP4 0.0.0.0\r
`, "a=sctpmap:" + n.port + " " + n.protocol + ` 65535\r
`], n.maxMessageSize !== void 0 && r.push("a=max-message-size:" + n.maxMessageSize + `\r
`), r.join("");
    }, e.generateSessionId = function() {
      return Math.random().toString().substr(2, 22);
    }, e.writeSessionBoilerplate = function(t, n, r) {
      let s;
      const a = n !== void 0 ? n : 2;
      return t ? s = t : s = e.generateSessionId(), `v=0\r
o=` + (r || "thisisadapterortc") + " " + s + " " + a + ` IN IP4 127.0.0.1\r
s=-\r
t=0 0\r
`;
    }, e.getDirection = function(t, n) {
      const r = e.splitLines(t);
      for (let s = 0; s < r.length; s++)
        switch (r[s]) {
          case "a=sendrecv":
          case "a=sendonly":
          case "a=recvonly":
          case "a=inactive":
            return r[s].substring(2);
        }
      return n ? e.getDirection(n) : "sendrecv";
    }, e.getKind = function(t) {
      return e.splitLines(t)[0].split(" ")[0].substring(2);
    }, e.isRejected = function(t) {
      return t.split(" ", 2)[1] === "0";
    }, e.parseMLine = function(t) {
      const r = e.splitLines(t)[0].substring(2).split(" ");
      return {
        kind: r[0],
        port: parseInt(r[1], 10),
        protocol: r[2],
        fmt: r.slice(3).join(" ")
      };
    }, e.parseOLine = function(t) {
      const r = e.matchPrefix(t, "o=")[0].substring(2).split(" ");
      return {
        username: r[0],
        sessionId: r[1],
        sessionVersion: parseInt(r[2], 10),
        netType: r[3],
        addressType: r[4],
        address: r[5]
      };
    }, e.isValidSDP = function(t) {
      if (typeof t != "string" || t.length === 0)
        return !1;
      const n = e.splitLines(t);
      for (let r = 0; r < n.length; r++)
        if (n[r].length < 2 || n[r].charAt(1) !== "=")
          return !1;
      return !0;
    }, i.exports = e;
  }(rn)), rn.exports;
}
var vo = Qd(), At = /* @__PURE__ */ Nd(vo), Yd = /* @__PURE__ */ cc({
  __proto__: null,
  default: At
}, [vo]);
function Si(i) {
  if (!i.RTCIceCandidate || i.RTCIceCandidate && "foundation" in i.RTCIceCandidate.prototype)
    return;
  const e = i.RTCIceCandidate;
  i.RTCIceCandidate = function(n) {
    if (typeof n == "object" && n.candidate && n.candidate.indexOf("a=") === 0 && (n = JSON.parse(JSON.stringify(n)), n.candidate = n.candidate.substring(2)), n.candidate && n.candidate.length) {
      const r = new e(n), s = At.parseCandidate(n.candidate);
      for (const a in s)
        a in r || Object.defineProperty(r, a, {
          value: s[a]
        });
      return r.toJSON = function() {
        return {
          candidate: r.candidate,
          sdpMid: r.sdpMid,
          sdpMLineIndex: r.sdpMLineIndex,
          usernameFragment: r.usernameFragment
        };
      }, r;
    }
    return new e(n);
  }, i.RTCIceCandidate.prototype = e.prototype, Pt(i, "icecandidate", (t) => (t.candidate && Object.defineProperty(t, "candidate", {
    value: new i.RTCIceCandidate(t.candidate),
    writable: "false"
  }), t));
}
function Dn(i) {
  !i.RTCIceCandidate || i.RTCIceCandidate && "relayProtocol" in i.RTCIceCandidate.prototype || Pt(i, "icecandidate", (e) => {
    if (e.candidate) {
      const t = At.parseCandidate(e.candidate.candidate);
      t.type === "relay" && (e.candidate.relayProtocol = {
        0: "tls",
        1: "tcp",
        2: "udp"
      }[t.priority >> 24]);
    }
    return e;
  });
}
function Ci(i, e) {
  if (!i.RTCPeerConnection)
    return;
  "sctp" in i.RTCPeerConnection.prototype || Object.defineProperty(i.RTCPeerConnection.prototype, "sctp", {
    get() {
      return typeof this._sctp == "undefined" ? null : this._sctp;
    }
  });
  const t = function(o) {
    if (!o || !o.sdp)
      return !1;
    const c = At.splitSections(o.sdp);
    return c.shift(), c.some((d) => {
      const u = At.parseMLine(d);
      return u && u.kind === "application" && u.protocol.indexOf("SCTP") !== -1;
    });
  }, n = function(o) {
    const c = o.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
    if (c === null || c.length < 2)
      return -1;
    const d = parseInt(c[1], 10);
    return d !== d ? -1 : d;
  }, r = function(o) {
    let c = 65536;
    return e.browser === "firefox" && (e.version < 57 ? o === -1 ? c = 16384 : c = 2147483637 : e.version < 60 ? c = e.version === 57 ? 65535 : 65536 : c = 2147483637), c;
  }, s = function(o, c) {
    let d = 65536;
    e.browser === "firefox" && e.version === 57 && (d = 65535);
    const u = At.matchPrefix(o.sdp, "a=max-message-size:");
    return u.length > 0 ? d = parseInt(u[0].substring(19), 10) : e.browser === "firefox" && c !== -1 && (d = 2147483637), d;
  }, a = i.RTCPeerConnection.prototype.setRemoteDescription;
  i.RTCPeerConnection.prototype.setRemoteDescription = function() {
    if (this._sctp = null, e.browser === "chrome" && e.version >= 76) {
      const {
        sdpSemantics: c
      } = this.getConfiguration();
      c === "plan-b" && Object.defineProperty(this, "sctp", {
        get() {
          return typeof this._sctp == "undefined" ? null : this._sctp;
        },
        enumerable: !0,
        configurable: !0
      });
    }
    if (t(arguments[0])) {
      const c = n(arguments[0]), d = r(c), u = s(arguments[0], c);
      let l;
      d === 0 && u === 0 ? l = Number.POSITIVE_INFINITY : d === 0 || u === 0 ? l = Math.max(d, u) : l = Math.min(d, u);
      const h = {};
      Object.defineProperty(h, "maxMessageSize", {
        get() {
          return l;
        }
      }), this._sctp = h;
    }
    return a.apply(this, arguments);
  };
}
function Pi(i) {
  if (!(i.RTCPeerConnection && "createDataChannel" in i.RTCPeerConnection.prototype))
    return;
  function e(n, r) {
    const s = n.send;
    n.send = function() {
      const o = arguments[0], c = o.length || o.size || o.byteLength;
      if (n.readyState === "open" && r.sctp && c > r.sctp.maxMessageSize)
        throw new TypeError("Message too large (can send a maximum of " + r.sctp.maxMessageSize + " bytes)");
      return s.apply(n, arguments);
    };
  }
  const t = i.RTCPeerConnection.prototype.createDataChannel;
  i.RTCPeerConnection.prototype.createDataChannel = function() {
    const r = t.apply(this, arguments);
    return e(r, this), r;
  }, Pt(i, "datachannel", (n) => (e(n.channel, n.target), n));
}
function An(i) {
  if (!i.RTCPeerConnection || "connectionState" in i.RTCPeerConnection.prototype)
    return;
  const e = i.RTCPeerConnection.prototype;
  Object.defineProperty(e, "connectionState", {
    get() {
      return {
        completed: "connected",
        checking: "connecting"
      }[this.iceConnectionState] || this.iceConnectionState;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "onconnectionstatechange", {
    get() {
      return this._onconnectionstatechange || null;
    },
    set(t) {
      this._onconnectionstatechange && (this.removeEventListener("connectionstatechange", this._onconnectionstatechange), delete this._onconnectionstatechange), t && this.addEventListener("connectionstatechange", this._onconnectionstatechange = t);
    },
    enumerable: !0,
    configurable: !0
  }), ["setLocalDescription", "setRemoteDescription"].forEach((t) => {
    const n = e[t];
    e[t] = function() {
      return this._connectionstatechangepoly || (this._connectionstatechangepoly = (r) => {
        const s = r.target;
        if (s._lastConnectionState !== s.connectionState) {
          s._lastConnectionState = s.connectionState;
          const a = new Event("connectionstatechange", r);
          s.dispatchEvent(a);
        }
        return r;
      }, this.addEventListener("iceconnectionstatechange", this._connectionstatechangepoly)), n.apply(this, arguments);
    };
  });
}
function Ln(i, e) {
  if (!i.RTCPeerConnection || e.browser === "chrome" && e.version >= 71 || e.browser === "safari" && e._safariVersion >= 13.1)
    return;
  const t = i.RTCPeerConnection.prototype.setRemoteDescription;
  i.RTCPeerConnection.prototype.setRemoteDescription = function(r) {
    if (r && r.sdp && r.sdp.indexOf(`
a=extmap-allow-mixed`) !== -1) {
      const s = r.sdp.split(`
`).filter((a) => a.trim() !== "a=extmap-allow-mixed").join(`
`);
      i.RTCSessionDescription && r instanceof i.RTCSessionDescription ? arguments[0] = new i.RTCSessionDescription({
        type: r.type,
        sdp: s
      }) : r.sdp = s;
    }
    return t.apply(this, arguments);
  };
}
function Ei(i, e) {
  if (!(i.RTCPeerConnection && i.RTCPeerConnection.prototype))
    return;
  const t = i.RTCPeerConnection.prototype.addIceCandidate;
  !t || t.length === 0 || (i.RTCPeerConnection.prototype.addIceCandidate = function() {
    return arguments[0] ? (e.browser === "chrome" && e.version < 78 || e.browser === "firefox" && e.version < 68 || e.browser === "safari") && arguments[0] && arguments[0].candidate === "" ? Promise.resolve() : t.apply(this, arguments) : (arguments[1] && arguments[1].apply(null), Promise.resolve());
  });
}
function Ri(i, e) {
  if (!(i.RTCPeerConnection && i.RTCPeerConnection.prototype))
    return;
  const t = i.RTCPeerConnection.prototype.setLocalDescription;
  !t || t.length === 0 || (i.RTCPeerConnection.prototype.setLocalDescription = function() {
    let r = arguments[0] || {};
    if (typeof r != "object" || r.type && r.sdp)
      return t.apply(this, arguments);
    if (r = {
      type: r.type,
      sdp: r.sdp
    }, !r.type)
      switch (this.signalingState) {
        case "stable":
        case "have-local-offer":
        case "have-remote-pranswer":
          r.type = "offer";
          break;
        default:
          r.type = "answer";
          break;
      }
    return r.sdp || r.type !== "offer" && r.type !== "answer" ? t.apply(this, [r]) : (r.type === "offer" ? this.createOffer : this.createAnswer).apply(this).then((a) => t.apply(this, [a]));
  });
}
var Xd = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  removeExtmapAllowMixed: Ln,
  shimAddIceCandidateNullOrEmpty: Ei,
  shimConnectionState: An,
  shimMaxMessageSize: Ci,
  shimParameterlessSetLocalDescription: Ri,
  shimRTCIceCandidate: Si,
  shimRTCIceCandidateRelayProtocol: Dn,
  shimSendThrowTypeError: Pi
});
function $d() {
  let {
    window: i
  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    shimChrome: !0,
    shimFirefox: !0,
    shimSafari: !0
  };
  const t = Va, n = zd(i), r = {
    browserDetails: n,
    commonShim: Xd,
    extractVersion: ii,
    disableLog: Kd,
    disableWarnings: Hd,
    // Expose sdp as a convenience. For production apps include directly.
    sdp: Yd
  };
  switch (n.browser) {
    case "chrome":
      if (!as || !xn || !e.shimChrome)
        return t("Chrome shim is not included in this adapter release."), r;
      if (n.version === null)
        return t("Chrome shim can not determine version, not shimming."), r;
      t("adapter.js shimming chrome."), r.browserShim = as, Ei(i, n), Ri(i), Wa(i, n), Ga(i), xn(i, n), Ka(i), Qa(i, n), Ha(i), za(i), Ya(i, n), Si(i), Dn(i), An(i), Ci(i, n), Pi(i), Ln(i, n);
      break;
    case "firefox":
      if (!os || !Mn || !e.shimFirefox)
        return t("Firefox shim is not included in this adapter release."), r;
      t("adapter.js shimming firefox."), r.browserShim = os, Ei(i, n), Ri(i), Xa(i, n), Mn(i, n), $a(i), to(i), Za(i), eo(i), io(i), no(i), ro(i), so(i), ao(i), Si(i), An(i), Ci(i, n), Pi(i);
      break;
    case "safari":
      if (!cs || !e.shimSafari)
        return t("Safari shim is not included in this adapter release."), r;
      t("adapter.js shimming safari."), r.browserShim = cs, Ei(i, n), Ri(i), fo(i), mo(i), uo(i), oo(i), co(i), po(i), lo(i), go(i), Si(i), Dn(i), Ci(i, n), Pi(i), Ln(i, n);
      break;
    default:
      t("Unsupported browser!");
      break;
  }
  return r;
}
$d({
  window: typeof window == "undefined" ? void 0 : window
});
const Zd = 10, Xt = "lk_e2ee", eu = "LKFrameEncryptionKey", tu = {
  sharedKey: !1,
  ratchetSalt: eu,
  ratchetWindowSize: 8,
  failureTolerance: Zd,
  keyringSize: 16
};
var ut;
(function(i) {
  i.SetKey = "setKey", i.RatchetRequest = "ratchetRequest", i.KeyRatcheted = "keyRatcheted";
})(ut || (ut = {}));
var us;
(function(i) {
  i.KeyRatcheted = "keyRatcheted";
})(us || (us = {}));
var dt;
(function(i) {
  i.ParticipantEncryptionStatusChanged = "participantEncryptionStatusChanged", i.EncryptionError = "encryptionError";
})(dt || (dt = {}));
var ls;
(function(i) {
  i.Error = "cryptorError";
})(ls || (ls = {}));
function iu() {
  return nu() || Nn();
}
function Nn() {
  return typeof window.RTCRtpScriptTransform != "undefined";
}
function nu() {
  return typeof window.RTCRtpSender != "undefined" && // @ts-ignore
  typeof window.RTCRtpSender.prototype.createEncodedStreams != "undefined";
}
class Jh extends He.EventEmitter {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    super(), this.onKeyRatcheted = (t, n, r) => {
      G.debug("key ratcheted event received", {
        ratchetResult: t,
        participantId: n,
        keyIndex: r
      });
    }, this.keyInfoMap = /* @__PURE__ */ new Map(), this.options = Object.assign(Object.assign({}, tu), e), this.on(ut.KeyRatcheted, this.onKeyRatcheted);
  }
  /**
   * callback to invoke once a key has been set for a participant
   * @param key
   * @param participantIdentity
   * @param keyIndex
   */
  onSetEncryptionKey(e, t, n) {
    const r = {
      key: e,
      participantIdentity: t,
      keyIndex: n
    };
    if (!this.options.sharedKey && !t)
      throw new Error("participant identity needs to be passed for encryption key if sharedKey option is false");
    this.keyInfoMap.set("".concat(t != null ? t : "shared", "-").concat(n != null ? n : 0), r), this.emit(ut.SetKey, r);
  }
  getKeys() {
    return Array.from(this.keyInfoMap.values());
  }
  getOptions() {
    return this.options;
  }
  ratchetKey(e, t) {
    this.emit(ut.RatchetRequest, e, t);
  }
}
class ft extends Error {
  constructor(e, t) {
    super(t || "an error has occured"), this.name = "LiveKitError", this.code = e;
  }
}
var K;
(function(i) {
  i[i.NotAllowed = 0] = "NotAllowed", i[i.ServerUnreachable = 1] = "ServerUnreachable", i[i.InternalError = 2] = "InternalError", i[i.Cancelled = 3] = "Cancelled", i[i.LeaveRequest = 4] = "LeaveRequest", i[i.Timeout = 5] = "Timeout";
})(K || (K = {}));
class Q extends ft {
  constructor(e, t, n, r) {
    super(1, e), this.name = "ConnectionError", this.status = n, this.reason = t, this.context = r, this.reasonName = K[t];
  }
}
class hr extends ft {
  constructor(e) {
    super(21, e != null ? e : "device is unsupported"), this.name = "DeviceUnsupportedError";
  }
}
class tt extends ft {
  constructor(e) {
    super(20, e != null ? e : "track is invalid"), this.name = "TrackInvalidError";
  }
}
class ru extends ft {
  constructor(e) {
    super(10, e != null ? e : "unsupported server"), this.name = "UnsupportedServer";
  }
}
class ce extends ft {
  constructor(e) {
    super(12, e != null ? e : "unexpected connection state"), this.name = "UnexpectedConnectionState";
  }
}
class Un extends ft {
  constructor(e) {
    super(13, e != null ? e : "unable to negotiate"), this.name = "NegotiationError";
  }
}
class hs extends ft {
  constructor(e, t) {
    super(15, e), this.name = "PublishTrackError", this.status = t;
  }
}
class fs extends ft {
  constructor(e, t) {
    super(15, e), this.reason = t, this.reasonName = typeof t == "string" ? t : lr[t];
  }
}
var Li;
(function(i) {
  i.PermissionDenied = "PermissionDenied", i.NotFound = "NotFound", i.DeviceInUse = "DeviceInUse", i.Other = "Other";
})(Li || (Li = {}));
(function(i) {
  function e(t) {
    if (t && "name" in t)
      return t.name === "NotFoundError" || t.name === "DevicesNotFoundError" ? i.NotFound : t.name === "NotAllowedError" || t.name === "PermissionDeniedError" ? i.PermissionDenied : t.name === "NotReadableError" || t.name === "TrackStartError" ? i.DeviceInUse : i.Other;
  }
  i.getFailure = e;
})(Li || (Li = {}));
var ps;
(function(i) {
  i[i.InvalidKey = 0] = "InvalidKey", i[i.MissingKey = 1] = "MissingKey", i[i.InternalError = 2] = "InternalError";
})(ps || (ps = {}));
var S;
(function(i) {
  i.Connected = "connected", i.Reconnecting = "reconnecting", i.SignalReconnecting = "signalReconnecting", i.Reconnected = "reconnected", i.Disconnected = "disconnected", i.ConnectionStateChanged = "connectionStateChanged", i.Moved = "moved", i.MediaDevicesChanged = "mediaDevicesChanged", i.ParticipantConnected = "participantConnected", i.ParticipantDisconnected = "participantDisconnected", i.TrackPublished = "trackPublished", i.TrackSubscribed = "trackSubscribed", i.TrackSubscriptionFailed = "trackSubscriptionFailed", i.TrackUnpublished = "trackUnpublished", i.TrackUnsubscribed = "trackUnsubscribed", i.TrackMuted = "trackMuted", i.TrackUnmuted = "trackUnmuted", i.LocalTrackPublished = "localTrackPublished", i.LocalTrackUnpublished = "localTrackUnpublished", i.LocalAudioSilenceDetected = "localAudioSilenceDetected", i.ActiveSpeakersChanged = "activeSpeakersChanged", i.ParticipantMetadataChanged = "participantMetadataChanged", i.ParticipantNameChanged = "participantNameChanged", i.ParticipantAttributesChanged = "participantAttributesChanged", i.ParticipantActive = "participantActive", i.RoomMetadataChanged = "roomMetadataChanged", i.DataReceived = "dataReceived", i.SipDTMFReceived = "sipDTMFReceived", i.TranscriptionReceived = "transcriptionReceived", i.ConnectionQualityChanged = "connectionQualityChanged", i.TrackStreamStateChanged = "trackStreamStateChanged", i.TrackSubscriptionPermissionChanged = "trackSubscriptionPermissionChanged", i.TrackSubscriptionStatusChanged = "trackSubscriptionStatusChanged", i.AudioPlaybackStatusChanged = "audioPlaybackChanged", i.VideoPlaybackStatusChanged = "videoPlaybackChanged", i.MediaDevicesError = "mediaDevicesError", i.ParticipantPermissionsChanged = "participantPermissionsChanged", i.SignalConnected = "signalConnected", i.RecordingStatusChanged = "recordingStatusChanged", i.ParticipantEncryptionStatusChanged = "participantEncryptionStatusChanged", i.EncryptionError = "encryptionError", i.DCBufferStatusChanged = "dcBufferStatusChanged", i.ActiveDeviceChanged = "activeDeviceChanged", i.ChatMessage = "chatMessage", i.LocalTrackSubscribed = "localTrackSubscribed", i.MetricsReceived = "metricsReceived";
})(S || (S = {}));
var C;
(function(i) {
  i.TrackPublished = "trackPublished", i.TrackSubscribed = "trackSubscribed", i.TrackSubscriptionFailed = "trackSubscriptionFailed", i.TrackUnpublished = "trackUnpublished", i.TrackUnsubscribed = "trackUnsubscribed", i.TrackMuted = "trackMuted", i.TrackUnmuted = "trackUnmuted", i.LocalTrackPublished = "localTrackPublished", i.LocalTrackUnpublished = "localTrackUnpublished", i.LocalTrackCpuConstrained = "localTrackCpuConstrained", i.LocalSenderCreated = "localSenderCreated", i.ParticipantMetadataChanged = "participantMetadataChanged", i.ParticipantNameChanged = "participantNameChanged", i.DataReceived = "dataReceived", i.SipDTMFReceived = "sipDTMFReceived", i.TranscriptionReceived = "transcriptionReceived", i.IsSpeakingChanged = "isSpeakingChanged", i.ConnectionQualityChanged = "connectionQualityChanged", i.TrackStreamStateChanged = "trackStreamStateChanged", i.TrackSubscriptionPermissionChanged = "trackSubscriptionPermissionChanged", i.TrackSubscriptionStatusChanged = "trackSubscriptionStatusChanged", i.TrackCpuConstrained = "trackCpuConstrained", i.MediaDevicesError = "mediaDevicesError", i.AudioStreamAcquired = "audioStreamAcquired", i.ParticipantPermissionsChanged = "participantPermissionsChanged", i.PCTrackAdded = "pcTrackAdded", i.AttributesChanged = "attributesChanged", i.LocalTrackSubscribed = "localTrackSubscribed", i.ChatMessage = "chatMessage", i.Active = "active";
})(C || (C = {}));
var M;
(function(i) {
  i.TransportsCreated = "transportsCreated", i.Connected = "connected", i.Disconnected = "disconnected", i.Resuming = "resuming", i.Resumed = "resumed", i.Restarting = "restarting", i.Restarted = "restarted", i.SignalResumed = "signalResumed", i.SignalRestarted = "signalRestarted", i.Closing = "closing", i.MediaTrackAdded = "mediaTrackAdded", i.ActiveSpeakersUpdate = "activeSpeakersUpdate", i.DataPacketReceived = "dataPacketReceived", i.RTPVideoMapUpdate = "rtpVideoMapUpdate", i.DCBufferStatusChanged = "dcBufferStatusChanged", i.ParticipantUpdate = "participantUpdate", i.RoomUpdate = "roomUpdate", i.SpeakersChanged = "speakersChanged", i.StreamStateChanged = "streamStateChanged", i.ConnectionQualityUpdate = "connectionQualityUpdate", i.SubscriptionError = "subscriptionError", i.SubscriptionPermissionUpdate = "subscriptionPermissionUpdate", i.RemoteMute = "remoteMute", i.SubscribedQualityUpdate = "subscribedQualityUpdate", i.LocalTrackUnpublished = "localTrackUnpublished", i.LocalTrackSubscribed = "localTrackSubscribed", i.Offline = "offline", i.SignalRequestResponse = "signalRequestResponse", i.SignalConnected = "signalConnected", i.RoomMoved = "roomMoved";
})(M || (M = {}));
var I;
(function(i) {
  i.Message = "message", i.Muted = "muted", i.Unmuted = "unmuted", i.Restarted = "restarted", i.Ended = "ended", i.Subscribed = "subscribed", i.Unsubscribed = "unsubscribed", i.CpuConstrained = "cpuConstrained", i.UpdateSettings = "updateSettings", i.UpdateSubscription = "updateSubscription", i.AudioPlaybackStarted = "audioPlaybackStarted", i.AudioPlaybackFailed = "audioPlaybackFailed", i.AudioSilenceDetected = "audioSilenceDetected", i.VisibilityChanged = "visibilityChanged", i.VideoDimensionsChanged = "videoDimensionsChanged", i.VideoPlaybackStarted = "videoPlaybackStarted", i.VideoPlaybackFailed = "videoPlaybackFailed", i.ElementAttached = "elementAttached", i.ElementDetached = "elementDetached", i.UpstreamPaused = "upstreamPaused", i.UpstreamResumed = "upstreamResumed", i.SubscriptionPermissionChanged = "subscriptionPermissionChanged", i.SubscriptionStatusChanged = "subscriptionStatusChanged", i.SubscriptionFailed = "subscriptionFailed", i.TrackProcessorUpdate = "trackProcessorUpdate", i.AudioTrackFeatureUpdate = "audioTrackFeatureUpdate", i.TranscriptionReceived = "transcriptionReceived", i.TimeSyncUpdate = "timeSyncUpdate", i.PreConnectBufferFlushed = "preConnectBufferFlushed";
})(I || (I = {}));
function su(i) {
  return typeof i == "undefined" ? i : typeof structuredClone == "function" ? typeof i == "object" && i !== null ? structuredClone(Object.assign({}, i)) : structuredClone(i) : JSON.parse(JSON.stringify(i));
}
const au = /version\/(\d+(\.?_?\d+)+)/i;
let sn;
function Re(i) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  if (typeof navigator == "undefined")
    return;
  const t = navigator.userAgent.toLowerCase();
  if (sn === void 0 || e) {
    const n = ou.find((r) => {
      let {
        test: s
      } = r;
      return s.test(t);
    });
    sn = n == null ? void 0 : n.describe(t);
  }
  return sn;
}
const ou = [
  {
    test: /firefox|iceweasel|fxios/i,
    describe(i) {
      return {
        name: "Firefox",
        version: wi(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, i),
        os: i.toLowerCase().includes("fxios") ? "iOS" : void 0,
        osVersion: an(i)
      };
    }
  },
  {
    test: /chrom|crios|crmo/i,
    describe(i) {
      return {
        name: "Chrome",
        version: wi(/(?:chrome|chromium|crios|crmo)\/(\d+(\.?_?\d+)+)/i, i),
        os: i.toLowerCase().includes("crios") ? "iOS" : void 0,
        osVersion: an(i)
      };
    }
  },
  /* Safari */
  {
    test: /safari|applewebkit/i,
    describe(i) {
      return {
        name: "Safari",
        version: wi(au, i),
        os: i.includes("mobile/") ? "iOS" : "macOS",
        osVersion: an(i)
      };
    }
  }
];
function wi(i, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  const n = e.match(i);
  return n && n.length >= t && n[t] || "";
}
function an(i) {
  return i.includes("mac os") ? wi(/\(.+?(\d+_\d+(:?_\d+)?)/, i, 1).replace(/_/g, ".") : void 0;
}
var cu = "2.15.3";
const du = cu, uu = 16;
class pe {
}
pe.setTimeout = function() {
  return setTimeout(...arguments);
};
pe.setInterval = // eslint-disable-next-line @typescript-eslint/no-implied-eval
function() {
  return setInterval(...arguments);
};
pe.clearTimeout = function() {
  return clearTimeout(...arguments);
};
pe.clearInterval = function() {
  return clearInterval(...arguments);
};
const lu = 5e3, $t = [];
var Ee;
(function(i) {
  i[i.LOW = 0] = "LOW", i[i.MEDIUM = 1] = "MEDIUM", i[i.HIGH = 2] = "HIGH";
})(Ee || (Ee = {}));
class E extends He.EventEmitter {
  constructor(e, t) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var r;
    super(), this.attachedElements = [], this.isMuted = !1, this.streamState = E.StreamState.Active, this.isInBackground = !1, this._currentBitrate = 0, this.log = G, this.appVisibilityChangedListener = () => {
      this.backgroundTimeout && clearTimeout(this.backgroundTimeout), document.visibilityState === "hidden" ? this.backgroundTimeout = setTimeout(() => this.handleAppVisibilityChanged(), lu) : this.handleAppVisibilityChanged();
    }, this.log = it((r = n.loggerName) !== null && r !== void 0 ? r : Ne.Track), this.loggerContextCb = n.loggerContextCb, this.setMaxListeners(100), this.kind = t, this._mediaStreamTrack = e, this._mediaStreamID = e.id, this.source = E.Source.Unknown;
  }
  get logContext() {
    var e;
    return Object.assign(Object.assign({}, (e = this.loggerContextCb) === null || e === void 0 ? void 0 : e.call(this)), W(this));
  }
  /** current receive bits per second */
  get currentBitrate() {
    return this._currentBitrate;
  }
  get mediaStreamTrack() {
    return this._mediaStreamTrack;
  }
  /**
   * @internal
   * used for keep mediaStream's first id, since it's id might change
   * if we disable/enable a track
   */
  get mediaStreamID() {
    return this._mediaStreamID;
  }
  attach(e) {
    let t = "audio";
    this.kind === E.Kind.Video && (t = "video"), this.attachedElements.length === 0 && this.kind === E.Kind.Video && this.addAppVisibilityListener(), e || (t === "audio" && ($t.forEach((s) => {
      s.parentElement === null && !e && (e = s);
    }), e && $t.splice($t.indexOf(e), 1)), e || (e = document.createElement(t))), this.attachedElements.includes(e) || this.attachedElements.push(e), Ot(this.mediaStreamTrack, e);
    const n = e.srcObject.getTracks(), r = n.some((s) => s.kind === "audio");
    return e.play().then(() => {
      this.emit(r ? I.AudioPlaybackStarted : I.VideoPlaybackStarted);
    }).catch((s) => {
      s.name === "NotAllowedError" ? this.emit(r ? I.AudioPlaybackFailed : I.VideoPlaybackFailed, s) : s.name === "AbortError" ? G.debug("".concat(r ? "audio" : "video", " playback aborted, likely due to new play request")) : G.warn("could not playback ".concat(r ? "audio" : "video"), s), r && e && n.some((a) => a.kind === "video") && s.name === "NotAllowedError" && (e.muted = !0, e.play().catch(() => {
      }));
    }), this.emit(I.ElementAttached, e), e;
  }
  detach(e) {
    try {
      if (e) {
        Lt(this.mediaStreamTrack, e);
        const n = this.attachedElements.indexOf(e);
        return n >= 0 && (this.attachedElements.splice(n, 1), this.recycleElement(e), this.emit(I.ElementDetached, e)), e;
      }
      const t = [];
      return this.attachedElements.forEach((n) => {
        Lt(this.mediaStreamTrack, n), t.push(n), this.recycleElement(n), this.emit(I.ElementDetached, n);
      }), this.attachedElements = [], t;
    } finally {
      this.attachedElements.length === 0 && this.removeAppVisibilityListener();
    }
  }
  stop() {
    this.stopMonitor(), this._mediaStreamTrack.stop();
  }
  enable() {
    this._mediaStreamTrack.enabled = !0;
  }
  disable() {
    this._mediaStreamTrack.enabled = !1;
  }
  /* @internal */
  stopMonitor() {
    this.monitorInterval && clearInterval(this.monitorInterval), this.timeSyncHandle && cancelAnimationFrame(this.timeSyncHandle);
  }
  /** @internal */
  updateLoggerOptions(e) {
    e.loggerName && (this.log = it(e.loggerName)), e.loggerContextCb && (this.loggerContextCb = e.loggerContextCb);
  }
  recycleElement(e) {
    if (e instanceof HTMLAudioElement) {
      let t = !0;
      e.pause(), $t.forEach((n) => {
        n.parentElement || (t = !1);
      }), t && $t.push(e);
    }
  }
  handleAppVisibilityChanged() {
    return m(this, void 0, void 0, function* () {
      this.isInBackground = document.visibilityState === "hidden", !this.isInBackground && this.kind === E.Kind.Video && setTimeout(() => this.attachedElements.forEach((e) => e.play().catch(() => {
      })), 0);
    });
  }
  addAppVisibilityListener() {
    Se() ? (this.isInBackground = document.visibilityState === "hidden", document.addEventListener("visibilitychange", this.appVisibilityChangedListener)) : this.isInBackground = !1;
  }
  removeAppVisibilityListener() {
    Se() && document.removeEventListener("visibilitychange", this.appVisibilityChangedListener);
  }
}
function Ot(i, e) {
  let t;
  e.srcObject instanceof MediaStream ? t = e.srcObject : t = new MediaStream();
  let n;
  i.kind === "audio" ? n = t.getAudioTracks() : n = t.getVideoTracks(), n.includes(i) || (n.forEach((r) => {
    t.removeTrack(r);
  }), t.addTrack(i)), (!Ct() || !(e instanceof HTMLVideoElement)) && (e.autoplay = !0), e.muted = t.getAudioTracks().length === 0, e instanceof HTMLVideoElement && (e.playsInline = !0), e.srcObject !== t && (e.srcObject = t, (Ct() || Bt()) && e instanceof HTMLVideoElement && setTimeout(() => {
    e.srcObject = t, e.play().catch(() => {
    });
  }, 0));
}
function Lt(i, e) {
  if (e.srcObject instanceof MediaStream) {
    const t = e.srcObject;
    t.removeTrack(i), t.getTracks().length > 0 ? e.srcObject = t : e.srcObject = null;
  }
}
(function(i) {
  let e;
  (function(d) {
    d.Audio = "audio", d.Video = "video", d.Unknown = "unknown";
  })(e = i.Kind || (i.Kind = {}));
  let t;
  (function(d) {
    d.Camera = "camera", d.Microphone = "microphone", d.ScreenShare = "screen_share", d.ScreenShareAudio = "screen_share_audio", d.Unknown = "unknown";
  })(t = i.Source || (i.Source = {}));
  let n;
  (function(d) {
    d.Active = "active", d.Paused = "paused", d.Unknown = "unknown";
  })(n = i.StreamState || (i.StreamState = {}));
  function r(d) {
    switch (d) {
      case e.Audio:
        return De.AUDIO;
      case e.Video:
        return De.VIDEO;
      default:
        return De.DATA;
    }
  }
  i.kindToProto = r;
  function s(d) {
    switch (d) {
      case De.AUDIO:
        return e.Audio;
      case De.VIDEO:
        return e.Video;
      default:
        return e.Unknown;
    }
  }
  i.kindFromProto = s;
  function a(d) {
    switch (d) {
      case t.Camera:
        return ae.CAMERA;
      case t.Microphone:
        return ae.MICROPHONE;
      case t.ScreenShare:
        return ae.SCREEN_SHARE;
      case t.ScreenShareAudio:
        return ae.SCREEN_SHARE_AUDIO;
      default:
        return ae.UNKNOWN;
    }
  }
  i.sourceToProto = a;
  function o(d) {
    switch (d) {
      case ae.CAMERA:
        return t.Camera;
      case ae.MICROPHONE:
        return t.Microphone;
      case ae.SCREEN_SHARE:
        return t.ScreenShare;
      case ae.SCREEN_SHARE_AUDIO:
        return t.ScreenShareAudio;
      default:
        return t.Unknown;
    }
  }
  i.sourceFromProto = o;
  function c(d) {
    switch (d) {
      case Rn.ACTIVE:
        return n.Active;
      case Rn.PAUSED:
        return n.Paused;
      default:
        return n.Unknown;
    }
  }
  i.streamStateFromProto = c;
})(E || (E = {}));
class J {
  constructor(e, t, n, r, s) {
    if (typeof e == "object")
      this.width = e.width, this.height = e.height, this.aspectRatio = e.aspectRatio, this.encoding = {
        maxBitrate: e.maxBitrate,
        maxFramerate: e.maxFramerate,
        priority: e.priority
      };
    else if (t !== void 0 && n !== void 0)
      this.width = e, this.height = t, this.aspectRatio = e / t, this.encoding = {
        maxBitrate: n,
        maxFramerate: r,
        priority: s
      };
    else
      throw new TypeError("Unsupported options: provide at least width, height and maxBitrate");
  }
  get resolution() {
    return {
      width: this.width,
      height: this.height,
      frameRate: this.encoding.maxFramerate,
      aspectRatio: this.aspectRatio
    };
  }
}
const hu = ["vp8", "h264"], fu = ["vp8", "h264", "vp9", "av1", "h265"];
function pu(i) {
  return !!hu.find((e) => e === i);
}
var ms;
(function(i) {
  i[i.PREFER_REGRESSION = 0] = "PREFER_REGRESSION", i[i.SIMULCAST = 1] = "SIMULCAST", i[i.REGRESSION = 2] = "REGRESSION";
})(ms || (ms = {}));
var Fn;
(function(i) {
  i.telephone = {
    maxBitrate: 12e3
  }, i.speech = {
    maxBitrate: 24e3
  }, i.music = {
    maxBitrate: 48e3
  }, i.musicStereo = {
    maxBitrate: 64e3
  }, i.musicHighQuality = {
    maxBitrate: 96e3
  }, i.musicHighQualityStereo = {
    maxBitrate: 128e3
  };
})(Fn || (Fn = {}));
const ci = {
  h90: new J(160, 90, 9e4, 20),
  h180: new J(320, 180, 16e4, 20),
  h216: new J(384, 216, 18e4, 20),
  h360: new J(640, 360, 45e4, 20),
  h540: new J(960, 540, 8e5, 25),
  h720: new J(1280, 720, 17e5, 30),
  h1080: new J(1920, 1080, 3e6, 30),
  h1440: new J(2560, 1440, 5e6, 30),
  h2160: new J(3840, 2160, 8e6, 30)
}, jn = {
  h120: new J(160, 120, 7e4, 20),
  h180: new J(240, 180, 125e3, 20),
  h240: new J(320, 240, 14e4, 20),
  h360: new J(480, 360, 33e4, 20),
  h480: new J(640, 480, 5e5, 20),
  h540: new J(720, 540, 6e5, 25),
  h720: new J(960, 720, 13e5, 30),
  h1080: new J(1440, 1080, 23e5, 30),
  h1440: new J(1920, 1440, 38e5, 30)
}, fr = {
  h360fps3: new J(640, 360, 2e5, 3, "medium"),
  h360fps15: new J(640, 360, 4e5, 15, "medium"),
  h720fps5: new J(1280, 720, 8e5, 5, "medium"),
  h720fps15: new J(1280, 720, 15e5, 15, "medium"),
  h720fps30: new J(1280, 720, 2e6, 30, "medium"),
  h1080fps15: new J(1920, 1080, 25e5, 15, "medium"),
  h1080fps30: new J(1920, 1080, 5e6, 30, "medium"),
  // original resolution, without resizing
  original: new J(0, 0, 7e6, 30, "medium")
}, mu = "|", gs = "https://aomediacodec.github.io/av1-rtp-spec/#dependency-descriptor-rtp-header-extension";
function gu(i) {
  const e = i.split(mu);
  return e.length > 1 ? [e[0], i.substr(e[0].length + 1)] : [i, ""];
}
function Ce(i) {
  return m(this, void 0, void 0, function* () {
    return new Promise((e) => pe.setTimeout(e, i));
  });
}
function Bn() {
  return "addTransceiver" in RTCPeerConnection.prototype;
}
function Vn() {
  return "addTrack" in RTCPeerConnection.prototype;
}
function vu() {
  if (!("getCapabilities" in RTCRtpSender) || Ct())
    return !1;
  const i = RTCRtpSender.getCapabilities("video");
  let e = !1;
  if (i) {
    for (const t of i.codecs)
      if (t.mimeType === "video/AV1") {
        e = !0;
        break;
      }
  }
  return e;
}
function bu() {
  if (!("getCapabilities" in RTCRtpSender) || Bt())
    return !1;
  if (Ct()) {
    const t = Re();
    if (t != null && t.version && Ke(t.version, "16") < 0 || (t == null ? void 0 : t.os) === "iOS" && (t != null && t.osVersion) && Ke(t.osVersion, "16") < 0)
      return !1;
  }
  const i = RTCRtpSender.getCapabilities("video");
  let e = !1;
  if (i) {
    for (const t of i.codecs)
      if (t.mimeType === "video/VP9") {
        e = !0;
        break;
      }
  }
  return e;
}
function qe(i) {
  return i === "av1" || i === "vp9";
}
function qn(i) {
  return document ? (i || (i = document.createElement("audio")), "setSinkId" in i) : !1;
}
function yu() {
  return typeof RTCPeerConnection == "undefined" ? !1 : Bn() || Vn();
}
function Bt() {
  var i;
  return ((i = Re()) === null || i === void 0 ? void 0 : i.name) === "Firefox";
}
function Ct() {
  var i;
  return ((i = Re()) === null || i === void 0 ? void 0 : i.name) === "Safari";
}
function Wn() {
  const i = Re();
  return (i == null ? void 0 : i.name) === "Safari" || (i == null ? void 0 : i.os) === "iOS";
}
function ku() {
  const i = Re();
  return (i == null ? void 0 : i.name) === "Safari" && i.version.startsWith("17.") || (i == null ? void 0 : i.os) === "iOS" && !!(i != null && i.osVersion) && Ke(i.osVersion, "17") >= 0;
}
function Tu(i) {
  return i || (i = Re()), (i == null ? void 0 : i.name) === "Safari" && Ke(i.version, "18.3") > 0 || (i == null ? void 0 : i.os) === "iOS" && !!(i != null && i.osVersion) && Ke(i.osVersion, "18.3") > 0;
}
function bo() {
  var i, e;
  return Se() ? (
    // @ts-expect-error `userAgentData` is not yet part of typescript
    (e = (i = navigator.userAgentData) === null || i === void 0 ? void 0 : i.mobile) !== null && e !== void 0 ? e : /Tablet|iPad|Mobile|Android|BlackBerry/.test(navigator.userAgent)
  ) : !1;
}
function Su() {
  const i = Re(), e = "17.2";
  if (i)
    return i.name !== "Safari" && i.os !== "iOS" || i.os === "iOS" && i.osVersion && Ke(e, i.osVersion) >= 0 ? !0 : i.name === "Safari" && Ke(e, i.version) >= 0;
}
function Se() {
  return typeof document != "undefined";
}
function Ge() {
  return navigator.product == "ReactNative";
}
function Gn(i) {
  return i.hostname.endsWith(".livekit.cloud") || i.hostname.endsWith(".livekit.run");
}
function yo() {
  if (global && global.LiveKitReactNativeGlobal)
    return global.LiveKitReactNativeGlobal;
}
function ko() {
  if (!Ge())
    return;
  let i = yo();
  if (i)
    return i.platform;
}
function vs() {
  if (Se())
    return window.devicePixelRatio;
  if (Ge()) {
    let i = yo();
    if (i)
      return i.devicePixelRatio;
  }
  return 1;
}
function Ke(i, e) {
  const t = i.split("."), n = e.split("."), r = Math.min(t.length, n.length);
  for (let s = 0; s < r; ++s) {
    const a = parseInt(t[s], 10), o = parseInt(n[s], 10);
    if (a > o) return 1;
    if (a < o) return -1;
    if (s === r - 1 && a === o) return 0;
  }
  return i === "" && e !== "" ? -1 : e === "" ? 1 : t.length == n.length ? 0 : t.length < n.length ? -1 : 1;
}
function Cu(i) {
  for (const e of i)
    e.target.handleResize(e);
}
function Pu(i) {
  for (const e of i)
    e.target.handleVisibilityChanged(e);
}
let on = null;
const bs = () => (on || (on = new ResizeObserver(Cu)), on);
let cn = null;
const ys = () => (cn || (cn = new IntersectionObserver(Pu, {
  root: null,
  rootMargin: "0px"
})), cn);
function Eu() {
  var i;
  const e = new ld({
    sdk: Pa.JS,
    protocol: uu,
    version: du
  });
  return Ge() && (e.os = (i = ko()) !== null && i !== void 0 ? i : ""), e;
}
function ks() {
  let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 16, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 16, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  const r = document.createElement("canvas");
  r.width = i, r.height = e;
  const s = r.getContext("2d");
  s == null || s.fillRect(0, 0, r.width, r.height), n && s && (s.beginPath(), s.arc(i / 2, e / 2, 50, 0, Math.PI * 2, !0), s.closePath(), s.fillStyle = "grey", s.fill());
  const a = r.captureStream(), [o] = a.getTracks();
  if (!o)
    throw Error("Could not get empty media stream video track");
  return o.enabled = t, o;
}
let Zt;
function dn() {
  if (!Zt) {
    const i = new AudioContext(), e = i.createOscillator(), t = i.createGain();
    t.gain.setValueAtTime(0, 0);
    const n = i.createMediaStreamDestination();
    if (e.connect(t), t.connect(n), e.start(), [Zt] = n.stream.getAudioTracks(), !Zt)
      throw Error("Could not get empty media stream audio track");
    Zt.enabled = !1;
  }
  return Zt.clone();
}
class xt {
  get isResolved() {
    return this._isResolved;
  }
  constructor(e, t) {
    this._isResolved = !1, this.onFinally = t, this.promise = new Promise((n, r) => m(this, void 0, void 0, function* () {
      this.resolve = n, this.reject = r, e && (yield e(n, r));
    })).finally(() => {
      var n;
      this._isResolved = !0, (n = this.onFinally) === null || n === void 0 || n.call(this);
    });
  }
}
function Ru(i) {
  return fu.includes(i);
}
function lt(i) {
  if (typeof i == "string" || typeof i == "number")
    return i;
  if (Array.isArray(i))
    return i[0];
  if (i.exact)
    return Array.isArray(i.exact) ? i.exact[0] : i.exact;
  if (i.ideal)
    return Array.isArray(i.ideal) ? i.ideal[0] : i.ideal;
  throw Error("could not unwrap constraint");
}
function wu(i) {
  return i.startsWith("http") ? i.replace(/^(http)/, "ws") : i;
}
function Kn(i) {
  return i.startsWith("ws") ? i.replace(/^(ws)/, "http") : i;
}
function _u(i, e) {
  return i.segments.map((t) => {
    let {
      id: n,
      text: r,
      language: s,
      startTime: a,
      endTime: o,
      final: c
    } = t;
    var d;
    const u = (d = e.get(n)) !== null && d !== void 0 ? d : Date.now(), l = Date.now();
    return c ? e.delete(n) : e.set(n, u), {
      id: n,
      text: r,
      startTime: Number.parseInt(a.toString()),
      endTime: Number.parseInt(o.toString()),
      final: c,
      language: s,
      firstReceivedTime: u,
      lastReceivedTime: l
    };
  });
}
function Iu(i) {
  const {
    id: e,
    timestamp: t,
    message: n,
    editTimestamp: r
  } = i;
  return {
    id: e,
    timestamp: Number.parseInt(t.toString()),
    editTimestamp: r ? Number.parseInt(r.toString()) : void 0,
    message: n
  };
}
function Ts(i) {
  switch (i.reason) {
    case K.LeaveRequest:
      return i.context;
    case K.Cancelled:
      return Le.CLIENT_INITIATED;
    case K.NotAllowed:
      return Le.USER_REJECTED;
    case K.ServerUnreachable:
      return Le.JOIN_FAILURE;
    default:
      return Le.UNKNOWN_REASON;
  }
}
function _i(i) {
  return i !== void 0 ? Number(i) : void 0;
}
function bt(i) {
  return i !== void 0 ? BigInt(i) : void 0;
}
function Nt(i) {
  return !!i && !(i instanceof MediaStreamTrack) && i.isLocal;
}
function We(i) {
  return !!i && i.kind == E.Kind.Audio;
}
function Et(i) {
  return !!i && i.kind == E.Kind.Video;
}
function at(i) {
  return Nt(i) && Et(i);
}
function Ye(i) {
  return Nt(i) && We(i);
}
function Hn(i) {
  return !!i && !i.isLocal;
}
function Ou(i) {
  return !!i && !i.isLocal;
}
function un(i) {
  return Hn(i) && Et(i);
}
function xu(i) {
  return i.isLocal;
}
function Mu(i, e) {
  const t = [];
  let n = new TextEncoder().encode(i);
  for (; n.length > e; ) {
    let r = e;
    for (; r > 0; ) {
      const s = n[r];
      if (s !== void 0 && (s & 192) !== 128)
        break;
      r--;
    }
    t.push(n.slice(0, r)), n = n.slice(r);
  }
  return n.length > 0 && t.push(n), t;
}
function To(i, e, t) {
  var n, r, s, a;
  const {
    optionsWithoutProcessor: o,
    audioProcessor: c,
    videoProcessor: d
  } = Po(i != null ? i : {}), u = e == null ? void 0 : e.processor, l = t == null ? void 0 : t.processor, h = o != null ? o : {};
  return h.audio === !0 && (h.audio = {}), h.video === !0 && (h.video = {}), h.audio && (zn(h.audio, e), (n = (s = h.audio).deviceId) !== null && n !== void 0 || (s.deviceId = {
    ideal: "default"
  }), (c || u) && (h.audio.processor = c != null ? c : u)), h.video && (zn(h.video, t), (r = (a = h.video).deviceId) !== null && r !== void 0 || (a.deviceId = {
    ideal: "default"
  }), (d || l) && (h.video.processor = d != null ? d : l)), h;
}
function zn(i, e) {
  return Object.keys(e).forEach((t) => {
    i[t] === void 0 && (i[t] = e[t]);
  }), i;
}
function pr(i) {
  var e, t, n, r;
  const s = {};
  if (i.video)
    if (typeof i.video == "object") {
      const a = {}, o = a, c = i.video;
      Object.keys(c).forEach((d) => {
        switch (d) {
          case "resolution":
            zn(o, c.resolution);
            break;
          default:
            o[d] = c[d];
        }
      }), s.video = a, (e = (n = s.video).deviceId) !== null && e !== void 0 || (n.deviceId = {
        ideal: "default"
      });
    } else
      s.video = i.video ? {
        deviceId: {
          ideal: "default"
        }
      } : !1;
  else
    s.video = !1;
  return i.audio ? typeof i.audio == "object" ? (s.audio = i.audio, (t = (r = s.audio).deviceId) !== null && t !== void 0 || (r.deviceId = {
    ideal: "default"
  })) : s.audio = {
    deviceId: {
      ideal: "default"
    }
  } : s.audio = !1, s;
}
function So(i) {
  return m(this, arguments, void 0, function(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200;
    return function* () {
      const n = Co();
      if (n) {
        const r = n.createAnalyser();
        r.fftSize = 2048;
        const s = r.frequencyBinCount, a = new Uint8Array(s);
        n.createMediaStreamSource(new MediaStream([e.mediaStreamTrack])).connect(r), yield Ce(t), r.getByteTimeDomainData(a);
        const c = a.some((d) => d !== 128 && d !== 0);
        return n.close(), !c;
      }
      return !1;
    }();
  });
}
function Co() {
  var i;
  const e = (
    // @ts-ignore
    typeof window != "undefined" && (window.AudioContext || window.webkitAudioContext)
  );
  if (e) {
    const t = new e({
      latencyHint: "interactive"
    });
    if (t.state === "suspended" && typeof window != "undefined" && (!((i = window.document) === null || i === void 0) && i.body)) {
      const n = () => m(this, void 0, void 0, function* () {
        var r;
        try {
          t.state === "suspended" && (yield t.resume());
        } catch (s) {
        }
        (r = window.document.body) === null || r === void 0 || r.removeEventListener("click", n);
      });
      window.document.body.addEventListener("click", n);
    }
    return t;
  }
}
function Du(i) {
  return i === "audioinput" ? E.Source.Microphone : i === "videoinput" ? E.Source.Camera : E.Source.Unknown;
}
function Jn(i) {
  return i === E.Source.Microphone ? "audioinput" : i === E.Source.Camera ? "videoinput" : void 0;
}
function Au(i) {
  var e, t;
  let n = (e = i.video) !== null && e !== void 0 ? e : !0;
  return i.resolution && i.resolution.width > 0 && i.resolution.height > 0 && (n = typeof n == "boolean" ? {} : n, Ct() ? n = Object.assign(Object.assign({}, n), {
    width: {
      max: i.resolution.width
    },
    height: {
      max: i.resolution.height
    },
    frameRate: i.resolution.frameRate
  }) : n = Object.assign(Object.assign({}, n), {
    width: {
      ideal: i.resolution.width
    },
    height: {
      ideal: i.resolution.height
    },
    frameRate: i.resolution.frameRate
  })), {
    audio: (t = i.audio) !== null && t !== void 0 ? t : !1,
    video: n,
    // @ts-expect-error support for experimental display media features
    controller: i.controller,
    selfBrowserSurface: i.selfBrowserSurface,
    surfaceSwitching: i.surfaceSwitching,
    systemAudio: i.systemAudio,
    preferCurrentTab: i.preferCurrentTab
  };
}
function Ii(i) {
  return i.split("/")[1].toLowerCase();
}
function Lu(i) {
  const e = [];
  return i.forEach((t) => {
    t.track !== void 0 && e.push(new dr({
      cid: t.track.mediaStreamID,
      track: t.trackInfo
    }));
  }), e;
}
function W(i) {
  return "mediaStreamTrack" in i ? {
    trackID: i.sid,
    source: i.source,
    muted: i.isMuted,
    enabled: i.mediaStreamTrack.enabled,
    kind: i.kind,
    streamID: i.mediaStreamID,
    streamTrackID: i.mediaStreamTrack.id
  } : {
    trackID: i.trackSid,
    enabled: i.isEnabled,
    muted: i.isMuted,
    trackInfo: Object.assign({
      mimeType: i.mimeType,
      name: i.trackName,
      encrypted: i.isEncrypted,
      kind: i.kind,
      source: i.source
    }, i.track ? W(i.track) : {})
  };
}
function Nu() {
  return typeof RTCRtpReceiver != "undefined" && "getSynchronizationSources" in RTCRtpReceiver;
}
function Uu(i, e) {
  var t;
  i === void 0 && (i = {}), e === void 0 && (e = {});
  const n = [...Object.keys(e), ...Object.keys(i)], r = {};
  for (const s of n)
    i[s] !== e[s] && (r[s] = (t = e[s]) !== null && t !== void 0 ? t : "");
  return r;
}
function Po(i) {
  const e = Object.assign({}, i);
  let t, n;
  return typeof e.audio == "object" && e.audio.processor && (t = e.audio.processor, e.audio = Object.assign(Object.assign({}, e.audio), {
    processor: void 0
  })), typeof e.video == "object" && e.video.processor && (n = e.video.processor, e.video = Object.assign(Object.assign({}, e.video), {
    processor: void 0
  })), {
    audioProcessor: t,
    videoProcessor: n,
    optionsWithoutProcessor: su(e)
  };
}
function Fu(i) {
  switch (i) {
    case ae.CAMERA:
      return E.Source.Camera;
    case ae.MICROPHONE:
      return E.Source.Microphone;
    case ae.SCREEN_SHARE:
      return E.Source.ScreenShare;
    case ae.SCREEN_SHARE_AUDIO:
      return E.Source.ScreenShareAudio;
    default:
      return E.Source.Unknown;
  }
}
function Ss(i, e) {
  return i.width * i.height < e.width * e.height;
}
function ju(i, e) {
  var t;
  return (t = i.layers) === null || t === void 0 ? void 0 : t.find((n) => n.quality === e);
}
class Bu extends He.EventEmitter {
  constructor(e) {
    super(), this.onWorkerMessage = (t) => {
      var n, r;
      const {
        kind: s,
        data: a
      } = t.data;
      switch (s) {
        case "error":
          G.error(a.error.message), this.emit(dt.EncryptionError, a.error);
          break;
        case "initAck":
          a.enabled && this.keyProvider.getKeys().forEach((o) => {
            this.postKey(o);
          });
          break;
        case "enable":
          if (a.enabled && this.keyProvider.getKeys().forEach((o) => {
            this.postKey(o);
          }), this.encryptionEnabled !== a.enabled && a.participantIdentity === ((n = this.room) === null || n === void 0 ? void 0 : n.localParticipant.identity))
            this.emit(dt.ParticipantEncryptionStatusChanged, a.enabled, this.room.localParticipant), this.encryptionEnabled = a.enabled;
          else if (a.participantIdentity) {
            const o = (r = this.room) === null || r === void 0 ? void 0 : r.getParticipantByIdentity(a.participantIdentity);
            if (!o)
              throw TypeError("couldn't set encryption status, participant not found".concat(a.participantIdentity));
            this.emit(dt.ParticipantEncryptionStatusChanged, a.enabled, o);
          }
          break;
        case "ratchetKey":
          this.keyProvider.emit(ut.KeyRatcheted, a.ratchetResult, a.participantIdentity, a.keyIndex);
          break;
      }
    }, this.onWorkerError = (t) => {
      G.error("e2ee worker encountered an error:", {
        error: t.error
      }), this.emit(dt.EncryptionError, t.error);
    }, this.keyProvider = e.keyProvider, this.worker = e.worker, this.encryptionEnabled = !1;
  }
  /**
   * @internal
   */
  setup(e) {
    if (!iu())
      throw new hr("tried to setup end-to-end encryption on an unsupported browser");
    if (G.info("setting up e2ee"), e !== this.room) {
      this.room = e, this.setupEventListeners(e, this.keyProvider);
      const t = {
        kind: "init",
        data: {
          keyProviderOptions: this.keyProvider.getOptions(),
          loglevel: jd.getLevel()
        }
      };
      this.worker && (G.info("initializing worker", {
        worker: this.worker
      }), this.worker.onmessage = this.onWorkerMessage, this.worker.onerror = this.onWorkerError, this.worker.postMessage(t));
    }
  }
  /**
   * @internal
   */
  setParticipantCryptorEnabled(e, t) {
    G.debug("set e2ee to ".concat(e, " for participant ").concat(t)), this.postEnable(e, t);
  }
  /**
   * @internal
   */
  setSifTrailer(e) {
    !e || e.length === 0 ? G.warn("ignoring server sent trailer as it's empty") : this.postSifTrailer(e);
  }
  setupEngine(e) {
    e.on(M.RTPVideoMapUpdate, (t) => {
      this.postRTPMap(t);
    });
  }
  setupEventListeners(e, t) {
    e.on(S.TrackPublished, (n, r) => this.setParticipantCryptorEnabled(n.trackInfo.encryption !== Pe.NONE, r.identity)), e.on(S.ConnectionStateChanged, (n) => {
      n === H.Connected && e.remoteParticipants.forEach((r) => {
        r.trackPublications.forEach((s) => {
          this.setParticipantCryptorEnabled(s.trackInfo.encryption !== Pe.NONE, r.identity);
        });
      });
    }).on(S.TrackUnsubscribed, (n, r, s) => {
      var a;
      const o = {
        kind: "removeTransform",
        data: {
          participantIdentity: s.identity,
          trackId: n.mediaStreamID
        }
      };
      (a = this.worker) === null || a === void 0 || a.postMessage(o);
    }).on(S.TrackSubscribed, (n, r, s) => {
      this.setupE2EEReceiver(n, s.identity, r.trackInfo);
    }).on(S.SignalConnected, () => {
      if (!this.room)
        throw new TypeError("expected room to be present on signal connect");
      t.getKeys().forEach((n) => {
        this.postKey(n);
      }), this.setParticipantCryptorEnabled(this.room.localParticipant.isE2EEEnabled, this.room.localParticipant.identity);
    }), e.localParticipant.on(C.LocalSenderCreated, (n, r) => m(this, void 0, void 0, function* () {
      this.setupE2EESender(r, n);
    })), t.on(ut.SetKey, (n) => this.postKey(n)).on(ut.RatchetRequest, (n, r) => this.postRatchetRequest(n, r));
  }
  postRatchetRequest(e, t) {
    if (!this.worker)
      throw Error("could not ratchet key, worker is missing");
    const n = {
      kind: "ratchetRequest",
      data: {
        participantIdentity: e,
        keyIndex: t
      }
    };
    this.worker.postMessage(n);
  }
  postKey(e) {
    let {
      key: t,
      participantIdentity: n,
      keyIndex: r
    } = e;
    var s;
    if (!this.worker)
      throw Error("could not set key, worker is missing");
    const a = {
      kind: "setKey",
      data: {
        participantIdentity: n,
        isPublisher: n === ((s = this.room) === null || s === void 0 ? void 0 : s.localParticipant.identity),
        key: t,
        keyIndex: r
      }
    };
    this.worker.postMessage(a);
  }
  postEnable(e, t) {
    if (this.worker) {
      const n = {
        kind: "enable",
        data: {
          enabled: e,
          participantIdentity: t
        }
      };
      this.worker.postMessage(n);
    } else
      throw new ReferenceError("failed to enable e2ee, worker is not ready");
  }
  postRTPMap(e) {
    var t;
    if (!this.worker)
      throw TypeError("could not post rtp map, worker is missing");
    if (!(!((t = this.room) === null || t === void 0) && t.localParticipant.identity))
      throw TypeError("could not post rtp map, local participant identity is missing");
    const n = {
      kind: "setRTPMap",
      data: {
        map: e,
        participantIdentity: this.room.localParticipant.identity
      }
    };
    this.worker.postMessage(n);
  }
  postSifTrailer(e) {
    if (!this.worker)
      throw Error("could not post SIF trailer, worker is missing");
    const t = {
      kind: "setSifTrailer",
      data: {
        trailer: e
      }
    };
    this.worker.postMessage(t);
  }
  setupE2EEReceiver(e, t, n) {
    if (e.receiver) {
      if (!(n != null && n.mimeType) || n.mimeType === "")
        throw new TypeError("MimeType missing from trackInfo, cannot set up E2EE cryptor");
      this.handleReceiver(e.receiver, e.mediaStreamID, t, e.kind === "video" ? Ii(n.mimeType) : void 0);
    }
  }
  setupE2EESender(e, t) {
    if (!Nt(e) || !t) {
      t || G.warn("early return because sender is not ready");
      return;
    }
    this.handleSender(t, e.mediaStreamID, void 0);
  }
  /**
   * Handles the given {@code RTCRtpReceiver} by creating a {@code TransformStream} which will inject
   * a frame decoder.
   *
   */
  handleReceiver(e, t, n, r) {
    return m(this, void 0, void 0, function* () {
      if (this.worker) {
        if (Nn()) {
          const s = {
            kind: "decode",
            participantIdentity: n,
            trackId: t,
            codec: r
          };
          e.transform = new RTCRtpScriptTransform(this.worker, s);
        } else {
          if (Xt in e && r) {
            const c = {
              kind: "updateCodec",
              data: {
                trackId: t,
                codec: r,
                participantIdentity: n
              }
            };
            this.worker.postMessage(c);
            return;
          }
          let s = e.writableStream, a = e.readableStream;
          if (!s || !a) {
            const c = e.createEncodedStreams();
            e.writableStream = c.writable, s = c.writable, e.readableStream = c.readable, a = c.readable;
          }
          const o = {
            kind: "decode",
            data: {
              readableStream: a,
              writableStream: s,
              trackId: t,
              codec: r,
              participantIdentity: n,
              isReuse: Xt in e
            }
          };
          this.worker.postMessage(o, [a, s]);
        }
        e[Xt] = !0;
      }
    });
  }
  /**
   * Handles the given {@code RTCRtpSender} by creating a {@code TransformStream} which will inject
   * a frame encoder.
   *
   */
  handleSender(e, t, n) {
    var r;
    if (!(Xt in e || !this.worker)) {
      if (!(!((r = this.room) === null || r === void 0) && r.localParticipant.identity) || this.room.localParticipant.identity === "")
        throw TypeError("local identity needs to be known in order to set up encrypted sender");
      if (Nn()) {
        G.info("initialize script transform");
        const s = {
          kind: "encode",
          participantIdentity: this.room.localParticipant.identity,
          trackId: t,
          codec: n
        };
        e.transform = new RTCRtpScriptTransform(this.worker, s);
      } else {
        G.info("initialize encoded streams");
        const s = e.createEncodedStreams(), a = {
          kind: "encode",
          data: {
            readableStream: s.readable,
            writableStream: s.writable,
            codec: n,
            trackId: t,
            participantIdentity: this.room.localParticipant.identity,
            isReuse: !1
          }
        };
        this.worker.postMessage(a, [s.readable, s.writable]);
      }
      e[Xt] = !0;
    }
  }
}
const ln = "default";
class he {
  constructor() {
    this._previousDevices = [];
  }
  static getInstance() {
    return this.instance === void 0 && (this.instance = new he()), this.instance;
  }
  get previousDevices() {
    return this._previousDevices;
  }
  getDevices(e) {
    return m(this, arguments, void 0, function(t) {
      var n = this;
      let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      return function* () {
        var s;
        if (((s = he.userMediaPromiseMap) === null || s === void 0 ? void 0 : s.size) > 0) {
          G.debug("awaiting getUserMedia promise");
          try {
            t ? yield he.userMediaPromiseMap.get(t) : yield Promise.all(he.userMediaPromiseMap.values());
          } catch (o) {
            G.warn("error waiting for media permissons");
          }
        }
        let a = yield navigator.mediaDevices.enumerateDevices();
        if (r && // for safari we need to skip this check, as otherwise it will re-acquire user media and fail on iOS https://bugs.webkit.org/show_bug.cgi?id=179363
        !(Ct() && n.hasDeviceInUse(t)) && (a.filter((c) => c.kind === t).length === 0 || a.some((c) => {
          const d = c.label === "", u = t ? c.kind === t : !0;
          return d && u;
        }))) {
          const c = {
            video: t !== "audioinput" && t !== "audiooutput",
            audio: t !== "videoinput" && {
              deviceId: {
                ideal: "default"
              }
            }
          }, d = yield navigator.mediaDevices.getUserMedia(c);
          a = yield navigator.mediaDevices.enumerateDevices(), d.getTracks().forEach((u) => {
            u.stop();
          });
        }
        return n._previousDevices = a, t && (a = a.filter((o) => o.kind === t)), a;
      }();
    });
  }
  normalizeDeviceId(e, t, n) {
    return m(this, void 0, void 0, function* () {
      if (t !== ln)
        return t;
      const r = yield this.getDevices(e), s = r.find((o) => o.deviceId === ln);
      if (!s) {
        G.warn("could not reliably determine default device");
        return;
      }
      const a = r.find((o) => o.deviceId !== ln && o.groupId === (n != null ? n : s.groupId));
      if (!a) {
        G.warn("could not reliably determine default device");
        return;
      }
      return a == null ? void 0 : a.deviceId;
    });
  }
  hasDeviceInUse(e) {
    return e ? he.userMediaPromiseMap.has(e) : he.userMediaPromiseMap.size > 0;
  }
}
he.mediaDeviceKinds = ["audioinput", "audiooutput", "videoinput"];
he.userMediaPromiseMap = /* @__PURE__ */ new Map();
var si;
(function(i) {
  i[i.WAITING = 0] = "WAITING", i[i.RUNNING = 1] = "RUNNING", i[i.COMPLETED = 2] = "COMPLETED";
})(si || (si = {}));
class Vu {
  constructor() {
    this.pendingTasks = /* @__PURE__ */ new Map(), this.taskMutex = new ge(), this.nextTaskIndex = 0;
  }
  run(e) {
    return m(this, void 0, void 0, function* () {
      const t = {
        id: this.nextTaskIndex++,
        enqueuedAt: Date.now(),
        status: si.WAITING
      };
      this.pendingTasks.set(t.id, t);
      const n = yield this.taskMutex.lock();
      try {
        return t.executedAt = Date.now(), t.status = si.RUNNING, yield e();
      } finally {
        t.status = si.COMPLETED, this.pendingTasks.delete(t.id), n();
      }
    });
  }
  flush() {
    return m(this, void 0, void 0, function* () {
      return this.run(() => m(this, void 0, void 0, function* () {
      }));
    });
  }
  snapshot() {
    return Array.from(this.pendingTasks.values());
  }
}
function qu(i, e) {
  const t = new URL(wu(i));
  return e.forEach((n, r) => {
    t.searchParams.set(r, n);
  }), Eo(t, "rtc");
}
function Wu(i) {
  const e = new URL(Kn(i));
  return Eo(e, "validate");
}
function Gu(i) {
  return i.endsWith("/") ? i : "".concat(i, "/");
}
function Eo(i, e) {
  return i.pathname = "".concat(Gu(i.pathname)).concat(e), i.toString();
}
const Ku = ["syncState", "trickle", "offer", "answer", "simulate", "leave"];
function Hu(i) {
  const e = Ku.indexOf(i.case) >= 0;
  return G.trace("request allowed to bypass queue:", {
    canPass: e,
    req: i
  }), e;
}
var Y;
(function(i) {
  i[i.CONNECTING = 0] = "CONNECTING", i[i.CONNECTED = 1] = "CONNECTED", i[i.RECONNECTING = 2] = "RECONNECTING", i[i.DISCONNECTING = 3] = "DISCONNECTING", i[i.DISCONNECTED = 4] = "DISCONNECTED";
})(Y || (Y = {}));
class mr {
  get currentState() {
    return this.state;
  }
  get isDisconnected() {
    return this.state === Y.DISCONNECTING || this.state === Y.DISCONNECTED;
  }
  get isEstablishingConnection() {
    return this.state === Y.CONNECTING || this.state === Y.RECONNECTING;
  }
  getNextRequestId() {
    return this._requestId += 1, this._requestId;
  }
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var n;
    this.rtt = 0, this.state = Y.DISCONNECTED, this.log = G, this._requestId = 0, this.resetCallbacks = () => {
      this.onAnswer = void 0, this.onLeave = void 0, this.onLocalTrackPublished = void 0, this.onLocalTrackUnpublished = void 0, this.onNegotiateRequested = void 0, this.onOffer = void 0, this.onRemoteMuteChanged = void 0, this.onSubscribedQualityUpdate = void 0, this.onTokenRefresh = void 0, this.onTrickle = void 0, this.onClose = void 0;
    }, this.log = it((n = t.loggerName) !== null && n !== void 0 ? n : Ne.Signal), this.loggerContextCb = t.loggerContextCb, this.useJSON = e, this.requestQueue = new Vu(), this.queuedRequests = [], this.closingLock = new ge(), this.connectionLock = new ge(), this.state = Y.DISCONNECTED;
  }
  get logContext() {
    var e, t;
    return (t = (e = this.loggerContextCb) === null || e === void 0 ? void 0 : e.call(this)) !== null && t !== void 0 ? t : {};
  }
  join(e, t, n, r) {
    return m(this, void 0, void 0, function* () {
      return this.state = Y.CONNECTING, this.options = n, yield this.connect(e, t, n, r);
    });
  }
  reconnect(e, t, n, r) {
    return m(this, void 0, void 0, function* () {
      if (!this.options) {
        this.log.warn("attempted to reconnect without signal options being set, ignoring", this.logContext);
        return;
      }
      return this.state = Y.RECONNECTING, this.clearPingInterval(), yield this.connect(e, t, Object.assign(Object.assign({}, this.options), {
        reconnect: !0,
        sid: n,
        reconnectReason: r
      }));
    });
  }
  connect(e, t, n, r) {
    this.connectOptions = n;
    const s = Eu(), a = zu(t, s, n), o = qu(e, a), c = Wu(o);
    return new Promise((d, u) => m(this, void 0, void 0, function* () {
      const l = yield this.connectionLock.lock();
      try {
        const h = () => m(this, void 0, void 0, function* () {
          this.close(), clearTimeout(p), u(new Q("room connection has been cancelled (signal)", K.Cancelled));
        }), p = setTimeout(() => {
          this.close(), u(new Q("room connection has timed out (signal)", K.ServerUnreachable));
        }, n.websocketTimeout);
        r != null && r.aborted && h(), r == null || r.addEventListener("abort", h);
        const v = new URL(o);
        v.searchParams.has("access_token") && v.searchParams.set("access_token", "<redacted>"), this.log.debug("connecting to ".concat(v), Object.assign({
          reconnect: n.reconnect,
          reconnectReason: n.reconnectReason
        }, this.logContext)), this.ws && (yield this.close(!1)), this.ws = new WebSocket(o), this.ws.binaryType = "arraybuffer", this.ws.onopen = () => {
          clearTimeout(p);
        }, this.ws.onerror = (f) => m(this, void 0, void 0, function* () {
          if (this.state !== Y.CONNECTED) {
            this.state = Y.DISCONNECTED, clearTimeout(p);
            try {
              const T = yield fetch(c);
              if (T.status.toFixed(0).startsWith("4")) {
                const g = yield T.text();
                u(new Q(g, K.NotAllowed, T.status));
              } else
                u(new Q("Encountered unknown websocket error during connection: ".concat(f.toString()), K.InternalError, T.status));
            } catch (T) {
              u(new Q(T instanceof Error ? T.message : "server was not reachable", K.ServerUnreachable));
            }
            return;
          }
          this.handleWSError(f);
        }), this.ws.onmessage = (f) => m(this, void 0, void 0, function* () {
          var T, g, O;
          let w;
          if (typeof f.data == "string") {
            const b = JSON.parse(f.data);
            w = Zr.fromJson(b, {
              ignoreUnknownFields: !0
            });
          } else if (f.data instanceof ArrayBuffer)
            w = Zr.fromBinary(new Uint8Array(f.data));
          else {
            this.log.error("could not decode websocket message: ".concat(typeof f.data), this.logContext);
            return;
          }
          if (this.state !== Y.CONNECTED) {
            let b = !1;
            if (((T = w.message) === null || T === void 0 ? void 0 : T.case) === "join" ? (this.state = Y.CONNECTED, r == null || r.removeEventListener("abort", h), this.pingTimeoutDuration = w.message.value.pingTimeout, this.pingIntervalDuration = w.message.value.pingInterval, this.pingTimeoutDuration && this.pingTimeoutDuration > 0 && (this.log.debug("ping config", Object.assign(Object.assign({}, this.logContext), {
              timeout: this.pingTimeoutDuration,
              interval: this.pingIntervalDuration
            })), this.startPingInterval()), d(w.message.value)) : this.state === Y.RECONNECTING && w.message.case !== "leave" ? (this.state = Y.CONNECTED, r == null || r.removeEventListener("abort", h), this.startPingInterval(), ((g = w.message) === null || g === void 0 ? void 0 : g.case) === "reconnect" ? d(w.message.value) : (this.log.debug("declaring signal reconnected without reconnect response received", this.logContext), d(void 0), b = !0)) : this.isEstablishingConnection && w.message.case === "leave" ? u(new Q("Received leave request while trying to (re)connect", K.LeaveRequest, void 0, w.message.value.reason)) : n.reconnect || u(new Q("did not receive join response, got ".concat((O = w.message) === null || O === void 0 ? void 0 : O.case, " instead"), K.InternalError)), !b)
              return;
          }
          this.signalLatency && (yield Ce(this.signalLatency)), this.handleSignalResponse(w);
        }), this.ws.onclose = (f) => {
          this.isEstablishingConnection && u(new Q("Websocket got closed during a (re)connection attempt", K.InternalError)), this.log.warn("websocket closed", Object.assign(Object.assign({}, this.logContext), {
            reason: f.reason,
            code: f.code,
            wasClean: f.wasClean,
            state: this.state
          })), this.handleOnClose(f.reason);
        };
      } finally {
        l();
      }
    }));
  }
  close() {
    return m(this, arguments, void 0, function() {
      var e = this;
      let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      return function* () {
        const n = yield e.closingLock.lock();
        try {
          if (e.clearPingInterval(), t && (e.state = Y.DISCONNECTING), e.ws) {
            e.ws.onmessage = null, e.ws.onopen = null, e.ws.onclose = null;
            const r = new Promise((s) => {
              e.ws ? e.ws.onclose = () => {
                s();
              } : s();
            });
            e.ws.readyState < e.ws.CLOSING && (e.ws.close(), yield Promise.race([r, Ce(250)])), e.ws = void 0;
          }
        } finally {
          t && (e.state = Y.DISCONNECTED), n();
        }
      }();
    });
  }
  // initial offer after joining
  sendOffer(e, t) {
    this.log.debug("sending offer", Object.assign(Object.assign({}, this.logContext), {
      offerSdp: e.sdp
    })), this.sendRequest({
      case: "offer",
      value: Ni(e, t)
    });
  }
  // answer a server-initiated offer
  sendAnswer(e, t) {
    return this.log.debug("sending answer", Object.assign(Object.assign({}, this.logContext), {
      answerSdp: e.sdp
    })), this.sendRequest({
      case: "answer",
      value: Ni(e, t)
    });
  }
  sendIceCandidate(e, t) {
    return this.log.debug("sending ice candidate", Object.assign(Object.assign({}, this.logContext), {
      candidate: e
    })), this.sendRequest({
      case: "trickle",
      value: new or({
        candidateInit: JSON.stringify(e),
        target: t
      })
    });
  }
  sendMuteTrack(e, t) {
    return this.sendRequest({
      case: "mute",
      value: new cr({
        sid: e,
        muted: t
      })
    });
  }
  sendAddTrack(e) {
    return this.sendRequest({
      case: "addTrack",
      value: e
    });
  }
  sendUpdateLocalMetadata(e, t) {
    return m(this, arguments, void 0, function(n, r) {
      var s = this;
      let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return function* () {
        const o = s.getNextRequestId();
        return yield s.sendRequest({
          case: "updateMetadata",
          value: new Ma({
            requestId: o,
            metadata: n,
            name: r,
            attributes: a
          })
        }), o;
      }();
    });
  }
  sendUpdateTrackSettings(e) {
    this.sendRequest({
      case: "trackSetting",
      value: e
    });
  }
  sendUpdateSubscription(e) {
    return this.sendRequest({
      case: "subscription",
      value: e
    });
  }
  sendSyncState(e) {
    return this.sendRequest({
      case: "syncState",
      value: e
    });
  }
  sendUpdateVideoLayers(e, t) {
    return this.sendRequest({
      case: "updateLayers",
      value: new xa({
        trackSid: e,
        layers: t
      })
    });
  }
  sendUpdateSubscriptionPermissions(e, t) {
    return this.sendRequest({
      case: "subscriptionPermission",
      value: new La({
        allParticipants: e,
        trackPermissions: t
      })
    });
  }
  sendSimulateScenario(e) {
    return this.sendRequest({
      case: "simulate",
      value: e
    });
  }
  sendPing() {
    return Promise.all([this.sendRequest({
      case: "ping",
      value: Z.parse(Date.now())
    }), this.sendRequest({
      case: "pingReq",
      value: new ja({
        timestamp: Z.parse(Date.now()),
        rtt: Z.parse(this.rtt)
      })
    })]);
  }
  sendUpdateLocalAudioTrack(e, t) {
    return this.sendRequest({
      case: "updateAudioTrack",
      value: new Oa({
        trackSid: e,
        features: t
      })
    });
  }
  sendLeave() {
    return this.sendRequest({
      case: "leave",
      value: new Ki({
        reason: Le.CLIENT_INITIATED,
        // server doesn't process this field, keeping it here to indicate the intent of a full disconnect
        action: Dt.DISCONNECT
      })
    });
  }
  sendRequest(e) {
    return m(this, arguments, void 0, function(t) {
      var n = this;
      let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      return function* () {
        if (!r && !Hu(t) && n.state === Y.RECONNECTING) {
          n.queuedRequests.push(() => m(n, void 0, void 0, function* () {
            yield this.sendRequest(t, !0);
          }));
          return;
        }
        if (r || (yield n.requestQueue.flush()), n.signalLatency && (yield Ce(n.signalLatency)), !n.ws || n.ws.readyState !== n.ws.OPEN) {
          n.log.error("cannot send signal request before connected, type: ".concat(t == null ? void 0 : t.case), n.logContext);
          return;
        }
        const a = new pd({
          message: t
        });
        try {
          n.useJSON ? n.ws.send(a.toJsonString()) : n.ws.send(a.toBinary());
        } catch (o) {
          n.log.error("error sending signal message", Object.assign(Object.assign({}, n.logContext), {
            error: o
          }));
        }
      }();
    });
  }
  handleSignalResponse(e) {
    var t, n;
    const r = e.message;
    if (r == null) {
      this.log.debug("received unsupported message", this.logContext);
      return;
    }
    let s = !1;
    if (r.case === "answer") {
      const a = Cs(r.value);
      this.onAnswer && this.onAnswer(a, r.value.id);
    } else if (r.case === "offer") {
      const a = Cs(r.value);
      this.onOffer && this.onOffer(a, r.value.id);
    } else if (r.case === "trickle") {
      const a = JSON.parse(r.value.candidateInit);
      this.onTrickle && this.onTrickle(a, r.value.target);
    } else r.case === "update" ? this.onParticipantUpdate && this.onParticipantUpdate((t = r.value.participants) !== null && t !== void 0 ? t : []) : r.case === "trackPublished" ? this.onLocalTrackPublished && this.onLocalTrackPublished(r.value) : r.case === "speakersChanged" ? this.onSpeakersChanged && this.onSpeakersChanged((n = r.value.speakers) !== null && n !== void 0 ? n : []) : r.case === "leave" ? this.onLeave && this.onLeave(r.value) : r.case === "mute" ? this.onRemoteMuteChanged && this.onRemoteMuteChanged(r.value.sid, r.value.muted) : r.case === "roomUpdate" ? this.onRoomUpdate && r.value.room && this.onRoomUpdate(r.value.room) : r.case === "connectionQuality" ? this.onConnectionQuality && this.onConnectionQuality(r.value) : r.case === "streamStateUpdate" ? this.onStreamStateUpdate && this.onStreamStateUpdate(r.value) : r.case === "subscribedQualityUpdate" ? this.onSubscribedQualityUpdate && this.onSubscribedQualityUpdate(r.value) : r.case === "subscriptionPermissionUpdate" ? this.onSubscriptionPermissionUpdate && this.onSubscriptionPermissionUpdate(r.value) : r.case === "refreshToken" ? this.onTokenRefresh && this.onTokenRefresh(r.value) : r.case === "trackUnpublished" ? this.onLocalTrackUnpublished && this.onLocalTrackUnpublished(r.value) : r.case === "subscriptionResponse" ? this.onSubscriptionError && this.onSubscriptionError(r.value) : r.case === "pong" || (r.case === "pongResp" ? (this.rtt = Date.now() - Number.parseInt(r.value.lastPingTimestamp.toString()), this.resetPingTimeout(), s = !0) : r.case === "requestResponse" ? this.onRequestResponse && this.onRequestResponse(r.value) : r.case === "trackSubscribed" ? this.onLocalTrackSubscribed && this.onLocalTrackSubscribed(r.value.trackSid) : r.case === "roomMoved" ? (this.onTokenRefresh && this.onTokenRefresh(r.value.token), this.onRoomMoved && this.onRoomMoved(r.value)) : this.log.debug("unsupported message", Object.assign(Object.assign({}, this.logContext), {
      msgCase: r.case
    })));
    s || this.resetPingTimeout();
  }
  setReconnected() {
    for (; this.queuedRequests.length > 0; ) {
      const e = this.queuedRequests.shift();
      e && this.requestQueue.run(e);
    }
  }
  handleOnClose(e) {
    return m(this, void 0, void 0, function* () {
      if (this.state === Y.DISCONNECTED) return;
      const t = this.onClose;
      yield this.close(), this.log.debug("websocket connection closed: ".concat(e), Object.assign(Object.assign({}, this.logContext), {
        reason: e
      })), t && t(e);
    });
  }
  handleWSError(e) {
    this.log.error("websocket error", Object.assign(Object.assign({}, this.logContext), {
      error: e
    }));
  }
  /**
   * Resets the ping timeout and starts a new timeout.
   * Call this after receiving a pong message
   */
  resetPingTimeout() {
    if (this.clearPingTimeout(), !this.pingTimeoutDuration) {
      this.log.warn("ping timeout duration not set", this.logContext);
      return;
    }
    this.pingTimeout = pe.setTimeout(() => {
      this.log.warn("ping timeout triggered. last pong received at: ".concat(new Date(Date.now() - this.pingTimeoutDuration * 1e3).toUTCString()), this.logContext), this.handleOnClose("ping timeout");
    }, this.pingTimeoutDuration * 1e3);
  }
  /**
   * Clears ping timeout (does not start a new timeout)
   */
  clearPingTimeout() {
    this.pingTimeout && pe.clearTimeout(this.pingTimeout);
  }
  startPingInterval() {
    if (this.clearPingInterval(), this.resetPingTimeout(), !this.pingIntervalDuration) {
      this.log.warn("ping interval duration not set", this.logContext);
      return;
    }
    this.log.debug("start ping interval", this.logContext), this.pingInterval = pe.setInterval(() => {
      this.sendPing();
    }, this.pingIntervalDuration * 1e3);
  }
  clearPingInterval() {
    this.log.debug("clearing ping interval", this.logContext), this.clearPingTimeout(), this.pingInterval && pe.clearInterval(this.pingInterval);
  }
}
function Cs(i) {
  const e = {
    type: "offer",
    sdp: i.sdp
  };
  switch (i.type) {
    case "answer":
    case "offer":
    case "pranswer":
    case "rollback":
      e.type = i.type;
      break;
  }
  return e;
}
function Ni(i, e) {
  return new St({
    sdp: i.sdp,
    type: i.type,
    id: e
  });
}
function zu(i, e, t) {
  var n;
  const r = new URLSearchParams();
  return r.set("access_token", i), t.reconnect && (r.set("reconnect", "1"), t.sid && r.set("sid", t.sid)), r.set("auto_subscribe", t.autoSubscribe ? "1" : "0"), r.set("sdk", Ge() ? "reactnative" : "js"), r.set("version", e.version), r.set("protocol", e.protocol.toString()), e.deviceModel && r.set("device_model", e.deviceModel), e.os && r.set("os", e.os), e.osVersion && r.set("os_version", e.osVersion), e.browser && r.set("browser", e.browser), e.browserVersion && r.set("browser_version", e.browserVersion), t.adaptiveStream && r.set("adaptive_stream", "1"), t.reconnectReason && r.set("reconnect_reason", t.reconnectReason.toString()), !((n = navigator.connection) === null || n === void 0) && n.type && r.set("network", navigator.connection.type), r;
}
class Ps {
  constructor() {
    this.buffer = [], this._totalSize = 0;
  }
  push(e) {
    this.buffer.push(e), this._totalSize += e.data.byteLength;
  }
  pop() {
    const e = this.buffer.shift();
    return e && (this._totalSize -= e.data.byteLength), e;
  }
  getAll() {
    return this.buffer.slice();
  }
  popToSequence(e) {
    for (; this.buffer.length > 0 && this.buffer[0].sequence <= e; )
      this.pop();
  }
  alignBufferedAmount(e) {
    for (; this.buffer.length > 0; ) {
      const t = this.buffer[0];
      if (this._totalSize - t.data.byteLength <= e)
        break;
      this.pop();
    }
  }
  get length() {
    return this.buffer.length;
  }
}
class Ju {
  /**
   * @param ttl ttl of the key (ms)
   */
  constructor(e) {
    this._map = /* @__PURE__ */ new Map(), this._lastCleanup = 0, this.ttl = e;
  }
  set(e, t) {
    const n = Date.now();
    n - this._lastCleanup > this.ttl / 2 && this.cleanup();
    const r = n + this.ttl;
    return this._map.set(e, {
      value: t,
      expiresAt: r
    }), this;
  }
  get(e) {
    const t = this._map.get(e);
    if (t) {
      if (t.expiresAt < Date.now()) {
        this._map.delete(e);
        return;
      }
      return t.value;
    }
  }
  has(e) {
    const t = this._map.get(e);
    return t ? t.expiresAt < Date.now() ? (this._map.delete(e), !1) : !0 : !1;
  }
  delete(e) {
    return this._map.delete(e);
  }
  clear() {
    this._map.clear();
  }
  cleanup() {
    const e = Date.now();
    for (const [t, n] of this._map.entries())
      n.expiresAt < e && this._map.delete(t);
    this._lastCleanup = e;
  }
  get size() {
    return this.cleanup(), this._map.size;
  }
  forEach(e) {
    this.cleanup();
    for (const [t, n] of this._map.entries())
      n.expiresAt >= Date.now() && e(n.value, t, this.asValueMap());
  }
  map(e) {
    this.cleanup();
    const t = [], n = this.asValueMap();
    for (const [r, s] of n.entries())
      t.push(e(s, r, n));
    return t;
  }
  asValueMap() {
    const e = /* @__PURE__ */ new Map();
    for (const [t, n] of this._map.entries())
      n.expiresAt >= Date.now() && e.set(t, n.value);
    return e;
  }
}
var Oe = {}, hn = {}, fn = { exports: {} }, Es;
function gr() {
  if (Es) return fn.exports;
  Es = 1;
  var i = fn.exports = {
    v: [{
      name: "version",
      reg: /^(\d*)$/
    }],
    o: [{
      // o=- 20518 0 IN IP4 203.0.113.1
      // NB: sessionId will be a String in most cases because it is huge
      name: "origin",
      reg: /^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/,
      names: ["username", "sessionId", "sessionVersion", "netType", "ipVer", "address"],
      format: "%s %s %d %s IP%d %s"
    }],
    // default parsing of these only (though some of these feel outdated)
    s: [{
      name: "name"
    }],
    i: [{
      name: "description"
    }],
    u: [{
      name: "uri"
    }],
    e: [{
      name: "email"
    }],
    p: [{
      name: "phone"
    }],
    z: [{
      name: "timezones"
    }],
    // TODO: this one can actually be parsed properly...
    r: [{
      name: "repeats"
    }],
    // TODO: this one can also be parsed properly
    // k: [{}], // outdated thing ignored
    t: [{
      // t=0 0
      name: "timing",
      reg: /^(\d*) (\d*)/,
      names: ["start", "stop"],
      format: "%d %d"
    }],
    c: [{
      // c=IN IP4 10.47.197.26
      name: "connection",
      reg: /^IN IP(\d) (\S*)/,
      names: ["version", "ip"],
      format: "IN IP%d %s"
    }],
    b: [{
      // b=AS:4000
      push: "bandwidth",
      reg: /^(TIAS|AS|CT|RR|RS):(\d*)/,
      names: ["type", "limit"],
      format: "%s:%s"
    }],
    m: [{
      // m=video 51744 RTP/AVP 126 97 98 34 31
      // NB: special - pushes to session
      // TODO: rtp/fmtp should be filtered by the payloads found here?
      reg: /^(\w*) (\d*) ([\w/]*)(?: (.*))?/,
      names: ["type", "port", "protocol", "payloads"],
      format: "%s %d %s %s"
    }],
    a: [
      {
        // a=rtpmap:110 opus/48000/2
        push: "rtp",
        reg: /^rtpmap:(\d*) ([\w\-.]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/,
        names: ["payload", "codec", "rate", "encoding"],
        format: function(e) {
          return e.encoding ? "rtpmap:%d %s/%s/%s" : e.rate ? "rtpmap:%d %s/%s" : "rtpmap:%d %s";
        }
      },
      {
        // a=fmtp:108 profile-level-id=24;object=23;bitrate=64000
        // a=fmtp:111 minptime=10; useinbandfec=1
        push: "fmtp",
        reg: /^fmtp:(\d*) ([\S| ]*)/,
        names: ["payload", "config"],
        format: "fmtp:%d %s"
      },
      {
        // a=control:streamid=0
        name: "control",
        reg: /^control:(.*)/,
        format: "control:%s"
      },
      {
        // a=rtcp:65179 IN IP4 193.84.77.194
        name: "rtcp",
        reg: /^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/,
        names: ["port", "netType", "ipVer", "address"],
        format: function(e) {
          return e.address != null ? "rtcp:%d %s IP%d %s" : "rtcp:%d";
        }
      },
      {
        // a=rtcp-fb:98 trr-int 100
        push: "rtcpFbTrrInt",
        reg: /^rtcp-fb:(\*|\d*) trr-int (\d*)/,
        names: ["payload", "value"],
        format: "rtcp-fb:%s trr-int %d"
      },
      {
        // a=rtcp-fb:98 nack rpsi
        push: "rtcpFb",
        reg: /^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/,
        names: ["payload", "type", "subtype"],
        format: function(e) {
          return e.subtype != null ? "rtcp-fb:%s %s %s" : "rtcp-fb:%s %s";
        }
      },
      {
        // a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
        // a=extmap:1/recvonly URI-gps-string
        // a=extmap:3 urn:ietf:params:rtp-hdrext:encrypt urn:ietf:params:rtp-hdrext:smpte-tc 25@600/24
        push: "ext",
        reg: /^extmap:(\d+)(?:\/(\w+))?(?: (urn:ietf:params:rtp-hdrext:encrypt))? (\S*)(?: (\S*))?/,
        names: ["value", "direction", "encrypt-uri", "uri", "config"],
        format: function(e) {
          return "extmap:%d" + (e.direction ? "/%s" : "%v") + (e["encrypt-uri"] ? " %s" : "%v") + " %s" + (e.config ? " %s" : "");
        }
      },
      {
        // a=extmap-allow-mixed
        name: "extmapAllowMixed",
        reg: /^(extmap-allow-mixed)/
      },
      {
        // a=crypto:1 AES_CM_128_HMAC_SHA1_80 inline:PS1uQCVeeCFCanVmcjkpPywjNWhcYD0mXXtxaVBR|2^20|1:32
        push: "crypto",
        reg: /^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/,
        names: ["id", "suite", "config", "sessionConfig"],
        format: function(e) {
          return e.sessionConfig != null ? "crypto:%d %s %s %s" : "crypto:%d %s %s";
        }
      },
      {
        // a=setup:actpass
        name: "setup",
        reg: /^setup:(\w*)/,
        format: "setup:%s"
      },
      {
        // a=connection:new
        name: "connectionType",
        reg: /^connection:(new|existing)/,
        format: "connection:%s"
      },
      {
        // a=mid:1
        name: "mid",
        reg: /^mid:([^\s]*)/,
        format: "mid:%s"
      },
      {
        // a=msid:0c8b064d-d807-43b4-b434-f92a889d8587 98178685-d409-46e0-8e16-7ef0db0db64a
        name: "msid",
        reg: /^msid:(.*)/,
        format: "msid:%s"
      },
      {
        // a=ptime:20
        name: "ptime",
        reg: /^ptime:(\d*(?:\.\d*)*)/,
        format: "ptime:%d"
      },
      {
        // a=maxptime:60
        name: "maxptime",
        reg: /^maxptime:(\d*(?:\.\d*)*)/,
        format: "maxptime:%d"
      },
      {
        // a=sendrecv
        name: "direction",
        reg: /^(sendrecv|recvonly|sendonly|inactive)/
      },
      {
        // a=ice-lite
        name: "icelite",
        reg: /^(ice-lite)/
      },
      {
        // a=ice-ufrag:F7gI
        name: "iceUfrag",
        reg: /^ice-ufrag:(\S*)/,
        format: "ice-ufrag:%s"
      },
      {
        // a=ice-pwd:x9cml/YzichV2+XlhiMu8g
        name: "icePwd",
        reg: /^ice-pwd:(\S*)/,
        format: "ice-pwd:%s"
      },
      {
        // a=fingerprint:SHA-1 00:11:22:33:44:55:66:77:88:99:AA:BB:CC:DD:EE:FF:00:11:22:33
        name: "fingerprint",
        reg: /^fingerprint:(\S*) (\S*)/,
        names: ["type", "hash"],
        format: "fingerprint:%s %s"
      },
      {
        // a=candidate:0 1 UDP 2113667327 203.0.113.1 54400 typ host
        // a=candidate:1162875081 1 udp 2113937151 192.168.34.75 60017 typ host generation 0 network-id 3 network-cost 10
        // a=candidate:3289912957 2 udp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 generation 0 network-id 3 network-cost 10
        // a=candidate:229815620 1 tcp 1518280447 192.168.150.19 60017 typ host tcptype active generation 0 network-id 3 network-cost 10
        // a=candidate:3289912957 2 tcp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 tcptype passive generation 0 network-id 3 network-cost 10
        push: "candidates",
        reg: /^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?(?: network-id (\d*))?(?: network-cost (\d*))?/,
        names: ["foundation", "component", "transport", "priority", "ip", "port", "type", "raddr", "rport", "tcptype", "generation", "network-id", "network-cost"],
        format: function(e) {
          var t = "candidate:%s %d %s %d %s %d typ %s";
          return t += e.raddr != null ? " raddr %s rport %d" : "%v%v", t += e.tcptype != null ? " tcptype %s" : "%v", e.generation != null && (t += " generation %d"), t += e["network-id"] != null ? " network-id %d" : "%v", t += e["network-cost"] != null ? " network-cost %d" : "%v", t;
        }
      },
      {
        // a=end-of-candidates (keep after the candidates line for readability)
        name: "endOfCandidates",
        reg: /^(end-of-candidates)/
      },
      {
        // a=remote-candidates:1 203.0.113.1 54400 2 203.0.113.1 54401 ...
        name: "remoteCandidates",
        reg: /^remote-candidates:(.*)/,
        format: "remote-candidates:%s"
      },
      {
        // a=ice-options:google-ice
        name: "iceOptions",
        reg: /^ice-options:(\S*)/,
        format: "ice-options:%s"
      },
      {
        // a=ssrc:2566107569 cname:t9YU8M1UxTF8Y1A1
        push: "ssrcs",
        reg: /^ssrc:(\d*) ([\w_-]*)(?::(.*))?/,
        names: ["id", "attribute", "value"],
        format: function(e) {
          var t = "ssrc:%d";
          return e.attribute != null && (t += " %s", e.value != null && (t += ":%s")), t;
        }
      },
      {
        // a=ssrc-group:FEC 1 2
        // a=ssrc-group:FEC-FR 3004364195 1080772241
        push: "ssrcGroups",
        // token-char = %x21 / %x23-27 / %x2A-2B / %x2D-2E / %x30-39 / %x41-5A / %x5E-7E
        reg: /^ssrc-group:([\x21\x23\x24\x25\x26\x27\x2A\x2B\x2D\x2E\w]*) (.*)/,
        names: ["semantics", "ssrcs"],
        format: "ssrc-group:%s %s"
      },
      {
        // a=msid-semantic: WMS Jvlam5X3SX1OP6pn20zWogvaKJz5Hjf9OnlV
        name: "msidSemantic",
        reg: /^msid-semantic:\s?(\w*) (\S*)/,
        names: ["semantic", "token"],
        format: "msid-semantic: %s %s"
        // space after ':' is not accidental
      },
      {
        // a=group:BUNDLE audio video
        push: "groups",
        reg: /^group:(\w*) (.*)/,
        names: ["type", "mids"],
        format: "group:%s %s"
      },
      {
        // a=rtcp-mux
        name: "rtcpMux",
        reg: /^(rtcp-mux)/
      },
      {
        // a=rtcp-rsize
        name: "rtcpRsize",
        reg: /^(rtcp-rsize)/
      },
      {
        // a=sctpmap:5000 webrtc-datachannel 1024
        name: "sctpmap",
        reg: /^sctpmap:([\w_/]*) (\S*)(?: (\S*))?/,
        names: ["sctpmapNumber", "app", "maxMessageSize"],
        format: function(e) {
          return e.maxMessageSize != null ? "sctpmap:%s %s %s" : "sctpmap:%s %s";
        }
      },
      {
        // a=x-google-flag:conference
        name: "xGoogleFlag",
        reg: /^x-google-flag:([^\s]*)/,
        format: "x-google-flag:%s"
      },
      {
        // a=rid:1 send max-width=1280;max-height=720;max-fps=30;depend=0
        push: "rids",
        reg: /^rid:([\d\w]+) (\w+)(?: ([\S| ]*))?/,
        names: ["id", "direction", "params"],
        format: function(e) {
          return e.params ? "rid:%s %s %s" : "rid:%s %s";
        }
      },
      {
        // a=imageattr:97 send [x=800,y=640,sar=1.1,q=0.6] [x=480,y=320] recv [x=330,y=250]
        // a=imageattr:* send [x=800,y=640] recv *
        // a=imageattr:100 recv [x=320,y=240]
        push: "imageattrs",
        reg: new RegExp(
          // a=imageattr:97
          "^imageattr:(\\d+|\\*)[\\s\\t]+(send|recv)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*)(?:[\\s\\t]+(recv|send)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*))?"
        ),
        names: ["pt", "dir1", "attrs1", "dir2", "attrs2"],
        format: function(e) {
          return "imageattr:%s %s %s" + (e.dir2 ? " %s %s" : "");
        }
      },
      {
        // a=simulcast:send 1,2,3;~4,~5 recv 6;~7,~8
        // a=simulcast:recv 1;4,5 send 6;7
        name: "simulcast",
        reg: new RegExp(
          // a=simulcast:
          "^simulcast:(send|recv) ([a-zA-Z0-9\\-_~;,]+)(?:\\s?(send|recv) ([a-zA-Z0-9\\-_~;,]+))?$"
        ),
        names: ["dir1", "list1", "dir2", "list2"],
        format: function(e) {
          return "simulcast:%s %s" + (e.dir2 ? " %s %s" : "");
        }
      },
      {
        // old simulcast draft 03 (implemented by Firefox)
        //   https://tools.ietf.org/html/draft-ietf-mmusic-sdp-simulcast-03
        // a=simulcast: recv pt=97;98 send pt=97
        // a=simulcast: send rid=5;6;7 paused=6,7
        name: "simulcast_03",
        reg: /^simulcast:[\s\t]+([\S+\s\t]+)$/,
        names: ["value"],
        format: "simulcast: %s"
      },
      {
        // a=framerate:25
        // a=framerate:29.97
        name: "framerate",
        reg: /^framerate:(\d+(?:$|\.\d+))/,
        format: "framerate:%s"
      },
      {
        // RFC4570
        // a=source-filter: incl IN IP4 239.5.2.31 10.1.15.5
        name: "sourceFilter",
        reg: /^source-filter: *(excl|incl) (\S*) (IP4|IP6|\*) (\S*) (.*)/,
        names: ["filterMode", "netType", "addressTypes", "destAddress", "srcList"],
        format: "source-filter: %s %s %s %s %s"
      },
      {
        // a=bundle-only
        name: "bundleOnly",
        reg: /^(bundle-only)/
      },
      {
        // a=label:1
        name: "label",
        reg: /^label:(.+)/,
        format: "label:%s"
      },
      {
        // RFC version 26 for SCTP over DTLS
        // https://tools.ietf.org/html/draft-ietf-mmusic-sctp-sdp-26#section-5
        name: "sctpPort",
        reg: /^sctp-port:(\d+)$/,
        format: "sctp-port:%s"
      },
      {
        // RFC version 26 for SCTP over DTLS
        // https://tools.ietf.org/html/draft-ietf-mmusic-sctp-sdp-26#section-6
        name: "maxMessageSize",
        reg: /^max-message-size:(\d+)$/,
        format: "max-message-size:%s"
      },
      {
        // RFC7273
        // a=ts-refclk:ptp=IEEE1588-2008:39-A7-94-FF-FE-07-CB-D0:37
        push: "tsRefClocks",
        reg: /^ts-refclk:([^\s=]*)(?:=(\S*))?/,
        names: ["clksrc", "clksrcExt"],
        format: function(e) {
          return "ts-refclk:%s" + (e.clksrcExt != null ? "=%s" : "");
        }
      },
      {
        // RFC7273
        // a=mediaclk:direct=963214424
        name: "mediaClk",
        reg: /^mediaclk:(?:id=(\S*))? *([^\s=]*)(?:=(\S*))?(?: *rate=(\d+)\/(\d+))?/,
        names: ["id", "mediaClockName", "mediaClockValue", "rateNumerator", "rateDenominator"],
        format: function(e) {
          var t = "mediaclk:";
          return t += e.id != null ? "id=%s %s" : "%v%s", t += e.mediaClockValue != null ? "=%s" : "", t += e.rateNumerator != null ? " rate=%s" : "", t += e.rateDenominator != null ? "/%s" : "", t;
        }
      },
      {
        // a=keywds:keywords
        name: "keywords",
        reg: /^keywds:(.+)$/,
        format: "keywds:%s"
      },
      {
        // a=content:main
        name: "content",
        reg: /^content:(.+)/,
        format: "content:%s"
      },
      // BFCP https://tools.ietf.org/html/rfc4583
      {
        // a=floorctrl:c-s
        name: "bfcpFloorCtrl",
        reg: /^floorctrl:(c-only|s-only|c-s)/,
        format: "floorctrl:%s"
      },
      {
        // a=confid:1
        name: "bfcpConfId",
        reg: /^confid:(\d+)/,
        format: "confid:%s"
      },
      {
        // a=userid:1
        name: "bfcpUserId",
        reg: /^userid:(\d+)/,
        format: "userid:%s"
      },
      {
        // a=floorid:1
        name: "bfcpFloorId",
        reg: /^floorid:(.+) (?:m-stream|mstrm):(.+)/,
        names: ["id", "mStream"],
        format: "floorid:%s mstrm:%s"
      },
      {
        // any a= that we don't understand is kept verbatim on media.invalid
        push: "invalid",
        names: ["value"]
      }
    ]
  };
  return Object.keys(i).forEach(function(e) {
    var t = i[e];
    t.forEach(function(n) {
      n.reg || (n.reg = /(.*)/), n.format || (n.format = "%s");
    });
  }), fn.exports;
}
var Rs;
function Qu() {
  return Rs || (Rs = 1, function(i) {
    var e = function(o) {
      return String(Number(o)) === o ? Number(o) : o;
    }, t = function(o, c, d, u) {
      if (u && !d)
        c[u] = e(o[1]);
      else
        for (var l = 0; l < d.length; l += 1)
          o[l + 1] != null && (c[d[l]] = e(o[l + 1]));
    }, n = function(o, c, d) {
      var u = o.name && o.names;
      o.push && !c[o.push] ? c[o.push] = [] : u && !c[o.name] && (c[o.name] = {});
      var l = o.push ? {} : (
        // blank object that will be pushed
        u ? c[o.name] : c
      );
      t(d.match(o.reg), l, o.names, o.name), o.push && c[o.push].push(l);
    }, r = gr(), s = RegExp.prototype.test.bind(/^([a-z])=(.*)/);
    i.parse = function(o) {
      var c = {}, d = [], u = c;
      return o.split(/(\r\n|\r|\n)/).filter(s).forEach(function(l) {
        var h = l[0], p = l.slice(2);
        h === "m" && (d.push({
          rtp: [],
          fmtp: []
        }), u = d[d.length - 1]);
        for (var v = 0; v < (r[h] || []).length; v += 1) {
          var f = r[h][v];
          if (f.reg.test(p))
            return n(f, u, p);
        }
      }), c.media = d, c;
    };
    var a = function(o, c) {
      var d = c.split(/=(.+)/, 2);
      return d.length === 2 ? o[d[0]] = e(d[1]) : d.length === 1 && c.length > 1 && (o[d[0]] = void 0), o;
    };
    i.parseParams = function(o) {
      return o.split(/;\s?/).reduce(a, {});
    }, i.parseFmtpConfig = i.parseParams, i.parsePayloads = function(o) {
      return o.toString().split(" ").map(Number);
    }, i.parseRemoteCandidates = function(o) {
      for (var c = [], d = o.split(" ").map(e), u = 0; u < d.length; u += 3)
        c.push({
          component: d[u],
          ip: d[u + 1],
          port: d[u + 2]
        });
      return c;
    }, i.parseImageAttributes = function(o) {
      return o.split(" ").map(function(c) {
        return c.substring(1, c.length - 1).split(",").reduce(a, {});
      });
    }, i.parseSimulcastStreamList = function(o) {
      return o.split(";").map(function(c) {
        return c.split(",").map(function(d) {
          var u, l = !1;
          return d[0] !== "~" ? u = e(d) : (u = e(d.substring(1, d.length)), l = !0), {
            scid: u,
            paused: l
          };
        });
      });
    };
  }(hn)), hn;
}
var pn, ws;
function Yu() {
  if (ws) return pn;
  ws = 1;
  var i = gr(), e = /%[sdv%]/g, t = function(a) {
    var o = 1, c = arguments, d = c.length;
    return a.replace(e, function(u) {
      if (o >= d)
        return u;
      var l = c[o];
      switch (o += 1, u) {
        case "%%":
          return "%";
        case "%s":
          return String(l);
        case "%d":
          return Number(l);
        case "%v":
          return "";
      }
    });
  }, n = function(a, o, c) {
    var d = o.format instanceof Function ? o.format(o.push ? c : c[o.name]) : o.format, u = [a + "=" + d];
    if (o.names)
      for (var l = 0; l < o.names.length; l += 1) {
        var h = o.names[l];
        o.name ? u.push(c[o.name][h]) : u.push(c[o.names[l]]);
      }
    else
      u.push(c[o.name]);
    return t.apply(null, u);
  }, r = ["v", "o", "s", "i", "u", "e", "p", "c", "b", "t", "r", "z", "a"], s = ["i", "c", "b", "a"];
  return pn = function(a, o) {
    o = o || {}, a.version == null && (a.version = 0), a.name == null && (a.name = " "), a.media.forEach(function(l) {
      l.payloads == null && (l.payloads = "");
    });
    var c = o.outerOrder || r, d = o.innerOrder || s, u = [];
    return c.forEach(function(l) {
      i[l].forEach(function(h) {
        h.name in a && a[h.name] != null ? u.push(n(l, h, a)) : h.push in a && a[h.push] != null && a[h.push].forEach(function(p) {
          u.push(n(l, h, p));
        });
      });
    }), a.media.forEach(function(l) {
      u.push(n("m", i.m[0], l)), d.forEach(function(h) {
        i[h].forEach(function(p) {
          p.name in l && l[p.name] != null ? u.push(n(h, p, l)) : p.push in l && l[p.push] != null && l[p.push].forEach(function(v) {
            u.push(n(h, p, v));
          });
        });
      });
    }), u.join(`\r
`) + `\r
`;
  }, pn;
}
var _s;
function Xu() {
  if (_s) return Oe;
  _s = 1;
  var i = Qu(), e = Yu(), t = gr();
  return Oe.grammar = t, Oe.write = e, Oe.parse = i.parse, Oe.parseParams = i.parseParams, Oe.parseFmtpConfig = i.parseFmtpConfig, Oe.parsePayloads = i.parsePayloads, Oe.parseRemoteCandidates = i.parseRemoteCandidates, Oe.parseImageAttributes = i.parseImageAttributes, Oe.parseSimulcastStreamList = i.parseSimulcastStreamList, Oe;
}
var ot = Xu();
function vr(i, e, t) {
  var n, r, s;
  e === void 0 && (e = 50), t === void 0 && (t = {});
  var a = (n = t.isImmediate) != null && n, o = (r = t.callback) != null && r, c = t.maxWait, d = Date.now(), u = [];
  function l() {
    if (c !== void 0) {
      var p = Date.now() - d;
      if (p + e >= c) return c - p;
    }
    return e;
  }
  var h = function() {
    var p = [].slice.call(arguments), v = this;
    return new Promise(function(f, T) {
      var g = a && s === void 0;
      if (s !== void 0 && clearTimeout(s), s = setTimeout(function() {
        if (s = void 0, d = Date.now(), !a) {
          var w = i.apply(v, p);
          o && o(w), u.forEach(function(b) {
            return (0, b.resolve)(w);
          }), u = [];
        }
      }, l()), g) {
        var O = i.apply(v, p);
        return o && o(O), f(O);
      }
      u.push({
        resolve: f,
        reject: T
      });
    });
  };
  return h.cancel = function(p) {
    s !== void 0 && clearTimeout(s), u.forEach(function(v) {
      return (0, v.reject)(p);
    }), u = [];
  }, h;
}
const $u = 0.7, Zu = 20, Ut = {
  NegotiationStarted: "negotiationStarted",
  NegotiationComplete: "negotiationComplete",
  RTPVideoPayloadTypes: "rtpVideoPayloadTypes"
};
class Is extends He.EventEmitter {
  get pc() {
    return this._pc || (this._pc = this.createPC()), this._pc;
  }
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var n;
    super(), this.log = G, this.ddExtID = 0, this.latestOfferId = 0, this.pendingCandidates = [], this.restartingIce = !1, this.renegotiate = !1, this.trackBitrates = [], this.remoteStereoMids = [], this.remoteNackMids = [], this.negotiate = vr((r) => m(this, void 0, void 0, function* () {
      this.emit(Ut.NegotiationStarted);
      try {
        yield this.createAndSendOffer();
      } catch (s) {
        if (r)
          r(s);
        else
          throw s;
      }
    }), Zu), this.close = () => {
      this._pc && (this._pc.close(), this._pc.onconnectionstatechange = null, this._pc.oniceconnectionstatechange = null, this._pc.onicegatheringstatechange = null, this._pc.ondatachannel = null, this._pc.onnegotiationneeded = null, this._pc.onsignalingstatechange = null, this._pc.onicecandidate = null, this._pc.ondatachannel = null, this._pc.ontrack = null, this._pc.onconnectionstatechange = null, this._pc.oniceconnectionstatechange = null, this._pc = null);
    }, this.log = it((n = t.loggerName) !== null && n !== void 0 ? n : Ne.PCTransport), this.loggerOptions = t, this.config = e, this._pc = this.createPC(), this.offerLock = new ge();
  }
  createPC() {
    const e = new RTCPeerConnection(this.config);
    return e.onicecandidate = (t) => {
      var n;
      t.candidate && ((n = this.onIceCandidate) === null || n === void 0 || n.call(this, t.candidate));
    }, e.onicecandidateerror = (t) => {
      var n;
      (n = this.onIceCandidateError) === null || n === void 0 || n.call(this, t);
    }, e.oniceconnectionstatechange = () => {
      var t;
      (t = this.onIceConnectionStateChange) === null || t === void 0 || t.call(this, e.iceConnectionState);
    }, e.onsignalingstatechange = () => {
      var t;
      (t = this.onSignalingStatechange) === null || t === void 0 || t.call(this, e.signalingState);
    }, e.onconnectionstatechange = () => {
      var t;
      (t = this.onConnectionStateChange) === null || t === void 0 || t.call(this, e.connectionState);
    }, e.ondatachannel = (t) => {
      var n;
      (n = this.onDataChannel) === null || n === void 0 || n.call(this, t);
    }, e.ontrack = (t) => {
      var n;
      (n = this.onTrack) === null || n === void 0 || n.call(this, t);
    }, e;
  }
  get logContext() {
    var e, t;
    return Object.assign({}, (t = (e = this.loggerOptions).loggerContextCb) === null || t === void 0 ? void 0 : t.call(e));
  }
  get isICEConnected() {
    return this._pc !== null && (this.pc.iceConnectionState === "connected" || this.pc.iceConnectionState === "completed");
  }
  addIceCandidate(e) {
    return m(this, void 0, void 0, function* () {
      if (this.pc.remoteDescription && !this.restartingIce)
        return this.pc.addIceCandidate(e);
      this.pendingCandidates.push(e);
    });
  }
  setRemoteDescription(e, t) {
    return m(this, void 0, void 0, function* () {
      var n;
      if (e.type === "answer" && this.latestOfferId > 0 && t > 0 && t !== this.latestOfferId)
        return this.log.warn("ignoring answer for old offer", Object.assign(Object.assign({}, this.logContext), {
          offerId: t,
          latestOfferId: this.latestOfferId
        })), !1;
      let r;
      if (e.type === "offer") {
        let {
          stereoMids: s,
          nackMids: a
        } = el(e);
        this.remoteStereoMids = s, this.remoteNackMids = a;
      } else if (e.type === "answer") {
        const s = ot.parse((n = e.sdp) !== null && n !== void 0 ? n : "");
        s.media.forEach((a) => {
          a.type === "audio" && this.trackBitrates.some((o) => {
            if (!o.transceiver || a.mid != o.transceiver.mid)
              return !1;
            let c = 0;
            if (a.rtp.some((u) => u.codec.toUpperCase() === o.codec.toUpperCase() ? (c = u.payload, !0) : !1), c === 0)
              return !0;
            let d = !1;
            for (const u of a.fmtp)
              if (u.payload === c) {
                u.config = u.config.split(";").filter((l) => !l.includes("maxaveragebitrate")).join(";"), o.maxbr > 0 && (u.config += ";maxaveragebitrate=".concat(o.maxbr * 1e3)), d = !0;
                break;
              }
            return d || o.maxbr > 0 && a.fmtp.push({
              payload: c,
              config: "maxaveragebitrate=".concat(o.maxbr * 1e3)
            }), !0;
          });
        }), r = ot.write(s);
      }
      return yield this.setMungedSDP(e, r, !0), this.pendingCandidates.forEach((s) => {
        this.pc.addIceCandidate(s);
      }), this.pendingCandidates = [], this.restartingIce = !1, this.renegotiate ? (this.renegotiate = !1, yield this.createAndSendOffer()) : e.type === "answer" && (this.emit(Ut.NegotiationComplete), e.sdp && ot.parse(e.sdp).media.forEach((a) => {
        a.type === "video" && this.emit(Ut.RTPVideoPayloadTypes, a.rtp);
      })), !0;
    });
  }
  createAndSendOffer(e) {
    return m(this, void 0, void 0, function* () {
      var t;
      const n = yield this.offerLock.lock();
      try {
        if (this.onOffer === void 0)
          return;
        if (e != null && e.iceRestart && (this.log.debug("restarting ICE", this.logContext), this.restartingIce = !0), this._pc && this._pc.signalingState === "have-local-offer") {
          const o = this._pc.remoteDescription;
          if (e != null && e.iceRestart && o)
            yield this._pc.setRemoteDescription(o);
          else {
            this.renegotiate = !0;
            return;
          }
        } else if (!this._pc || this._pc.signalingState === "closed") {
          this.log.warn("could not createOffer with closed peer connection", this.logContext);
          return;
        }
        this.log.debug("starting to negotiate", this.logContext);
        const r = this.latestOfferId + 1;
        this.latestOfferId = r;
        const s = yield this.pc.createOffer(e);
        this.log.debug("original offer", Object.assign({
          sdp: s.sdp
        }, this.logContext));
        const a = ot.parse((t = s.sdp) !== null && t !== void 0 ? t : "");
        if (a.media.forEach((o) => {
          xs(o), o.type === "audio" ? Os(o, [], []) : o.type === "video" && this.trackBitrates.some((c) => {
            if (!o.msid || !c.cid || !o.msid.includes(c.cid))
              return !1;
            let d = 0;
            if (o.rtp.some((l) => l.codec.toUpperCase() === c.codec.toUpperCase() ? (d = l.payload, !0) : !1), d === 0 || (qe(c.codec) && !Ct() && this.ensureVideoDDExtensionForSVC(o, a), c.codec !== "av1"))
              return !0;
            const u = Math.round(c.maxbr * $u);
            for (const l of o.fmtp)
              if (l.payload === d) {
                l.config.includes("x-google-start-bitrate") || (l.config += ";x-google-start-bitrate=".concat(u));
                break;
              }
            return !0;
          });
        }), this.latestOfferId > r) {
          this.log.warn("latestOfferId mismatch", Object.assign(Object.assign({}, this.logContext), {
            latestOfferId: this.latestOfferId,
            offerId: r
          }));
          return;
        }
        yield this.setMungedSDP(s, ot.write(a)), this.onOffer(s, this.latestOfferId);
      } finally {
        n();
      }
    });
  }
  createAndSetAnswer() {
    return m(this, void 0, void 0, function* () {
      var e;
      const t = yield this.pc.createAnswer(), n = ot.parse((e = t.sdp) !== null && e !== void 0 ? e : "");
      return n.media.forEach((r) => {
        xs(r), r.type === "audio" && Os(r, this.remoteStereoMids, this.remoteNackMids);
      }), yield this.setMungedSDP(t, ot.write(n)), t;
    });
  }
  createDataChannel(e, t) {
    return this.pc.createDataChannel(e, t);
  }
  addTransceiver(e, t) {
    return this.pc.addTransceiver(e, t);
  }
  addTrack(e) {
    if (!this._pc)
      throw new ce("PC closed, cannot add track");
    return this._pc.addTrack(e);
  }
  setTrackCodecBitrate(e) {
    this.trackBitrates.push(e);
  }
  setConfiguration(e) {
    var t;
    if (!this._pc)
      throw new ce("PC closed, cannot configure");
    return (t = this._pc) === null || t === void 0 ? void 0 : t.setConfiguration(e);
  }
  canRemoveTrack() {
    var e;
    return !!(!((e = this._pc) === null || e === void 0) && e.removeTrack);
  }
  removeTrack(e) {
    var t;
    return (t = this._pc) === null || t === void 0 ? void 0 : t.removeTrack(e);
  }
  getConnectionState() {
    var e, t;
    return (t = (e = this._pc) === null || e === void 0 ? void 0 : e.connectionState) !== null && t !== void 0 ? t : "closed";
  }
  getICEConnectionState() {
    var e, t;
    return (t = (e = this._pc) === null || e === void 0 ? void 0 : e.iceConnectionState) !== null && t !== void 0 ? t : "closed";
  }
  getSignallingState() {
    var e, t;
    return (t = (e = this._pc) === null || e === void 0 ? void 0 : e.signalingState) !== null && t !== void 0 ? t : "closed";
  }
  getTransceivers() {
    var e, t;
    return (t = (e = this._pc) === null || e === void 0 ? void 0 : e.getTransceivers()) !== null && t !== void 0 ? t : [];
  }
  getSenders() {
    var e, t;
    return (t = (e = this._pc) === null || e === void 0 ? void 0 : e.getSenders()) !== null && t !== void 0 ? t : [];
  }
  getLocalDescription() {
    var e;
    return (e = this._pc) === null || e === void 0 ? void 0 : e.localDescription;
  }
  getRemoteDescription() {
    var e;
    return (e = this.pc) === null || e === void 0 ? void 0 : e.remoteDescription;
  }
  getStats() {
    return this.pc.getStats();
  }
  getConnectedAddress() {
    return m(this, void 0, void 0, function* () {
      var e;
      if (!this._pc)
        return;
      let t = "";
      const n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
      if ((yield this._pc.getStats()).forEach((o) => {
        switch (o.type) {
          case "transport":
            t = o.selectedCandidatePairId;
            break;
          case "candidate-pair":
            t === "" && o.selected && (t = o.id), n.set(o.id, o);
            break;
          case "remote-candidate":
            r.set(o.id, "".concat(o.address, ":").concat(o.port));
            break;
        }
      }), t === "")
        return;
      const a = (e = n.get(t)) === null || e === void 0 ? void 0 : e.remoteCandidateId;
      if (a !== void 0)
        return r.get(a);
    });
  }
  setMungedSDP(e, t, n) {
    return m(this, void 0, void 0, function* () {
      if (t) {
        const r = e.sdp;
        e.sdp = t;
        try {
          this.log.debug("setting munged ".concat(n ? "remote" : "local", " description"), this.logContext), n ? yield this.pc.setRemoteDescription(e) : yield this.pc.setLocalDescription(e);
          return;
        } catch (s) {
          this.log.warn("not able to set ".concat(e.type, ", falling back to unmodified sdp"), Object.assign(Object.assign({}, this.logContext), {
            error: s,
            sdp: t
          })), e.sdp = r;
        }
      }
      try {
        n ? yield this.pc.setRemoteDescription(e) : yield this.pc.setLocalDescription(e);
      } catch (r) {
        let s = "unknown error";
        r instanceof Error ? s = r.message : typeof r == "string" && (s = r);
        const a = {
          error: s,
          sdp: e.sdp
        };
        throw !n && this.pc.remoteDescription && (a.remoteSdp = this.pc.remoteDescription), this.log.error("unable to set ".concat(e.type), Object.assign(Object.assign({}, this.logContext), {
          fields: a
        })), new Un(s);
      }
    });
  }
  ensureVideoDDExtensionForSVC(e, t) {
    var n, r;
    if (!((n = e.ext) === null || n === void 0 ? void 0 : n.some((a) => a.uri === gs))) {
      if (this.ddExtID === 0) {
        let a = 0;
        t.media.forEach((o) => {
          var c;
          o.type === "video" && ((c = o.ext) === null || c === void 0 || c.forEach((d) => {
            d.value > a && (a = d.value);
          }));
        }), this.ddExtID = a + 1;
      }
      (r = e.ext) === null || r === void 0 || r.push({
        value: this.ddExtID,
        uri: gs
      });
    }
  }
}
function Os(i, e, t) {
  let n = 0;
  i.rtp.some((r) => r.codec === "opus" ? (n = r.payload, !0) : !1), n > 0 && (i.rtcpFb || (i.rtcpFb = []), t.includes(i.mid) && !i.rtcpFb.some((r) => r.payload === n && r.type === "nack") && i.rtcpFb.push({
    payload: n,
    type: "nack"
  }), e.includes(i.mid) && i.fmtp.some((r) => r.payload === n ? (r.config.includes("stereo=1") || (r.config += ";stereo=1"), !0) : !1));
}
function el(i) {
  var e;
  const t = [], n = [], r = ot.parse((e = i.sdp) !== null && e !== void 0 ? e : "");
  let s = 0;
  return r.media.forEach((a) => {
    var o;
    a.type === "audio" && (a.rtp.some((c) => c.codec === "opus" ? (s = c.payload, !0) : !1), !((o = a.rtcpFb) === null || o === void 0) && o.some((c) => c.payload === s && c.type === "nack") && n.push(a.mid), a.fmtp.some((c) => c.payload === s ? (c.config.includes("sprop-stereo=1") && t.push(a.mid), !0) : !1));
  }), {
    stereoMids: t,
    nackMids: n
  };
}
function xs(i) {
  if (i.connection) {
    const e = i.connection.ip.indexOf(":") >= 0;
    (i.connection.version === 4 && e || i.connection.version === 6 && !e) && (i.connection.ip = "0.0.0.0", i.connection.version = 4);
  }
}
const Qn = "vp8", tl = {
  audioPreset: Fn.music,
  dtx: !0,
  red: !0,
  forceStereo: !1,
  simulcast: !0,
  screenShareEncoding: fr.h1080fps15.encoding,
  stopMicTrackOnMute: !1,
  videoCodec: Qn,
  backupCodec: !0,
  preConnectBuffer: !1
}, Ro = {
  deviceId: {
    ideal: "default"
  },
  autoGainControl: !0,
  echoCancellation: !0,
  noiseSuppression: !0,
  voiceIsolation: !0
}, wo = {
  deviceId: {
    ideal: "default"
  },
  resolution: ci.h720.resolution
}, il = {
  adaptiveStream: !1,
  dynacast: !1,
  stopLocalTrackOnUnpublish: !0,
  reconnectPolicy: new Vd(),
  disconnectOnPageLeave: !0,
  webAudioMix: !1
}, br = {
  autoSubscribe: !0,
  maxRetries: 1,
  peerConnectionTimeout: 15e3,
  websocketTimeout: 15e3
};
var te;
(function(i) {
  i[i.NEW = 0] = "NEW", i[i.CONNECTING = 1] = "CONNECTING", i[i.CONNECTED = 2] = "CONNECTED", i[i.FAILED = 3] = "FAILED", i[i.CLOSING = 4] = "CLOSING", i[i.CLOSED = 5] = "CLOSED";
})(te || (te = {}));
class nl {
  get needsPublisher() {
    return this.isPublisherConnectionRequired;
  }
  get needsSubscriber() {
    return this.isSubscriberConnectionRequired;
  }
  get currentState() {
    return this.state;
  }
  constructor(e, t, n) {
    var r;
    this.peerConnectionTimeout = br.peerConnectionTimeout, this.log = G, this.updateState = () => {
      var s;
      const a = this.state, o = this.requiredTransports.map((c) => c.getConnectionState());
      o.every((c) => c === "connected") ? this.state = te.CONNECTED : o.some((c) => c === "failed") ? this.state = te.FAILED : o.some((c) => c === "connecting") ? this.state = te.CONNECTING : o.every((c) => c === "closed") ? this.state = te.CLOSED : o.some((c) => c === "closed") ? this.state = te.CLOSING : o.every((c) => c === "new") && (this.state = te.NEW), a !== this.state && (this.log.debug("pc state change: from ".concat(te[a], " to ").concat(te[this.state]), this.logContext), (s = this.onStateChange) === null || s === void 0 || s.call(this, this.state, this.publisher.getConnectionState(), this.subscriber.getConnectionState()));
    }, this.log = it((r = n.loggerName) !== null && r !== void 0 ? r : Ne.PCManager), this.loggerOptions = n, this.isPublisherConnectionRequired = !t, this.isSubscriberConnectionRequired = t, this.publisher = new Is(e, n), this.subscriber = new Is(e, n), this.publisher.onConnectionStateChange = this.updateState, this.subscriber.onConnectionStateChange = this.updateState, this.publisher.onIceConnectionStateChange = this.updateState, this.subscriber.onIceConnectionStateChange = this.updateState, this.publisher.onSignalingStatechange = this.updateState, this.subscriber.onSignalingStatechange = this.updateState, this.publisher.onIceCandidate = (s) => {
      var a;
      (a = this.onIceCandidate) === null || a === void 0 || a.call(this, s, Ae.PUBLISHER);
    }, this.subscriber.onIceCandidate = (s) => {
      var a;
      (a = this.onIceCandidate) === null || a === void 0 || a.call(this, s, Ae.SUBSCRIBER);
    }, this.subscriber.onDataChannel = (s) => {
      var a;
      (a = this.onDataChannel) === null || a === void 0 || a.call(this, s);
    }, this.subscriber.onTrack = (s) => {
      var a;
      (a = this.onTrack) === null || a === void 0 || a.call(this, s);
    }, this.publisher.onOffer = (s, a) => {
      var o;
      (o = this.onPublisherOffer) === null || o === void 0 || o.call(this, s, a);
    }, this.state = te.NEW, this.connectionLock = new ge(), this.remoteOfferLock = new ge();
  }
  get logContext() {
    var e, t;
    return Object.assign({}, (t = (e = this.loggerOptions).loggerContextCb) === null || t === void 0 ? void 0 : t.call(e));
  }
  requirePublisher() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
    this.isPublisherConnectionRequired = e, this.updateState();
  }
  requireSubscriber() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
    this.isSubscriberConnectionRequired = e, this.updateState();
  }
  createAndSendPublisherOffer(e) {
    return this.publisher.createAndSendOffer(e);
  }
  setPublisherAnswer(e, t) {
    return this.publisher.setRemoteDescription(e, t);
  }
  removeTrack(e) {
    return this.publisher.removeTrack(e);
  }
  close() {
    return m(this, void 0, void 0, function* () {
      if (this.publisher && this.publisher.getSignallingState() !== "closed") {
        const e = this.publisher;
        for (const t of e.getSenders())
          try {
            e.canRemoveTrack() && e.removeTrack(t);
          } catch (n) {
            this.log.warn("could not removeTrack", Object.assign(Object.assign({}, this.logContext), {
              error: n
            }));
          }
      }
      yield Promise.all([this.publisher.close(), this.subscriber.close()]), this.updateState();
    });
  }
  triggerIceRestart() {
    return m(this, void 0, void 0, function* () {
      this.subscriber.restartingIce = !0, this.needsPublisher && (yield this.createAndSendPublisherOffer({
        iceRestart: !0
      }));
    });
  }
  addIceCandidate(e, t) {
    return m(this, void 0, void 0, function* () {
      t === Ae.PUBLISHER ? yield this.publisher.addIceCandidate(e) : yield this.subscriber.addIceCandidate(e);
    });
  }
  createSubscriberAnswerFromOffer(e, t) {
    return m(this, void 0, void 0, function* () {
      this.log.debug("received server offer", Object.assign(Object.assign({}, this.logContext), {
        RTCSdpType: e.type,
        sdp: e.sdp,
        signalingState: this.subscriber.getSignallingState().toString()
      }));
      const n = yield this.remoteOfferLock.lock();
      try {
        return (yield this.subscriber.setRemoteDescription(e, t)) ? yield this.subscriber.createAndSetAnswer() : void 0;
      } finally {
        n();
      }
    });
  }
  updateConfiguration(e, t) {
    this.publisher.setConfiguration(e), this.subscriber.setConfiguration(e), t && this.triggerIceRestart();
  }
  ensurePCTransportConnection(e, t) {
    return m(this, void 0, void 0, function* () {
      var n;
      const r = yield this.connectionLock.lock();
      try {
        this.isPublisherConnectionRequired && this.publisher.getConnectionState() !== "connected" && this.publisher.getConnectionState() !== "connecting" && (this.log.debug("negotiation required, start negotiating", this.logContext), this.publisher.negotiate()), yield Promise.all((n = this.requiredTransports) === null || n === void 0 ? void 0 : n.map((s) => this.ensureTransportConnected(s, e, t)));
      } finally {
        r();
      }
    });
  }
  negotiate(e) {
    return m(this, void 0, void 0, function* () {
      return new Promise((t, n) => m(this, void 0, void 0, function* () {
        const r = setTimeout(() => {
          n("negotiation timed out");
        }, this.peerConnectionTimeout), s = () => {
          clearTimeout(r), n("negotiation aborted");
        };
        e.signal.addEventListener("abort", s), this.publisher.once(Ut.NegotiationStarted, () => {
          e.signal.aborted || this.publisher.once(Ut.NegotiationComplete, () => {
            clearTimeout(r), t();
          });
        }), yield this.publisher.negotiate((a) => {
          clearTimeout(r), n(a);
        });
      }));
    });
  }
  addPublisherTransceiver(e, t) {
    return this.publisher.addTransceiver(e, t);
  }
  addPublisherTrack(e) {
    return this.publisher.addTrack(e);
  }
  createPublisherDataChannel(e, t) {
    return this.publisher.createDataChannel(e, t);
  }
  /**
   * Returns the first required transport's address if no explicit target is specified
   */
  getConnectedAddress(e) {
    return e === Ae.PUBLISHER ? this.publisher.getConnectedAddress() : e === Ae.SUBSCRIBER ? this.publisher.getConnectedAddress() : this.requiredTransports[0].getConnectedAddress();
  }
  get requiredTransports() {
    const e = [];
    return this.isPublisherConnectionRequired && e.push(this.publisher), this.isSubscriberConnectionRequired && e.push(this.subscriber), e;
  }
  ensureTransportConnected(e, t) {
    return m(this, arguments, void 0, function(n, r) {
      var s = this;
      let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.peerConnectionTimeout;
      return function* () {
        if (n.getConnectionState() !== "connected")
          return new Promise((c, d) => m(s, void 0, void 0, function* () {
            const u = () => {
              this.log.warn("abort transport connection", this.logContext), pe.clearTimeout(l), d(new Q("room connection has been cancelled", K.Cancelled));
            };
            r != null && r.signal.aborted && u(), r == null || r.signal.addEventListener("abort", u);
            const l = pe.setTimeout(() => {
              r == null || r.signal.removeEventListener("abort", u), d(new Q("could not establish pc connection", K.InternalError));
            }, a);
            for (; this.state !== te.CONNECTED; )
              if (yield Ce(50), r != null && r.signal.aborted) {
                d(new Q("room connection has been cancelled", K.Cancelled));
                return;
              }
            pe.clearTimeout(l), r == null || r.signal.removeEventListener("abort", u), c();
          }));
      }();
    });
  }
}
class ne extends Error {
  /**
   * Creates an error object with the given code and message, plus an optional data payload.
   *
   * If thrown in an RPC method handler, the error will be sent back to the caller.
   *
   * Error codes 1001-1999 are reserved for built-in errors (see RpcError.ErrorCode for their meanings).
   */
  constructor(e, t, n) {
    super(t), this.code = e, this.message = Ms(t, ne.MAX_MESSAGE_BYTES), this.data = n ? Ms(n, ne.MAX_DATA_BYTES) : void 0;
  }
  /**
   * @internal
   */
  static fromProto(e) {
    return new ne(e.code, e.message, e.data);
  }
  /**
   * @internal
   */
  toProto() {
    return new ka({
      code: this.code,
      message: this.message,
      data: this.data
    });
  }
  /**
   * Creates an error object from the code, with an auto-populated message.
   *
   * @internal
   */
  static builtIn(e, t) {
    return new ne(ne.ErrorCode[e], ne.ErrorMessage[e], t);
  }
}
ne.MAX_MESSAGE_BYTES = 256;
ne.MAX_DATA_BYTES = 15360;
ne.ErrorCode = {
  APPLICATION_ERROR: 1500,
  CONNECTION_TIMEOUT: 1501,
  RESPONSE_TIMEOUT: 1502,
  RECIPIENT_DISCONNECTED: 1503,
  RESPONSE_PAYLOAD_TOO_LARGE: 1504,
  SEND_FAILED: 1505,
  UNSUPPORTED_METHOD: 1400,
  RECIPIENT_NOT_FOUND: 1401,
  REQUEST_PAYLOAD_TOO_LARGE: 1402,
  UNSUPPORTED_SERVER: 1403,
  UNSUPPORTED_VERSION: 1404
};
ne.ErrorMessage = {
  APPLICATION_ERROR: "Application error in method handler",
  CONNECTION_TIMEOUT: "Connection timeout",
  RESPONSE_TIMEOUT: "Response timeout",
  RECIPIENT_DISCONNECTED: "Recipient disconnected",
  RESPONSE_PAYLOAD_TOO_LARGE: "Response payload too large",
  SEND_FAILED: "Failed to send",
  UNSUPPORTED_METHOD: "Method not supported at destination",
  RECIPIENT_NOT_FOUND: "Recipient not found",
  REQUEST_PAYLOAD_TOO_LARGE: "Request payload too large",
  UNSUPPORTED_SERVER: "RPC not supported by server",
  UNSUPPORTED_VERSION: "Unsupported RPC version"
};
const _o = 15360;
function yr(i) {
  return new TextEncoder().encode(i).length;
}
function Ms(i, e) {
  if (yr(i) <= e)
    return i;
  let t = 0, n = i.length;
  const r = new TextEncoder();
  for (; t < n; ) {
    const s = Math.floor((t + n + 1) / 2);
    r.encode(i.slice(0, s)).length <= e ? t = s : n = s - 1;
  }
  return i.slice(0, t);
}
const kr = 2e3;
function zi(i, e) {
  if (!e)
    return 0;
  let t, n;
  return "bytesReceived" in i ? (t = i.bytesReceived, n = e.bytesReceived) : "bytesSent" in i && (t = i.bytesSent, n = e.bytesSent), t === void 0 || n === void 0 || i.timestamp === void 0 || e.timestamp === void 0 ? 0 : (t - n) * 8 * 1e3 / (i.timestamp - e.timestamp);
}
const Tr = typeof MediaRecorder != "undefined";
class rl {
  constructor() {
    throw new Error("MediaRecorder is not available in this environment");
  }
}
const sl = Tr ? MediaRecorder : rl;
class al extends sl {
  constructor(e, t) {
    if (!Tr)
      throw new Error("MediaRecorder is not available in this environment");
    super(new MediaStream([e.mediaStreamTrack]), t);
    let n, r;
    const s = () => r === void 0, a = () => {
      this.removeEventListener("dataavailable", n), this.removeEventListener("stop", a), this.removeEventListener("error", o), r == null || r.close(), r = void 0;
    }, o = (c) => {
      r == null || r.error(c), this.removeEventListener("dataavailable", n), this.removeEventListener("stop", a), this.removeEventListener("error", o), r = void 0;
    };
    this.byteStream = new ReadableStream({
      start: (c) => {
        r = c, n = (d) => m(this, void 0, void 0, function* () {
          const u = yield d.data.arrayBuffer();
          s() || c.enqueue(new Uint8Array(u));
        }), this.addEventListener("dataavailable", n);
      },
      cancel: () => {
        a();
      }
    }), this.addEventListener("stop", a), this.addEventListener("error", o);
  }
}
function ol() {
  return Tr;
}
const cl = 1e3, dl = 1e4;
class Io extends E {
  /** @internal */
  get sender() {
    return this._sender;
  }
  /** @internal */
  set sender(e) {
    this._sender = e;
  }
  get constraints() {
    return this._constraints;
  }
  get hasPreConnectBuffer() {
    return !!this.localTrackRecorder;
  }
  /**
   *
   * @param mediaTrack
   * @param kind
   * @param constraints MediaTrackConstraints that are being used when restarting or reacquiring tracks
   * @param userProvidedTrack Signals to the SDK whether or not the mediaTrack should be managed (i.e. released and reacquired) internally by the SDK
   */
  constructor(e, t, n) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, s = arguments.length > 4 ? arguments[4] : void 0;
    super(e, t, s), this.manuallyStopped = !1, this._isUpstreamPaused = !1, this.handleTrackMuteEvent = () => this.debouncedTrackMuteHandler().catch(() => this.log.debug("track mute bounce got cancelled by an unmute event", this.logContext)), this.debouncedTrackMuteHandler = vr(() => m(this, void 0, void 0, function* () {
      yield this.pauseUpstream();
    }), 5e3), this.handleTrackUnmuteEvent = () => m(this, void 0, void 0, function* () {
      this.debouncedTrackMuteHandler.cancel("unmute"), yield this.resumeUpstream();
    }), this.handleEnded = () => {
      this.isInBackground && (this.reacquireTrack = !0), this._mediaStreamTrack.removeEventListener("mute", this.handleTrackMuteEvent), this._mediaStreamTrack.removeEventListener("unmute", this.handleTrackUnmuteEvent), this.emit(I.Ended, this);
    }, this.reacquireTrack = !1, this.providedByUser = r, this.muteLock = new ge(), this.pauseUpstreamLock = new ge(), this.processorLock = new ge(), this.restartLock = new ge(), this.setMediaStreamTrack(e, !0), this._constraints = e.getConstraints(), n && (this._constraints = n);
  }
  get id() {
    return this._mediaStreamTrack.id;
  }
  get dimensions() {
    if (this.kind !== E.Kind.Video)
      return;
    const {
      width: e,
      height: t
    } = this._mediaStreamTrack.getSettings();
    if (e && t)
      return {
        width: e,
        height: t
      };
  }
  get isUpstreamPaused() {
    return this._isUpstreamPaused;
  }
  get isUserProvided() {
    return this.providedByUser;
  }
  get mediaStreamTrack() {
    var e, t;
    return (t = (e = this.processor) === null || e === void 0 ? void 0 : e.processedTrack) !== null && t !== void 0 ? t : this._mediaStreamTrack;
  }
  get isLocal() {
    return !0;
  }
  /**
   * @internal
   * returns mediaStreamTrack settings of the capturing mediastreamtrack source - ignoring processors
   */
  getSourceTrackSettings() {
    return this._mediaStreamTrack.getSettings();
  }
  setMediaStreamTrack(e, t) {
    return m(this, void 0, void 0, function* () {
      var n;
      if (e === this._mediaStreamTrack && !t)
        return;
      this._mediaStreamTrack && (this.attachedElements.forEach((s) => {
        Lt(this._mediaStreamTrack, s);
      }), this.debouncedTrackMuteHandler.cancel("new-track"), this._mediaStreamTrack.removeEventListener("ended", this.handleEnded), this._mediaStreamTrack.removeEventListener("mute", this.handleTrackMuteEvent), this._mediaStreamTrack.removeEventListener("unmute", this.handleTrackUnmuteEvent)), this.mediaStream = new MediaStream([e]), e && (e.addEventListener("ended", this.handleEnded), e.addEventListener("mute", this.handleTrackMuteEvent), e.addEventListener("unmute", this.handleTrackUnmuteEvent), this._constraints = e.getConstraints());
      let r;
      if (this.processor && e) {
        const s = yield this.processorLock.lock();
        try {
          if (this.log.debug("restarting processor", this.logContext), this.kind === "unknown")
            throw TypeError("cannot set processor on track of unknown kind");
          this.processorElement && (Ot(e, this.processorElement), this.processorElement.muted = !0), yield this.processor.restart({
            track: e,
            kind: this.kind,
            element: this.processorElement
          }), r = this.processor.processedTrack;
        } finally {
          s();
        }
      }
      this.sender && ((n = this.sender.transport) === null || n === void 0 ? void 0 : n.state) !== "closed" && (yield this.sender.replaceTrack(r != null ? r : e)), !this.providedByUser && this._mediaStreamTrack !== e && this._mediaStreamTrack.stop(), this._mediaStreamTrack = e, e && (this._mediaStreamTrack.enabled = !this.isMuted, yield this.resumeUpstream(), this.attachedElements.forEach((s) => {
        Ot(r != null ? r : e, s);
      }));
    });
  }
  waitForDimensions() {
    return m(this, arguments, void 0, function() {
      var e = this;
      let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : cl;
      return function* () {
        var n;
        if (e.kind === E.Kind.Audio)
          throw new Error("cannot get dimensions for audio tracks");
        ((n = Re()) === null || n === void 0 ? void 0 : n.os) === "iOS" && (yield Ce(10));
        const r = Date.now();
        for (; Date.now() - r < t; ) {
          const s = e.dimensions;
          if (s)
            return s;
          yield Ce(50);
        }
        throw new tt("unable to get track dimensions after timeout");
      }();
    });
  }
  setDeviceId(e) {
    return m(this, void 0, void 0, function* () {
      return this._constraints.deviceId === e && this._mediaStreamTrack.getSettings().deviceId === lt(e) || (this._constraints.deviceId = e, this.isMuted) ? !0 : (yield this.restartTrack(), lt(e) === this._mediaStreamTrack.getSettings().deviceId);
    });
  }
  /**
   * @returns DeviceID of the device that is currently being used for this track
   */
  getDeviceId() {
    return m(this, arguments, void 0, function() {
      var e = this;
      let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      return function* () {
        if (e.source === E.Source.ScreenShare)
          return;
        const {
          deviceId: n,
          groupId: r
        } = e._mediaStreamTrack.getSettings(), s = e.kind === E.Kind.Audio ? "audioinput" : "videoinput";
        return t ? he.getInstance().normalizeDeviceId(s, n, r) : n;
      }();
    });
  }
  mute() {
    return m(this, void 0, void 0, function* () {
      return this.setTrackMuted(!0), this;
    });
  }
  unmute() {
    return m(this, void 0, void 0, function* () {
      return this.setTrackMuted(!1), this;
    });
  }
  replaceTrack(e, t) {
    return m(this, void 0, void 0, function* () {
      if (!this.sender)
        throw new tt("unable to replace an unpublished track");
      let n, r;
      return typeof t == "boolean" ? n = t : t !== void 0 && (n = t.userProvidedTrack, r = t.stopProcessor), this.providedByUser = n != null ? n : !0, this.log.debug("replace MediaStreamTrack", this.logContext), yield this.setMediaStreamTrack(e), r && this.processor && (yield this.stopProcessor()), this;
    });
  }
  restart(e) {
    return m(this, void 0, void 0, function* () {
      this.manuallyStopped = !1;
      const t = yield this.restartLock.lock();
      try {
        e || (e = this._constraints);
        const {
          deviceId: n,
          facingMode: r
        } = e, s = qd(e, ["deviceId", "facingMode"]);
        this.log.debug("restarting track with constraints", Object.assign(Object.assign({}, this.logContext), {
          constraints: e
        }));
        const a = {
          audio: !1,
          video: !1
        };
        this.kind === E.Kind.Video ? a.video = n || r ? {
          deviceId: n,
          facingMode: r
        } : !0 : a.audio = n ? {
          deviceId: n
        } : !0, this.attachedElements.forEach((d) => {
          Lt(this.mediaStreamTrack, d);
        }), this._mediaStreamTrack.removeEventListener("ended", this.handleEnded), this._mediaStreamTrack.stop();
        const c = (yield navigator.mediaDevices.getUserMedia(a)).getTracks()[0];
        return yield c.applyConstraints(s), c.addEventListener("ended", this.handleEnded), this.log.debug("re-acquired MediaStreamTrack", this.logContext), yield this.setMediaStreamTrack(c), this._constraints = e, this.emit(I.Restarted, this), this.manuallyStopped && (this.log.warn("track was stopped during a restart, stopping restarted track", this.logContext), this.stop()), this;
      } finally {
        t();
      }
    });
  }
  setTrackMuted(e) {
    this.log.debug("setting ".concat(this.kind, " track ").concat(e ? "muted" : "unmuted"), this.logContext), !(this.isMuted === e && this._mediaStreamTrack.enabled !== e) && (this.isMuted = e, this._mediaStreamTrack.enabled = !e, this.emit(e ? I.Muted : I.Unmuted, this));
  }
  get needsReAcquisition() {
    return this._mediaStreamTrack.readyState !== "live" || this._mediaStreamTrack.muted || !this._mediaStreamTrack.enabled || this.reacquireTrack;
  }
  handleAppVisibilityChanged() {
    const e = Object.create(null, {
      handleAppVisibilityChanged: {
        get: () => super.handleAppVisibilityChanged
      }
    });
    return m(this, void 0, void 0, function* () {
      yield e.handleAppVisibilityChanged.call(this), bo() && (this.log.debug("visibility changed, is in Background: ".concat(this.isInBackground), this.logContext), !this.isInBackground && this.needsReAcquisition && !this.isUserProvided && !this.isMuted && (this.log.debug("track needs to be reacquired, restarting ".concat(this.source), this.logContext), yield this.restart(), this.reacquireTrack = !1));
    });
  }
  stop() {
    var e;
    this.manuallyStopped = !0, super.stop(), this._mediaStreamTrack.removeEventListener("ended", this.handleEnded), this._mediaStreamTrack.removeEventListener("mute", this.handleTrackMuteEvent), this._mediaStreamTrack.removeEventListener("unmute", this.handleTrackUnmuteEvent), (e = this.processor) === null || e === void 0 || e.destroy(), this.processor = void 0;
  }
  /**
   * pauses publishing to the server without disabling the local MediaStreamTrack
   * this is used to display a user's own video locally while pausing publishing to
   * the server.
   * this API is unsupported on Safari < 12 due to a bug
   **/
  pauseUpstream() {
    return m(this, void 0, void 0, function* () {
      var e;
      const t = yield this.pauseUpstreamLock.lock();
      try {
        if (this._isUpstreamPaused === !0)
          return;
        if (!this.sender) {
          this.log.warn("unable to pause upstream for an unpublished track", this.logContext);
          return;
        }
        this._isUpstreamPaused = !0, this.emit(I.UpstreamPaused, this);
        const n = Re();
        if ((n == null ? void 0 : n.name) === "Safari" && Ke(n.version, "12.0") < 0)
          throw new hr("pauseUpstream is not supported on Safari < 12.");
        ((e = this.sender.transport) === null || e === void 0 ? void 0 : e.state) !== "closed" && (yield this.sender.replaceTrack(null));
      } finally {
        t();
      }
    });
  }
  resumeUpstream() {
    return m(this, void 0, void 0, function* () {
      var e;
      const t = yield this.pauseUpstreamLock.lock();
      try {
        if (this._isUpstreamPaused === !1)
          return;
        if (!this.sender) {
          this.log.warn("unable to resume upstream for an unpublished track", this.logContext);
          return;
        }
        this._isUpstreamPaused = !1, this.emit(I.UpstreamResumed, this), ((e = this.sender.transport) === null || e === void 0 ? void 0 : e.state) !== "closed" && (yield this.sender.replaceTrack(this.mediaStreamTrack));
      } finally {
        t();
      }
    });
  }
  /**
   * Gets the RTCStatsReport for the LocalTrack's underlying RTCRtpSender
   * See https://developer.mozilla.org/en-US/docs/Web/API/RTCStatsReport
   *
   * @returns Promise<RTCStatsReport> | undefined
   */
  getRTCStatsReport() {
    return m(this, void 0, void 0, function* () {
      var e;
      return !((e = this.sender) === null || e === void 0) && e.getStats ? yield this.sender.getStats() : void 0;
    });
  }
  /**
   * Sets a processor on this track.
   * See https://github.com/livekit/track-processors-js for example usage
   *
   * @experimental
   *
   * @param processor
   * @param showProcessedStreamLocally
   * @returns
   */
  setProcessor(e) {
    return m(this, arguments, void 0, function(t) {
      var n = this;
      let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      return function* () {
        var s;
        const a = yield n.processorLock.lock();
        try {
          n.log.debug("setting up processor", n.logContext);
          const o = document.createElement(n.kind), c = {
            kind: n.kind,
            track: n._mediaStreamTrack,
            element: o,
            audioContext: n.audioContext
          };
          if (yield t.init(c), n.log.debug("processor initialized", n.logContext), n.processor && (yield n.stopProcessor()), n.kind === "unknown")
            throw TypeError("cannot set processor on track of unknown kind");
          if (Ot(n._mediaStreamTrack, o), o.muted = !0, o.play().catch((d) => {
            d instanceof DOMException && d.name === "AbortError" ? (n.log.warn("failed to play processor element, retrying", Object.assign(Object.assign({}, n.logContext), {
              error: d
            })), setTimeout(() => {
              o.play().catch((u) => {
                n.log.error("failed to play processor element", Object.assign(Object.assign({}, n.logContext), {
                  err: u
                }));
              });
            }, 100)) : n.log.error("failed to play processor element", Object.assign(Object.assign({}, n.logContext), {
              error: d
            }));
          }), n.processor = t, n.processorElement = o, n.processor.processedTrack) {
            for (const d of n.attachedElements)
              d !== n.processorElement && r && (Lt(n._mediaStreamTrack, d), Ot(n.processor.processedTrack, d));
            yield (s = n.sender) === null || s === void 0 ? void 0 : s.replaceTrack(n.processor.processedTrack);
          }
          n.emit(I.TrackProcessorUpdate, n.processor);
        } finally {
          a();
        }
      }();
    });
  }
  getProcessor() {
    return this.processor;
  }
  /**
   * Stops the track processor
   * See https://github.com/livekit/track-processors-js for example usage
   *
   * @experimental
   * @returns
   */
  stopProcessor() {
    return m(this, arguments, void 0, function() {
      var e = this;
      let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      return function* () {
        var n, r;
        e.processor && (e.log.debug("stopping processor", e.logContext), (n = e.processor.processedTrack) === null || n === void 0 || n.stop(), yield e.processor.destroy(), e.processor = void 0, t || ((r = e.processorElement) === null || r === void 0 || r.remove(), e.processorElement = void 0), yield e._mediaStreamTrack.applyConstraints(e._constraints), yield e.setMediaStreamTrack(e._mediaStreamTrack, !0), e.emit(I.TrackProcessorUpdate));
      }();
    });
  }
  /** @internal */
  startPreConnectBuffer() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 100;
    if (!ol()) {
      this.log.warn("MediaRecorder is not available, cannot start preconnect buffer", this.logContext);
      return;
    }
    if (!this.localTrackRecorder)
      this.localTrackRecorder = new al(this, {
        mimeType: "audio/webm;codecs=opus"
      });
    else {
      this.log.warn("preconnect buffer already started");
      return;
    }
    this.localTrackRecorder.start(e), this.autoStopPreConnectBuffer = setTimeout(() => {
      this.log.warn("preconnect buffer timed out, stopping recording automatically", this.logContext), this.stopPreConnectBuffer();
    }, dl);
  }
  /** @internal */
  stopPreConnectBuffer() {
    clearTimeout(this.autoStopPreConnectBuffer), this.localTrackRecorder && (this.localTrackRecorder.stop(), this.localTrackRecorder = void 0);
  }
  /** @internal */
  getPreConnectBuffer() {
    var e;
    return (e = this.localTrackRecorder) === null || e === void 0 ? void 0 : e.byteStream;
  }
}
class Ui extends Io {
  /**
   * boolean indicating whether enhanced noise cancellation is currently being used on this track
   */
  get enhancedNoiseCancellation() {
    return this.isKrispNoiseFilterEnabled;
  }
  /**
   *
   * @param mediaTrack
   * @param constraints MediaTrackConstraints that are being used when restarting or reacquiring tracks
   * @param userProvidedTrack Signals to the SDK whether or not the mediaTrack should be managed (i.e. released and reacquired) internally by the SDK
   */
  constructor(e, t) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, r = arguments.length > 3 ? arguments[3] : void 0, s = arguments.length > 4 ? arguments[4] : void 0;
    super(e, E.Kind.Audio, t, n, s), this.stopOnMute = !1, this.isKrispNoiseFilterEnabled = !1, this.monitorSender = () => m(this, void 0, void 0, function* () {
      if (!this.sender) {
        this._currentBitrate = 0;
        return;
      }
      let a;
      try {
        a = yield this.getSenderStats();
      } catch (o) {
        this.log.error("could not get audio sender stats", Object.assign(Object.assign({}, this.logContext), {
          error: o
        }));
        return;
      }
      a && this.prevStats && (this._currentBitrate = zi(a, this.prevStats)), this.prevStats = a;
    }), this.handleKrispNoiseFilterEnable = () => {
      this.isKrispNoiseFilterEnabled = !0, this.log.debug("Krisp noise filter enabled", this.logContext), this.emit(I.AudioTrackFeatureUpdate, this, le.TF_ENHANCED_NOISE_CANCELLATION, !0);
    }, this.handleKrispNoiseFilterDisable = () => {
      this.isKrispNoiseFilterEnabled = !1, this.log.debug("Krisp noise filter disabled", this.logContext), this.emit(I.AudioTrackFeatureUpdate, this, le.TF_ENHANCED_NOISE_CANCELLATION, !1);
    }, this.audioContext = r, this.checkForSilence();
  }
  mute() {
    const e = Object.create(null, {
      mute: {
        get: () => super.mute
      }
    });
    return m(this, void 0, void 0, function* () {
      const t = yield this.muteLock.lock();
      try {
        return this.isMuted ? (this.log.debug("Track already muted", this.logContext), this) : (this.source === E.Source.Microphone && this.stopOnMute && !this.isUserProvided && (this.log.debug("stopping mic track", this.logContext), this._mediaStreamTrack.stop()), yield e.mute.call(this), this);
      } finally {
        t();
      }
    });
  }
  unmute() {
    const e = Object.create(null, {
      unmute: {
        get: () => super.unmute
      }
    });
    return m(this, void 0, void 0, function* () {
      const t = yield this.muteLock.lock();
      try {
        if (!this.isMuted)
          return this.log.debug("Track already unmuted", this.logContext), this;
        const n = this._constraints.deviceId && this._mediaStreamTrack.getSettings().deviceId !== lt(this._constraints.deviceId);
        return this.source === E.Source.Microphone && (this.stopOnMute || this._mediaStreamTrack.readyState === "ended" || n) && !this.isUserProvided && (this.log.debug("reacquiring mic track", this.logContext), yield this.restartTrack()), yield e.unmute.call(this), this;
      } finally {
        t();
      }
    });
  }
  restartTrack(e) {
    return m(this, void 0, void 0, function* () {
      let t;
      if (e) {
        const n = pr({
          audio: e
        });
        typeof n.audio != "boolean" && (t = n.audio);
      }
      yield this.restart(t);
    });
  }
  restart(e) {
    const t = Object.create(null, {
      restart: {
        get: () => super.restart
      }
    });
    return m(this, void 0, void 0, function* () {
      const n = yield t.restart.call(this, e);
      return this.checkForSilence(), n;
    });
  }
  /* @internal */
  startMonitor() {
    Se() && (this.monitorInterval || (this.monitorInterval = setInterval(() => {
      this.monitorSender();
    }, kr)));
  }
  setProcessor(e) {
    return m(this, void 0, void 0, function* () {
      var t;
      const n = yield this.processorLock.lock();
      try {
        if (!Ge() && !this.audioContext)
          throw Error("Audio context needs to be set on LocalAudioTrack in order to enable processors");
        this.processor && (yield this.stopProcessor());
        const r = {
          kind: this.kind,
          track: this._mediaStreamTrack,
          // RN won't have or use AudioContext
          audioContext: this.audioContext
        };
        this.log.debug("setting up audio processor ".concat(e.name), this.logContext), yield e.init(r), this.processor = e, this.processor.processedTrack && (yield (t = this.sender) === null || t === void 0 ? void 0 : t.replaceTrack(this.processor.processedTrack), this.processor.processedTrack.addEventListener("enable-lk-krisp-noise-filter", this.handleKrispNoiseFilterEnable), this.processor.processedTrack.addEventListener("disable-lk-krisp-noise-filter", this.handleKrispNoiseFilterDisable)), this.emit(I.TrackProcessorUpdate, this.processor);
      } finally {
        n();
      }
    });
  }
  /**
   * @internal
   * @experimental
   */
  setAudioContext(e) {
    this.audioContext = e;
  }
  getSenderStats() {
    return m(this, void 0, void 0, function* () {
      var e;
      if (!(!((e = this.sender) === null || e === void 0) && e.getStats))
        return;
      const t = yield this.sender.getStats();
      let n;
      return t.forEach((r) => {
        r.type === "outbound-rtp" && (n = {
          type: "audio",
          streamId: r.id,
          packetsSent: r.packetsSent,
          packetsLost: r.packetsLost,
          bytesSent: r.bytesSent,
          timestamp: r.timestamp,
          roundTripTime: r.roundTripTime,
          jitter: r.jitter
        });
      }), n;
    });
  }
  checkForSilence() {
    return m(this, void 0, void 0, function* () {
      const e = yield So(this);
      return e && (this.isMuted || this.log.warn("silence detected on local audio track", this.logContext), this.emit(I.AudioSilenceDetected)), e;
    });
  }
}
function ul(i, e, t) {
  switch (i.kind) {
    case "audio":
      return new Ui(i, e, !1, void 0, t);
    case "video":
      return new Fi(i, e, !1, t);
    default:
      throw new tt("unsupported track type: ".concat(i.kind));
  }
}
const ll = Object.values(ci), hl = Object.values(jn), fl = Object.values(fr), pl = [ci.h180, ci.h360], ml = [jn.h180, jn.h360], gl = (i) => [{
  scaleResolutionDownBy: 2,
  fps: i.encoding.maxFramerate
}].map((t) => {
  var n, r;
  return new J(Math.floor(i.width / t.scaleResolutionDownBy), Math.floor(i.height / t.scaleResolutionDownBy), Math.max(15e4, Math.floor(i.encoding.maxBitrate / (Math.pow(t.scaleResolutionDownBy, 2) * (((n = i.encoding.maxFramerate) !== null && n !== void 0 ? n : 30) / ((r = t.fps) !== null && r !== void 0 ? r : 30))))), t.fps, i.encoding.priority);
}), Yn = ["q", "h", "f"];
function Xn(i, e, t, n) {
  var r, s;
  let a = n == null ? void 0 : n.videoEncoding;
  i && (a = n == null ? void 0 : n.screenShareEncoding);
  const o = n == null ? void 0 : n.simulcast, c = n == null ? void 0 : n.scalabilityMode, d = n == null ? void 0 : n.videoCodec;
  if (!a && !o && !c || !e || !t)
    return [{}];
  a || (a = bl(i, e, t, d), G.debug("using video encoding", a));
  const u = a.maxFramerate, l = new J(e, t, a.maxBitrate, a.maxFramerate, a.priority);
  if (c && qe(d)) {
    const v = new Oo(c), f = [];
    if (v.spatial > 3)
      throw new Error("unsupported scalabilityMode: ".concat(c));
    const T = Re();
    if (Wn() || // Even tho RN runs M114, it does not produce SVC layers when a single encoding
    // is provided. So we'll use the legacy SVC specification for now.
    // TODO: when we upstream libwebrtc, this will need additional verification
    Ge() || (T == null ? void 0 : T.name) === "Chrome" && Ke(T == null ? void 0 : T.version, "113") < 0) {
      const g = v.suffix == "h" ? 2 : 3, O = Tu(T);
      for (let w = 0; w < v.spatial; w += 1)
        f.push({
          rid: Yn[2 - w],
          maxBitrate: a.maxBitrate / Math.pow(g, w),
          maxFramerate: l.encoding.maxFramerate,
          scaleResolutionDownBy: O ? Math.pow(2, w) : void 0
        });
      f[0].scalabilityMode = c;
    } else
      f.push({
        maxBitrate: a.maxBitrate,
        maxFramerate: l.encoding.maxFramerate,
        /* @ts-ignore */
        scalabilityMode: c
      });
    return l.encoding.priority && (f[0].priority = l.encoding.priority, f[0].networkPriority = l.encoding.priority), G.debug("using svc encoding", {
      encodings: f
    }), f;
  }
  if (!o)
    return [a];
  let h = [];
  i ? h = (r = As(n == null ? void 0 : n.screenShareSimulcastLayers)) !== null && r !== void 0 ? r : Ds(i, l) : h = (s = As(n == null ? void 0 : n.videoSimulcastLayers)) !== null && s !== void 0 ? s : Ds(i, l);
  let p;
  if (h.length > 0) {
    const v = h[0];
    h.length > 1 && ([, p] = h);
    const f = Math.max(e, t);
    if (f >= 960 && p)
      return mn(e, t, [v, p, l], u);
    if (f >= 480)
      return mn(e, t, [v, l], u);
  }
  return mn(e, t, [l]);
}
function vl(i, e, t) {
  var n, r, s, a;
  if (!t.backupCodec || t.backupCodec === !0 || t.backupCodec.codec === t.videoCodec)
    return;
  e !== t.backupCodec.codec && G.warn("requested a different codec than specified as backup", {
    serverRequested: e,
    backup: t.backupCodec.codec
  }), t.videoCodec = e, t.videoEncoding = t.backupCodec.encoding;
  const o = i.mediaStreamTrack.getSettings(), c = (n = o.width) !== null && n !== void 0 ? n : (r = i.dimensions) === null || r === void 0 ? void 0 : r.width, d = (s = o.height) !== null && s !== void 0 ? s : (a = i.dimensions) === null || a === void 0 ? void 0 : a.height;
  return i.source === E.Source.ScreenShare && t.simulcast && (t.simulcast = !1), Xn(i.source === E.Source.ScreenShare, c, d, t);
}
function bl(i, e, t, n) {
  const r = yl(i, e, t);
  let {
    encoding: s
  } = r[0];
  const a = Math.max(e, t);
  for (let o = 0; o < r.length; o += 1) {
    const c = r[o];
    if (s = c.encoding, c.width >= a)
      break;
  }
  if (n)
    switch (n) {
      case "av1":
      case "h265":
        s = Object.assign({}, s), s.maxBitrate = s.maxBitrate * 0.7;
        break;
      case "vp9":
        s = Object.assign({}, s), s.maxBitrate = s.maxBitrate * 0.85;
        break;
    }
  return s;
}
function yl(i, e, t) {
  if (i)
    return fl;
  const n = e > t ? e / t : t / e;
  return Math.abs(n - 16 / 9) < Math.abs(n - 4 / 3) ? ll : hl;
}
function Ds(i, e) {
  if (i)
    return gl(e);
  const {
    width: t,
    height: n
  } = e, r = t > n ? t / n : n / t;
  return Math.abs(r - 16 / 9) < Math.abs(r - 4 / 3) ? pl : ml;
}
function mn(i, e, t, n) {
  const r = [];
  if (t.forEach((s, a) => {
    if (a >= Yn.length)
      return;
    const o = Math.min(i, e), d = {
      rid: Yn[a],
      scaleResolutionDownBy: Math.max(1, o / Math.min(s.width, s.height)),
      maxBitrate: s.encoding.maxBitrate
    }, u = n && s.encoding.maxFramerate ? Math.min(n, s.encoding.maxFramerate) : s.encoding.maxFramerate;
    u && (d.maxFramerate = u);
    const l = Bt() || a === 0;
    s.encoding.priority && l && (d.priority = s.encoding.priority, d.networkPriority = s.encoding.priority), r.push(d);
  }), Ge() && ko() === "ios") {
    let s;
    r.forEach((o) => {
      s ? o.maxFramerate && o.maxFramerate > s && (s = o.maxFramerate) : s = o.maxFramerate;
    });
    let a = !0;
    r.forEach((o) => {
      var c;
      o.maxFramerate != s && (a && (a = !1, G.info("Simulcast on iOS React-Native requires all encodings to share the same framerate.")), G.info('Setting framerate of encoding "'.concat((c = o.rid) !== null && c !== void 0 ? c : "", '" to ').concat(s)), o.maxFramerate = s);
    });
  }
  return r;
}
function As(i) {
  if (i)
    return i.sort((e, t) => {
      const {
        encoding: n
      } = e, {
        encoding: r
      } = t;
      return n.maxBitrate > r.maxBitrate ? 1 : n.maxBitrate < r.maxBitrate ? -1 : n.maxBitrate === r.maxBitrate && n.maxFramerate && r.maxFramerate ? n.maxFramerate > r.maxFramerate ? 1 : -1 : 0;
    });
}
class Oo {
  constructor(e) {
    const t = e.match(/^L(\d)T(\d)(h|_KEY|_KEY_SHIFT){0,1}$/);
    if (!t)
      throw new Error("invalid scalability mode");
    if (this.spatial = parseInt(t[1]), this.temporal = parseInt(t[2]), t.length > 3)
      switch (t[3]) {
        case "h":
        case "_KEY":
        case "_KEY_SHIFT":
          this.suffix = t[3];
      }
  }
  toString() {
    var e;
    return "L".concat(this.spatial, "T").concat(this.temporal).concat((e = this.suffix) !== null && e !== void 0 ? e : "");
  }
}
function kl(i) {
  return i.source === E.Source.ScreenShare || i.constraints.height && lt(i.constraints.height) >= 1080 ? "maintain-resolution" : "balanced";
}
const Tl = 5e3;
class Fi extends Io {
  get sender() {
    return this._sender;
  }
  set sender(e) {
    this._sender = e, this.degradationPreference && this.setDegradationPreference(this.degradationPreference);
  }
  /**
   *
   * @param mediaTrack
   * @param constraints MediaTrackConstraints that are being used when restarting or reacquiring tracks
   * @param userProvidedTrack Signals to the SDK whether or not the mediaTrack should be managed (i.e. released and reacquired) internally by the SDK
   */
  constructor(e, t) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, r = arguments.length > 3 ? arguments[3] : void 0;
    super(e, E.Kind.Video, t, n, r), this.simulcastCodecs = /* @__PURE__ */ new Map(), this.degradationPreference = "balanced", this.isCpuConstrained = !1, this.optimizeForPerformance = !1, this.monitorSender = () => m(this, void 0, void 0, function* () {
      if (!this.sender) {
        this._currentBitrate = 0;
        return;
      }
      let s;
      try {
        s = yield this.getSenderStats();
      } catch (c) {
        this.log.error("could not get video sender stats", Object.assign(Object.assign({}, this.logContext), {
          error: c
        }));
        return;
      }
      const a = new Map(s.map((c) => [c.rid, c])), o = s.some((c) => c.qualityLimitationReason === "cpu");
      if (o !== this.isCpuConstrained && (this.isCpuConstrained = o, this.isCpuConstrained && this.emit(I.CpuConstrained)), this.prevStats) {
        let c = 0;
        a.forEach((d, u) => {
          var l;
          const h = (l = this.prevStats) === null || l === void 0 ? void 0 : l.get(u);
          c += zi(d, h);
        }), this._currentBitrate = c;
      }
      this.prevStats = a;
    }), this.senderLock = new ge();
  }
  get isSimulcast() {
    return !!(this.sender && this.sender.getParameters().encodings.length > 1);
  }
  /* @internal */
  startMonitor(e) {
    var t;
    if (this.signalClient = e, !Se())
      return;
    const n = (t = this.sender) === null || t === void 0 ? void 0 : t.getParameters();
    n && (this.encodings = n.encodings), !this.monitorInterval && (this.monitorInterval = setInterval(() => {
      this.monitorSender();
    }, kr));
  }
  stop() {
    this._mediaStreamTrack.getConstraints(), this.simulcastCodecs.forEach((e) => {
      e.mediaStreamTrack.stop();
    }), super.stop();
  }
  pauseUpstream() {
    const e = Object.create(null, {
      pauseUpstream: {
        get: () => super.pauseUpstream
      }
    });
    return m(this, void 0, void 0, function* () {
      var t, n, r, s, a;
      yield e.pauseUpstream.call(this);
      try {
        for (var o = !0, c = et(this.simulcastCodecs.values()), d; d = yield c.next(), t = d.done, !t; o = !0)
          s = d.value, o = !1, yield (a = s.sender) === null || a === void 0 ? void 0 : a.replaceTrack(null);
      } catch (u) {
        n = {
          error: u
        };
      } finally {
        try {
          !o && !t && (r = c.return) && (yield r.call(c));
        } finally {
          if (n) throw n.error;
        }
      }
    });
  }
  resumeUpstream() {
    const e = Object.create(null, {
      resumeUpstream: {
        get: () => super.resumeUpstream
      }
    });
    return m(this, void 0, void 0, function* () {
      var t, n, r, s, a;
      yield e.resumeUpstream.call(this);
      try {
        for (var o = !0, c = et(this.simulcastCodecs.values()), d; d = yield c.next(), t = d.done, !t; o = !0) {
          s = d.value, o = !1;
          const u = s;
          yield (a = u.sender) === null || a === void 0 ? void 0 : a.replaceTrack(u.mediaStreamTrack);
        }
      } catch (u) {
        n = {
          error: u
        };
      } finally {
        try {
          !o && !t && (r = c.return) && (yield r.call(c));
        } finally {
          if (n) throw n.error;
        }
      }
    });
  }
  mute() {
    const e = Object.create(null, {
      mute: {
        get: () => super.mute
      }
    });
    return m(this, void 0, void 0, function* () {
      const t = yield this.muteLock.lock();
      try {
        return this.isMuted ? (this.log.debug("Track already muted", this.logContext), this) : (this.source === E.Source.Camera && !this.isUserProvided && (this.log.debug("stopping camera track", this.logContext), this._mediaStreamTrack.stop()), yield e.mute.call(this), this);
      } finally {
        t();
      }
    });
  }
  unmute() {
    const e = Object.create(null, {
      unmute: {
        get: () => super.unmute
      }
    });
    return m(this, void 0, void 0, function* () {
      const t = yield this.muteLock.lock();
      try {
        return this.isMuted ? (this.source === E.Source.Camera && !this.isUserProvided && (this.log.debug("reacquiring camera track", this.logContext), yield this.restartTrack()), yield e.unmute.call(this), this) : (this.log.debug("Track already unmuted", this.logContext), this);
      } finally {
        t();
      }
    });
  }
  setTrackMuted(e) {
    super.setTrackMuted(e);
    for (const t of this.simulcastCodecs.values())
      t.mediaStreamTrack.enabled = !e;
  }
  getSenderStats() {
    return m(this, void 0, void 0, function* () {
      var e;
      if (!(!((e = this.sender) === null || e === void 0) && e.getStats))
        return [];
      const t = [], n = yield this.sender.getStats();
      return n.forEach((r) => {
        var s;
        if (r.type === "outbound-rtp") {
          const a = {
            type: "video",
            streamId: r.id,
            frameHeight: r.frameHeight,
            frameWidth: r.frameWidth,
            framesPerSecond: r.framesPerSecond,
            framesSent: r.framesSent,
            firCount: r.firCount,
            pliCount: r.pliCount,
            nackCount: r.nackCount,
            packetsSent: r.packetsSent,
            bytesSent: r.bytesSent,
            qualityLimitationReason: r.qualityLimitationReason,
            qualityLimitationDurations: r.qualityLimitationDurations,
            qualityLimitationResolutionChanges: r.qualityLimitationResolutionChanges,
            rid: (s = r.rid) !== null && s !== void 0 ? s : r.id,
            retransmittedPacketsSent: r.retransmittedPacketsSent,
            targetBitrate: r.targetBitrate,
            timestamp: r.timestamp
          }, o = n.get(r.remoteId);
          o && (a.jitter = o.jitter, a.packetsLost = o.packetsLost, a.roundTripTime = o.roundTripTime), t.push(a);
        }
      }), t.sort((r, s) => {
        var a, o;
        return ((a = s.frameWidth) !== null && a !== void 0 ? a : 0) - ((o = r.frameWidth) !== null && o !== void 0 ? o : 0);
      }), t;
    });
  }
  setPublishingQuality(e) {
    const t = [];
    for (let n = Ee.LOW; n <= Ee.HIGH; n += 1)
      t.push(new ur({
        quality: n,
        enabled: n <= e
      }));
    this.log.debug("setting publishing quality. max quality ".concat(e), this.logContext), this.setPublishingLayers(qe(this.codec), t);
  }
  restartTrack(e) {
    return m(this, void 0, void 0, function* () {
      var t, n, r, s, a;
      let o;
      if (e) {
        const l = pr({
          video: e
        });
        typeof l.video != "boolean" && (o = l.video);
      }
      yield this.restart(o), this.isCpuConstrained = !1;
      try {
        for (var c = !0, d = et(this.simulcastCodecs.values()), u; u = yield d.next(), t = u.done, !t; c = !0) {
          s = u.value, c = !1;
          const l = s;
          l.sender && ((a = l.sender.transport) === null || a === void 0 ? void 0 : a.state) !== "closed" && (l.mediaStreamTrack = this.mediaStreamTrack.clone(), yield l.sender.replaceTrack(l.mediaStreamTrack));
        }
      } catch (l) {
        n = {
          error: l
        };
      } finally {
        try {
          !c && !t && (r = d.return) && (yield r.call(d));
        } finally {
          if (n) throw n.error;
        }
      }
    });
  }
  setProcessor(e) {
    const t = Object.create(null, {
      setProcessor: {
        get: () => super.setProcessor
      }
    });
    return m(this, arguments, void 0, function(n) {
      var r = this;
      let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      return function* () {
        var a, o, c, d, u, l;
        if (yield t.setProcessor.call(r, n, s), !((u = r.processor) === null || u === void 0) && u.processedTrack)
          try {
            for (var h = !0, p = et(r.simulcastCodecs.values()), v; v = yield p.next(), a = v.done, !a; h = !0)
              d = v.value, h = !1, yield (l = d.sender) === null || l === void 0 ? void 0 : l.replaceTrack(r.processor.processedTrack);
          } catch (f) {
            o = {
              error: f
            };
          } finally {
            try {
              !h && !a && (c = p.return) && (yield c.call(p));
            } finally {
              if (o) throw o.error;
            }
          }
      }();
    });
  }
  setDegradationPreference(e) {
    return m(this, void 0, void 0, function* () {
      if (this.degradationPreference = e, this.sender)
        try {
          this.log.debug("setting degradationPreference to ".concat(e), this.logContext);
          const t = this.sender.getParameters();
          t.degradationPreference = e, this.sender.setParameters(t);
        } catch (t) {
          this.log.warn("failed to set degradationPreference", Object.assign({
            error: t
          }, this.logContext));
        }
    });
  }
  addSimulcastTrack(e, t) {
    if (this.simulcastCodecs.has(e)) {
      this.log.error("".concat(e, " already added, skipping adding simulcast codec"), this.logContext);
      return;
    }
    const n = {
      codec: e,
      mediaStreamTrack: this.mediaStreamTrack.clone(),
      sender: void 0,
      encodings: t
    };
    return this.simulcastCodecs.set(e, n), n;
  }
  setSimulcastTrackSender(e, t) {
    const n = this.simulcastCodecs.get(e);
    n && (n.sender = t, setTimeout(() => {
      this.subscribedCodecs && this.setPublishingCodecs(this.subscribedCodecs);
    }, Tl));
  }
  /**
   * @internal
   * Sets codecs that should be publishing, returns new codecs that have not yet
   * been published
   */
  setPublishingCodecs(e) {
    return m(this, void 0, void 0, function* () {
      var t, n, r, s, a, o, c;
      if (this.log.debug("setting publishing codecs", Object.assign(Object.assign({}, this.logContext), {
        codecs: e,
        currentCodec: this.codec
      })), !this.codec && e.length > 0)
        return yield this.setPublishingLayers(qe(e[0].codec), e[0].qualities), [];
      this.subscribedCodecs = e;
      const d = [];
      try {
        for (t = !0, n = et(e); r = yield n.next(), s = r.done, !s; t = !0) {
          c = r.value, t = !1;
          const u = c;
          if (!this.codec || this.codec === u.codec)
            yield this.setPublishingLayers(qe(u.codec), u.qualities);
          else {
            const l = this.simulcastCodecs.get(u.codec);
            if (this.log.debug("try setPublishingCodec for ".concat(u.codec), Object.assign(Object.assign({}, this.logContext), {
              simulcastCodecInfo: l
            })), !l || !l.sender) {
              for (const h of u.qualities)
                if (h.enabled) {
                  d.push(u.codec);
                  break;
                }
            } else l.encodings && (this.log.debug("try setPublishingLayersForSender ".concat(u.codec), this.logContext), yield Ls(l.sender, l.encodings, u.qualities, this.senderLock, qe(u.codec), this.log, this.logContext));
          }
        }
      } catch (u) {
        a = {
          error: u
        };
      } finally {
        try {
          !t && !s && (o = n.return) && (yield o.call(n));
        } finally {
          if (a) throw a.error;
        }
      }
      return d;
    });
  }
  /**
   * @internal
   * Sets layers that should be publishing
   */
  setPublishingLayers(e, t) {
    return m(this, void 0, void 0, function* () {
      if (this.optimizeForPerformance) {
        this.log.info("skipping setPublishingLayers due to optimized publishing performance", Object.assign(Object.assign({}, this.logContext), {
          qualities: t
        }));
        return;
      }
      this.log.debug("setting publishing layers", Object.assign(Object.assign({}, this.logContext), {
        qualities: t
      })), !(!this.sender || !this.encodings) && (yield Ls(this.sender, this.encodings, t, this.senderLock, e, this.log, this.logContext));
    });
  }
  /**
   * Designed for lower powered devices, reduces video publishing quality and disables simulcast.
   * @experimental
   */
  prioritizePerformance() {
    return m(this, void 0, void 0, function* () {
      if (!this.sender)
        throw new Error("sender not found");
      const e = yield this.senderLock.lock();
      try {
        this.optimizeForPerformance = !0;
        const t = this.sender.getParameters();
        t.encodings = t.encodings.map((n, r) => {
          var s;
          return Object.assign(Object.assign({}, n), {
            active: r === 0,
            scaleResolutionDownBy: Math.max(1, Math.ceil(((s = this.mediaStreamTrack.getSettings().height) !== null && s !== void 0 ? s : 360) / 360)),
            scalabilityMode: r === 0 && qe(this.codec) ? "L1T3" : void 0,
            maxFramerate: r === 0 ? 15 : 0,
            maxBitrate: r === 0 ? n.maxBitrate : 0
          });
        }), this.log.debug("setting performance optimised encodings", Object.assign(Object.assign({}, this.logContext), {
          encodings: t.encodings
        })), this.encodings = t.encodings, yield this.sender.setParameters(t);
      } catch (t) {
        this.log.error("failed to set performance optimised encodings", Object.assign(Object.assign({}, this.logContext), {
          error: t
        })), this.optimizeForPerformance = !1;
      } finally {
        e();
      }
    });
  }
  handleAppVisibilityChanged() {
    const e = Object.create(null, {
      handleAppVisibilityChanged: {
        get: () => super.handleAppVisibilityChanged
      }
    });
    return m(this, void 0, void 0, function* () {
      yield e.handleAppVisibilityChanged.call(this), bo() && this.isInBackground && this.source === E.Source.Camera && (this._mediaStreamTrack.enabled = !1);
    });
  }
}
function Ls(i, e, t, n, r, s, a) {
  return m(this, void 0, void 0, function* () {
    const o = yield n.lock();
    s.debug("setPublishingLayersForSender", Object.assign(Object.assign({}, a), {
      sender: i,
      qualities: t,
      senderEncodings: e
    }));
    try {
      const c = i.getParameters(), {
        encodings: d
      } = c;
      if (!d)
        return;
      if (d.length !== e.length) {
        s.warn("cannot set publishing layers, encodings mismatch", Object.assign(Object.assign({}, a), {
          encodings: d,
          senderEncodings: e
        }));
        return;
      }
      let u = !1;
      !1 && d[0].scalabilityMode || (r && t.some((p) => p.enabled) && t.forEach((p) => p.enabled = !0), d.forEach((h, p) => {
        var v;
        let f = (v = h.rid) !== null && v !== void 0 ? v : "";
        f === "" && (f = "q");
        const T = xo(f), g = t.find((O) => O.quality === T);
        g && h.active !== g.enabled && (u = !0, h.active = g.enabled, s.debug("setting layer ".concat(g.quality, " to ").concat(h.active ? "enabled" : "disabled"), a), Bt() && (g.enabled ? (h.scaleResolutionDownBy = e[p].scaleResolutionDownBy, h.maxBitrate = e[p].maxBitrate, h.maxFrameRate = e[p].maxFrameRate) : (h.scaleResolutionDownBy = 4, h.maxBitrate = 10, h.maxFrameRate = 2)));
      })), u && (c.encodings = d, s.debug("setting encodings", Object.assign(Object.assign({}, a), {
        encodings: c.encodings
      })), yield i.setParameters(c));
    } finally {
      o();
    }
  });
}
function xo(i) {
  switch (i) {
    case "f":
      return Ee.HIGH;
    case "h":
      return Ee.MEDIUM;
    case "q":
      return Ee.LOW;
    default:
      return Ee.HIGH;
  }
}
function Ns(i, e, t, n) {
  if (!t)
    return [new yt({
      quality: Ee.HIGH,
      width: i,
      height: e,
      bitrate: 0,
      ssrc: 0
    })];
  if (n) {
    const r = t[0].scalabilityMode, s = new Oo(r), a = [], o = s.suffix == "h" ? 1.5 : 2, c = s.suffix == "h" ? 2 : 3;
    for (let d = 0; d < s.spatial; d += 1)
      a.push(new yt({
        quality: Math.min(Ee.HIGH, s.spatial - 1) - d,
        width: Math.ceil(i / Math.pow(o, d)),
        height: Math.ceil(e / Math.pow(o, d)),
        bitrate: t[0].maxBitrate ? Math.ceil(t[0].maxBitrate / Math.pow(c, d)) : 0,
        ssrc: 0
      }));
    return a;
  }
  return t.map((r) => {
    var s, a, o;
    const c = (s = r.scaleResolutionDownBy) !== null && s !== void 0 ? s : 1;
    let d = xo((a = r.rid) !== null && a !== void 0 ? a : "");
    return new yt({
      quality: d,
      width: Math.ceil(i / c),
      height: Math.ceil(e / c),
      bitrate: (o = r.maxBitrate) !== null && o !== void 0 ? o : 0,
      ssrc: 0
    });
  });
}
const Us = "_lossy", Fs = "_reliable", Sl = 2 * 1e3, gn = "leave-reconnect", Cl = 3e4;
var xe;
(function(i) {
  i[i.New = 0] = "New", i[i.Connected = 1] = "Connected", i[i.Disconnected = 2] = "Disconnected", i[i.Reconnecting = 3] = "Reconnecting", i[i.Closed = 4] = "Closed";
})(xe || (xe = {}));
class Pl extends He.EventEmitter {
  get isClosed() {
    return this._isClosed;
  }
  get pendingReconnect() {
    return !!this.reconnectTimeout;
  }
  constructor(e) {
    var t;
    super(), this.options = e, this.rtcConfig = {}, this.peerConnectionTimeout = br.peerConnectionTimeout, this.fullReconnectOnNext = !1, this.latestRemoteOfferId = 0, this.subscriberPrimary = !1, this.pcState = xe.New, this._isClosed = !0, this.pendingTrackResolvers = {}, this.reconnectAttempts = 0, this.reconnectStart = 0, this.attemptingReconnect = !1, this.joinAttempts = 0, this.maxJoinAttempts = 1, this.shouldFailNext = !1, this.log = G, this.reliableDataSequence = 1, this.reliableMessageBuffer = new Ps(), this.reliableReceivedState = new Ju(Cl), this.handleDataChannel = (n) => m(this, [n], void 0, function(r) {
      var s = this;
      let {
        channel: a
      } = r;
      return function* () {
        if (a) {
          if (a.label === Fs)
            s.reliableDCSub = a;
          else if (a.label === Us)
            s.lossyDCSub = a;
          else
            return;
          s.log.debug("on data channel ".concat(a.id, ", ").concat(a.label), s.logContext), a.onmessage = s.handleDataMessage;
        }
      }();
    }), this.handleDataMessage = (n) => m(this, void 0, void 0, function* () {
      var r, s;
      const a = yield this.dataProcessLock.lock();
      try {
        let o;
        if (n.data instanceof ArrayBuffer)
          o = n.data;
        else if (n.data instanceof Blob)
          o = yield n.data.arrayBuffer();
        else {
          this.log.error("unsupported data type", Object.assign(Object.assign({}, this.logContext), {
            data: n.data
          }));
          return;
        }
        const c = ke.fromBinary(new Uint8Array(o));
        if (c.sequence > 0 && c.participantSid !== "") {
          const d = this.reliableReceivedState.get(c.participantSid);
          if (d && c.sequence <= d)
            return;
          this.reliableReceivedState.set(c.participantSid, c.sequence);
        }
        ((r = c.value) === null || r === void 0 ? void 0 : r.case) === "speaker" ? this.emit(M.ActiveSpeakersUpdate, c.value.value.speakers) : (((s = c.value) === null || s === void 0 ? void 0 : s.case) === "user" && Rl(c, c.value.value), this.emit(M.DataPacketReceived, c));
      } finally {
        a();
      }
    }), this.handleDataError = (n) => {
      const s = n.currentTarget.maxRetransmits === 0 ? "lossy" : "reliable";
      if (n instanceof ErrorEvent && n.error) {
        const {
          error: a
        } = n.error;
        this.log.error("DataChannel error on ".concat(s, ": ").concat(n.message), Object.assign(Object.assign({}, this.logContext), {
          error: a
        }));
      } else
        this.log.error("Unknown DataChannel error on ".concat(s), Object.assign(Object.assign({}, this.logContext), {
          event: n
        }));
    }, this.handleBufferedAmountLow = (n) => {
      const s = n.currentTarget.maxRetransmits === 0 ? q.LOSSY : q.RELIABLE;
      this.updateAndEmitDCBufferStatus(s);
    }, this.handleDisconnect = (n, r) => {
      if (this._isClosed)
        return;
      this.log.warn("".concat(n, " disconnected"), this.logContext), this.reconnectAttempts === 0 && (this.reconnectStart = Date.now());
      const s = (c) => {
        this.log.warn("could not recover connection after ".concat(this.reconnectAttempts, " attempts, ").concat(c, "ms. giving up"), this.logContext), this.emit(M.Disconnected), this.close();
      }, a = Date.now() - this.reconnectStart;
      let o = this.getNextRetryDelay({
        elapsedMs: a,
        retryCount: this.reconnectAttempts
      });
      if (o === null) {
        s(a);
        return;
      }
      n === gn && (o = 0), this.log.debug("reconnecting in ".concat(o, "ms"), this.logContext), this.clearReconnectTimeout(), this.token && this.regionUrlProvider && this.regionUrlProvider.updateToken(this.token), this.reconnectTimeout = pe.setTimeout(() => this.attemptReconnect(r).finally(() => this.reconnectTimeout = void 0), o);
    }, this.waitForRestarted = () => new Promise((n, r) => {
      this.pcState === xe.Connected && n();
      const s = () => {
        this.off(M.Disconnected, a), n();
      }, a = () => {
        this.off(M.Restarted, s), r();
      };
      this.once(M.Restarted, s), this.once(M.Disconnected, a);
    }), this.updateAndEmitDCBufferStatus = (n) => {
      const r = this.isBufferStatusLow(n);
      typeof r != "undefined" && r !== this.dcBufferStatus.get(n) && (this.dcBufferStatus.set(n, r), this.emit(M.DCBufferStatusChanged, r, n));
    }, this.isBufferStatusLow = (n) => {
      const r = this.dataChannelForKind(n);
      if (r)
        return n === q.RELIABLE && this.reliableMessageBuffer.alignBufferedAmount(r.bufferedAmount), r.bufferedAmount <= r.bufferedAmountLowThreshold;
    }, this.handleBrowserOnLine = () => {
      this.client.currentState === Y.RECONNECTING && (this.clearReconnectTimeout(), this.attemptReconnect(wt.RR_SIGNAL_DISCONNECTED));
    }, this.log = it((t = e.loggerName) !== null && t !== void 0 ? t : Ne.Engine), this.loggerOptions = {
      loggerName: e.loggerName,
      loggerContextCb: () => this.logContext
    }, this.client = new mr(void 0, this.loggerOptions), this.client.signalLatency = this.options.expSignalLatency, this.reconnectPolicy = this.options.reconnectPolicy, this.registerOnLineListener(), this.closingLock = new ge(), this.dataProcessLock = new ge(), this.dcBufferStatus = /* @__PURE__ */ new Map([[q.LOSSY, !0], [q.RELIABLE, !0]]), this.client.onParticipantUpdate = (n) => this.emit(M.ParticipantUpdate, n), this.client.onConnectionQuality = (n) => this.emit(M.ConnectionQualityUpdate, n), this.client.onRoomUpdate = (n) => this.emit(M.RoomUpdate, n), this.client.onSubscriptionError = (n) => this.emit(M.SubscriptionError, n), this.client.onSubscriptionPermissionUpdate = (n) => this.emit(M.SubscriptionPermissionUpdate, n), this.client.onSpeakersChanged = (n) => this.emit(M.SpeakersChanged, n), this.client.onStreamStateUpdate = (n) => this.emit(M.StreamStateChanged, n), this.client.onRequestResponse = (n) => this.emit(M.SignalRequestResponse, n);
  }
  /** @internal */
  get logContext() {
    var e, t, n, r, s, a;
    return {
      room: (t = (e = this.latestJoinResponse) === null || e === void 0 ? void 0 : e.room) === null || t === void 0 ? void 0 : t.name,
      roomID: (r = (n = this.latestJoinResponse) === null || n === void 0 ? void 0 : n.room) === null || r === void 0 ? void 0 : r.sid,
      participant: (a = (s = this.latestJoinResponse) === null || s === void 0 ? void 0 : s.participant) === null || a === void 0 ? void 0 : a.identity,
      pID: this.participantSid
    };
  }
  join(e, t, n, r) {
    return m(this, void 0, void 0, function* () {
      this.url = e, this.token = t, this.signalOpts = n, this.maxJoinAttempts = n.maxRetries;
      try {
        this.joinAttempts += 1, this.setupSignalClientCallbacks();
        const s = yield this.client.join(e, t, n, r);
        return this._isClosed = !1, this.latestJoinResponse = s, this.subscriberPrimary = s.subscriberPrimary, this.pcManager || (yield this.configure(s)), (!this.subscriberPrimary || s.fastPublish) && this.negotiate(), this.clientConfiguration = s.clientConfiguration, this.emit(M.SignalConnected, s), s;
      } catch (s) {
        if (s instanceof Q && s.reason === K.ServerUnreachable && (this.log.warn("Couldn't connect to server, attempt ".concat(this.joinAttempts, " of ").concat(this.maxJoinAttempts), this.logContext), this.joinAttempts < this.maxJoinAttempts))
          return this.join(e, t, n, r);
        throw s;
      }
    });
  }
  close() {
    return m(this, void 0, void 0, function* () {
      const e = yield this.closingLock.lock();
      if (this.isClosed) {
        e();
        return;
      }
      try {
        this._isClosed = !0, this.joinAttempts = 0, this.emit(M.Closing), this.removeAllListeners(), this.deregisterOnLineListener(), this.clearPendingReconnect(), yield this.cleanupPeerConnections(), yield this.cleanupClient();
      } finally {
        e();
      }
    });
  }
  cleanupPeerConnections() {
    return m(this, void 0, void 0, function* () {
      var e;
      yield (e = this.pcManager) === null || e === void 0 ? void 0 : e.close(), this.pcManager = void 0;
      const t = (n) => {
        n && (n.close(), n.onbufferedamountlow = null, n.onclose = null, n.onclosing = null, n.onerror = null, n.onmessage = null, n.onopen = null);
      };
      t(this.lossyDC), t(this.lossyDCSub), t(this.reliableDC), t(this.reliableDCSub), this.lossyDC = void 0, this.lossyDCSub = void 0, this.reliableDC = void 0, this.reliableDCSub = void 0, this.reliableMessageBuffer = new Ps(), this.reliableDataSequence = 1, this.reliableReceivedState.clear();
    });
  }
  cleanupClient() {
    return m(this, void 0, void 0, function* () {
      yield this.client.close(), this.client.resetCallbacks();
    });
  }
  addTrack(e) {
    if (this.pendingTrackResolvers[e.cid])
      throw new tt("a track with the same ID has already been published");
    return new Promise((t, n) => {
      const r = setTimeout(() => {
        delete this.pendingTrackResolvers[e.cid], n(new Q("publication of local track timed out, no response from server", K.Timeout));
      }, 1e4);
      this.pendingTrackResolvers[e.cid] = {
        resolve: (s) => {
          clearTimeout(r), t(s);
        },
        reject: () => {
          clearTimeout(r), n(new Error("Cancelled publication by calling unpublish"));
        }
      }, this.client.sendAddTrack(e);
    });
  }
  /**
   * Removes sender from PeerConnection, returning true if it was removed successfully
   * and a negotiation is necessary
   * @param sender
   * @returns
   */
  removeTrack(e) {
    if (e.track && this.pendingTrackResolvers[e.track.id]) {
      const {
        reject: t
      } = this.pendingTrackResolvers[e.track.id];
      t && t(), delete this.pendingTrackResolvers[e.track.id];
    }
    try {
      return this.pcManager.removeTrack(e), !0;
    } catch (t) {
      this.log.warn("failed to remove track", Object.assign(Object.assign({}, this.logContext), {
        error: t
      }));
    }
    return !1;
  }
  updateMuteStatus(e, t) {
    this.client.sendMuteTrack(e, t);
  }
  get dataSubscriberReadyState() {
    var e;
    return (e = this.reliableDCSub) === null || e === void 0 ? void 0 : e.readyState;
  }
  getConnectedServerAddress() {
    return m(this, void 0, void 0, function* () {
      var e;
      return (e = this.pcManager) === null || e === void 0 ? void 0 : e.getConnectedAddress();
    });
  }
  /* @internal */
  setRegionUrlProvider(e) {
    this.regionUrlProvider = e;
  }
  configure(e) {
    return m(this, void 0, void 0, function* () {
      var t, n;
      if (this.pcManager && this.pcManager.currentState !== te.NEW)
        return;
      this.participantSid = (t = e.participant) === null || t === void 0 ? void 0 : t.sid;
      const r = this.makeRTCConfiguration(e);
      this.pcManager = new nl(r, e.subscriberPrimary, this.loggerOptions), this.emit(M.TransportsCreated, this.pcManager.publisher, this.pcManager.subscriber), this.pcManager.onIceCandidate = (s, a) => {
        this.client.sendIceCandidate(s, a);
      }, this.pcManager.onPublisherOffer = (s, a) => {
        this.client.sendOffer(s, a);
      }, this.pcManager.onDataChannel = this.handleDataChannel, this.pcManager.onStateChange = (s, a, o) => m(this, void 0, void 0, function* () {
        if (this.log.debug("primary PC state changed ".concat(s), this.logContext), ["closed", "disconnected", "failed"].includes(a) && (this.publisherConnectionPromise = void 0), s === te.CONNECTED) {
          const u = this.pcState === xe.New;
          this.pcState = xe.Connected, u && this.emit(M.Connected, e);
        } else s === te.FAILED && this.pcState === xe.Connected && (this.pcState = xe.Disconnected, this.handleDisconnect("peerconnection failed", o === "failed" ? wt.RR_SUBSCRIBER_FAILED : wt.RR_PUBLISHER_FAILED));
        const c = this.client.isDisconnected || this.client.currentState === Y.RECONNECTING, d = [te.FAILED, te.CLOSING, te.CLOSED].includes(s);
        c && d && !this._isClosed && this.emit(M.Offline);
      }), this.pcManager.onTrack = (s) => {
        this.emit(M.MediaTrackAdded, s.track, s.streams[0], s.receiver);
      }, El((n = e.serverInfo) === null || n === void 0 ? void 0 : n.protocol) || this.createDataChannels();
    });
  }
  setupSignalClientCallbacks() {
    this.client.onAnswer = (e, t) => m(this, void 0, void 0, function* () {
      this.pcManager && (this.log.debug("received server answer", Object.assign(Object.assign({}, this.logContext), {
        RTCSdpType: e.type
      })), yield this.pcManager.setPublisherAnswer(e, t));
    }), this.client.onTrickle = (e, t) => {
      this.pcManager && (this.log.debug("got ICE candidate from peer", Object.assign(Object.assign({}, this.logContext), {
        candidate: e,
        target: t
      })), this.pcManager.addIceCandidate(e, t));
    }, this.client.onOffer = (e, t) => m(this, void 0, void 0, function* () {
      if (this.latestRemoteOfferId = t, !this.pcManager)
        return;
      const n = yield this.pcManager.createSubscriberAnswerFromOffer(e, t);
      n && this.client.sendAnswer(n, t);
    }), this.client.onLocalTrackPublished = (e) => {
      var t;
      if (this.log.debug("received trackPublishedResponse", Object.assign(Object.assign({}, this.logContext), {
        cid: e.cid,
        track: (t = e.track) === null || t === void 0 ? void 0 : t.sid
      })), !this.pendingTrackResolvers[e.cid]) {
        this.log.error("missing track resolver for ".concat(e.cid), Object.assign(Object.assign({}, this.logContext), {
          cid: e.cid
        }));
        return;
      }
      const {
        resolve: n
      } = this.pendingTrackResolvers[e.cid];
      delete this.pendingTrackResolvers[e.cid], n(e.track);
    }, this.client.onLocalTrackUnpublished = (e) => {
      this.emit(M.LocalTrackUnpublished, e);
    }, this.client.onLocalTrackSubscribed = (e) => {
      this.emit(M.LocalTrackSubscribed, e);
    }, this.client.onTokenRefresh = (e) => {
      this.token = e;
    }, this.client.onRemoteMuteChanged = (e, t) => {
      this.emit(M.RemoteMute, e, t);
    }, this.client.onSubscribedQualityUpdate = (e) => {
      this.emit(M.SubscribedQualityUpdate, e);
    }, this.client.onRoomMoved = (e) => {
      var t;
      this.participantSid = (t = e.participant) === null || t === void 0 ? void 0 : t.sid, this.latestJoinResponse && (this.latestJoinResponse.room = e.room), this.emit(M.RoomMoved, e);
    }, this.client.onClose = () => {
      this.handleDisconnect("signal", wt.RR_SIGNAL_DISCONNECTED);
    }, this.client.onLeave = (e) => {
      switch (this.log.debug("client leave request", Object.assign(Object.assign({}, this.logContext), {
        reason: e == null ? void 0 : e.reason
      })), e.regions && this.regionUrlProvider && (this.log.debug("updating regions", this.logContext), this.regionUrlProvider.setServerReportedRegions(e.regions)), e.action) {
        case Dt.DISCONNECT:
          this.emit(M.Disconnected, e == null ? void 0 : e.reason), this.close();
          break;
        case Dt.RECONNECT:
          this.fullReconnectOnNext = !0, this.handleDisconnect(gn);
          break;
        case Dt.RESUME:
          this.handleDisconnect(gn);
      }
    };
  }
  makeRTCConfiguration(e) {
    var t;
    const n = Object.assign({}, this.rtcConfig);
    if (!((t = this.signalOpts) === null || t === void 0) && t.e2eeEnabled && (this.log.debug("E2EE - setting up transports with insertable streams", this.logContext), n.encodedInsertableStreams = !0), e.iceServers && !n.iceServers) {
      const r = [];
      e.iceServers.forEach((s) => {
        const a = {
          urls: s.urls
        };
        s.username && (a.username = s.username), s.credential && (a.credential = s.credential), r.push(a);
      }), n.iceServers = r;
    }
    return e.clientConfiguration && e.clientConfiguration.forceRelay === ai.ENABLED && (n.iceTransportPolicy = "relay"), n.sdpSemantics = "unified-plan", n.continualGatheringPolicy = "gather_continually", n;
  }
  createDataChannels() {
    this.pcManager && (this.lossyDC && (this.lossyDC.onmessage = null, this.lossyDC.onerror = null), this.reliableDC && (this.reliableDC.onmessage = null, this.reliableDC.onerror = null), this.lossyDC = this.pcManager.createPublisherDataChannel(Us, {
      ordered: !1,
      maxRetransmits: 0
    }), this.reliableDC = this.pcManager.createPublisherDataChannel(Fs, {
      ordered: !0
    }), this.lossyDC.onmessage = this.handleDataMessage, this.reliableDC.onmessage = this.handleDataMessage, this.lossyDC.onerror = this.handleDataError, this.reliableDC.onerror = this.handleDataError, this.lossyDC.bufferedAmountLowThreshold = 65535, this.reliableDC.bufferedAmountLowThreshold = 65535, this.lossyDC.onbufferedamountlow = this.handleBufferedAmountLow, this.reliableDC.onbufferedamountlow = this.handleBufferedAmountLow);
  }
  createSender(e, t, n) {
    return m(this, void 0, void 0, function* () {
      if (Bn())
        return yield this.createTransceiverRTCRtpSender(e, t, n);
      if (Vn())
        return this.log.warn("using add-track fallback", this.logContext), yield this.createRTCRtpSender(e.mediaStreamTrack);
      throw new ce("Required webRTC APIs not supported on this device");
    });
  }
  createSimulcastSender(e, t, n, r) {
    return m(this, void 0, void 0, function* () {
      if (Bn())
        return this.createSimulcastTransceiverSender(e, t, n, r);
      if (Vn())
        return this.log.debug("using add-track fallback", this.logContext), this.createRTCRtpSender(e.mediaStreamTrack);
      throw new ce("Cannot stream on this device");
    });
  }
  createTransceiverRTCRtpSender(e, t, n) {
    return m(this, void 0, void 0, function* () {
      if (!this.pcManager)
        throw new ce("publisher is closed");
      const r = [];
      e.mediaStream && r.push(e.mediaStream), Et(e) && (e.codec = t.videoCodec);
      const s = {
        direction: "sendonly",
        streams: r
      };
      return n && (s.sendEncodings = n), (yield this.pcManager.addPublisherTransceiver(e.mediaStreamTrack, s)).sender;
    });
  }
  createSimulcastTransceiverSender(e, t, n, r) {
    return m(this, void 0, void 0, function* () {
      if (!this.pcManager)
        throw new ce("publisher is closed");
      const s = {
        direction: "sendonly"
      };
      r && (s.sendEncodings = r);
      const a = yield this.pcManager.addPublisherTransceiver(t.mediaStreamTrack, s);
      if (n.videoCodec)
        return e.setSimulcastTrackSender(n.videoCodec, a.sender), a.sender;
    });
  }
  createRTCRtpSender(e) {
    return m(this, void 0, void 0, function* () {
      if (!this.pcManager)
        throw new ce("publisher is closed");
      return this.pcManager.addPublisherTrack(e);
    });
  }
  attemptReconnect(e) {
    return m(this, void 0, void 0, function* () {
      var t, n, r;
      if (!this._isClosed) {
        if (this.attemptingReconnect) {
          G.warn("already attempting reconnect, returning early", this.logContext);
          return;
        }
        (((t = this.clientConfiguration) === null || t === void 0 ? void 0 : t.resumeConnection) === ai.DISABLED || // signaling state could change to closed due to hardware sleep
        // those connections cannot be resumed
        ((r = (n = this.pcManager) === null || n === void 0 ? void 0 : n.currentState) !== null && r !== void 0 ? r : te.NEW) === te.NEW) && (this.fullReconnectOnNext = !0);
        try {
          this.attemptingReconnect = !0, this.fullReconnectOnNext ? yield this.restartConnection() : yield this.resumeConnection(e), this.clearPendingReconnect(), this.fullReconnectOnNext = !1;
        } catch (s) {
          this.reconnectAttempts += 1;
          let a = !0;
          s instanceof ce ? (this.log.debug("received unrecoverable error", Object.assign(Object.assign({}, this.logContext), {
            error: s
          })), a = !1) : s instanceof _t || (this.fullReconnectOnNext = !0), a ? this.handleDisconnect("reconnect", wt.RR_UNKNOWN) : (this.log.info("could not recover connection after ".concat(this.reconnectAttempts, " attempts, ").concat(Date.now() - this.reconnectStart, "ms. giving up"), this.logContext), this.emit(M.Disconnected), yield this.close());
        } finally {
          this.attemptingReconnect = !1;
        }
      }
    });
  }
  getNextRetryDelay(e) {
    try {
      return this.reconnectPolicy.nextRetryDelayInMs(e);
    } catch (t) {
      this.log.warn("encountered error in reconnect policy", Object.assign(Object.assign({}, this.logContext), {
        error: t
      }));
    }
    return null;
  }
  restartConnection(e) {
    return m(this, void 0, void 0, function* () {
      var t, n, r;
      try {
        if (!this.url || !this.token)
          throw new ce("could not reconnect, url or token not saved");
        this.log.info("reconnecting, attempt: ".concat(this.reconnectAttempts), this.logContext), this.emit(M.Restarting), this.client.isDisconnected || (yield this.client.sendLeave()), yield this.cleanupPeerConnections(), yield this.cleanupClient();
        let s;
        try {
          if (!this.signalOpts)
            throw this.log.warn("attempted connection restart, without signal options present", this.logContext), new _t();
          s = yield this.join(e != null ? e : this.url, this.token, this.signalOpts);
        } catch (a) {
          throw a instanceof Q && a.reason === K.NotAllowed ? new ce("could not reconnect, token might be expired") : new _t();
        }
        if (this.shouldFailNext)
          throw this.shouldFailNext = !1, new Error("simulated failure");
        if (this.client.setReconnected(), this.emit(M.SignalRestarted, s), yield this.waitForPCReconnected(), this.client.currentState !== Y.CONNECTED)
          throw new _t("Signal connection got severed during reconnect");
        (t = this.regionUrlProvider) === null || t === void 0 || t.resetAttempts(), this.emit(M.Restarted);
      } catch (s) {
        const a = yield (n = this.regionUrlProvider) === null || n === void 0 ? void 0 : n.getNextBestRegionUrl();
        if (a) {
          yield this.restartConnection(a);
          return;
        } else
          throw (r = this.regionUrlProvider) === null || r === void 0 || r.resetAttempts(), s;
      }
    });
  }
  resumeConnection(e) {
    return m(this, void 0, void 0, function* () {
      var t;
      if (!this.url || !this.token)
        throw new ce("could not reconnect, url or token not saved");
      if (!this.pcManager)
        throw new ce("publisher and subscriber connections unset");
      this.log.info("resuming signal connection, attempt ".concat(this.reconnectAttempts), this.logContext), this.emit(M.Resuming);
      let n;
      try {
        this.setupSignalClientCallbacks(), n = yield this.client.reconnect(this.url, this.token, this.participantSid, e);
      } catch (r) {
        let s = "";
        throw r instanceof Error && (s = r.message, this.log.error(r.message, Object.assign(Object.assign({}, this.logContext), {
          error: r
        }))), r instanceof Q && r.reason === K.NotAllowed ? new ce("could not reconnect, token might be expired") : r instanceof Q && r.reason === K.LeaveRequest ? r : new _t(s);
      }
      if (this.emit(M.SignalResumed), n) {
        const r = this.makeRTCConfiguration(n);
        this.pcManager.updateConfiguration(r), this.latestJoinResponse && (this.latestJoinResponse.serverInfo = n.serverInfo);
      } else
        this.log.warn("Did not receive reconnect response", this.logContext);
      if (this.shouldFailNext)
        throw this.shouldFailNext = !1, new Error("simulated failure");
      if (yield this.pcManager.triggerIceRestart(), yield this.waitForPCReconnected(), this.client.currentState !== Y.CONNECTED)
        throw new _t("Signal connection got severed during reconnect");
      this.client.setReconnected(), ((t = this.reliableDC) === null || t === void 0 ? void 0 : t.readyState) === "open" && this.reliableDC.id === null && this.createDataChannels(), n != null && n.lastMessageSeq && this.resendReliableMessagesForResume(n.lastMessageSeq), this.emit(M.Resumed);
    });
  }
  waitForPCInitialConnection(e, t) {
    return m(this, void 0, void 0, function* () {
      if (!this.pcManager)
        throw new ce("PC manager is closed");
      yield this.pcManager.ensurePCTransportConnection(t, e);
    });
  }
  waitForPCReconnected() {
    return m(this, void 0, void 0, function* () {
      this.pcState = xe.Reconnecting, this.log.debug("waiting for peer connection to reconnect", this.logContext);
      try {
        if (yield Ce(Sl), !this.pcManager)
          throw new ce("PC manager is closed");
        yield this.pcManager.ensurePCTransportConnection(void 0, this.peerConnectionTimeout), this.pcState = xe.Connected;
      } catch (e) {
        throw this.pcState = xe.Disconnected, new Q("could not establish PC connection, ".concat(e.message), K.InternalError);
      }
    });
  }
  /** @internal */
  publishRpcResponse(e, t, n, r) {
    return m(this, void 0, void 0, function* () {
      const s = new ke({
        destinationIdentities: [e],
        kind: q.RELIABLE,
        value: {
          case: "rpcResponse",
          value: new ya({
            requestId: t,
            value: r ? {
              case: "error",
              value: r.toProto()
            } : {
              case: "payload",
              value: n != null ? n : ""
            }
          })
        }
      });
      yield this.sendDataPacket(s, q.RELIABLE);
    });
  }
  /** @internal */
  publishRpcAck(e, t) {
    return m(this, void 0, void 0, function* () {
      const n = new ke({
        destinationIdentities: [e],
        kind: q.RELIABLE,
        value: {
          case: "rpcAck",
          value: new ba({
            requestId: t
          })
        }
      });
      yield this.sendDataPacket(n, q.RELIABLE);
    });
  }
  /* @internal */
  sendDataPacket(e, t) {
    return m(this, void 0, void 0, function* () {
      yield this.ensurePublisherConnected(t), t === q.RELIABLE && (e.sequence = this.reliableDataSequence, this.reliableDataSequence += 1);
      const n = e.toBinary(), r = this.dataChannelForKind(t);
      if (r) {
        if (t === q.RELIABLE && this.reliableMessageBuffer.push({
          data: n,
          sequence: e.sequence
        }), this.attemptingReconnect)
          return;
        r.send(n);
      }
      this.updateAndEmitDCBufferStatus(t);
    });
  }
  resendReliableMessagesForResume(e) {
    return m(this, void 0, void 0, function* () {
      yield this.ensurePublisherConnected(q.RELIABLE);
      const t = this.dataChannelForKind(q.RELIABLE);
      t && (this.reliableMessageBuffer.popToSequence(e), this.reliableMessageBuffer.getAll().forEach((n) => {
        t.send(n.data);
      })), this.updateAndEmitDCBufferStatus(q.RELIABLE);
    });
  }
  waitForBufferStatusLow(e) {
    return new Promise((t, n) => m(this, void 0, void 0, function* () {
      if (this.isBufferStatusLow(e))
        t();
      else {
        const r = () => n("Engine closed");
        for (this.once(M.Closing, r); !this.dcBufferStatus.get(e); )
          yield Ce(10);
        this.off(M.Closing, r), t();
      }
    }));
  }
  /**
   * @internal
   */
  ensureDataTransportConnected(e) {
    return m(this, arguments, void 0, function(t) {
      var n = this;
      let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.subscriberPrimary;
      return function* () {
        var s;
        if (!n.pcManager)
          throw new ce("PC manager is closed");
        const a = r ? n.pcManager.subscriber : n.pcManager.publisher, o = r ? "Subscriber" : "Publisher";
        if (!a)
          throw new Q("".concat(o, " connection not set"), K.InternalError);
        let c = !1;
        !r && !n.dataChannelForKind(t, r) && (n.createDataChannels(), c = !0), !c && !r && !n.pcManager.publisher.isICEConnected && n.pcManager.publisher.getICEConnectionState() !== "checking" && (c = !0), c && n.negotiate();
        const d = n.dataChannelForKind(t, r);
        if ((d == null ? void 0 : d.readyState) === "open")
          return;
        const u = (/* @__PURE__ */ new Date()).getTime() + n.peerConnectionTimeout;
        for (; (/* @__PURE__ */ new Date()).getTime() < u; ) {
          if (a.isICEConnected && ((s = n.dataChannelForKind(t, r)) === null || s === void 0 ? void 0 : s.readyState) === "open")
            return;
          yield Ce(50);
        }
        throw new Q("could not establish ".concat(o, " connection, state: ").concat(a.getICEConnectionState()), K.InternalError);
      }();
    });
  }
  ensurePublisherConnected(e) {
    return m(this, void 0, void 0, function* () {
      this.publisherConnectionPromise || (this.publisherConnectionPromise = this.ensureDataTransportConnected(e, !1)), yield this.publisherConnectionPromise;
    });
  }
  /* @internal */
  verifyTransport() {
    return !(!this.pcManager || this.pcManager.currentState !== te.CONNECTED || !this.client.ws || this.client.ws.readyState === WebSocket.CLOSED);
  }
  /** @internal */
  negotiate() {
    return m(this, void 0, void 0, function* () {
      return new Promise((e, t) => m(this, void 0, void 0, function* () {
        if (!this.pcManager) {
          t(new Un("PC manager is closed"));
          return;
        }
        this.pcManager.requirePublisher(), this.pcManager.publisher.getTransceivers().length == 0 && !this.lossyDC && !this.reliableDC && this.createDataChannels();
        const n = new AbortController(), r = () => {
          n.abort(), this.log.debug("engine disconnected while negotiation was ongoing", this.logContext), e();
        };
        this.isClosed && t("cannot negotiate on closed engine"), this.on(M.Closing, r), this.pcManager.publisher.once(Ut.RTPVideoPayloadTypes, (s) => {
          const a = /* @__PURE__ */ new Map();
          s.forEach((o) => {
            const c = o.codec.toLowerCase();
            Ru(c) && a.set(o.payload, c);
          }), this.emit(M.RTPVideoMapUpdate, a);
        });
        try {
          yield this.pcManager.negotiate(n), e();
        } catch (s) {
          s instanceof Un && (this.fullReconnectOnNext = !0), this.handleDisconnect("negotiation", wt.RR_UNKNOWN), t(s);
        } finally {
          this.off(M.Closing, r);
        }
      }));
    });
  }
  dataChannelForKind(e, t) {
    if (t) {
      if (e === q.LOSSY)
        return this.lossyDCSub;
      if (e === q.RELIABLE)
        return this.reliableDCSub;
    } else {
      if (e === q.LOSSY)
        return this.lossyDC;
      if (e === q.RELIABLE)
        return this.reliableDC;
    }
  }
  /** @internal */
  sendSyncState(e, t) {
    var n, r;
    if (!this.pcManager) {
      this.log.warn("sync state cannot be sent without peer connection setup", this.logContext);
      return;
    }
    const s = this.pcManager.subscriber.getLocalDescription(), a = this.pcManager.subscriber.getRemoteDescription(), o = (r = (n = this.signalOpts) === null || n === void 0 ? void 0 : n.autoSubscribe) !== null && r !== void 0 ? r : !0, c = new Array(), d = new Array();
    e.forEach((u) => {
      u.isDesired !== o && c.push(u.trackSid), u.isEnabled || d.push(u.trackSid);
    }), this.client.sendSyncState(new Na({
      answer: s ? Ni({
        sdp: s.sdp,
        type: s.type
      }) : void 0,
      offer: a ? Ni({
        sdp: a.sdp,
        type: a.type
      }) : void 0,
      subscription: new Gi({
        trackSids: c,
        subscribe: !o,
        participantTracks: []
      }),
      publishTracks: Lu(t),
      dataChannels: this.dataChannelsInfo(),
      trackSidsDisabled: d,
      datachannelReceiveStates: this.reliableReceivedState.map((u, l) => new Ua({
        publisherSid: l,
        lastSeq: u
      }))
    }));
  }
  /* @internal */
  failNext() {
    this.shouldFailNext = !0;
  }
  dataChannelsInfo() {
    const e = [], t = (n, r) => {
      (n == null ? void 0 : n.id) !== void 0 && n.id !== null && e.push(new Fa({
        label: n.label,
        id: n.id,
        target: r
      }));
    };
    return t(this.dataChannelForKind(q.LOSSY), Ae.PUBLISHER), t(this.dataChannelForKind(q.RELIABLE), Ae.PUBLISHER), t(this.dataChannelForKind(q.LOSSY, !0), Ae.SUBSCRIBER), t(this.dataChannelForKind(q.RELIABLE, !0), Ae.SUBSCRIBER), e;
  }
  clearReconnectTimeout() {
    this.reconnectTimeout && pe.clearTimeout(this.reconnectTimeout);
  }
  clearPendingReconnect() {
    this.clearReconnectTimeout(), this.reconnectAttempts = 0;
  }
  registerOnLineListener() {
    Se() && window.addEventListener("online", this.handleBrowserOnLine);
  }
  deregisterOnLineListener() {
    Se() && window.removeEventListener("online", this.handleBrowserOnLine);
  }
}
class _t extends Error {
}
function El(i) {
  return i !== void 0 && i > 13;
}
function Rl(i, e) {
  const t = i.participantIdentity ? i.participantIdentity : e.participantIdentity;
  i.participantIdentity = t, e.participantIdentity = t;
  const n = i.destinationIdentities.length !== 0 ? i.destinationIdentities : e.destinationIdentities;
  i.destinationIdentities = n, e.destinationIdentities = n;
}
class $n {
  constructor(e, t) {
    this.lastUpdateAt = 0, this.settingsCacheTime = 3e3, this.attemptedRegions = [], this.serverUrl = new URL(e), this.token = t;
  }
  updateToken(e) {
    this.token = e;
  }
  isCloud() {
    return Gn(this.serverUrl);
  }
  getServerUrl() {
    return this.serverUrl;
  }
  getNextBestRegionUrl(e) {
    return m(this, void 0, void 0, function* () {
      if (!this.isCloud())
        throw Error("region availability is only supported for LiveKit Cloud domains");
      (!this.regionSettings || Date.now() - this.lastUpdateAt > this.settingsCacheTime) && (this.regionSettings = yield this.fetchRegionSettings(e));
      const t = this.regionSettings.regions.filter((n) => !this.attemptedRegions.find((r) => r.url === n.url));
      if (t.length > 0) {
        const n = t[0];
        return this.attemptedRegions.push(n), G.debug("next region: ".concat(n.region)), n.url;
      } else
        return null;
    });
  }
  resetAttempts() {
    this.attemptedRegions = [];
  }
  /* @internal */
  fetchRegionSettings(e) {
    return m(this, void 0, void 0, function* () {
      const t = yield fetch("".concat(wl(this.serverUrl), "/regions"), {
        headers: {
          authorization: "Bearer ".concat(this.token)
        },
        signal: e
      });
      if (t.ok) {
        const n = yield t.json();
        return this.lastUpdateAt = Date.now(), n;
      } else
        throw new Q("Could not fetch region settings: ".concat(t.statusText), t.status === 401 ? K.NotAllowed : K.InternalError, t.status);
    });
  }
  setServerReportedRegions(e) {
    this.regionSettings = e, this.lastUpdateAt = Date.now();
  }
}
function wl(i) {
  return "".concat(i.protocol.replace("ws", "http"), "//").concat(i.host, "/settings");
}
class Mo {
  get info() {
    return this._info;
  }
  constructor(e, t, n) {
    this.reader = t, this.totalByteSize = n, this._info = e, this.bytesReceived = 0;
  }
}
class _l extends Mo {
  handleChunkReceived(e) {
    var t;
    this.bytesReceived += e.content.byteLength;
    const n = this.totalByteSize ? this.bytesReceived / this.totalByteSize : void 0;
    (t = this.onProgress) === null || t === void 0 || t.call(this, n);
  }
  [Symbol.asyncIterator]() {
    const e = this.reader.getReader();
    return {
      next: () => m(this, void 0, void 0, function* () {
        try {
          const {
            done: t,
            value: n
          } = yield e.read();
          return t ? {
            done: !0,
            value: void 0
          } : (this.handleChunkReceived(n), {
            done: !1,
            value: n.content
          });
        } catch (t) {
          return {
            done: !0,
            value: void 0
          };
        }
      }),
      return() {
        return m(this, void 0, void 0, function* () {
          return e.releaseLock(), {
            done: !0,
            value: void 0
          };
        });
      }
    };
  }
  readAll() {
    return m(this, void 0, void 0, function* () {
      var e, t, n, r;
      let s = /* @__PURE__ */ new Set();
      try {
        for (var a = !0, o = et(this), c; c = yield o.next(), e = c.done, !e; a = !0) {
          r = c.value, a = !1;
          const d = r;
          s.add(d);
        }
      } catch (d) {
        t = {
          error: d
        };
      } finally {
        try {
          !a && !e && (n = o.return) && (yield n.call(o));
        } finally {
          if (t) throw t.error;
        }
      }
      return Array.from(s);
    });
  }
}
class Il extends Mo {
  /**
   * A TextStreamReader instance can be used as an AsyncIterator that returns the entire string
   * that has been received up to the current point in time.
   */
  constructor(e, t, n) {
    super(e, t, n), this.receivedChunks = /* @__PURE__ */ new Map();
  }
  handleChunkReceived(e) {
    var t;
    const n = _i(e.chunkIndex), r = this.receivedChunks.get(n);
    if (r && r.version > e.version)
      return;
    this.receivedChunks.set(n, e), this.bytesReceived += e.content.byteLength;
    const s = this.totalByteSize ? this.bytesReceived / this.totalByteSize : void 0;
    (t = this.onProgress) === null || t === void 0 || t.call(this, s);
  }
  /**
   * Async iterator implementation to allow usage of `for await...of` syntax.
   * Yields structured chunks from the stream.
   *
   */
  [Symbol.asyncIterator]() {
    const e = this.reader.getReader(), t = new TextDecoder();
    return {
      next: () => m(this, void 0, void 0, function* () {
        try {
          const {
            done: n,
            value: r
          } = yield e.read();
          return n ? {
            done: !0,
            value: void 0
          } : (this.handleChunkReceived(r), {
            done: !1,
            value: t.decode(r.content)
          });
        } catch (n) {
          return {
            done: !0,
            value: void 0
          };
        }
      }),
      return() {
        return m(this, void 0, void 0, function* () {
          return e.releaseLock(), {
            done: !0,
            value: void 0
          };
        });
      }
    };
  }
  readAll() {
    return m(this, void 0, void 0, function* () {
      var e, t, n, r;
      let s = "";
      try {
        for (var a = !0, o = et(this), c; c = yield o.next(), e = c.done, !e; a = !0)
          r = c.value, a = !1, s += r;
      } catch (d) {
        t = {
          error: d
        };
      } finally {
        try {
          !a && !e && (n = o.return) && (yield n.call(o));
        } finally {
          if (t) throw t.error;
        }
      }
      return s;
    });
  }
}
class Do {
  constructor(e, t, n) {
    this.writableStream = e, this.defaultWriter = e.getWriter(), this.onClose = n, this.info = t;
  }
  write(e) {
    return this.defaultWriter.write(e);
  }
  close() {
    return m(this, void 0, void 0, function* () {
      var e;
      yield this.defaultWriter.close(), this.defaultWriter.releaseLock(), (e = this.onClose) === null || e === void 0 || e.call(this);
    });
  }
}
class Ol extends Do {
}
class xl extends Do {
}
class Ao extends E {
  constructor(e, t, n, r, s) {
    super(e, n, s), this.sid = t, this.receiver = r;
  }
  get isLocal() {
    return !1;
  }
  /** @internal */
  setMuted(e) {
    this.isMuted !== e && (this.isMuted = e, this._mediaStreamTrack.enabled = !e, this.emit(e ? I.Muted : I.Unmuted, this));
  }
  /** @internal */
  setMediaStream(e) {
    this.mediaStream = e;
    const t = (n) => {
      n.track === this._mediaStreamTrack && (e.removeEventListener("removetrack", t), this.receiver && "playoutDelayHint" in this.receiver && (this.receiver.playoutDelayHint = void 0), this.receiver = void 0, this._currentBitrate = 0, this.emit(I.Ended, this));
    };
    e.addEventListener("removetrack", t);
  }
  start() {
    this.startMonitor(), super.enable();
  }
  stop() {
    this.stopMonitor(), super.disable();
  }
  /**
   * Gets the RTCStatsReport for the RemoteTrack's underlying RTCRtpReceiver
   * See https://developer.mozilla.org/en-US/docs/Web/API/RTCStatsReport
   *
   * @returns Promise<RTCStatsReport> | undefined
   */
  getRTCStatsReport() {
    return m(this, void 0, void 0, function* () {
      var e;
      return !((e = this.receiver) === null || e === void 0) && e.getStats ? yield this.receiver.getStats() : void 0;
    });
  }
  /**
   * Allows to set a playout delay (in seconds) for this track.
   * A higher value allows for more buffering of the track in the browser
   * and will result in a delay of media being played back of `delayInSeconds`
   */
  setPlayoutDelay(e) {
    this.receiver ? "playoutDelayHint" in this.receiver ? this.receiver.playoutDelayHint = e : this.log.warn("Playout delay not supported in this browser") : this.log.warn("Cannot set playout delay, track already ended");
  }
  /**
   * Returns the current playout delay (in seconds) of this track.
   */
  getPlayoutDelay() {
    if (this.receiver) {
      if ("playoutDelayHint" in this.receiver)
        return this.receiver.playoutDelayHint;
      this.log.warn("Playout delay not supported in this browser");
    } else
      this.log.warn("Cannot get playout delay, track already ended");
    return 0;
  }
  /* @internal */
  startMonitor() {
    this.monitorInterval || (this.monitorInterval = setInterval(() => this.monitorReceiver(), kr)), Nu() && this.registerTimeSyncUpdate();
  }
  registerTimeSyncUpdate() {
    const e = () => {
      var t;
      this.timeSyncHandle = requestAnimationFrame(() => e());
      const n = (t = this.receiver) === null || t === void 0 ? void 0 : t.getSynchronizationSources()[0];
      if (n) {
        const {
          timestamp: r,
          rtpTimestamp: s
        } = n;
        s && this.rtpTimestamp !== s && (this.emit(I.TimeSyncUpdate, {
          timestamp: r,
          rtpTimestamp: s
        }), this.rtpTimestamp = s);
      }
    };
    e();
  }
}
class Ml extends Ao {
  constructor(e, t, n, r, s, a) {
    super(e, t, E.Kind.Audio, n, a), this.monitorReceiver = () => m(this, void 0, void 0, function* () {
      if (!this.receiver) {
        this._currentBitrate = 0;
        return;
      }
      const o = yield this.getReceiverStats();
      o && this.prevStats && this.receiver && (this._currentBitrate = zi(o, this.prevStats)), this.prevStats = o;
    }), this.audioContext = r, this.webAudioPluginNodes = [], s && (this.sinkId = s.deviceId);
  }
  /**
   * sets the volume for all attached audio elements
   */
  setVolume(e) {
    var t;
    for (const n of this.attachedElements)
      this.audioContext ? (t = this.gainNode) === null || t === void 0 || t.gain.setTargetAtTime(e, 0, 0.1) : n.volume = e;
    Ge() && this._mediaStreamTrack._setVolume(e), this.elementVolume = e;
  }
  /**
   * gets the volume of attached audio elements (loudest)
   */
  getVolume() {
    if (this.elementVolume)
      return this.elementVolume;
    if (Ge())
      return 1;
    let e = 0;
    return this.attachedElements.forEach((t) => {
      t.volume > e && (e = t.volume);
    }), e;
  }
  /**
   * calls setSinkId on all attached elements, if supported
   * @param deviceId audio output device
   */
  setSinkId(e) {
    return m(this, void 0, void 0, function* () {
      this.sinkId = e, yield Promise.all(this.attachedElements.map((t) => {
        if (qn(t))
          return t.setSinkId(e);
      }));
    });
  }
  attach(e) {
    const t = this.attachedElements.length === 0;
    return e ? super.attach(e) : e = super.attach(), this.sinkId && qn(e) && e.setSinkId(this.sinkId).catch((n) => {
      this.log.error("Failed to set sink id on remote audio track", n, this.logContext);
    }), this.audioContext && t && (this.log.debug("using audio context mapping", this.logContext), this.connectWebAudio(this.audioContext, e), e.volume = 0, e.muted = !0), this.elementVolume && this.setVolume(this.elementVolume), e;
  }
  detach(e) {
    let t;
    return e ? (t = super.detach(e), this.audioContext && (this.attachedElements.length > 0 ? this.connectWebAudio(this.audioContext, this.attachedElements[0]) : this.disconnectWebAudio())) : (t = super.detach(), this.disconnectWebAudio()), t;
  }
  /**
   * @internal
   * @experimental
   */
  setAudioContext(e) {
    this.audioContext = e, e && this.attachedElements.length > 0 ? this.connectWebAudio(e, this.attachedElements[0]) : e || this.disconnectWebAudio();
  }
  /**
   * @internal
   * @experimental
   * @param {AudioNode[]} nodes - An array of WebAudio nodes. These nodes should not be connected to each other when passed, as the sdk will take care of connecting them in the order of the array.
   */
  setWebAudioPlugins(e) {
    this.webAudioPluginNodes = e, this.attachedElements.length > 0 && this.audioContext && this.connectWebAudio(this.audioContext, this.attachedElements[0]);
  }
  connectWebAudio(e, t) {
    this.disconnectWebAudio(), this.sourceNode = e.createMediaStreamSource(t.srcObject);
    let n = this.sourceNode;
    this.webAudioPluginNodes.forEach((r) => {
      n.connect(r), n = r;
    }), this.gainNode = e.createGain(), n.connect(this.gainNode), this.gainNode.connect(e.destination), this.elementVolume && this.gainNode.gain.setTargetAtTime(this.elementVolume, 0, 0.1), e.state !== "running" && e.resume().then(() => {
      e.state !== "running" && this.emit(I.AudioPlaybackFailed, new Error("Audio Context couldn't be started automatically"));
    }).catch((r) => {
      this.emit(I.AudioPlaybackFailed, r);
    });
  }
  disconnectWebAudio() {
    var e, t;
    (e = this.gainNode) === null || e === void 0 || e.disconnect(), (t = this.sourceNode) === null || t === void 0 || t.disconnect(), this.gainNode = void 0, this.sourceNode = void 0;
  }
  getReceiverStats() {
    return m(this, void 0, void 0, function* () {
      if (!this.receiver || !this.receiver.getStats)
        return;
      const e = yield this.receiver.getStats();
      let t;
      return e.forEach((n) => {
        n.type === "inbound-rtp" && (t = {
          type: "audio",
          streamId: n.id,
          timestamp: n.timestamp,
          jitter: n.jitter,
          bytesReceived: n.bytesReceived,
          concealedSamples: n.concealedSamples,
          concealmentEvents: n.concealmentEvents,
          silentConcealedSamples: n.silentConcealedSamples,
          silentConcealmentEvents: n.silentConcealmentEvents,
          totalAudioEnergy: n.totalAudioEnergy,
          totalSamplesDuration: n.totalSamplesDuration
        });
      }), t;
    });
  }
}
const vn = 100;
class Dl extends Ao {
  constructor(e, t, n, r, s) {
    super(e, t, E.Kind.Video, n, s), this.elementInfos = [], this.monitorReceiver = () => m(this, void 0, void 0, function* () {
      if (!this.receiver) {
        this._currentBitrate = 0;
        return;
      }
      const a = yield this.getReceiverStats();
      a && this.prevStats && this.receiver && (this._currentBitrate = zi(a, this.prevStats)), this.prevStats = a;
    }), this.debouncedHandleResize = vr(() => {
      this.updateDimensions();
    }, vn), this.adaptiveStreamSettings = r;
  }
  get isAdaptiveStream() {
    return this.adaptiveStreamSettings !== void 0;
  }
  /**
   * Note: When using adaptiveStream, you need to use remoteVideoTrack.attach() to add the track to a HTMLVideoElement, otherwise your video tracks might never start
   */
  get mediaStreamTrack() {
    return this._mediaStreamTrack;
  }
  /** @internal */
  setMuted(e) {
    super.setMuted(e), this.attachedElements.forEach((t) => {
      e ? Lt(this._mediaStreamTrack, t) : Ot(this._mediaStreamTrack, t);
    });
  }
  attach(e) {
    if (e ? super.attach(e) : e = super.attach(), this.adaptiveStreamSettings && this.elementInfos.find((t) => t.element === e) === void 0) {
      const t = new Al(e);
      this.observeElementInfo(t);
    }
    return e;
  }
  /**
   * Observe an ElementInfo for changes when adaptive streaming.
   * @param elementInfo
   * @internal
   */
  observeElementInfo(e) {
    this.adaptiveStreamSettings && this.elementInfos.find((t) => t === e) === void 0 ? (e.handleResize = () => {
      this.debouncedHandleResize();
    }, e.handleVisibilityChanged = () => {
      this.updateVisibility();
    }, this.elementInfos.push(e), e.observe(), this.debouncedHandleResize(), this.updateVisibility()) : this.log.warn("visibility resize observer not triggered", this.logContext);
  }
  /**
   * Stop observing an ElementInfo for changes.
   * @param elementInfo
   * @internal
   */
  stopObservingElementInfo(e) {
    if (!this.isAdaptiveStream) {
      this.log.warn("stopObservingElementInfo ignored", this.logContext);
      return;
    }
    const t = this.elementInfos.filter((n) => n === e);
    for (const n of t)
      n.stopObserving();
    this.elementInfos = this.elementInfos.filter((n) => n !== e), this.updateVisibility(), this.debouncedHandleResize();
  }
  detach(e) {
    let t = [];
    if (e)
      return this.stopObservingElement(e), super.detach(e);
    t = super.detach();
    for (const n of t)
      this.stopObservingElement(n);
    return t;
  }
  /** @internal */
  getDecoderImplementation() {
    var e;
    return (e = this.prevStats) === null || e === void 0 ? void 0 : e.decoderImplementation;
  }
  getReceiverStats() {
    return m(this, void 0, void 0, function* () {
      if (!this.receiver || !this.receiver.getStats)
        return;
      const e = yield this.receiver.getStats();
      let t, n = "", r = /* @__PURE__ */ new Map();
      return e.forEach((s) => {
        s.type === "inbound-rtp" ? (n = s.codecId, t = {
          type: "video",
          streamId: s.id,
          framesDecoded: s.framesDecoded,
          framesDropped: s.framesDropped,
          framesReceived: s.framesReceived,
          packetsReceived: s.packetsReceived,
          packetsLost: s.packetsLost,
          frameWidth: s.frameWidth,
          frameHeight: s.frameHeight,
          pliCount: s.pliCount,
          firCount: s.firCount,
          nackCount: s.nackCount,
          jitter: s.jitter,
          timestamp: s.timestamp,
          bytesReceived: s.bytesReceived,
          decoderImplementation: s.decoderImplementation
        }) : s.type === "codec" && r.set(s.id, s);
      }), t && n !== "" && r.get(n) && (t.mimeType = r.get(n).mimeType), t;
    });
  }
  stopObservingElement(e) {
    const t = this.elementInfos.filter((n) => n.element === e);
    for (const n of t)
      this.stopObservingElementInfo(n);
  }
  handleAppVisibilityChanged() {
    const e = Object.create(null, {
      handleAppVisibilityChanged: {
        get: () => super.handleAppVisibilityChanged
      }
    });
    return m(this, void 0, void 0, function* () {
      yield e.handleAppVisibilityChanged.call(this), this.isAdaptiveStream && this.updateVisibility();
    });
  }
  updateVisibility() {
    var e, t;
    const n = this.elementInfos.reduce((o, c) => Math.max(o, c.visibilityChangedAt || 0), 0), r = !((t = (e = this.adaptiveStreamSettings) === null || e === void 0 ? void 0 : e.pauseVideoInBackground) !== null && t !== void 0) || t ? this.isInBackground : !1, s = this.elementInfos.some((o) => o.pictureInPicture), a = this.elementInfos.some((o) => o.visible) && !r || s;
    if (this.lastVisible !== a) {
      if (!a && Date.now() - n < vn) {
        pe.setTimeout(() => {
          this.updateVisibility();
        }, vn);
        return;
      }
      this.lastVisible = a, this.emit(I.VisibilityChanged, a, this);
    }
  }
  updateDimensions() {
    var e, t;
    let n = 0, r = 0;
    const s = this.getPixelDensity();
    for (const a of this.elementInfos) {
      const o = a.width() * s, c = a.height() * s;
      o + c > n + r && (n = o, r = c);
    }
    ((e = this.lastDimensions) === null || e === void 0 ? void 0 : e.width) === n && ((t = this.lastDimensions) === null || t === void 0 ? void 0 : t.height) === r || (this.lastDimensions = {
      width: n,
      height: r
    }, this.emit(I.VideoDimensionsChanged, this.lastDimensions, this));
  }
  getPixelDensity() {
    var e;
    const t = (e = this.adaptiveStreamSettings) === null || e === void 0 ? void 0 : e.pixelDensity;
    return t === "screen" ? vs() : t || (vs() > 2 ? 2 : 1);
  }
}
class Al {
  get visible() {
    return this.isPiP || this.isIntersecting;
  }
  get pictureInPicture() {
    return this.isPiP;
  }
  constructor(e, t) {
    this.onVisibilityChanged = (n) => {
      var r;
      const {
        target: s,
        isIntersecting: a
      } = n;
      s === this.element && (this.isIntersecting = a, this.isPiP = ei(this.element), this.visibilityChangedAt = Date.now(), (r = this.handleVisibilityChanged) === null || r === void 0 || r.call(this));
    }, this.onEnterPiP = () => {
      var n, r, s;
      (r = (n = window.documentPictureInPicture) === null || n === void 0 ? void 0 : n.window) === null || r === void 0 || r.addEventListener("pagehide", this.onLeavePiP), this.isPiP = ei(this.element), (s = this.handleVisibilityChanged) === null || s === void 0 || s.call(this);
    }, this.onLeavePiP = () => {
      var n;
      this.isPiP = ei(this.element), (n = this.handleVisibilityChanged) === null || n === void 0 || n.call(this);
    }, this.element = e, this.isIntersecting = t != null ? t : Zn(e), this.isPiP = Se() && ei(e), this.visibilityChangedAt = 0;
  }
  width() {
    return this.element.clientWidth;
  }
  height() {
    return this.element.clientHeight;
  }
  observe() {
    var e, t, n;
    this.isIntersecting = Zn(this.element), this.isPiP = ei(this.element), this.element.handleResize = () => {
      var r;
      (r = this.handleResize) === null || r === void 0 || r.call(this);
    }, this.element.handleVisibilityChanged = this.onVisibilityChanged, ys().observe(this.element), bs().observe(this.element), this.element.addEventListener("enterpictureinpicture", this.onEnterPiP), this.element.addEventListener("leavepictureinpicture", this.onLeavePiP), (e = window.documentPictureInPicture) === null || e === void 0 || e.addEventListener("enter", this.onEnterPiP), (n = (t = window.documentPictureInPicture) === null || t === void 0 ? void 0 : t.window) === null || n === void 0 || n.addEventListener("pagehide", this.onLeavePiP);
  }
  stopObserving() {
    var e, t, n, r, s;
    (e = ys()) === null || e === void 0 || e.unobserve(this.element), (t = bs()) === null || t === void 0 || t.unobserve(this.element), this.element.removeEventListener("enterpictureinpicture", this.onEnterPiP), this.element.removeEventListener("leavepictureinpicture", this.onLeavePiP), (n = window.documentPictureInPicture) === null || n === void 0 || n.removeEventListener("enter", this.onEnterPiP), (s = (r = window.documentPictureInPicture) === null || r === void 0 ? void 0 : r.window) === null || s === void 0 || s.removeEventListener("pagehide", this.onLeavePiP);
  }
}
function ei(i) {
  var e, t;
  return document.pictureInPictureElement === i ? !0 : !((e = window.documentPictureInPicture) === null || e === void 0) && e.window ? Zn(i, (t = window.documentPictureInPicture) === null || t === void 0 ? void 0 : t.window) : !1;
}
function Zn(i, e) {
  const t = e || window;
  let n = i.offsetTop, r = i.offsetLeft;
  const s = i.offsetWidth, a = i.offsetHeight, {
    hidden: o
  } = i, {
    display: c
  } = getComputedStyle(i);
  for (; i.offsetParent; )
    i = i.offsetParent, n += i.offsetTop, r += i.offsetLeft;
  return n < t.pageYOffset + t.innerHeight && r < t.pageXOffset + t.innerWidth && n + a > t.pageYOffset && r + s > t.pageXOffset && !o && c !== "none";
}
class Xe extends He.EventEmitter {
  constructor(e, t, n, r) {
    var s;
    super(), this.metadataMuted = !1, this.encryption = Pe.NONE, this.log = G, this.handleMuted = () => {
      this.emit(I.Muted);
    }, this.handleUnmuted = () => {
      this.emit(I.Unmuted);
    }, this.log = it((s = r == null ? void 0 : r.loggerName) !== null && s !== void 0 ? s : Ne.Publication), this.loggerContextCb = this.loggerContextCb, this.setMaxListeners(100), this.kind = e, this.trackSid = t, this.trackName = n, this.source = E.Source.Unknown;
  }
  /** @internal */
  setTrack(e) {
    this.track && (this.track.off(I.Muted, this.handleMuted), this.track.off(I.Unmuted, this.handleUnmuted)), this.track = e, e && (e.on(I.Muted, this.handleMuted), e.on(I.Unmuted, this.handleUnmuted));
  }
  get logContext() {
    var e;
    return Object.assign(Object.assign({}, (e = this.loggerContextCb) === null || e === void 0 ? void 0 : e.call(this)), W(this));
  }
  get isMuted() {
    return this.metadataMuted;
  }
  get isEnabled() {
    return !0;
  }
  get isSubscribed() {
    return this.track !== void 0;
  }
  get isEncrypted() {
    return this.encryption !== Pe.NONE;
  }
  /**
   * an [AudioTrack] if this publication holds an audio track
   */
  get audioTrack() {
    if (We(this.track))
      return this.track;
  }
  /**
   * an [VideoTrack] if this publication holds a video track
   */
  get videoTrack() {
    if (Et(this.track))
      return this.track;
  }
  /** @internal */
  updateInfo(e) {
    this.trackSid = e.sid, this.trackName = e.name, this.source = E.sourceFromProto(e.source), this.mimeType = e.mimeType, this.kind === E.Kind.Video && e.width > 0 && (this.dimensions = {
      width: e.width,
      height: e.height
    }, this.simulcasted = e.simulcast), this.encryption = e.encryption, this.trackInfo = e, this.log.debug("update publication info", Object.assign(Object.assign({}, this.logContext), {
      info: e
    }));
  }
}
(function(i) {
  (function(e) {
    e.Desired = "desired", e.Subscribed = "subscribed", e.Unsubscribed = "unsubscribed";
  })(i.SubscriptionStatus || (i.SubscriptionStatus = {})), function(e) {
    e.Allowed = "allowed", e.NotAllowed = "not_allowed";
  }(i.PermissionStatus || (i.PermissionStatus = {}));
})(Xe || (Xe = {}));
class er extends Xe {
  get isUpstreamPaused() {
    var e;
    return (e = this.track) === null || e === void 0 ? void 0 : e.isUpstreamPaused;
  }
  constructor(e, t, n, r) {
    super(e, t.sid, t.name, r), this.track = void 0, this.handleTrackEnded = () => {
      this.emit(I.Ended);
    }, this.handleCpuConstrained = () => {
      this.track && Et(this.track) && this.emit(I.CpuConstrained, this.track);
    }, this.updateInfo(t), this.setTrack(n);
  }
  setTrack(e) {
    this.track && (this.track.off(I.Ended, this.handleTrackEnded), this.track.off(I.CpuConstrained, this.handleCpuConstrained)), super.setTrack(e), e && (e.on(I.Ended, this.handleTrackEnded), e.on(I.CpuConstrained, this.handleCpuConstrained));
  }
  get isMuted() {
    return this.track ? this.track.isMuted : super.isMuted;
  }
  get audioTrack() {
    return super.audioTrack;
  }
  get videoTrack() {
    return super.videoTrack;
  }
  get isLocal() {
    return !0;
  }
  /**
   * Mute the track associated with this publication
   */
  mute() {
    return m(this, void 0, void 0, function* () {
      var e;
      return (e = this.track) === null || e === void 0 ? void 0 : e.mute();
    });
  }
  /**
   * Unmute track associated with this publication
   */
  unmute() {
    return m(this, void 0, void 0, function* () {
      var e;
      return (e = this.track) === null || e === void 0 ? void 0 : e.unmute();
    });
  }
  /**
   * Pauses the media stream track associated with this publication from being sent to the server
   * and signals "muted" event to other participants
   * Useful if you want to pause the stream without pausing the local media stream track
   */
  pauseUpstream() {
    return m(this, void 0, void 0, function* () {
      var e;
      yield (e = this.track) === null || e === void 0 ? void 0 : e.pauseUpstream();
    });
  }
  /**
   * Resumes sending the media stream track associated with this publication to the server after a call to [[pauseUpstream()]]
   * and signals "unmuted" event to other participants (unless the track is explicitly muted)
   */
  resumeUpstream() {
    return m(this, void 0, void 0, function* () {
      var e;
      yield (e = this.track) === null || e === void 0 ? void 0 : e.resumeUpstream();
    });
  }
  getTrackFeatures() {
    var e;
    if (We(this.track)) {
      const t = this.track.getSourceTrackSettings(), n = /* @__PURE__ */ new Set();
      return t.autoGainControl && n.add(le.TF_AUTO_GAIN_CONTROL), t.echoCancellation && n.add(le.TF_ECHO_CANCELLATION), t.noiseSuppression && n.add(le.TF_NOISE_SUPPRESSION), t.channelCount && t.channelCount > 1 && n.add(le.TF_STEREO), !((e = this.options) === null || e === void 0) && e.dtx || n.add(le.TF_NO_DTX), this.track.enhancedNoiseCancellation && n.add(le.TF_ENHANCED_NOISE_CANCELLATION), Array.from(n.values());
    } else return [];
  }
}
function Ji(i, e) {
  return m(this, void 0, void 0, function* () {
    i != null || (i = {});
    let t = !1;
    const {
      audioProcessor: n,
      videoProcessor: r,
      optionsWithoutProcessor: s
    } = Po(i);
    let a = s.audio, o = s.video;
    if (n && typeof s.audio == "object" && (s.audio.processor = n), r && typeof s.video == "object" && (s.video.processor = r), i.audio && typeof s.audio == "object" && typeof s.audio.deviceId == "string") {
      const l = s.audio.deviceId;
      s.audio.deviceId = {
        exact: l
      }, t = !0, a = Object.assign(Object.assign({}, s.audio), {
        deviceId: {
          ideal: l
        }
      });
    }
    if (s.video && typeof s.video == "object" && typeof s.video.deviceId == "string") {
      const l = s.video.deviceId;
      s.video.deviceId = {
        exact: l
      }, t = !0, o = Object.assign(Object.assign({}, s.video), {
        deviceId: {
          ideal: l
        }
      });
    }
    (s.audio === !0 || typeof s.audio == "object" && !s.audio.deviceId) && (s.audio = {
      deviceId: "default"
    }), s.video === !0 ? s.video = {
      deviceId: "default"
    } : typeof s.video == "object" && !s.video.deviceId && (s.video.deviceId = "default");
    const c = To(s, Ro, wo), d = pr(c), u = navigator.mediaDevices.getUserMedia(d);
    s.audio && (he.userMediaPromiseMap.set("audioinput", u), u.catch(() => he.userMediaPromiseMap.delete("audioinput"))), s.video && (he.userMediaPromiseMap.set("videoinput", u), u.catch(() => he.userMediaPromiseMap.delete("videoinput")));
    try {
      const l = yield u;
      return yield Promise.all(l.getTracks().map((h) => m(this, void 0, void 0, function* () {
        const p = h.kind === "audio";
        let v = p ? c.audio : c.video;
        (typeof v == "boolean" || !v) && (v = {});
        let f;
        const T = p ? d.audio : d.video;
        typeof T != "boolean" && (f = T);
        const g = h.getSettings().deviceId;
        f != null && f.deviceId && lt(f.deviceId) !== g ? f.deviceId = g : f || (f = {
          deviceId: g
        });
        const O = ul(h, f, e);
        return O.kind === E.Kind.Video ? O.source = E.Source.Camera : O.kind === E.Kind.Audio && (O.source = E.Source.Microphone), O.mediaStream = l, We(O) && n ? yield O.setProcessor(n) : Et(O) && r && (yield O.setProcessor(r)), O;
      })));
    } catch (l) {
      if (!t)
        throw l;
      return Ji(Object.assign(Object.assign({}, i), {
        audio: a,
        video: o
      }), e);
    }
  });
}
function Ll(i) {
  return m(this, void 0, void 0, function* () {
    return (yield Ji({
      audio: !1,
      video: !0
    }))[0];
  });
}
function Nl(i) {
  return m(this, void 0, void 0, function* () {
    return (yield Ji({
      audio: !0,
      video: !1
    }))[0];
  });
}
var ct;
(function(i) {
  i.Excellent = "excellent", i.Good = "good", i.Poor = "poor", i.Lost = "lost", i.Unknown = "unknown";
})(ct || (ct = {}));
function Ul(i) {
  switch (i) {
    case ti.EXCELLENT:
      return ct.Excellent;
    case ti.GOOD:
      return ct.Good;
    case ti.POOR:
      return ct.Poor;
    case ti.LOST:
      return ct.Lost;
    default:
      return ct.Unknown;
  }
}
class Lo extends He.EventEmitter {
  get logContext() {
    var e, t;
    return Object.assign({}, (t = (e = this.loggerOptions) === null || e === void 0 ? void 0 : e.loggerContextCb) === null || t === void 0 ? void 0 : t.call(e));
  }
  get isEncrypted() {
    return this.trackPublications.size > 0 && Array.from(this.trackPublications.values()).every((e) => e.isEncrypted);
  }
  get isAgent() {
    var e;
    return ((e = this.permissions) === null || e === void 0 ? void 0 : e.agent) || this.kind === oi.AGENT;
  }
  get isActive() {
    var e;
    return ((e = this.participantInfo) === null || e === void 0 ? void 0 : e.state) === Mt.ACTIVE;
  }
  get kind() {
    return this._kind;
  }
  /** participant attributes, similar to metadata, but as a key/value map */
  get attributes() {
    return Object.freeze(Object.assign({}, this._attributes));
  }
  /** @internal */
  constructor(e, t, n, r, s, a) {
    let o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : oi.STANDARD;
    var c;
    super(), this.audioLevel = 0, this.isSpeaking = !1, this._connectionQuality = ct.Unknown, this.log = G, this.log = it((c = a == null ? void 0 : a.loggerName) !== null && c !== void 0 ? c : Ne.Participant), this.loggerOptions = a, this.setMaxListeners(100), this.sid = e, this.identity = t, this.name = n, this.metadata = r, this.audioTrackPublications = /* @__PURE__ */ new Map(), this.videoTrackPublications = /* @__PURE__ */ new Map(), this.trackPublications = /* @__PURE__ */ new Map(), this._kind = o, this._attributes = s != null ? s : {};
  }
  getTrackPublications() {
    return Array.from(this.trackPublications.values());
  }
  /**
   * Finds the first track that matches the source filter, for example, getting
   * the user's camera track with getTrackBySource(Track.Source.Camera).
   */
  getTrackPublication(e) {
    for (const [, t] of this.trackPublications)
      if (t.source === e)
        return t;
  }
  /**
   * Finds the first track that matches the track's name.
   */
  getTrackPublicationByName(e) {
    for (const [, t] of this.trackPublications)
      if (t.trackName === e)
        return t;
  }
  /**
   * Waits until the participant is active and ready to receive data messages
   * @returns a promise that resolves when the participant is active
   */
  waitUntilActive() {
    return this.isActive ? Promise.resolve() : this.activeFuture ? this.activeFuture.promise : (this.activeFuture = new xt(), this.once(C.Active, () => {
      var e, t;
      (t = (e = this.activeFuture) === null || e === void 0 ? void 0 : e.resolve) === null || t === void 0 || t.call(e), this.activeFuture = void 0;
    }), this.activeFuture.promise);
  }
  get connectionQuality() {
    return this._connectionQuality;
  }
  get isCameraEnabled() {
    var e;
    const t = this.getTrackPublication(E.Source.Camera);
    return !(!((e = t == null ? void 0 : t.isMuted) !== null && e !== void 0) || e);
  }
  get isMicrophoneEnabled() {
    var e;
    const t = this.getTrackPublication(E.Source.Microphone);
    return !(!((e = t == null ? void 0 : t.isMuted) !== null && e !== void 0) || e);
  }
  get isScreenShareEnabled() {
    return !!this.getTrackPublication(E.Source.ScreenShare);
  }
  get isLocal() {
    return !1;
  }
  /** when participant joined the room */
  get joinedAt() {
    return this.participantInfo ? new Date(Number.parseInt(this.participantInfo.joinedAt.toString()) * 1e3) : /* @__PURE__ */ new Date();
  }
  /** @internal */
  updateInfo(e) {
    var t;
    return this.participantInfo && this.participantInfo.sid === e.sid && this.participantInfo.version > e.version ? !1 : (this.identity = e.identity, this.sid = e.sid, this._setName(e.name), this._setMetadata(e.metadata), this._setAttributes(e.attributes), e.state === Mt.ACTIVE && ((t = this.participantInfo) === null || t === void 0 ? void 0 : t.state) !== Mt.ACTIVE && this.emit(C.Active), e.permission && this.setPermissions(e.permission), this.participantInfo = e, !0);
  }
  /**
   * Updates metadata from server
   **/
  _setMetadata(e) {
    const t = this.metadata !== e, n = this.metadata;
    this.metadata = e, t && this.emit(C.ParticipantMetadataChanged, n);
  }
  _setName(e) {
    const t = this.name !== e;
    this.name = e, t && this.emit(C.ParticipantNameChanged, e);
  }
  /**
   * Updates metadata from server
   **/
  _setAttributes(e) {
    const t = Uu(this.attributes, e);
    this._attributes = e, Object.keys(t).length > 0 && this.emit(C.AttributesChanged, t);
  }
  /** @internal */
  setPermissions(e) {
    var t, n, r, s, a, o;
    const c = this.permissions, d = e.canPublish !== ((t = this.permissions) === null || t === void 0 ? void 0 : t.canPublish) || e.canSubscribe !== ((n = this.permissions) === null || n === void 0 ? void 0 : n.canSubscribe) || e.canPublishData !== ((r = this.permissions) === null || r === void 0 ? void 0 : r.canPublishData) || e.hidden !== ((s = this.permissions) === null || s === void 0 ? void 0 : s.hidden) || e.recorder !== ((a = this.permissions) === null || a === void 0 ? void 0 : a.recorder) || e.canPublishSources.length !== this.permissions.canPublishSources.length || e.canPublishSources.some((u, l) => {
      var h;
      return u !== ((h = this.permissions) === null || h === void 0 ? void 0 : h.canPublishSources[l]);
    }) || e.canSubscribeMetrics !== ((o = this.permissions) === null || o === void 0 ? void 0 : o.canSubscribeMetrics);
    return this.permissions = e, d && this.emit(C.ParticipantPermissionsChanged, c), d;
  }
  /** @internal */
  setIsSpeaking(e) {
    e !== this.isSpeaking && (this.isSpeaking = e, e && (this.lastSpokeAt = /* @__PURE__ */ new Date()), this.emit(C.IsSpeakingChanged, e));
  }
  /** @internal */
  setConnectionQuality(e) {
    const t = this._connectionQuality;
    this._connectionQuality = Ul(e), t !== this._connectionQuality && this.emit(C.ConnectionQualityChanged, this._connectionQuality);
  }
  /**
   * @internal
   */
  setDisconnected() {
    var e, t;
    this.activeFuture && ((t = (e = this.activeFuture).reject) === null || t === void 0 || t.call(e, new Error("Participant disconnected")), this.activeFuture = void 0);
  }
  /**
   * @internal
   */
  setAudioContext(e) {
    this.audioContext = e, this.audioTrackPublications.forEach((t) => We(t.track) && t.track.setAudioContext(e));
  }
  addTrackPublication(e) {
    e.on(I.Muted, () => {
      this.emit(C.TrackMuted, e);
    }), e.on(I.Unmuted, () => {
      this.emit(C.TrackUnmuted, e);
    });
    const t = e;
    switch (t.track && (t.track.sid = e.trackSid), this.trackPublications.set(e.trackSid, e), e.kind) {
      case E.Kind.Audio:
        this.audioTrackPublications.set(e.trackSid, e);
        break;
      case E.Kind.Video:
        this.videoTrackPublications.set(e.trackSid, e);
        break;
    }
  }
}
function Fl(i) {
  var e, t, n;
  if (!i.participantSid && !i.participantIdentity)
    throw new Error("Invalid track permission, must provide at least one of participantIdentity and participantSid");
  return new Aa({
    participantIdentity: (e = i.participantIdentity) !== null && e !== void 0 ? e : "",
    participantSid: (t = i.participantSid) !== null && t !== void 0 ? t : "",
    allTracks: (n = i.allowAll) !== null && n !== void 0 ? n : !1,
    trackSids: i.allowedTrackSids || []
  });
}
const js = 15e3;
class jl extends Lo {
  /** @internal */
  constructor(e, t, n, r, s) {
    super(e, t, void 0, void 0, void 0, {
      loggerName: r.loggerName,
      loggerContextCb: () => this.engine.logContext
    }), this.pendingPublishing = /* @__PURE__ */ new Set(), this.pendingPublishPromises = /* @__PURE__ */ new Map(), this.participantTrackPermissions = [], this.allParticipantsAllowedToSubscribe = !0, this.encryptionType = Pe.NONE, this.enabledPublishVideoCodecs = [], this.pendingAcks = /* @__PURE__ */ new Map(), this.pendingResponses = /* @__PURE__ */ new Map(), this.handleReconnecting = () => {
      this.reconnectFuture || (this.reconnectFuture = new xt());
    }, this.handleReconnected = () => {
      var a, o;
      (o = (a = this.reconnectFuture) === null || a === void 0 ? void 0 : a.resolve) === null || o === void 0 || o.call(a), this.reconnectFuture = void 0, this.updateTrackSubscriptionPermissions();
    }, this.handleDisconnected = () => {
      var a, o, c, d, u, l;
      this.reconnectFuture && (this.reconnectFuture.promise.catch((h) => this.log.warn(h.message, this.logContext)), (o = (a = this.reconnectFuture) === null || a === void 0 ? void 0 : a.reject) === null || o === void 0 || o.call(a, "Got disconnected during reconnection attempt"), this.reconnectFuture = void 0), this.signalConnectedFuture && ((d = (c = this.signalConnectedFuture).reject) === null || d === void 0 || d.call(c, "Got disconnected without signal connected"), this.signalConnectedFuture = void 0), (l = (u = this.activeAgentFuture) === null || u === void 0 ? void 0 : u.reject) === null || l === void 0 || l.call(u, "Got disconnected without active agent present"), this.activeAgentFuture = void 0, this.firstActiveAgent = void 0;
    }, this.handleSignalConnected = (a) => {
      var o, c;
      a.participant && this.updateInfo(a.participant), this.signalConnectedFuture || (this.signalConnectedFuture = new xt()), (c = (o = this.signalConnectedFuture).resolve) === null || c === void 0 || c.call(o);
    }, this.handleSignalRequestResponse = (a) => {
      const {
        requestId: o,
        reason: c,
        message: d
      } = a, u = this.pendingSignalRequests.get(o);
      u && (c !== lr.OK && u.reject(new fs(d, c)), this.pendingSignalRequests.delete(o));
    }, this.handleDataPacket = (a) => {
      switch (a.value.case) {
        case "rpcResponse":
          let o = a.value.value, c = null, d = null;
          o.value.case === "payload" ? c = o.value.value : o.value.case === "error" && (d = ne.fromProto(o.value.value)), this.handleIncomingRpcResponse(o.requestId, c, d);
          break;
        case "rpcAck":
          let u = a.value.value;
          this.handleIncomingRpcAck(u.requestId);
          break;
      }
    }, this.updateTrackSubscriptionPermissions = () => {
      this.log.debug("updating track subscription permissions", Object.assign(Object.assign({}, this.logContext), {
        allParticipantsAllowed: this.allParticipantsAllowedToSubscribe,
        participantTrackPermissions: this.participantTrackPermissions
      })), this.engine.client.sendUpdateSubscriptionPermissions(this.allParticipantsAllowedToSubscribe, this.participantTrackPermissions.map((a) => Fl(a)));
    }, this.onTrackUnmuted = (a) => {
      this.onTrackMuted(a, a.isUpstreamPaused);
    }, this.onTrackMuted = (a, o) => {
      if (o === void 0 && (o = !0), !a.sid) {
        this.log.error("could not update mute status for unpublished track", Object.assign(Object.assign({}, this.logContext), W(a)));
        return;
      }
      this.engine.updateMuteStatus(a.sid, o);
    }, this.onTrackUpstreamPaused = (a) => {
      this.log.debug("upstream paused", Object.assign(Object.assign({}, this.logContext), W(a))), this.onTrackMuted(a, !0);
    }, this.onTrackUpstreamResumed = (a) => {
      this.log.debug("upstream resumed", Object.assign(Object.assign({}, this.logContext), W(a))), this.onTrackMuted(a, a.isMuted);
    }, this.onTrackFeatureUpdate = (a) => {
      const o = this.audioTrackPublications.get(a.sid);
      if (!o) {
        this.log.warn("Could not update local audio track settings, missing publication for track ".concat(a.sid), this.logContext);
        return;
      }
      this.engine.client.sendUpdateLocalAudioTrack(o.trackSid, o.getTrackFeatures());
    }, this.onTrackCpuConstrained = (a, o) => {
      this.log.debug("track cpu constrained", Object.assign(Object.assign({}, this.logContext), W(o))), this.emit(C.LocalTrackCpuConstrained, a, o);
    }, this.handleSubscribedQualityUpdate = (a) => m(this, void 0, void 0, function* () {
      var o, c, d, u, l;
      if (!(!((l = this.roomOptions) === null || l === void 0) && l.dynacast))
        return;
      const h = this.videoTrackPublications.get(a.trackSid);
      if (!h) {
        this.log.warn("received subscribed quality update for unknown track", Object.assign(Object.assign({}, this.logContext), {
          trackSid: a.trackSid
        }));
        return;
      }
      if (!h.videoTrack)
        return;
      const p = yield h.videoTrack.setPublishingCodecs(a.subscribedCodecs);
      try {
        for (var v = !0, f = et(p), T; T = yield f.next(), o = T.done, !o; v = !0) {
          u = T.value, v = !1;
          const g = u;
          pu(g) && (this.log.debug("publish ".concat(g, " for ").concat(h.videoTrack.sid), Object.assign(Object.assign({}, this.logContext), W(h))), yield this.publishAdditionalCodecForTrack(h.videoTrack, g, h.options));
        }
      } catch (g) {
        c = {
          error: g
        };
      } finally {
        try {
          !v && !o && (d = f.return) && (yield d.call(f));
        } finally {
          if (c) throw c.error;
        }
      }
    }), this.handleLocalTrackUnpublished = (a) => {
      const o = this.trackPublications.get(a.trackSid);
      if (!o) {
        this.log.warn("received unpublished event for unknown track", Object.assign(Object.assign({}, this.logContext), {
          trackSid: a.trackSid
        }));
        return;
      }
      this.unpublishTrack(o.track);
    }, this.handleTrackEnded = (a) => m(this, void 0, void 0, function* () {
      if (a.source === E.Source.ScreenShare || a.source === E.Source.ScreenShareAudio)
        this.log.debug("unpublishing local track due to TrackEnded", Object.assign(Object.assign({}, this.logContext), W(a))), this.unpublishTrack(a);
      else if (a.isUserProvided)
        yield a.mute();
      else if (Ye(a) || at(a))
        try {
          if (Se())
            try {
              const o = yield navigator == null ? void 0 : navigator.permissions.query({
                // the permission query for camera and microphone currently not supported in Safari and Firefox
                // @ts-ignore
                name: a.source === E.Source.Camera ? "camera" : "microphone"
              });
              if (o && o.state === "denied")
                throw this.log.warn("user has revoked access to ".concat(a.source), Object.assign(Object.assign({}, this.logContext), W(a))), o.onchange = () => {
                  o.state !== "denied" && (a.isMuted || a.restartTrack(), o.onchange = null);
                }, new Error("GetUserMedia Permission denied");
            } catch (o) {
            }
          a.isMuted || (this.log.debug("track ended, attempting to use a different device", Object.assign(Object.assign({}, this.logContext), W(a))), Ye(a) ? yield a.restartTrack({
            deviceId: "default"
          }) : yield a.restartTrack());
        } catch (o) {
          this.log.warn("could not restart track, muting instead", Object.assign(Object.assign({}, this.logContext), W(a))), yield a.mute();
        }
    }), this.audioTrackPublications = /* @__PURE__ */ new Map(), this.videoTrackPublications = /* @__PURE__ */ new Map(), this.trackPublications = /* @__PURE__ */ new Map(), this.engine = n, this.roomOptions = r, this.setupEngine(n), this.activeDeviceMap = /* @__PURE__ */ new Map([["audioinput", "default"], ["videoinput", "default"], ["audiooutput", "default"]]), this.pendingSignalRequests = /* @__PURE__ */ new Map(), this.rpcHandlers = s;
  }
  get lastCameraError() {
    return this.cameraError;
  }
  get lastMicrophoneError() {
    return this.microphoneError;
  }
  get isE2EEEnabled() {
    return this.encryptionType !== Pe.NONE;
  }
  getTrackPublication(e) {
    const t = super.getTrackPublication(e);
    if (t)
      return t;
  }
  getTrackPublicationByName(e) {
    const t = super.getTrackPublicationByName(e);
    if (t)
      return t;
  }
  /**
   * @internal
   */
  setupEngine(e) {
    var t;
    this.engine = e, this.engine.on(M.RemoteMute, (n, r) => {
      const s = this.trackPublications.get(n);
      !s || !s.track || (r ? s.mute() : s.unmute());
    }), !((t = this.signalConnectedFuture) === null || t === void 0) && t.isResolved && (this.signalConnectedFuture = void 0), this.engine.on(M.Connected, this.handleReconnected).on(M.SignalConnected, this.handleSignalConnected).on(M.SignalRestarted, this.handleReconnected).on(M.SignalResumed, this.handleReconnected).on(M.Restarting, this.handleReconnecting).on(M.Resuming, this.handleReconnecting).on(M.LocalTrackUnpublished, this.handleLocalTrackUnpublished).on(M.SubscribedQualityUpdate, this.handleSubscribedQualityUpdate).on(M.Disconnected, this.handleDisconnected).on(M.SignalRequestResponse, this.handleSignalRequestResponse).on(M.DataPacketReceived, this.handleDataPacket);
  }
  /**
   * Sets and updates the metadata of the local participant.
   * Note: this requires `canUpdateOwnMetadata` permission.
   * method will throw if the user doesn't have the required permissions
   * @param metadata
   */
  setMetadata(e) {
    return m(this, void 0, void 0, function* () {
      yield this.requestMetadataUpdate({
        metadata: e
      });
    });
  }
  /**
   * Sets and updates the name of the local participant.
   * Note: this requires `canUpdateOwnMetadata` permission.
   * method will throw if the user doesn't have the required permissions
   * @param metadata
   */
  setName(e) {
    return m(this, void 0, void 0, function* () {
      yield this.requestMetadataUpdate({
        name: e
      });
    });
  }
  /**
   * Set or update participant attributes. It will make updates only to keys that
   * are present in `attributes`, and will not override others.
   * Note: this requires `canUpdateOwnMetadata` permission.
   * @param attributes attributes to update
   */
  setAttributes(e) {
    return m(this, void 0, void 0, function* () {
      yield this.requestMetadataUpdate({
        attributes: e
      });
    });
  }
  requestMetadataUpdate(e) {
    return m(this, arguments, void 0, function(t) {
      var n = this;
      let {
        metadata: r,
        name: s,
        attributes: a
      } = t;
      return function* () {
        return new Promise((o, c) => m(n, void 0, void 0, function* () {
          var d, u;
          try {
            let l = !1;
            const h = yield this.engine.client.sendUpdateLocalMetadata((d = r != null ? r : this.metadata) !== null && d !== void 0 ? d : "", (u = s != null ? s : this.name) !== null && u !== void 0 ? u : "", a), p = performance.now();
            for (this.pendingSignalRequests.set(h, {
              resolve: o,
              reject: (v) => {
                c(v), l = !0;
              },
              values: {
                name: s,
                metadata: r,
                attributes: a
              }
            }); performance.now() - p < 5e3 && !l; ) {
              if ((!s || this.name === s) && (!r || this.metadata === r) && (!a || Object.entries(a).every((v) => {
                let [f, T] = v;
                return this.attributes[f] === T || T === "" && !this.attributes[f];
              }))) {
                this.pendingSignalRequests.delete(h), o();
                return;
              }
              yield Ce(50);
            }
            c(new fs("Request to update local metadata timed out", "TimeoutError"));
          } catch (l) {
            l instanceof Error && c(l);
          }
        }));
      }();
    });
  }
  /**
   * Enable or disable a participant's camera track.
   *
   * If a track has already published, it'll mute or unmute the track.
   * Resolves with a `LocalTrackPublication` instance if successful and `undefined` otherwise
   */
  setCameraEnabled(e, t, n) {
    return this.setTrackEnabled(E.Source.Camera, e, t, n);
  }
  /**
   * Enable or disable a participant's microphone track.
   *
   * If a track has already published, it'll mute or unmute the track.
   * Resolves with a `LocalTrackPublication` instance if successful and `undefined` otherwise
   */
  setMicrophoneEnabled(e, t, n) {
    return this.setTrackEnabled(E.Source.Microphone, e, t, n);
  }
  /**
   * Start or stop sharing a participant's screen
   * Resolves with a `LocalTrackPublication` instance if successful and `undefined` otherwise
   */
  setScreenShareEnabled(e, t, n) {
    return this.setTrackEnabled(E.Source.ScreenShare, e, t, n);
  }
  /** @internal */
  setPermissions(e) {
    const t = this.permissions, n = super.setPermissions(e);
    return n && t && this.emit(C.ParticipantPermissionsChanged, t), n;
  }
  /** @internal */
  setE2EEEnabled(e) {
    return m(this, void 0, void 0, function* () {
      this.encryptionType = e ? Pe.GCM : Pe.NONE, yield this.republishAllTracks(void 0, !1);
    });
  }
  setTrackEnabled(e, t, n, r) {
    return m(this, void 0, void 0, function* () {
      var s, a;
      this.log.debug("setTrackEnabled", Object.assign(Object.assign({}, this.logContext), {
        source: e,
        enabled: t
      })), this.republishPromise && (yield this.republishPromise);
      let o = this.getTrackPublication(e);
      if (t)
        if (o)
          yield o.unmute();
        else {
          let c;
          if (this.pendingPublishing.has(e)) {
            const d = yield this.waitForPendingPublicationOfSource(e);
            return d || this.log.info("waiting for pending publication promise timed out", Object.assign(Object.assign({}, this.logContext), {
              source: e
            })), yield d == null ? void 0 : d.unmute(), d;
          }
          this.pendingPublishing.add(e);
          try {
            switch (e) {
              case E.Source.Camera:
                c = yield this.createTracks({
                  video: (s = n) !== null && s !== void 0 ? s : !0
                });
                break;
              case E.Source.Microphone:
                c = yield this.createTracks({
                  audio: (a = n) !== null && a !== void 0 ? a : !0
                });
                break;
              case E.Source.ScreenShare:
                c = yield this.createScreenTracks(Object.assign({}, n));
                break;
              default:
                throw new tt(e);
            }
          } catch (d) {
            throw c == null || c.forEach((u) => {
              u.stop();
            }), d instanceof Error && this.emit(C.MediaDevicesError, d, Jn(e)), this.pendingPublishing.delete(e), d;
          }
          for (const d of c)
            e === E.Source.Microphone && We(d) && (r != null && r.preConnectBuffer) && (this.log.info("starting preconnect buffer for microphone", Object.assign({}, this.logContext)), d.startPreConnectBuffer());
          try {
            const d = [];
            for (const l of c)
              this.log.info("publishing track", Object.assign(Object.assign({}, this.logContext), W(l))), d.push(this.publishTrack(l, r));
            [o] = yield Promise.all(d);
          } catch (d) {
            throw c == null || c.forEach((u) => {
              u.stop();
            }), d;
          } finally {
            this.pendingPublishing.delete(e);
          }
        }
      else if (!(o != null && o.track) && this.pendingPublishing.has(e) && (o = yield this.waitForPendingPublicationOfSource(e), o || this.log.info("waiting for pending publication promise timed out", Object.assign(Object.assign({}, this.logContext), {
        source: e
      }))), o && o.track)
        if (e === E.Source.ScreenShare) {
          o = yield this.unpublishTrack(o.track);
          const c = this.getTrackPublication(E.Source.ScreenShareAudio);
          c && c.track && this.unpublishTrack(c.track);
        } else
          yield o.mute();
      return o;
    });
  }
  /**
   * Publish both camera and microphone at the same time. This is useful for
   * displaying a single Permission Dialog box to the end user.
   */
  enableCameraAndMicrophone() {
    return m(this, void 0, void 0, function* () {
      if (!(this.pendingPublishing.has(E.Source.Camera) || this.pendingPublishing.has(E.Source.Microphone))) {
        this.pendingPublishing.add(E.Source.Camera), this.pendingPublishing.add(E.Source.Microphone);
        try {
          const e = yield this.createTracks({
            audio: !0,
            video: !0
          });
          yield Promise.all(e.map((t) => this.publishTrack(t)));
        } finally {
          this.pendingPublishing.delete(E.Source.Camera), this.pendingPublishing.delete(E.Source.Microphone);
        }
      }
    });
  }
  /**
   * Create local camera and/or microphone tracks
   * @param options
   * @returns
   */
  createTracks(e) {
    return m(this, void 0, void 0, function* () {
      var t, n;
      e != null || (e = {});
      const r = To(e, (t = this.roomOptions) === null || t === void 0 ? void 0 : t.audioCaptureDefaults, (n = this.roomOptions) === null || n === void 0 ? void 0 : n.videoCaptureDefaults);
      try {
        return (yield Ji(r, {
          loggerName: this.roomOptions.loggerName,
          loggerContextCb: () => this.logContext
        })).map((o) => (We(o) && (this.microphoneError = void 0, o.setAudioContext(this.audioContext), o.source = E.Source.Microphone, this.emit(C.AudioStreamAcquired)), Et(o) && (this.cameraError = void 0, o.source = E.Source.Camera), o));
      } catch (s) {
        throw s instanceof Error && (e.audio && (this.microphoneError = s), e.video && (this.cameraError = s)), s;
      }
    });
  }
  /**
   * Creates a screen capture tracks with getDisplayMedia().
   * A LocalVideoTrack is always created and returned.
   * If { audio: true }, and the browser supports audio capture, a LocalAudioTrack is also created.
   */
  createScreenTracks(e) {
    return m(this, void 0, void 0, function* () {
      if (e === void 0 && (e = {}), navigator.mediaDevices.getDisplayMedia === void 0)
        throw new hr("getDisplayMedia not supported");
      e.resolution === void 0 && !ku() && (e.resolution = fr.h1080fps30.resolution);
      const t = Au(e), n = yield navigator.mediaDevices.getDisplayMedia(t), r = n.getVideoTracks();
      if (r.length === 0)
        throw new tt("no video track found");
      const s = new Fi(r[0], void 0, !1, {
        loggerName: this.roomOptions.loggerName,
        loggerContextCb: () => this.logContext
      });
      s.source = E.Source.ScreenShare, e.contentHint && (s.mediaStreamTrack.contentHint = e.contentHint);
      const a = [s];
      if (n.getAudioTracks().length > 0) {
        this.emit(C.AudioStreamAcquired);
        const o = new Ui(n.getAudioTracks()[0], void 0, !1, this.audioContext, {
          loggerName: this.roomOptions.loggerName,
          loggerContextCb: () => this.logContext
        });
        o.source = E.Source.ScreenShareAudio, a.push(o);
      }
      return a;
    });
  }
  /**
   * Publish a new track to the room
   * @param track
   * @param options
   */
  publishTrack(e, t) {
    return m(this, void 0, void 0, function* () {
      return this.publishOrRepublishTrack(e, t);
    });
  }
  publishOrRepublishTrack(e, t) {
    return m(this, arguments, void 0, function(n, r) {
      var s = this;
      let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
      return function* () {
        var o, c, d, u;
        Ye(n) && n.setAudioContext(s.audioContext), yield (o = s.reconnectFuture) === null || o === void 0 ? void 0 : o.promise, s.republishPromise && !a && (yield s.republishPromise), Nt(n) && s.pendingPublishPromises.has(n) && (yield s.pendingPublishPromises.get(n));
        let l;
        if (n instanceof MediaStreamTrack)
          l = n.getConstraints();
        else {
          l = n.constraints;
          let g;
          switch (n.source) {
            case E.Source.Microphone:
              g = "audioinput";
              break;
            case E.Source.Camera:
              g = "videoinput";
          }
          g && s.activeDeviceMap.has(g) && (l = Object.assign(Object.assign({}, l), {
            deviceId: s.activeDeviceMap.get(g)
          }));
        }
        if (n instanceof MediaStreamTrack)
          switch (n.kind) {
            case "audio":
              n = new Ui(n, l, !0, s.audioContext, {
                loggerName: s.roomOptions.loggerName,
                loggerContextCb: () => s.logContext
              });
              break;
            case "video":
              n = new Fi(n, l, !0, {
                loggerName: s.roomOptions.loggerName,
                loggerContextCb: () => s.logContext
              });
              break;
            default:
              throw new tt("unsupported MediaStreamTrack kind ".concat(n.kind));
          }
        else
          n.updateLoggerOptions({
            loggerName: s.roomOptions.loggerName,
            loggerContextCb: () => s.logContext
          });
        let h;
        if (s.trackPublications.forEach((g) => {
          g.track && g.track === n && (h = g);
        }), h)
          return s.log.warn("track has already been published, skipping", Object.assign(Object.assign({}, s.logContext), W(h))), h;
        const p = "channelCount" in n.mediaStreamTrack.getSettings() && // @ts-ignore `channelCount` on getSettings() is currently only available for Safari, but is generally the best way to determine a stereo track https://developer.mozilla.org/en-US/docs/Web/API/MediaTrackSettings/channelCount
        n.mediaStreamTrack.getSettings().channelCount === 2 || n.mediaStreamTrack.getConstraints().channelCount === 2, v = (c = r == null ? void 0 : r.forceStereo) !== null && c !== void 0 ? c : p;
        v && (r || (r = {}), r.dtx === void 0 && s.log.info("Opus DTX will be disabled for stereo tracks by default. Enable them explicitly to make it work.", Object.assign(Object.assign({}, s.logContext), W(n))), r.red === void 0 && s.log.info("Opus RED will be disabled for stereo tracks by default. Enable them explicitly to make it work."), (d = r.dtx) !== null && d !== void 0 || (r.dtx = !1), (u = r.red) !== null && u !== void 0 || (r.red = !1));
        const f = Object.assign(Object.assign({}, s.roomOptions.publishDefaults), r);
        !Su() && s.roomOptions.e2ee && (s.log.info("End-to-end encryption is set up, simulcast publishing will be disabled on Safari versions and iOS browsers running iOS < v17.2", Object.assign({}, s.logContext)), f.simulcast = !1), f.source && (n.source = f.source);
        const T = new Promise((g, O) => m(s, void 0, void 0, function* () {
          try {
            if (this.engine.client.currentState !== Y.CONNECTED) {
              this.log.debug("deferring track publication until signal is connected", Object.assign(Object.assign({}, this.logContext), {
                track: W(n)
              }));
              const w = setTimeout(() => {
                O(new hs("publishing rejected as engine not connected within timeout", 408));
              }, 15e3);
              yield this.waitUntilEngineConnected(), clearTimeout(w);
              const b = yield this.publish(n, f, v);
              g(b);
            } else
              try {
                const w = yield this.publish(n, f, v);
                g(w);
              } catch (w) {
                O(w);
              }
          } catch (w) {
            O(w);
          }
        }));
        s.pendingPublishPromises.set(n, T);
        try {
          return yield T;
        } catch (g) {
          throw g;
        } finally {
          s.pendingPublishPromises.delete(n);
        }
      }();
    });
  }
  waitUntilEngineConnected() {
    return this.signalConnectedFuture || (this.signalConnectedFuture = new xt()), this.signalConnectedFuture.promise;
  }
  hasPermissionsToPublish(e) {
    if (!this.permissions)
      return this.log.warn("no permissions present for publishing track", Object.assign(Object.assign({}, this.logContext), W(e))), !1;
    const {
      canPublish: t,
      canPublishSources: n
    } = this.permissions;
    return t && (n.length === 0 || n.map((r) => Fu(r)).includes(e.source)) ? !0 : (this.log.warn("insufficient permissions to publish", Object.assign(Object.assign({}, this.logContext), W(e))), !1);
  }
  publish(e, t, n) {
    return m(this, void 0, void 0, function* () {
      var r, s, a, o, c, d, u, l, h, p;
      if (!this.hasPermissionsToPublish(e))
        throw new hs("failed to publish track, insufficient permissions", 403);
      Array.from(this.trackPublications.values()).find((x) => Nt(e) && x.source === e.source) && e.source !== E.Source.Unknown && this.log.info("publishing a second track with the same source: ".concat(e.source), Object.assign(Object.assign({}, this.logContext), W(e))), t.stopMicTrackOnMute && We(e) && (e.stopOnMute = !0), e.source === E.Source.ScreenShare && Bt() && (t.simulcast = !1), t.videoCodec === "av1" && !vu() && (t.videoCodec = void 0), t.videoCodec === "vp9" && !bu() && (t.videoCodec = void 0), t.videoCodec === void 0 && (t.videoCodec = Qn), this.enabledPublishVideoCodecs.length > 0 && (this.enabledPublishVideoCodecs.some((x) => t.videoCodec === Ii(x.mime)) || (t.videoCodec = Ii(this.enabledPublishVideoCodecs[0].mime)));
      const f = t.videoCodec;
      e.on(I.Muted, this.onTrackMuted), e.on(I.Unmuted, this.onTrackUnmuted), e.on(I.Ended, this.handleTrackEnded), e.on(I.UpstreamPaused, this.onTrackUpstreamPaused), e.on(I.UpstreamResumed, this.onTrackUpstreamResumed), e.on(I.AudioTrackFeatureUpdate, this.onTrackFeatureUpdate);
      const T = [], g = !(!((r = t.dtx) !== null && r !== void 0) || r), O = e.getSourceTrackSettings();
      O.autoGainControl && T.push(le.TF_AUTO_GAIN_CONTROL), O.echoCancellation && T.push(le.TF_ECHO_CANCELLATION), O.noiseSuppression && T.push(le.TF_NOISE_SUPPRESSION), O.channelCount && O.channelCount > 1 && T.push(le.TF_STEREO), g && T.push(le.TF_NO_DTX), Ye(e) && e.hasPreConnectBuffer && T.push(le.TF_PRECONNECT_BUFFER);
      const w = new _n({
        // get local track id for use during publishing
        cid: e.mediaStreamTrack.id,
        name: t.name,
        type: E.kindToProto(e.kind),
        muted: e.isMuted,
        source: E.sourceToProto(e.source),
        disableDtx: g,
        encryption: this.encryptionType,
        stereo: n,
        disableRed: this.isE2EEEnabled || !(!((s = t.red) !== null && s !== void 0) || s),
        stream: t == null ? void 0 : t.stream,
        backupCodecPolicy: t == null ? void 0 : t.backupCodecPolicy,
        audioFeatures: T
      });
      let b;
      if (e.kind === E.Kind.Video) {
        let x = {
          width: 0,
          height: 0
        };
        try {
          x = yield e.waitForDimensions();
        } catch (L) {
          const _ = (o = (a = this.roomOptions.videoCaptureDefaults) === null || a === void 0 ? void 0 : a.resolution) !== null && o !== void 0 ? o : ci.h720.resolution;
          x = {
            width: _.width,
            height: _.height
          }, this.log.error("could not determine track dimensions, using defaults", Object.assign(Object.assign(Object.assign({}, this.logContext), W(e)), {
            dims: x
          }));
        }
        w.width = x.width, w.height = x.height, at(e) && (qe(f) && (e.source === E.Source.ScreenShare && (t.scalabilityMode = "L1T3", "contentHint" in e.mediaStreamTrack && (e.mediaStreamTrack.contentHint = "motion", this.log.info("forcing contentHint to motion for screenshare with SVC codecs", Object.assign(Object.assign({}, this.logContext), W(e))))), t.scalabilityMode = (c = t.scalabilityMode) !== null && c !== void 0 ? c : "L3T3_KEY"), w.simulcastCodecs = [new wn({
          codec: f,
          cid: e.mediaStreamTrack.id
        })], t.backupCodec === !0 && (t.backupCodec = {
          codec: Qn
        }), t.backupCodec && f !== t.backupCodec.codec && // TODO remove this once e2ee is supported for backup codecs
        w.encryption === Pe.NONE && (this.roomOptions.dynacast || (this.roomOptions.dynacast = !0), w.simulcastCodecs.push(new wn({
          codec: t.backupCodec.codec,
          cid: ""
        })))), b = Xn(e.source === E.Source.ScreenShare, w.width, w.height, t), w.layers = Ns(w.width, w.height, b, qe(t.videoCodec));
      } else e.kind === E.Kind.Audio && (b = [{
        maxBitrate: (d = t.audioPreset) === null || d === void 0 ? void 0 : d.maxBitrate,
        priority: (l = (u = t.audioPreset) === null || u === void 0 ? void 0 : u.priority) !== null && l !== void 0 ? l : "high",
        networkPriority: (p = (h = t.audioPreset) === null || h === void 0 ? void 0 : h.priority) !== null && p !== void 0 ? p : "high"
      }]);
      if (!this.engine || this.engine.isClosed)
        throw new ce("cannot publish track when not connected");
      const y = () => m(this, void 0, void 0, function* () {
        var x, L, _;
        if (!this.engine.pcManager)
          throw new ce("pcManager is not ready");
        if (e.sender = yield this.engine.createSender(e, t, b), this.emit(C.LocalSenderCreated, e.sender, e), at(e) && ((x = t.degradationPreference) !== null && x !== void 0 || (t.degradationPreference = kl(e)), e.setDegradationPreference(t.degradationPreference)), b)
          if (Bt() && e.kind === E.Kind.Audio) {
            let U;
            for (const V of this.engine.pcManager.publisher.getTransceivers())
              if (V.sender === e.sender) {
                U = V;
                break;
              }
            U && this.engine.pcManager.publisher.setTrackCodecBitrate({
              transceiver: U,
              codec: "opus",
              maxbr: !((L = b[0]) === null || L === void 0) && L.maxBitrate ? b[0].maxBitrate / 1e3 : 0
            });
          } else e.codec && qe(e.codec) && (!((_ = b[0]) === null || _ === void 0) && _.maxBitrate) && this.engine.pcManager.publisher.setTrackCodecBitrate({
            cid: w.cid,
            codec: e.codec,
            maxbr: b[0].maxBitrate / 1e3
          });
        yield this.engine.negotiate();
      });
      let P;
      const D = new Promise((x, L) => m(this, void 0, void 0, function* () {
        var _;
        try {
          P = yield this.engine.addTrack(w), x(P);
        } catch (U) {
          e.sender && (!((_ = this.engine.pcManager) === null || _ === void 0) && _.publisher) && (this.engine.pcManager.publisher.removeTrack(e.sender), yield this.engine.negotiate().catch((V) => {
            this.log.error("failed to negotiate after removing track due to failed add track request", Object.assign(Object.assign(Object.assign({}, this.logContext), W(e)), {
              error: V
            }));
          })), L(U);
        }
      }));
      if (this.enabledPublishVideoCodecs.length > 0)
        P = (yield Promise.all([D, y()]))[0];
      else {
        P = yield D;
        let x;
        if (P.codecs.forEach((L) => {
          x === void 0 && (x = L.mimeType);
        }), x && e.kind === E.Kind.Video) {
          const L = Ii(x);
          L !== f && (this.log.debug("falling back to server selected codec", Object.assign(Object.assign(Object.assign({}, this.logContext), W(e)), {
            codec: L
          })), t.videoCodec = L, b = Xn(e.source === E.Source.ScreenShare, w.width, w.height, t));
        }
        yield y();
      }
      const A = new er(e.kind, P, e, {
        loggerName: this.roomOptions.loggerName,
        loggerContextCb: () => this.logContext
      });
      if (A.on(I.CpuConstrained, (x) => this.onTrackCpuConstrained(x, A)), A.options = t, e.sid = P.sid, this.log.debug("publishing ".concat(e.kind, " with encodings"), Object.assign(Object.assign({}, this.logContext), {
        encodings: b,
        trackInfo: P
      })), at(e) ? e.startMonitor(this.engine.client) : Ye(e) && e.startMonitor(), this.addTrackPublication(A), this.emit(C.LocalTrackPublished, A), Ye(e) && P.audioFeatures.includes(le.TF_PRECONNECT_BUFFER)) {
        const x = e.getPreConnectBuffer();
        this.on(C.LocalTrackSubscribed, (L) => {
          if (L.trackSid === P.sid) {
            if (!e.hasPreConnectBuffer) {
              this.log.warn("subscribe event came to late, buffer already closed", this.logContext);
              return;
            }
            this.log.debug("finished recording preconnect buffer", Object.assign(Object.assign({}, this.logContext), W(e))), e.stopPreConnectBuffer();
          }
        }), x && new Promise((_, U) => m(this, void 0, void 0, function* () {
          var V, oe, N, B, j, ee;
          try {
            this.log.debug("waiting for agent", Object.assign(Object.assign({}, this.logContext), W(e)));
            const z = setTimeout(() => {
              U(new Error("agent not active within 10 seconds"));
            }, 1e4), Ue = yield this.waitUntilActiveAgentPresent();
            clearTimeout(z), this.log.debug("sending preconnect buffer", Object.assign(Object.assign({}, this.logContext), W(e)));
            const fe = yield this.streamBytes({
              name: "preconnect-buffer",
              mimeType: "audio/opus",
              topic: "lk.agent.pre-connect-audio-buffer",
              destinationIdentities: [Ue.identity],
              attributes: {
                trackId: A.trackSid,
                sampleRate: String((j = O.sampleRate) !== null && j !== void 0 ? j : "48000"),
                channels: String((ee = O.channelCount) !== null && ee !== void 0 ? ee : "1")
              }
            });
            try {
              for (var X = !0, F = et(x), ve; ve = yield F.next(), V = ve.done, !V; X = !0) {
                B = ve.value, X = !1;
                const ue = B;
                yield fe.write(ue);
              }
            } catch (ue) {
              oe = {
                error: ue
              };
            } finally {
              try {
                !X && !V && (N = F.return) && (yield N.call(F));
              } finally {
                if (oe) throw oe.error;
              }
            }
            yield fe.close(), _();
          } catch (z) {
            U(z);
          }
        })).then(() => {
          this.log.debug("preconnect buffer sent successfully", Object.assign(Object.assign({}, this.logContext), W(e)));
        }).catch((_) => {
          this.log.error("error sending preconnect buffer", Object.assign(Object.assign(Object.assign({}, this.logContext), W(e)), {
            error: _
          }));
        });
      }
      return A;
    });
  }
  get isLocal() {
    return !0;
  }
  /** @internal
   * publish additional codec to existing track
   */
  publishAdditionalCodecForTrack(e, t, n) {
    return m(this, void 0, void 0, function* () {
      var r;
      if (this.encryptionType !== Pe.NONE)
        return;
      let s;
      if (this.trackPublications.forEach((p) => {
        p.track && p.track === e && (s = p);
      }), !s)
        throw new tt("track is not published");
      if (!at(e))
        throw new tt("track is not a video track");
      const a = Object.assign(Object.assign({}, (r = this.roomOptions) === null || r === void 0 ? void 0 : r.publishDefaults), n), o = vl(e, t, a);
      if (!o) {
        this.log.info("backup codec has been disabled, ignoring request to add additional codec for track", Object.assign(Object.assign({}, this.logContext), W(e)));
        return;
      }
      const c = e.addSimulcastTrack(t, o);
      if (!c)
        return;
      const d = new _n({
        cid: c.mediaStreamTrack.id,
        type: E.kindToProto(e.kind),
        muted: e.isMuted,
        source: E.sourceToProto(e.source),
        sid: e.sid,
        simulcastCodecs: [{
          codec: a.videoCodec,
          cid: c.mediaStreamTrack.id
        }]
      });
      if (d.layers = Ns(d.width, d.height, o), !this.engine || this.engine.isClosed)
        throw new ce("cannot publish track when not connected");
      const u = () => m(this, void 0, void 0, function* () {
        yield this.engine.createSimulcastSender(e, c, a, o), yield this.engine.negotiate();
      }), h = (yield Promise.all([this.engine.addTrack(d), u()]))[0];
      this.log.debug("published ".concat(t, " for track ").concat(e.sid), Object.assign(Object.assign({}, this.logContext), {
        encodings: o,
        trackInfo: h
      }));
    });
  }
  unpublishTrack(e, t) {
    return m(this, void 0, void 0, function* () {
      var n, r;
      if (Nt(e)) {
        const d = this.pendingPublishPromises.get(e);
        d && (this.log.info("awaiting publish promise before attempting to unpublish", Object.assign(Object.assign({}, this.logContext), W(e))), yield d);
      }
      const s = this.getPublicationForTrack(e), a = s ? W(s) : void 0;
      if (this.log.debug("unpublishing track", Object.assign(Object.assign({}, this.logContext), a)), !s || !s.track) {
        this.log.warn("track was not unpublished because no publication was found", Object.assign(Object.assign({}, this.logContext), a));
        return;
      }
      e = s.track, e.off(I.Muted, this.onTrackMuted), e.off(I.Unmuted, this.onTrackUnmuted), e.off(I.Ended, this.handleTrackEnded), e.off(I.UpstreamPaused, this.onTrackUpstreamPaused), e.off(I.UpstreamResumed, this.onTrackUpstreamResumed), e.off(I.AudioTrackFeatureUpdate, this.onTrackFeatureUpdate), t === void 0 && (t = (r = (n = this.roomOptions) === null || n === void 0 ? void 0 : n.stopLocalTrackOnUnpublish) !== null && r !== void 0 ? r : !0), t ? e.stop() : e.stopMonitor();
      let o = !1;
      const c = e.sender;
      if (e.sender = void 0, this.engine.pcManager && this.engine.pcManager.currentState < te.FAILED && c)
        try {
          for (const d of this.engine.pcManager.publisher.getTransceivers())
            d.sender === c && (d.direction = "inactive", o = !0);
          if (this.engine.removeTrack(c) && (o = !0), at(e)) {
            for (const [, d] of e.simulcastCodecs)
              d.sender && (this.engine.removeTrack(d.sender) && (o = !0), d.sender = void 0);
            e.simulcastCodecs.clear();
          }
        } catch (d) {
          this.log.warn("failed to unpublish track", Object.assign(Object.assign(Object.assign({}, this.logContext), a), {
            error: d
          }));
        }
      switch (this.trackPublications.delete(s.trackSid), s.kind) {
        case E.Kind.Audio:
          this.audioTrackPublications.delete(s.trackSid);
          break;
        case E.Kind.Video:
          this.videoTrackPublications.delete(s.trackSid);
          break;
      }
      return this.emit(C.LocalTrackUnpublished, s), s.setTrack(void 0), o && (yield this.engine.negotiate()), s;
    });
  }
  unpublishTracks(e) {
    return m(this, void 0, void 0, function* () {
      return (yield Promise.all(e.map((n) => this.unpublishTrack(n)))).filter((n) => !!n);
    });
  }
  republishAllTracks(e) {
    return m(this, arguments, void 0, function(t) {
      var n = this;
      let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      return function* () {
        n.republishPromise && (yield n.republishPromise), n.republishPromise = new Promise((s, a) => m(n, void 0, void 0, function* () {
          try {
            const o = [];
            this.trackPublications.forEach((c) => {
              c.track && (t && (c.options = Object.assign(Object.assign({}, c.options), t)), o.push(c));
            }), yield Promise.all(o.map((c) => m(this, void 0, void 0, function* () {
              const d = c.track;
              yield this.unpublishTrack(d, !1), r && !d.isMuted && d.source !== E.Source.ScreenShare && d.source !== E.Source.ScreenShareAudio && (Ye(d) || at(d)) && !d.isUserProvided && (this.log.debug("restarting existing track", Object.assign(Object.assign({}, this.logContext), {
                track: c.trackSid
              })), yield d.restartTrack()), yield this.publishOrRepublishTrack(d, c.options, !0);
            }))), s();
          } catch (o) {
            a(o);
          } finally {
            this.republishPromise = void 0;
          }
        })), yield n.republishPromise;
      }();
    });
  }
  /**
   * Publish a new data payload to the room. Data will be forwarded to each
   * participant in the room if the destination field in publishOptions is empty
   *
   * @param data Uint8Array of the payload. To send string data, use TextEncoder.encode
   * @param options optionally specify a `reliable`, `topic` and `destination`
   */
  publishData(e) {
    return m(this, arguments, void 0, function(t) {
      var n = this;
      let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return function* () {
        const s = r.reliable ? q.RELIABLE : q.LOSSY, a = r.destinationIdentities, o = r.topic, c = new ke({
          kind: s,
          value: {
            case: "user",
            value: new ma({
              participantIdentity: n.identity,
              payload: t,
              destinationIdentities: a,
              topic: o
            })
          }
        });
        yield n.engine.sendDataPacket(c, s);
      }();
    });
  }
  /**
   * Publish SIP DTMF message to the room.
   *
   * @param code DTMF code
   * @param digit DTMF digit
   */
  publishDtmf(e, t) {
    return m(this, void 0, void 0, function* () {
      const n = new ke({
        kind: q.RELIABLE,
        value: {
          case: "sipDtmf",
          value: new ga({
            code: e,
            digit: t
          })
        }
      });
      yield this.engine.sendDataPacket(n, q.RELIABLE);
    });
  }
  sendChatMessage(e, t) {
    return m(this, void 0, void 0, function* () {
      const n = {
        id: crypto.randomUUID(),
        message: e,
        timestamp: Date.now(),
        attachedFiles: t == null ? void 0 : t.attachments
      }, r = new ke({
        value: {
          case: "chatMessage",
          value: new Tn(Object.assign(Object.assign({}, n), {
            timestamp: Z.parse(n.timestamp)
          }))
        }
      });
      return yield this.engine.sendDataPacket(r, q.RELIABLE), this.emit(C.ChatMessage, n), n;
    });
  }
  editChatMessage(e, t) {
    return m(this, void 0, void 0, function* () {
      const n = Object.assign(Object.assign({}, t), {
        message: e,
        editTimestamp: Date.now()
      }), r = new ke({
        value: {
          case: "chatMessage",
          value: new Tn(Object.assign(Object.assign({}, n), {
            timestamp: Z.parse(n.timestamp),
            editTimestamp: Z.parse(n.editTimestamp)
          }))
        }
      });
      return yield this.engine.sendDataPacket(r, q.RELIABLE), this.emit(C.ChatMessage, n), n;
    });
  }
  sendText(e, t) {
    return m(this, void 0, void 0, function* () {
      var n;
      const r = crypto.randomUUID(), a = new TextEncoder().encode(e).byteLength, o = (n = t == null ? void 0 : t.attachments) === null || n === void 0 ? void 0 : n.map(() => crypto.randomUUID()), c = new Array(o ? o.length + 1 : 1).fill(0), d = (l, h) => {
        var p;
        c[h] = l;
        const v = c.reduce((f, T) => f + T, 0);
        (p = t == null ? void 0 : t.onProgress) === null || p === void 0 || p.call(t, v);
      }, u = yield this.streamText({
        streamId: r,
        totalSize: a,
        destinationIdentities: t == null ? void 0 : t.destinationIdentities,
        topic: t == null ? void 0 : t.topic,
        attachedStreamIds: o,
        attributes: t == null ? void 0 : t.attributes
      });
      return yield u.write(e), d(1, 0), yield u.close(), t != null && t.attachments && o && (yield Promise.all(t.attachments.map((l, h) => m(this, void 0, void 0, function* () {
        return this._sendFile(o[h], l, {
          topic: t.topic,
          mimeType: l.type,
          onProgress: (p) => {
            d(p, h + 1);
          }
        });
      })))), u.info;
    });
  }
  /**
   * @internal
   * @experimental CAUTION, might get removed in a minor release
   */
  streamText(e) {
    return m(this, void 0, void 0, function* () {
      var t, n;
      const r = (t = e == null ? void 0 : e.streamId) !== null && t !== void 0 ? t : crypto.randomUUID(), s = {
        id: r,
        mimeType: "text/plain",
        timestamp: Date.now(),
        topic: (n = e == null ? void 0 : e.topic) !== null && n !== void 0 ? n : "",
        size: e == null ? void 0 : e.totalSize,
        attributes: e == null ? void 0 : e.attributes
      }, a = new Cn({
        streamId: r,
        mimeType: s.mimeType,
        topic: s.topic,
        timestamp: bt(s.timestamp),
        totalLength: bt(e == null ? void 0 : e.totalSize),
        attributes: s.attributes,
        contentHeader: {
          case: "textHeader",
          value: new wa({
            version: e == null ? void 0 : e.version,
            attachedStreamIds: e == null ? void 0 : e.attachedStreamIds,
            replyToStreamId: e == null ? void 0 : e.replyToStreamId,
            operationType: (e == null ? void 0 : e.type) === "update" ? Sn.UPDATE : Sn.CREATE
          })
        }
      }), o = e == null ? void 0 : e.destinationIdentities, c = new ke({
        destinationIdentities: o,
        value: {
          case: "streamHeader",
          value: a
        }
      });
      yield this.engine.sendDataPacket(c, q.RELIABLE);
      let d = 0;
      const u = this, l = new WritableStream({
        // Implement the sink
        write(v) {
          return m(this, void 0, void 0, function* () {
            for (const f of Mu(v, js)) {
              yield u.engine.waitForBufferStatusLow(q.RELIABLE);
              const T = new Pn({
                content: f,
                streamId: r,
                chunkIndex: bt(d)
              }), g = new ke({
                destinationIdentities: o,
                value: {
                  case: "streamChunk",
                  value: T
                }
              });
              yield u.engine.sendDataPacket(g, q.RELIABLE), d += 1;
            }
          });
        },
        close() {
          return m(this, void 0, void 0, function* () {
            const v = new En({
              streamId: r
            }), f = new ke({
              destinationIdentities: o,
              value: {
                case: "streamTrailer",
                value: v
              }
            });
            yield u.engine.sendDataPacket(f, q.RELIABLE);
          });
        },
        abort(v) {
        }
      });
      let h = () => m(this, void 0, void 0, function* () {
        yield p.close();
      });
      u.engine.once(M.Closing, h);
      const p = new Ol(l, s, () => this.engine.off(M.Closing, h));
      return p;
    });
  }
  sendFile(e, t) {
    return m(this, void 0, void 0, function* () {
      const n = crypto.randomUUID();
      return yield this._sendFile(n, e, t), {
        id: n
      };
    });
  }
  _sendFile(e, t, n) {
    return m(this, void 0, void 0, function* () {
      var r;
      const s = yield this.streamBytes({
        streamId: e,
        totalSize: t.size,
        name: t.name,
        mimeType: (r = n == null ? void 0 : n.mimeType) !== null && r !== void 0 ? r : t.type,
        topic: n == null ? void 0 : n.topic,
        destinationIdentities: n == null ? void 0 : n.destinationIdentities
      }), a = t.stream().getReader();
      for (; ; ) {
        const {
          done: o,
          value: c
        } = yield a.read();
        if (o)
          break;
        yield s.write(c);
      }
      return yield s.close(), s.info;
    });
  }
  streamBytes(e) {
    return m(this, void 0, void 0, function* () {
      var t, n, r, s, a;
      const o = (t = e == null ? void 0 : e.streamId) !== null && t !== void 0 ? t : crypto.randomUUID(), c = e == null ? void 0 : e.destinationIdentities, d = {
        id: o,
        mimeType: (n = e == null ? void 0 : e.mimeType) !== null && n !== void 0 ? n : "application/octet-stream",
        topic: (r = e == null ? void 0 : e.topic) !== null && r !== void 0 ? r : "",
        timestamp: Date.now(),
        attributes: e == null ? void 0 : e.attributes,
        size: e == null ? void 0 : e.totalSize,
        name: (s = e == null ? void 0 : e.name) !== null && s !== void 0 ? s : "unknown"
      }, u = new Cn({
        totalLength: bt((a = d.size) !== null && a !== void 0 ? a : 0),
        mimeType: d.mimeType,
        streamId: o,
        topic: d.topic,
        timestamp: bt(Date.now()),
        attributes: d.attributes,
        contentHeader: {
          case: "byteHeader",
          value: new _a({
            name: d.name
          })
        }
      }), l = new ke({
        destinationIdentities: c,
        value: {
          case: "streamHeader",
          value: u
        }
      });
      yield this.engine.sendDataPacket(l, q.RELIABLE);
      let h = 0;
      const p = new ge(), v = this.engine, f = this.log, T = new WritableStream({
        write(O) {
          return m(this, void 0, void 0, function* () {
            const w = yield p.lock();
            let b = 0;
            try {
              for (; b < O.byteLength; ) {
                const y = O.slice(b, b + js);
                yield v.waitForBufferStatusLow(q.RELIABLE);
                const P = new ke({
                  destinationIdentities: c,
                  value: {
                    case: "streamChunk",
                    value: new Pn({
                      content: y,
                      streamId: o,
                      chunkIndex: bt(h)
                    })
                  }
                });
                yield v.sendDataPacket(P, q.RELIABLE), h += 1, b += y.byteLength;
              }
            } finally {
              w();
            }
          });
        },
        close() {
          return m(this, void 0, void 0, function* () {
            const O = new En({
              streamId: o
            }), w = new ke({
              destinationIdentities: c,
              value: {
                case: "streamTrailer",
                value: O
              }
            });
            yield v.sendDataPacket(w, q.RELIABLE);
          });
        },
        abort(O) {
          f.error("Sink error:", O);
        }
      });
      return new xl(T, d);
    });
  }
  /**
   * Initiate an RPC call to a remote participant
   * @param params - Parameters for initiating the RPC call, see {@link PerformRpcParams}
   * @returns A promise that resolves with the response payload or rejects with an error.
   * @throws Error on failure. Details in `message`.
   */
  performRpc(e) {
    return m(this, arguments, void 0, function(t) {
      var n = this;
      let {
        destinationIdentity: r,
        method: s,
        payload: a,
        responseTimeout: o = 1e4
      } = t;
      return function* () {
        return new Promise((d, u) => m(n, void 0, void 0, function* () {
          var l, h, p, v;
          if (yr(a) > _o) {
            u(ne.builtIn("REQUEST_PAYLOAD_TOO_LARGE"));
            return;
          }
          if (!((h = (l = this.engine.latestJoinResponse) === null || l === void 0 ? void 0 : l.serverInfo) === null || h === void 0) && h.version && Ke((v = (p = this.engine.latestJoinResponse) === null || p === void 0 ? void 0 : p.serverInfo) === null || v === void 0 ? void 0 : v.version, "1.8.0") < 0) {
            u(ne.builtIn("UNSUPPORTED_SERVER"));
            return;
          }
          const f = crypto.randomUUID();
          yield this.publishRpcRequest(r, f, s, a, o - 2e3);
          const T = setTimeout(() => {
            this.pendingAcks.delete(f), u(ne.builtIn("CONNECTION_TIMEOUT")), this.pendingResponses.delete(f), clearTimeout(g);
          }, 2e3);
          this.pendingAcks.set(f, {
            resolve: () => {
              clearTimeout(T);
            },
            participantIdentity: r
          });
          const g = setTimeout(() => {
            this.pendingResponses.delete(f), u(ne.builtIn("RESPONSE_TIMEOUT"));
          }, o);
          this.pendingResponses.set(f, {
            resolve: (O, w) => {
              clearTimeout(g), this.pendingAcks.has(f) && (this.pendingAcks.delete(f), clearTimeout(T)), w ? u(w) : d(O != null ? O : "");
            },
            participantIdentity: r
          });
        }));
      }();
    });
  }
  /**
   * @deprecated use `room.registerRpcMethod` instead
   */
  registerRpcMethod(e, t) {
    this.rpcHandlers.has(e) && this.log.warn("you're overriding the RPC handler for method ".concat(e, ", in the future this will throw an error")), this.rpcHandlers.set(e, t);
  }
  /**
   * @deprecated use `room.unregisterRpcMethod` instead
   */
  unregisterRpcMethod(e) {
    this.rpcHandlers.delete(e);
  }
  /**
   * Control who can subscribe to LocalParticipant's published tracks.
   *
   * By default, all participants can subscribe. This allows fine-grained control over
   * who is able to subscribe at a participant and track level.
   *
   * Note: if access is given at a track-level (i.e. both [allParticipantsAllowed] and
   * [ParticipantTrackPermission.allTracksAllowed] are false), any newer published tracks
   * will not grant permissions to any participants and will require a subsequent
   * permissions update to allow subscription.
   *
   * @param allParticipantsAllowed Allows all participants to subscribe all tracks.
   *  Takes precedence over [[participantTrackPermissions]] if set to true.
   *  By default this is set to true.
   * @param participantTrackPermissions Full list of individual permissions per
   *  participant/track. Any omitted participants will not receive any permissions.
   */
  setTrackSubscriptionPermissions(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    this.participantTrackPermissions = t, this.allParticipantsAllowedToSubscribe = e, this.engine.client.isDisconnected || this.updateTrackSubscriptionPermissions();
  }
  handleIncomingRpcAck(e) {
    const t = this.pendingAcks.get(e);
    t && (t.resolve(), this.pendingAcks.delete(e));
  }
  handleIncomingRpcResponse(e, t, n) {
    const r = this.pendingResponses.get(e);
    r && (r.resolve(t, n), this.pendingResponses.delete(e));
  }
  /** @internal */
  publishRpcRequest(e, t, n, r, s) {
    return m(this, void 0, void 0, function* () {
      const a = new ke({
        destinationIdentities: [e],
        kind: q.RELIABLE,
        value: {
          case: "rpcRequest",
          value: new va({
            id: t,
            method: n,
            payload: r,
            responseTimeoutMs: s,
            version: 1
          })
        }
      });
      yield this.engine.sendDataPacket(a, q.RELIABLE);
    });
  }
  /** @internal */
  handleParticipantDisconnected(e) {
    for (const [t, {
      participantIdentity: n
    }] of this.pendingAcks)
      n === e && this.pendingAcks.delete(t);
    for (const [t, {
      participantIdentity: n,
      resolve: r
    }] of this.pendingResponses)
      n === e && (r(null, ne.builtIn("RECIPIENT_DISCONNECTED")), this.pendingResponses.delete(t));
  }
  /** @internal */
  setEnabledPublishCodecs(e) {
    this.enabledPublishVideoCodecs = e.filter((t) => t.mime.split("/")[0].toLowerCase() === "video");
  }
  /** @internal */
  updateInfo(e) {
    return super.updateInfo(e) ? (e.tracks.forEach((t) => {
      var n, r;
      const s = this.trackPublications.get(t.sid);
      if (s) {
        const a = s.isMuted || ((r = (n = s.track) === null || n === void 0 ? void 0 : n.isUpstreamPaused) !== null && r !== void 0 ? r : !1);
        a !== t.muted && (this.log.debug("updating server mute state after reconcile", Object.assign(Object.assign(Object.assign({}, this.logContext), W(s)), {
          mutedOnServer: a
        })), this.engine.client.sendMuteTrack(t.sid, a));
      }
    }), !0) : !1;
  }
  /** @internal */
  setActiveAgent(e) {
    var t, n, r, s;
    this.firstActiveAgent = e, e && !this.firstActiveAgent && (this.firstActiveAgent = e), e ? (n = (t = this.activeAgentFuture) === null || t === void 0 ? void 0 : t.resolve) === null || n === void 0 || n.call(t, e) : (s = (r = this.activeAgentFuture) === null || r === void 0 ? void 0 : r.reject) === null || s === void 0 || s.call(r, "Agent disconnected"), this.activeAgentFuture = void 0;
  }
  waitUntilActiveAgentPresent() {
    return this.firstActiveAgent ? Promise.resolve(this.firstActiveAgent) : (this.activeAgentFuture || (this.activeAgentFuture = new xt()), this.activeAgentFuture.promise);
  }
  getPublicationForTrack(e) {
    let t;
    return this.trackPublications.forEach((n) => {
      const r = n.track;
      r && (e instanceof MediaStreamTrack ? (Ye(r) || at(r)) && r.mediaStreamTrack === e && (t = n) : e === r && (t = n));
    }), t;
  }
  waitForPendingPublicationOfSource(e) {
    return m(this, void 0, void 0, function* () {
      const n = Date.now();
      for (; Date.now() < n + 1e4; ) {
        const r = Array.from(this.pendingPublishPromises.entries()).find((s) => {
          let [a] = s;
          return a.source === e;
        });
        if (r)
          return r[1];
        yield Ce(20);
      }
    });
  }
}
class Bl extends Xe {
  constructor(e, t, n, r) {
    super(e, t.sid, t.name, r), this.track = void 0, this.allowed = !0, this.requestedDisabled = void 0, this.visible = !0, this.handleEnded = (s) => {
      this.setTrack(void 0), this.emit(I.Ended, s);
    }, this.handleVisibilityChange = (s) => {
      this.log.debug("adaptivestream video visibility ".concat(this.trackSid, ", visible=").concat(s), this.logContext), this.visible = s, this.emitTrackUpdate();
    }, this.handleVideoDimensionsChange = (s) => {
      this.log.debug("adaptivestream video dimensions ".concat(s.width, "x").concat(s.height), this.logContext), this.videoDimensionsAdaptiveStream = s, this.emitTrackUpdate();
    }, this.subscribed = n, this.updateInfo(t);
  }
  /**
   * Subscribe or unsubscribe to this remote track
   * @param subscribed true to subscribe to a track, false to unsubscribe
   */
  setSubscribed(e) {
    const t = this.subscriptionStatus, n = this.permissionStatus;
    this.subscribed = e, e && (this.allowed = !0);
    const r = new Gi({
      trackSids: [this.trackSid],
      subscribe: this.subscribed,
      participantTracks: [new Ta({
        // sending an empty participant id since TrackPublication doesn't keep it
        // this is filled in by the participant that receives this message
        participantSid: "",
        trackSids: [this.trackSid]
      })]
    });
    this.emit(I.UpdateSubscription, r), this.emitSubscriptionUpdateIfChanged(t), this.emitPermissionUpdateIfChanged(n);
  }
  get subscriptionStatus() {
    return this.subscribed === !1 ? Xe.SubscriptionStatus.Unsubscribed : super.isSubscribed ? Xe.SubscriptionStatus.Subscribed : Xe.SubscriptionStatus.Desired;
  }
  get permissionStatus() {
    return this.allowed ? Xe.PermissionStatus.Allowed : Xe.PermissionStatus.NotAllowed;
  }
  /**
   * Returns true if track is subscribed, and ready for playback
   */
  get isSubscribed() {
    return this.subscribed === !1 ? !1 : super.isSubscribed;
  }
  // returns client's desire to subscribe to a track, also true if autoSubscribe is enabled
  get isDesired() {
    return this.subscribed !== !1;
  }
  get isEnabled() {
    return this.requestedDisabled !== void 0 ? !this.requestedDisabled : this.isAdaptiveStream ? this.visible : !0;
  }
  get isLocal() {
    return !1;
  }
  /**
   * disable server from sending down data for this track. this is useful when
   * the participant is off screen, you may disable streaming down their video
   * to reduce bandwidth requirements
   * @param enabled
   */
  setEnabled(e) {
    !this.isManualOperationAllowed() || this.requestedDisabled === !e || (this.requestedDisabled = !e, this.emitTrackUpdate());
  }
  /**
   * for tracks that support simulcasting, adjust subscribed quality
   *
   * This indicates the highest quality the client can accept. if network
   * bandwidth does not allow, server will automatically reduce quality to
   * optimize for uninterrupted video
   */
  setVideoQuality(e) {
    !this.isManualOperationAllowed() || this.requestedMaxQuality === e || (this.requestedMaxQuality = e, this.requestedVideoDimensions = void 0, this.emitTrackUpdate());
  }
  /**
   * Explicitly set the video dimensions for this track.
   *
   * This will take precedence over adaptive stream dimensions.
   *
   * @param dimensions The video dimensions to set.
   */
  setVideoDimensions(e) {
    var t, n;
    this.isManualOperationAllowed() && (((t = this.requestedVideoDimensions) === null || t === void 0 ? void 0 : t.width) === e.width && ((n = this.requestedVideoDimensions) === null || n === void 0 ? void 0 : n.height) === e.height || (un(this.track) && (this.requestedVideoDimensions = e), this.requestedMaxQuality = void 0, this.emitTrackUpdate()));
  }
  setVideoFPS(e) {
    this.isManualOperationAllowed() && un(this.track) && this.fps !== e && (this.fps = e, this.emitTrackUpdate());
  }
  get videoQuality() {
    var e;
    return (e = this.requestedMaxQuality) !== null && e !== void 0 ? e : Ee.HIGH;
  }
  /** @internal */
  setTrack(e) {
    const t = this.subscriptionStatus, n = this.permissionStatus, r = this.track;
    r !== e && (r && (r.off(I.VideoDimensionsChanged, this.handleVideoDimensionsChange), r.off(I.VisibilityChanged, this.handleVisibilityChange), r.off(I.Ended, this.handleEnded), r.detach(), r.stopMonitor(), this.emit(I.Unsubscribed, r)), super.setTrack(e), e && (e.sid = this.trackSid, e.on(I.VideoDimensionsChanged, this.handleVideoDimensionsChange), e.on(I.VisibilityChanged, this.handleVisibilityChange), e.on(I.Ended, this.handleEnded), this.emit(I.Subscribed, e)), this.emitPermissionUpdateIfChanged(n), this.emitSubscriptionUpdateIfChanged(t));
  }
  /** @internal */
  setAllowed(e) {
    const t = this.subscriptionStatus, n = this.permissionStatus;
    this.allowed = e, this.emitPermissionUpdateIfChanged(n), this.emitSubscriptionUpdateIfChanged(t);
  }
  /** @internal */
  setSubscriptionError(e) {
    this.emit(I.SubscriptionFailed, e);
  }
  /** @internal */
  updateInfo(e) {
    super.updateInfo(e);
    const t = this.metadataMuted;
    this.metadataMuted = e.muted, this.track ? this.track.setMuted(e.muted) : t !== e.muted && this.emit(e.muted ? I.Muted : I.Unmuted);
  }
  emitSubscriptionUpdateIfChanged(e) {
    const t = this.subscriptionStatus;
    e !== t && this.emit(I.SubscriptionStatusChanged, t, e);
  }
  emitPermissionUpdateIfChanged(e) {
    this.permissionStatus !== e && this.emit(I.SubscriptionPermissionChanged, this.permissionStatus, e);
  }
  isManualOperationAllowed() {
    return this.isDesired ? !0 : (this.log.warn("cannot update track settings when not subscribed", this.logContext), !1);
  }
  get isAdaptiveStream() {
    return un(this.track) && this.track.isAdaptiveStream;
  }
  /* @internal */
  emitTrackUpdate() {
    const e = new Ia({
      trackSids: [this.trackSid],
      disabled: !this.isEnabled,
      fps: this.fps
    });
    if (this.kind === E.Kind.Video) {
      let t = this.requestedVideoDimensions;
      if (this.videoDimensionsAdaptiveStream !== void 0)
        if (t)
          Ss(this.videoDimensionsAdaptiveStream, t) && (this.log.debug("using adaptive stream dimensions instead of requested", Object.assign(Object.assign({}, this.logContext), this.videoDimensionsAdaptiveStream)), t = this.videoDimensionsAdaptiveStream);
        else if (this.requestedMaxQuality !== void 0 && this.trackInfo) {
          const n = ju(this.trackInfo, this.requestedMaxQuality);
          n && Ss(this.videoDimensionsAdaptiveStream, n) && (this.log.debug("using adaptive stream dimensions instead of max quality layer", Object.assign(Object.assign({}, this.logContext), this.videoDimensionsAdaptiveStream)), t = this.videoDimensionsAdaptiveStream);
        } else
          this.log.debug("using adaptive stream dimensions", Object.assign(Object.assign({}, this.logContext), this.videoDimensionsAdaptiveStream)), t = this.videoDimensionsAdaptiveStream;
      t ? (e.width = Math.ceil(t.width), e.height = Math.ceil(t.height)) : this.requestedMaxQuality !== void 0 ? (this.log.debug("using requested max quality", Object.assign(Object.assign({}, this.logContext), {
        quality: this.requestedMaxQuality
      })), e.quality = this.requestedMaxQuality) : (this.log.debug("using default quality", Object.assign(Object.assign({}, this.logContext), {
        quality: Ee.HIGH
      })), e.quality = Ee.HIGH);
    }
    this.emit(I.UpdateSettings, e);
  }
}
class ji extends Lo {
  /** @internal */
  static fromParticipantInfo(e, t, n) {
    return new ji(e, t.sid, t.identity, t.name, t.metadata, t.attributes, n, t.kind);
  }
  get logContext() {
    return Object.assign(Object.assign({}, super.logContext), {
      rpID: this.sid,
      remoteParticipant: this.identity
    });
  }
  /** @internal */
  constructor(e, t, n, r, s, a, o) {
    let c = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : oi.STANDARD;
    super(t, n || "", r, s, a, o, c), this.signalClient = e, this.trackPublications = /* @__PURE__ */ new Map(), this.audioTrackPublications = /* @__PURE__ */ new Map(), this.videoTrackPublications = /* @__PURE__ */ new Map(), this.volumeMap = /* @__PURE__ */ new Map();
  }
  addTrackPublication(e) {
    super.addTrackPublication(e), e.on(I.UpdateSettings, (t) => {
      this.log.debug("send update settings", Object.assign(Object.assign(Object.assign({}, this.logContext), W(e)), {
        settings: t
      })), this.signalClient.sendUpdateTrackSettings(t);
    }), e.on(I.UpdateSubscription, (t) => {
      t.participantTracks.forEach((n) => {
        n.participantSid = this.sid;
      }), this.signalClient.sendUpdateSubscription(t);
    }), e.on(I.SubscriptionPermissionChanged, (t) => {
      this.emit(C.TrackSubscriptionPermissionChanged, e, t);
    }), e.on(I.SubscriptionStatusChanged, (t) => {
      this.emit(C.TrackSubscriptionStatusChanged, e, t);
    }), e.on(I.Subscribed, (t) => {
      this.emit(C.TrackSubscribed, t, e);
    }), e.on(I.Unsubscribed, (t) => {
      this.emit(C.TrackUnsubscribed, t, e);
    }), e.on(I.SubscriptionFailed, (t) => {
      this.emit(C.TrackSubscriptionFailed, e.trackSid, t);
    });
  }
  getTrackPublication(e) {
    const t = super.getTrackPublication(e);
    if (t)
      return t;
  }
  getTrackPublicationByName(e) {
    const t = super.getTrackPublicationByName(e);
    if (t)
      return t;
  }
  /**
   * sets the volume on the participant's audio track
   * by default, this affects the microphone publication
   * a different source can be passed in as a second argument
   * if no track exists the volume will be applied when the microphone track is added
   */
  setVolume(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : E.Source.Microphone;
    this.volumeMap.set(t, e);
    const n = this.getTrackPublication(t);
    n && n.track && n.track.setVolume(e);
  }
  /**
   * gets the volume on the participant's microphone track
   */
  getVolume() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : E.Source.Microphone;
    const t = this.getTrackPublication(e);
    return t && t.track ? t.track.getVolume() : this.volumeMap.get(e);
  }
  /** @internal */
  addSubscribedMediaTrack(e, t, n, r, s, a) {
    let o = this.getTrackPublicationBySid(t);
    if (o || t.startsWith("TR") || this.trackPublications.forEach((u) => {
      !o && e.kind === u.kind.toString() && (o = u);
    }), !o) {
      if (a === 0) {
        this.log.error("could not find published track", Object.assign(Object.assign({}, this.logContext), {
          trackSid: t
        })), this.emit(C.TrackSubscriptionFailed, t);
        return;
      }
      a === void 0 && (a = 20), setTimeout(() => {
        this.addSubscribedMediaTrack(e, t, n, r, s, a - 1);
      }, 150);
      return;
    }
    if (e.readyState === "ended") {
      this.log.error("unable to subscribe because MediaStreamTrack is ended. Do not call MediaStreamTrack.stop()", Object.assign(Object.assign({}, this.logContext), W(o))), this.emit(C.TrackSubscriptionFailed, t);
      return;
    }
    const c = e.kind === "video";
    let d;
    return c ? d = new Dl(e, t, r, s) : d = new Ml(e, t, r, this.audioContext, this.audioOutput), d.source = o.source, d.isMuted = o.isMuted, d.setMediaStream(n), d.start(), o.setTrack(d), this.volumeMap.has(o.source) && Hn(d) && We(d) && d.setVolume(this.volumeMap.get(o.source)), o;
  }
  /** @internal */
  get hasMetadata() {
    return !!this.participantInfo;
  }
  /**
   * @internal
   */
  getTrackPublicationBySid(e) {
    return this.trackPublications.get(e);
  }
  /** @internal */
  updateInfo(e) {
    if (!super.updateInfo(e))
      return !1;
    const t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
    return e.tracks.forEach((r) => {
      var s, a;
      let o = this.getTrackPublicationBySid(r.sid);
      if (o)
        o.updateInfo(r);
      else {
        const c = E.kindFromProto(r.type);
        if (!c)
          return;
        o = new Bl(c, r, (s = this.signalClient.connectOptions) === null || s === void 0 ? void 0 : s.autoSubscribe, {
          loggerContextCb: () => this.logContext,
          loggerName: (a = this.loggerOptions) === null || a === void 0 ? void 0 : a.loggerName
        }), o.updateInfo(r), n.set(r.sid, o);
        const d = Array.from(this.trackPublications.values()).find((u) => u.source === (o == null ? void 0 : o.source));
        d && o.source !== E.Source.Unknown && this.log.debug("received a second track publication for ".concat(this.identity, " with the same source: ").concat(o.source), Object.assign(Object.assign({}, this.logContext), {
          oldTrack: W(d),
          newTrack: W(o)
        })), this.addTrackPublication(o);
      }
      t.set(r.sid, o);
    }), this.trackPublications.forEach((r) => {
      t.has(r.trackSid) || (this.log.trace("detected removed track on remote participant, unpublishing", Object.assign(Object.assign({}, this.logContext), W(r))), this.unpublishTrack(r.trackSid, !0));
    }), n.forEach((r) => {
      this.emit(C.TrackPublished, r);
    }), !0;
  }
  /** @internal */
  unpublishTrack(e, t) {
    const n = this.trackPublications.get(e);
    if (!n)
      return;
    const {
      track: r
    } = n;
    switch (r && (r.stop(), n.setTrack(void 0)), this.trackPublications.delete(e), n.kind) {
      case E.Kind.Audio:
        this.audioTrackPublications.delete(e);
        break;
      case E.Kind.Video:
        this.videoTrackPublications.delete(e);
        break;
    }
    t && this.emit(C.TrackUnpublished, n);
  }
  /**
   * @internal
   */
  setAudioOutput(e) {
    return m(this, void 0, void 0, function* () {
      this.audioOutput = e;
      const t = [];
      this.audioTrackPublications.forEach((n) => {
        var r;
        We(n.track) && Hn(n.track) && t.push(n.track.setSinkId((r = e.deviceId) !== null && r !== void 0 ? r : "default"));
      }), yield Promise.all(t);
    });
  }
  /** @internal */
  emit(e) {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
      n[r - 1] = arguments[r];
    return this.log.trace("participant event", Object.assign(Object.assign({}, this.logContext), {
      event: e,
      args: n
    })), super.emit(e, ...n);
  }
}
var H;
(function(i) {
  i.Disconnected = "disconnected", i.Connecting = "connecting", i.Connected = "connected", i.Reconnecting = "reconnecting", i.SignalReconnecting = "signalReconnecting";
})(H || (H = {}));
const Vl = 4 * 1e3;
class di extends He.EventEmitter {
  /**
   * Creates a new Room, the primary construct for a LiveKit session.
   * @param options
   */
  constructor(e) {
    var t, n, r, s;
    if (super(), t = this, this.state = H.Disconnected, this.activeSpeakers = [], this.isE2EEEnabled = !1, this.audioEnabled = !0, this.isVideoPlaybackBlocked = !1, this.log = G, this.bufferedEvents = [], this.isResuming = !1, this.byteStreamControllers = /* @__PURE__ */ new Map(), this.textStreamControllers = /* @__PURE__ */ new Map(), this.byteStreamHandlers = /* @__PURE__ */ new Map(), this.textStreamHandlers = /* @__PURE__ */ new Map(), this.rpcHandlers = /* @__PURE__ */ new Map(), this.connect = (a, o, c) => m(this, void 0, void 0, function* () {
      var d;
      if (!yu())
        throw Ge() ? Error("WebRTC isn't detected, have you called registerGlobals?") : Error("LiveKit doesn't seem to be supported on this browser. Try to update your browser and make sure no browser extensions are disabling webRTC.");
      const u = yield this.disconnectLock.lock();
      if (this.state === H.Connected)
        return this.log.info("already connected to room ".concat(this.name), this.logContext), u(), Promise.resolve();
      if (this.connectFuture)
        return u(), this.connectFuture.promise;
      this.setAndEmitConnectionState(H.Connecting), ((d = this.regionUrlProvider) === null || d === void 0 ? void 0 : d.getServerUrl().toString()) !== a && (this.regionUrl = void 0, this.regionUrlProvider = void 0), Gn(new URL(a)) && (this.regionUrlProvider === void 0 ? this.regionUrlProvider = new $n(a, o) : this.regionUrlProvider.updateToken(o), this.regionUrlProvider.fetchRegionSettings().then((p) => {
        var v;
        (v = this.regionUrlProvider) === null || v === void 0 || v.setServerReportedRegions(p);
      }).catch((p) => {
        this.log.warn("could not fetch region settings", Object.assign(Object.assign({}, this.logContext), {
          error: p
        }));
      }));
      const l = (p, v, f) => m(this, void 0, void 0, function* () {
        var T, g;
        this.abortController && this.abortController.abort();
        const O = new AbortController();
        this.abortController = O, u == null || u();
        try {
          yield this.attemptConnection(f != null ? f : a, o, c, O), this.abortController = void 0, p();
        } catch (w) {
          if (this.regionUrlProvider && w instanceof Q && w.reason !== K.Cancelled && w.reason !== K.NotAllowed) {
            let b = null;
            try {
              b = yield this.regionUrlProvider.getNextBestRegionUrl((T = this.abortController) === null || T === void 0 ? void 0 : T.signal);
            } catch (y) {
              if (y instanceof Q && (y.status === 401 || y.reason === K.Cancelled)) {
                this.handleDisconnect(this.options.stopLocalTrackOnUnpublish), v(y);
                return;
              }
            }
            b && !(!((g = this.abortController) === null || g === void 0) && g.signal.aborted) ? (this.log.info("Initial connection failed with ConnectionError: ".concat(w.message, ". Retrying with another region: ").concat(b), this.logContext), this.recreateEngine(), yield l(p, v, b)) : (this.handleDisconnect(this.options.stopLocalTrackOnUnpublish, Ts(w)), v(w));
          } else {
            let b = Le.UNKNOWN_REASON;
            w instanceof Q && (b = Ts(w)), this.handleDisconnect(this.options.stopLocalTrackOnUnpublish, b), v(w);
          }
        }
      }), h = this.regionUrl;
      return this.regionUrl = void 0, this.connectFuture = new xt((p, v) => {
        l(p, v, h);
      }, () => {
        this.clearConnectionFutures();
      }), this.connectFuture.promise;
    }), this.connectSignal = (a, o, c, d, u, l) => m(this, void 0, void 0, function* () {
      var h, p, v;
      const f = yield c.join(a, o, {
        autoSubscribe: d.autoSubscribe,
        adaptiveStream: typeof u.adaptiveStream == "object" ? !0 : u.adaptiveStream,
        maxRetries: d.maxRetries,
        e2eeEnabled: !!this.e2eeManager,
        websocketTimeout: d.websocketTimeout
      }, l.signal);
      let T = f.serverInfo;
      if (T || (T = {
        version: f.serverVersion,
        region: f.serverRegion
      }), this.serverInfo = T, this.log.debug("connected to Livekit Server ".concat(Object.entries(T).map((g) => {
        let [O, w] = g;
        return "".concat(O, ": ").concat(w);
      }).join(", ")), {
        room: (h = f.room) === null || h === void 0 ? void 0 : h.name,
        roomSid: (p = f.room) === null || p === void 0 ? void 0 : p.sid,
        identity: (v = f.participant) === null || v === void 0 ? void 0 : v.identity
      }), !T.version)
        throw new ru("unknown server version");
      return T.version === "0.15.1" && this.options.dynacast && (this.log.debug("disabling dynacast due to server version", this.logContext), u.dynacast = !1), f;
    }), this.applyJoinResponse = (a) => {
      const o = a.participant;
      if (this.localParticipant.sid = o.sid, this.localParticipant.identity = o.identity, this.localParticipant.setEnabledPublishCodecs(a.enabledPublishCodecs), this.options.e2ee && this.e2eeManager)
        try {
          this.e2eeManager.setSifTrailer(a.sifTrailer);
        } catch (c) {
          this.log.error(c instanceof Error ? c.message : "Could not set SifTrailer", Object.assign(Object.assign({}, this.logContext), {
            error: c
          }));
        }
      this.handleParticipantUpdates([o, ...a.otherParticipants]), a.room && this.handleRoomUpdate(a.room);
    }, this.attemptConnection = (a, o, c, d) => m(this, void 0, void 0, function* () {
      var u, l;
      this.state === H.Reconnecting || this.isResuming || !((u = this.engine) === null || u === void 0) && u.pendingReconnect ? (this.log.info("Reconnection attempt replaced by new connection attempt", this.logContext), this.recreateEngine()) : this.maybeCreateEngine(), !((l = this.regionUrlProvider) === null || l === void 0) && l.isCloud() && this.engine.setRegionUrlProvider(this.regionUrlProvider), this.acquireAudioContext(), this.connOptions = Object.assign(Object.assign({}, br), c), this.connOptions.rtcConfig && (this.engine.rtcConfig = this.connOptions.rtcConfig), this.connOptions.peerConnectionTimeout && (this.engine.peerConnectionTimeout = this.connOptions.peerConnectionTimeout);
      try {
        const h = yield this.connectSignal(a, o, this.engine, this.connOptions, this.options, d);
        this.applyJoinResponse(h), this.setupLocalParticipantEvents(), this.emit(S.SignalConnected);
      } catch (h) {
        yield this.engine.close(), this.recreateEngine();
        const p = new Q("could not establish signal connection", K.ServerUnreachable);
        throw h instanceof Error && (p.message = "".concat(p.message, ": ").concat(h.message)), h instanceof Q && (p.reason = h.reason, p.status = h.status), this.log.debug("error trying to establish signal connection", Object.assign(Object.assign({}, this.logContext), {
          error: h
        })), p;
      }
      if (d.signal.aborted)
        throw yield this.engine.close(), this.recreateEngine(), new Q("Connection attempt aborted", K.Cancelled);
      try {
        yield this.engine.waitForPCInitialConnection(this.connOptions.peerConnectionTimeout, d);
      } catch (h) {
        throw yield this.engine.close(), this.recreateEngine(), h;
      }
      Se() && this.options.disconnectOnPageLeave && (window.addEventListener("pagehide", this.onPageLeave), window.addEventListener("beforeunload", this.onPageLeave)), Se() && document.addEventListener("freeze", this.onPageLeave), this.setAndEmitConnectionState(H.Connected), this.emit(S.Connected), this.registerConnectionReconcile();
    }), this.disconnect = function() {
      for (var a = arguments.length, o = new Array(a), c = 0; c < a; c++)
        o[c] = arguments[c];
      return m(t, [...o], void 0, function() {
        var d = this;
        let u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
        return function* () {
          var l, h, p, v;
          const f = yield d.disconnectLock.lock();
          try {
            if (d.state === H.Disconnected) {
              d.log.debug("already disconnected", d.logContext);
              return;
            }
            d.log.info("disconnect from room", Object.assign({}, d.logContext)), (d.state === H.Connecting || d.state === H.Reconnecting || d.isResuming) && (d.log.warn("abort connection attempt", d.logContext), (l = d.abortController) === null || l === void 0 || l.abort(), (p = (h = d.connectFuture) === null || h === void 0 ? void 0 : h.reject) === null || p === void 0 || p.call(h, new Q("Client initiated disconnect", K.Cancelled)), d.connectFuture = void 0), !((v = d.engine) === null || v === void 0) && v.client.isDisconnected || (yield d.engine.client.sendLeave()), d.engine && (yield d.engine.close()), d.handleDisconnect(u, Le.CLIENT_INITIATED), d.engine = void 0;
          } finally {
            f();
          }
        }();
      });
    }, this.onPageLeave = () => m(this, void 0, void 0, function* () {
      this.log.info("Page leave detected, disconnecting", this.logContext), yield this.disconnect();
    }), this.startAudio = () => m(this, void 0, void 0, function* () {
      const a = [], o = Re();
      if (o && o.os === "iOS") {
        const c = "livekit-dummy-audio-el";
        let d = document.getElementById(c);
        if (!d) {
          d = document.createElement("audio"), d.id = c, d.autoplay = !0, d.hidden = !0;
          const u = dn();
          u.enabled = !0;
          const l = new MediaStream([u]);
          d.srcObject = l, document.addEventListener("visibilitychange", () => {
            d && (d.srcObject = document.hidden ? null : l, document.hidden || (this.log.debug("page visible again, triggering startAudio to resume playback and update playback status", this.logContext), this.startAudio()));
          }), document.body.append(d), this.once(S.Disconnected, () => {
            d == null || d.remove(), d = null;
          });
        }
        a.push(d);
      }
      this.remoteParticipants.forEach((c) => {
        c.audioTrackPublications.forEach((d) => {
          d.track && d.track.attachedElements.forEach((u) => {
            a.push(u);
          });
        });
      });
      try {
        yield Promise.all([this.acquireAudioContext(), ...a.map((c) => (c.muted = !1, c.play()))]), this.handleAudioPlaybackStarted();
      } catch (c) {
        throw this.handleAudioPlaybackFailed(c), c;
      }
    }), this.startVideo = () => m(this, void 0, void 0, function* () {
      const a = [];
      for (const o of this.remoteParticipants.values())
        o.videoTrackPublications.forEach((c) => {
          var d;
          (d = c.track) === null || d === void 0 || d.attachedElements.forEach((u) => {
            a.includes(u) || a.push(u);
          });
        });
      yield Promise.all(a.map((o) => o.play())).then(() => {
        this.handleVideoPlaybackStarted();
      }).catch((o) => {
        o.name === "NotAllowedError" ? this.handleVideoPlaybackFailed() : this.log.warn("Resuming video playback failed, make sure you call `startVideo` directly in a user gesture handler", this.logContext);
      });
    }), this.handleRestarting = () => {
      this.clearConnectionReconcile(), this.isResuming = !1;
      for (const a of this.remoteParticipants.values())
        this.handleParticipantDisconnected(a.identity, a);
      this.setAndEmitConnectionState(H.Reconnecting) && this.emit(S.Reconnecting);
    }, this.handleSignalRestarted = (a) => m(this, void 0, void 0, function* () {
      this.log.debug("signal reconnected to server, region ".concat(a.serverRegion), Object.assign(Object.assign({}, this.logContext), {
        region: a.serverRegion
      })), this.bufferedEvents = [], this.applyJoinResponse(a);
      try {
        yield this.localParticipant.republishAllTracks(void 0, !0);
      } catch (o) {
        this.log.error("error trying to re-publish tracks after reconnection", Object.assign(Object.assign({}, this.logContext), {
          error: o
        }));
      }
      try {
        yield this.engine.waitForRestarted(), this.log.debug("fully reconnected to server", Object.assign(Object.assign({}, this.logContext), {
          region: a.serverRegion
        }));
      } catch (o) {
        return;
      }
      this.setAndEmitConnectionState(H.Connected), this.emit(S.Reconnected), this.registerConnectionReconcile(), this.emitBufferedEvents();
    }), this.handleParticipantUpdates = (a) => {
      a.forEach((o) => {
        var c;
        if (o.identity === this.localParticipant.identity) {
          this.localParticipant.updateInfo(o);
          return;
        }
        o.identity === "" && (o.identity = (c = this.sidToIdentity.get(o.sid)) !== null && c !== void 0 ? c : "");
        let d = this.remoteParticipants.get(o.identity);
        o.state === Mt.DISCONNECTED ? this.handleParticipantDisconnected(o.identity, d) : d = this.getOrCreateParticipant(o.identity, o);
      });
    }, this.handleActiveSpeakersUpdate = (a) => {
      const o = [], c = {};
      a.forEach((d) => {
        if (c[d.sid] = !0, d.sid === this.localParticipant.sid)
          this.localParticipant.audioLevel = d.level, this.localParticipant.setIsSpeaking(!0), o.push(this.localParticipant);
        else {
          const u = this.getRemoteParticipantBySid(d.sid);
          u && (u.audioLevel = d.level, u.setIsSpeaking(!0), o.push(u));
        }
      }), c[this.localParticipant.sid] || (this.localParticipant.audioLevel = 0, this.localParticipant.setIsSpeaking(!1)), this.remoteParticipants.forEach((d) => {
        c[d.sid] || (d.audioLevel = 0, d.setIsSpeaking(!1));
      }), this.activeSpeakers = o, this.emitWhenConnected(S.ActiveSpeakersChanged, o);
    }, this.handleSpeakersChanged = (a) => {
      const o = /* @__PURE__ */ new Map();
      this.activeSpeakers.forEach((d) => {
        const u = this.remoteParticipants.get(d.identity);
        u && u.sid !== d.sid || o.set(d.sid, d);
      }), a.forEach((d) => {
        let u = this.getRemoteParticipantBySid(d.sid);
        d.sid === this.localParticipant.sid && (u = this.localParticipant), u && (u.audioLevel = d.level, u.setIsSpeaking(d.active), d.active ? o.set(d.sid, u) : o.delete(d.sid));
      });
      const c = Array.from(o.values());
      c.sort((d, u) => u.audioLevel - d.audioLevel), this.activeSpeakers = c, this.emitWhenConnected(S.ActiveSpeakersChanged, c);
    }, this.handleStreamStateUpdate = (a) => {
      a.streamStates.forEach((o) => {
        const c = this.getRemoteParticipantBySid(o.participantSid);
        if (!c)
          return;
        const d = c.getTrackPublicationBySid(o.trackSid);
        if (!d || !d.track)
          return;
        const u = E.streamStateFromProto(o.state);
        u !== d.track.streamState && (d.track.streamState = u, c.emit(C.TrackStreamStateChanged, d, d.track.streamState), this.emitWhenConnected(S.TrackStreamStateChanged, d, d.track.streamState, c));
      });
    }, this.handleSubscriptionPermissionUpdate = (a) => {
      const o = this.getRemoteParticipantBySid(a.participantSid);
      if (!o)
        return;
      const c = o.getTrackPublicationBySid(a.trackSid);
      c && c.setAllowed(a.allowed);
    }, this.handleSubscriptionError = (a) => {
      const o = Array.from(this.remoteParticipants.values()).find((d) => d.trackPublications.has(a.trackSid));
      if (!o)
        return;
      const c = o.getTrackPublicationBySid(a.trackSid);
      c && c.setSubscriptionError(a.err);
    }, this.handleDataPacket = (a) => {
      const o = this.remoteParticipants.get(a.participantIdentity);
      if (a.value.case === "user")
        this.handleUserPacket(o, a.value.value, a.kind);
      else if (a.value.case === "transcription")
        this.handleTranscription(o, a.value.value);
      else if (a.value.case === "sipDtmf")
        this.handleSipDtmf(o, a.value.value);
      else if (a.value.case === "chatMessage")
        this.handleChatMessage(o, a.value.value);
      else if (a.value.case === "metrics")
        this.handleMetrics(a.value.value, o);
      else if (a.value.case === "streamHeader")
        this.handleStreamHeader(a.value.value, a.participantIdentity);
      else if (a.value.case === "streamChunk")
        this.handleStreamChunk(a.value.value);
      else if (a.value.case === "streamTrailer")
        this.handleStreamTrailer(a.value.value);
      else if (a.value.case === "rpcRequest") {
        const c = a.value.value;
        this.handleIncomingRpcRequest(a.participantIdentity, c.id, c.method, c.payload, c.responseTimeoutMs, c.version);
      }
    }, this.handleUserPacket = (a, o, c) => {
      this.emit(S.DataReceived, o.payload, a, c, o.topic), a == null || a.emit(C.DataReceived, o.payload, c);
    }, this.handleSipDtmf = (a, o) => {
      this.emit(S.SipDTMFReceived, o, a), a == null || a.emit(C.SipDTMFReceived, o);
    }, this.bufferedSegments = /* @__PURE__ */ new Map(), this.handleTranscription = (a, o) => {
      const c = o.transcribedParticipantIdentity === this.localParticipant.identity ? this.localParticipant : this.getParticipantByIdentity(o.transcribedParticipantIdentity), d = c == null ? void 0 : c.trackPublications.get(o.trackId), u = _u(o, this.transcriptionReceivedTimes);
      d == null || d.emit(I.TranscriptionReceived, u), c == null || c.emit(C.TranscriptionReceived, u, d), this.emit(S.TranscriptionReceived, u, c, d);
    }, this.handleChatMessage = (a, o) => {
      const c = Iu(o);
      this.emit(S.ChatMessage, c, a);
    }, this.handleMetrics = (a, o) => {
      this.emit(S.MetricsReceived, a, o);
    }, this.handleAudioPlaybackStarted = () => {
      this.canPlaybackAudio || (this.audioEnabled = !0, this.emit(S.AudioPlaybackStatusChanged, !0));
    }, this.handleAudioPlaybackFailed = (a) => {
      this.log.warn("could not playback audio", Object.assign(Object.assign({}, this.logContext), {
        error: a
      })), this.canPlaybackAudio && (this.audioEnabled = !1, this.emit(S.AudioPlaybackStatusChanged, !1));
    }, this.handleVideoPlaybackStarted = () => {
      this.isVideoPlaybackBlocked && (this.isVideoPlaybackBlocked = !1, this.emit(S.VideoPlaybackStatusChanged, !0));
    }, this.handleVideoPlaybackFailed = () => {
      this.isVideoPlaybackBlocked || (this.isVideoPlaybackBlocked = !0, this.emit(S.VideoPlaybackStatusChanged, !1));
    }, this.handleDeviceChange = () => m(this, void 0, void 0, function* () {
      var a;
      ((a = Re()) === null || a === void 0 ? void 0 : a.os) !== "iOS" && (yield this.selectDefaultDevices()), this.emit(S.MediaDevicesChanged);
    }), this.handleRoomUpdate = (a) => {
      const o = this.roomInfo;
      this.roomInfo = a, o && o.metadata !== a.metadata && this.emitWhenConnected(S.RoomMetadataChanged, a.metadata), (o == null ? void 0 : o.activeRecording) !== a.activeRecording && this.emitWhenConnected(S.RecordingStatusChanged, a.activeRecording);
    }, this.handleConnectionQualityUpdate = (a) => {
      a.updates.forEach((o) => {
        if (o.participantSid === this.localParticipant.sid) {
          this.localParticipant.setConnectionQuality(o.quality);
          return;
        }
        const c = this.getRemoteParticipantBySid(o.participantSid);
        c && c.setConnectionQuality(o.quality);
      });
    }, this.onLocalParticipantMetadataChanged = (a) => {
      this.emit(S.ParticipantMetadataChanged, a, this.localParticipant);
    }, this.onLocalParticipantNameChanged = (a) => {
      this.emit(S.ParticipantNameChanged, a, this.localParticipant);
    }, this.onLocalAttributesChanged = (a) => {
      this.emit(S.ParticipantAttributesChanged, a, this.localParticipant);
    }, this.onLocalTrackMuted = (a) => {
      this.emit(S.TrackMuted, a, this.localParticipant);
    }, this.onLocalTrackUnmuted = (a) => {
      this.emit(S.TrackUnmuted, a, this.localParticipant);
    }, this.onTrackProcessorUpdate = (a) => {
      var o;
      (o = a == null ? void 0 : a.onPublish) === null || o === void 0 || o.call(a, this);
    }, this.onLocalTrackPublished = (a) => m(this, void 0, void 0, function* () {
      var o, c, d, u, l, h;
      (o = a.track) === null || o === void 0 || o.on(I.TrackProcessorUpdate, this.onTrackProcessorUpdate), (c = a.track) === null || c === void 0 || c.on(I.Restarted, this.onLocalTrackRestarted), (l = (u = (d = a.track) === null || d === void 0 ? void 0 : d.getProcessor()) === null || u === void 0 ? void 0 : u.onPublish) === null || l === void 0 || l.call(u, this), this.emit(S.LocalTrackPublished, a, this.localParticipant), Ye(a.track) && (yield a.track.checkForSilence()) && this.emit(S.LocalAudioSilenceDetected, a);
      const p = yield (h = a.track) === null || h === void 0 ? void 0 : h.getDeviceId(!1), v = Jn(a.source);
      v && p && p !== this.localParticipant.activeDeviceMap.get(v) && (this.localParticipant.activeDeviceMap.set(v, p), this.emit(S.ActiveDeviceChanged, v, p));
    }), this.onLocalTrackUnpublished = (a) => {
      var o, c;
      (o = a.track) === null || o === void 0 || o.off(I.TrackProcessorUpdate, this.onTrackProcessorUpdate), (c = a.track) === null || c === void 0 || c.off(I.Restarted, this.onLocalTrackRestarted), this.emit(S.LocalTrackUnpublished, a, this.localParticipant);
    }, this.onLocalTrackRestarted = (a) => m(this, void 0, void 0, function* () {
      const o = yield a.getDeviceId(!1), c = Jn(a.source);
      c && o && o !== this.localParticipant.activeDeviceMap.get(c) && (this.log.debug("local track restarted, setting ".concat(c, " ").concat(o, " active"), this.logContext), this.localParticipant.activeDeviceMap.set(c, o), this.emit(S.ActiveDeviceChanged, c, o));
    }), this.onLocalConnectionQualityChanged = (a) => {
      this.emit(S.ConnectionQualityChanged, a, this.localParticipant);
    }, this.onMediaDevicesError = (a, o) => {
      this.emit(S.MediaDevicesError, a, o);
    }, this.onLocalParticipantPermissionsChanged = (a) => {
      this.emit(S.ParticipantPermissionsChanged, a, this.localParticipant);
    }, this.onLocalChatMessageSent = (a) => {
      this.emit(S.ChatMessage, a, this.localParticipant);
    }, this.setMaxListeners(100), this.remoteParticipants = /* @__PURE__ */ new Map(), this.sidToIdentity = /* @__PURE__ */ new Map(), this.options = Object.assign(Object.assign({}, il), e), this.log = it((n = this.options.loggerName) !== null && n !== void 0 ? n : Ne.Room), this.transcriptionReceivedTimes = /* @__PURE__ */ new Map(), this.options.audioCaptureDefaults = Object.assign(Object.assign({}, Ro), e == null ? void 0 : e.audioCaptureDefaults), this.options.videoCaptureDefaults = Object.assign(Object.assign({}, wo), e == null ? void 0 : e.videoCaptureDefaults), this.options.publishDefaults = Object.assign(Object.assign({}, tl), e == null ? void 0 : e.publishDefaults), this.maybeCreateEngine(), this.disconnectLock = new ge(), this.localParticipant = new jl("", "", this.engine, this.options, this.rpcHandlers), this.options.videoCaptureDefaults.deviceId && this.localParticipant.activeDeviceMap.set("videoinput", lt(this.options.videoCaptureDefaults.deviceId)), this.options.audioCaptureDefaults.deviceId && this.localParticipant.activeDeviceMap.set("audioinput", lt(this.options.audioCaptureDefaults.deviceId)), !((r = this.options.audioOutput) === null || r === void 0) && r.deviceId && this.switchActiveDevice("audiooutput", lt(this.options.audioOutput.deviceId)).catch((a) => this.log.warn("Could not set audio output: ".concat(a.message), this.logContext)), this.options.e2ee && this.setupE2EE(), Se()) {
      const a = new AbortController();
      (s = navigator.mediaDevices) === null || s === void 0 || s.addEventListener("devicechange", this.handleDeviceChange, {
        signal: a.signal
      }), di.cleanupRegistry && di.cleanupRegistry.register(this, () => {
        a.abort();
      });
    }
  }
  registerTextStreamHandler(e, t) {
    if (this.textStreamHandlers.has(e))
      throw new TypeError('A text stream handler for topic "'.concat(e, '" has already been set.'));
    this.textStreamHandlers.set(e, t);
  }
  unregisterTextStreamHandler(e) {
    this.textStreamHandlers.delete(e);
  }
  registerByteStreamHandler(e, t) {
    if (this.byteStreamHandlers.has(e))
      throw new TypeError('A byte stream handler for topic "'.concat(e, '" has already been set.'));
    this.byteStreamHandlers.set(e, t);
  }
  unregisterByteStreamHandler(e) {
    this.byteStreamHandlers.delete(e);
  }
  /**
   * Establishes the participant as a receiver for calls of the specified RPC method.
   *
   * @param method - The name of the indicated RPC method
   * @param handler - Will be invoked when an RPC request for this method is received
   * @returns A promise that resolves when the method is successfully registered
   * @throws {Error} If a handler for this method is already registered (must call unregisterRpcMethod first)
   *
   * @example
   * ```typescript
   * room.localParticipant?.registerRpcMethod(
   *   'greet',
   *   async (data: RpcInvocationData) => {
   *     console.log(`Received greeting from ${data.callerIdentity}: ${data.payload}`);
   *     return `Hello, ${data.callerIdentity}!`;
   *   }
   * );
   * ```
   *
   * The handler should return a Promise that resolves to a string.
   * If unable to respond within `responseTimeout`, the request will result in an error on the caller's side.
   *
   * You may throw errors of type `RpcError` with a string `message` in the handler,
   * and they will be received on the caller's side with the message intact.
   * Other errors thrown in your handler will not be transmitted as-is, and will instead arrive to the caller as `1500` ("Application Error").
   */
  registerRpcMethod(e, t) {
    if (this.rpcHandlers.has(e))
      throw Error("RPC handler already registered for method ".concat(e, ", unregisterRpcMethod before trying to register again"));
    this.rpcHandlers.set(e, t);
  }
  /**
   * Unregisters a previously registered RPC method.
   *
   * @param method - The name of the RPC method to unregister
   */
  unregisterRpcMethod(e) {
    this.rpcHandlers.delete(e);
  }
  handleIncomingRpcRequest(e, t, n, r, s, a) {
    return m(this, void 0, void 0, function* () {
      if (yield this.engine.publishRpcAck(e, t), a !== 1) {
        yield this.engine.publishRpcResponse(e, t, null, ne.builtIn("UNSUPPORTED_VERSION"));
        return;
      }
      const o = this.rpcHandlers.get(n);
      if (!o) {
        yield this.engine.publishRpcResponse(e, t, null, ne.builtIn("UNSUPPORTED_METHOD"));
        return;
      }
      let c = null, d = null;
      try {
        const u = yield o({
          requestId: t,
          callerIdentity: e,
          payload: r,
          responseTimeout: s
        });
        yr(u) > _o ? c = ne.builtIn("RESPONSE_PAYLOAD_TOO_LARGE") : d = u;
      } catch (u) {
        u instanceof ne ? c = u : c = ne.builtIn("APPLICATION_ERROR");
      }
      yield this.engine.publishRpcResponse(e, t, d, c);
    });
  }
  /**
   * @experimental
   */
  setE2EEEnabled(e) {
    return m(this, void 0, void 0, function* () {
      if (this.e2eeManager)
        yield Promise.all([this.localParticipant.setE2EEEnabled(e)]), this.localParticipant.identity !== "" && this.e2eeManager.setParticipantCryptorEnabled(e, this.localParticipant.identity);
      else
        throw Error("e2ee not configured, please set e2ee settings within the room options");
    });
  }
  setupE2EE() {
    var e;
    this.options.e2ee && ("e2eeManager" in this.options.e2ee ? this.e2eeManager = this.options.e2ee.e2eeManager : this.e2eeManager = new Bu(this.options.e2ee), this.e2eeManager.on(dt.ParticipantEncryptionStatusChanged, (t, n) => {
      xu(n) && (this.isE2EEEnabled = t), this.emit(S.ParticipantEncryptionStatusChanged, t, n);
    }), this.e2eeManager.on(dt.EncryptionError, (t) => this.emit(S.EncryptionError, t)), (e = this.e2eeManager) === null || e === void 0 || e.setup(this));
  }
  get logContext() {
    var e;
    return {
      room: this.name,
      roomID: (e = this.roomInfo) === null || e === void 0 ? void 0 : e.sid,
      participant: this.localParticipant.identity,
      pID: this.localParticipant.sid
    };
  }
  /**
   * if the current room has a participant with `recorder: true` in its JWT grant
   **/
  get isRecording() {
    var e, t;
    return (t = (e = this.roomInfo) === null || e === void 0 ? void 0 : e.activeRecording) !== null && t !== void 0 ? t : !1;
  }
  /**
   * server assigned unique room id.
   * returns once a sid has been issued by the server.
   */
  getSid() {
    return m(this, void 0, void 0, function* () {
      return this.state === H.Disconnected ? "" : this.roomInfo && this.roomInfo.sid !== "" ? this.roomInfo.sid : new Promise((e, t) => {
        const n = (r) => {
          r.sid !== "" && (this.engine.off(M.RoomUpdate, n), e(r.sid));
        };
        this.engine.on(M.RoomUpdate, n), this.once(S.Disconnected, () => {
          this.engine.off(M.RoomUpdate, n), t("Room disconnected before room server id was available");
        });
      });
    });
  }
  /** user assigned name, derived from JWT token */
  get name() {
    var e, t;
    return (t = (e = this.roomInfo) === null || e === void 0 ? void 0 : e.name) !== null && t !== void 0 ? t : "";
  }
  /** room metadata */
  get metadata() {
    var e;
    return (e = this.roomInfo) === null || e === void 0 ? void 0 : e.metadata;
  }
  get numParticipants() {
    var e, t;
    return (t = (e = this.roomInfo) === null || e === void 0 ? void 0 : e.numParticipants) !== null && t !== void 0 ? t : 0;
  }
  get numPublishers() {
    var e, t;
    return (t = (e = this.roomInfo) === null || e === void 0 ? void 0 : e.numPublishers) !== null && t !== void 0 ? t : 0;
  }
  maybeCreateEngine() {
    this.engine && !this.engine.isClosed || (this.engine = new Pl(this.options), this.engine.on(M.ParticipantUpdate, this.handleParticipantUpdates).on(M.RoomUpdate, this.handleRoomUpdate).on(M.SpeakersChanged, this.handleSpeakersChanged).on(M.StreamStateChanged, this.handleStreamStateUpdate).on(M.ConnectionQualityUpdate, this.handleConnectionQualityUpdate).on(M.SubscriptionError, this.handleSubscriptionError).on(M.SubscriptionPermissionUpdate, this.handleSubscriptionPermissionUpdate).on(M.MediaTrackAdded, (e, t, n) => {
      this.onTrackAdded(e, t, n);
    }).on(M.Disconnected, (e) => {
      this.handleDisconnect(this.options.stopLocalTrackOnUnpublish, e);
    }).on(M.ActiveSpeakersUpdate, this.handleActiveSpeakersUpdate).on(M.DataPacketReceived, this.handleDataPacket).on(M.Resuming, () => {
      this.clearConnectionReconcile(), this.isResuming = !0, this.log.info("Resuming signal connection", this.logContext), this.setAndEmitConnectionState(H.SignalReconnecting) && this.emit(S.SignalReconnecting);
    }).on(M.Resumed, () => {
      this.registerConnectionReconcile(), this.isResuming = !1, this.log.info("Resumed signal connection", this.logContext), this.updateSubscriptions(), this.emitBufferedEvents(), this.setAndEmitConnectionState(H.Connected) && this.emit(S.Reconnected);
    }).on(M.SignalResumed, () => {
      this.bufferedEvents = [], (this.state === H.Reconnecting || this.isResuming) && this.sendSyncState();
    }).on(M.Restarting, this.handleRestarting).on(M.SignalRestarted, this.handleSignalRestarted).on(M.Offline, () => {
      this.setAndEmitConnectionState(H.Reconnecting) && this.emit(S.Reconnecting);
    }).on(M.DCBufferStatusChanged, (e, t) => {
      this.emit(S.DCBufferStatusChanged, e, t);
    }).on(M.LocalTrackSubscribed, (e) => {
      const t = this.localParticipant.getTrackPublications().find((n) => {
        let {
          trackSid: r
        } = n;
        return r === e;
      });
      if (!t) {
        this.log.warn("could not find local track subscription for subscribed event", this.logContext);
        return;
      }
      this.localParticipant.emit(C.LocalTrackSubscribed, t), this.emitWhenConnected(S.LocalTrackSubscribed, t, this.localParticipant);
    }).on(M.RoomMoved, (e) => {
      this.log.debug("room moved", e), e.room && this.handleRoomUpdate(e.room), this.remoteParticipants.forEach((t, n) => {
        this.handleParticipantDisconnected(n, t);
      }), this.emit(S.Moved, e.room.name), e.participant ? this.handleParticipantUpdates([e.participant, ...e.otherParticipants]) : this.handleParticipantUpdates(e.otherParticipants);
    }), this.localParticipant && this.localParticipant.setupEngine(this.engine), this.e2eeManager && this.e2eeManager.setupEngine(this.engine));
  }
  /**
   * getLocalDevices abstracts navigator.mediaDevices.enumerateDevices.
   * In particular, it requests device permissions by default if needed
   * and makes sure the returned device does not consist of dummy devices
   * @param kind
   * @returns a list of available local devices
   */
  static getLocalDevices(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    return he.getInstance().getDevices(e, t);
  }
  /**
   * prepareConnection should be called as soon as the page is loaded, in order
   * to speed up the connection attempt. This function will
   * - perform DNS resolution and pre-warm the DNS cache
   * - establish TLS connection and cache TLS keys
   *
   * With LiveKit Cloud, it will also determine the best edge data center for
   * the current client to connect to if a token is provided.
   */
  prepareConnection(e, t) {
    return m(this, void 0, void 0, function* () {
      if (this.state === H.Disconnected) {
        this.log.debug("prepareConnection to ".concat(e), this.logContext);
        try {
          if (Gn(new URL(e)) && t) {
            this.regionUrlProvider = new $n(e, t);
            const n = yield this.regionUrlProvider.getNextBestRegionUrl();
            n && this.state === H.Disconnected && (this.regionUrl = n, yield fetch(Kn(n), {
              method: "HEAD"
            }), this.log.debug("prepared connection to ".concat(n), this.logContext));
          } else
            yield fetch(Kn(e), {
              method: "HEAD"
            });
        } catch (n) {
          this.log.warn("could not prepare connection", Object.assign(Object.assign({}, this.logContext), {
            error: n
          }));
        }
      }
    });
  }
  /**
   * retrieves a participant by identity
   * @param identity
   * @returns
   */
  getParticipantByIdentity(e) {
    return this.localParticipant.identity === e ? this.localParticipant : this.remoteParticipants.get(e);
  }
  clearConnectionFutures() {
    this.connectFuture = void 0;
  }
  /**
   * @internal for testing
   */
  simulateScenario(e, t) {
    return m(this, void 0, void 0, function* () {
      let n = () => {
      }, r;
      switch (e) {
        case "signal-reconnect":
          yield this.engine.client.handleOnClose("simulate disconnect");
          break;
        case "speaker":
          r = new Be({
            scenario: {
              case: "speakerUpdate",
              value: 3
            }
          });
          break;
        case "node-failure":
          r = new Be({
            scenario: {
              case: "nodeFailure",
              value: !0
            }
          });
          break;
        case "server-leave":
          r = new Be({
            scenario: {
              case: "serverLeave",
              value: !0
            }
          });
          break;
        case "migration":
          r = new Be({
            scenario: {
              case: "migration",
              value: !0
            }
          });
          break;
        case "resume-reconnect":
          this.engine.failNext(), yield this.engine.client.handleOnClose("simulate resume-disconnect");
          break;
        case "disconnect-signal-on-resume":
          n = () => m(this, void 0, void 0, function* () {
            yield this.engine.client.handleOnClose("simulate resume-disconnect");
          }), r = new Be({
            scenario: {
              case: "disconnectSignalOnResume",
              value: !0
            }
          });
          break;
        case "disconnect-signal-on-resume-no-messages":
          n = () => m(this, void 0, void 0, function* () {
            yield this.engine.client.handleOnClose("simulate resume-disconnect");
          }), r = new Be({
            scenario: {
              case: "disconnectSignalOnResumeNoMessages",
              value: !0
            }
          });
          break;
        case "full-reconnect":
          this.engine.fullReconnectOnNext = !0, yield this.engine.client.handleOnClose("simulate full-reconnect");
          break;
        case "force-tcp":
        case "force-tls":
          r = new Be({
            scenario: {
              case: "switchCandidateProtocol",
              value: e === "force-tls" ? 2 : 1
            }
          }), n = () => m(this, void 0, void 0, function* () {
            const s = this.engine.client.onLeave;
            s && s(new Ki({
              reason: Le.CLIENT_INITIATED,
              action: Dt.RECONNECT
            }));
          });
          break;
        case "subscriber-bandwidth":
          if (t === void 0 || typeof t != "number")
            throw new Error("subscriber-bandwidth requires a number as argument");
          r = new Be({
            scenario: {
              case: "subscriberBandwidth",
              value: bt(t)
            }
          });
          break;
        case "leave-full-reconnect":
          r = new Be({
            scenario: {
              case: "leaveRequestFullReconnect",
              value: !0
            }
          });
      }
      r && (yield this.engine.client.sendSimulateScenario(r), yield n());
    });
  }
  /**
   * Returns true if audio playback is enabled
   */
  get canPlaybackAudio() {
    return this.audioEnabled;
  }
  /**
   * Returns true if video playback is enabled
   */
  get canPlaybackVideo() {
    return !this.isVideoPlaybackBlocked;
  }
  getActiveDevice(e) {
    return this.localParticipant.activeDeviceMap.get(e);
  }
  /**
   * Switches all active devices used in this room to the given device.
   *
   * Note: setting AudioOutput is not supported on some browsers. See [setSinkId](https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/setSinkId#browser_compatibility)
   *
   * @param kind use `videoinput` for camera track,
   *  `audioinput` for microphone track,
   *  `audiooutput` to set speaker for all incoming audio tracks
   * @param deviceId
   */
  switchActiveDevice(e, t) {
    return m(this, arguments, void 0, function(n, r) {
      var s = this;
      let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
      return function* () {
        var o, c, d, u, l, h, p;
        let v = !0, f = !1;
        const T = a ? {
          exact: r
        } : r;
        if (n === "audioinput") {
          f = s.localParticipant.audioTrackPublications.size === 0;
          const g = (o = s.getActiveDevice(n)) !== null && o !== void 0 ? o : s.options.audioCaptureDefaults.deviceId;
          s.options.audioCaptureDefaults.deviceId = T;
          const O = Array.from(s.localParticipant.audioTrackPublications.values()).filter((b) => b.source === E.Source.Microphone);
          try {
            v = (yield Promise.all(O.map((b) => {
              var y;
              return (y = b.audioTrack) === null || y === void 0 ? void 0 : y.setDeviceId(T);
            }))).every((b) => b === !0);
          } catch (b) {
            throw s.options.audioCaptureDefaults.deviceId = g, b;
          }
          const w = O.some((b) => {
            var y, P;
            return (P = (y = b.track) === null || y === void 0 ? void 0 : y.isMuted) !== null && P !== void 0 ? P : !1;
          });
          v && w && (f = !0);
        } else if (n === "videoinput") {
          f = s.localParticipant.videoTrackPublications.size === 0;
          const g = (c = s.getActiveDevice(n)) !== null && c !== void 0 ? c : s.options.videoCaptureDefaults.deviceId;
          s.options.videoCaptureDefaults.deviceId = T;
          const O = Array.from(s.localParticipant.videoTrackPublications.values()).filter((b) => b.source === E.Source.Camera);
          try {
            v = (yield Promise.all(O.map((b) => {
              var y;
              return (y = b.videoTrack) === null || y === void 0 ? void 0 : y.setDeviceId(T);
            }))).every((b) => b === !0);
          } catch (b) {
            throw s.options.videoCaptureDefaults.deviceId = g, b;
          }
          const w = O.some((b) => {
            var y, P;
            return (P = (y = b.track) === null || y === void 0 ? void 0 : y.isMuted) !== null && P !== void 0 ? P : !1;
          });
          v && w && (f = !0);
        } else if (n === "audiooutput") {
          if (f = !0, !qn() && !s.options.webAudioMix || s.options.webAudioMix && s.audioContext && !("setSinkId" in s.audioContext))
            throw new Error("cannot switch audio output, setSinkId not supported");
          s.options.webAudioMix && (r = (d = yield he.getInstance().normalizeDeviceId("audiooutput", r)) !== null && d !== void 0 ? d : ""), (u = (p = s.options).audioOutput) !== null && u !== void 0 || (p.audioOutput = {});
          const g = (l = s.getActiveDevice(n)) !== null && l !== void 0 ? l : s.options.audioOutput.deviceId;
          s.options.audioOutput.deviceId = r;
          try {
            s.options.webAudioMix && ((h = s.audioContext) === null || h === void 0 || h.setSinkId(r)), yield Promise.all(Array.from(s.remoteParticipants.values()).map((O) => O.setAudioOutput({
              deviceId: r
            })));
          } catch (O) {
            throw s.options.audioOutput.deviceId = g, O;
          }
        }
        return f && (s.localParticipant.activeDeviceMap.set(n, r), s.emit(S.ActiveDeviceChanged, n, r)), v;
      }();
    });
  }
  setupLocalParticipantEvents() {
    this.localParticipant.on(C.ParticipantMetadataChanged, this.onLocalParticipantMetadataChanged).on(C.ParticipantNameChanged, this.onLocalParticipantNameChanged).on(C.AttributesChanged, this.onLocalAttributesChanged).on(C.TrackMuted, this.onLocalTrackMuted).on(C.TrackUnmuted, this.onLocalTrackUnmuted).on(C.LocalTrackPublished, this.onLocalTrackPublished).on(C.LocalTrackUnpublished, this.onLocalTrackUnpublished).on(C.ConnectionQualityChanged, this.onLocalConnectionQualityChanged).on(C.MediaDevicesError, this.onMediaDevicesError).on(C.AudioStreamAcquired, this.startAudio).on(C.ChatMessage, this.onLocalChatMessageSent).on(C.ParticipantPermissionsChanged, this.onLocalParticipantPermissionsChanged);
  }
  recreateEngine() {
    var e;
    (e = this.engine) === null || e === void 0 || e.close(), this.engine = void 0, this.isResuming = !1, this.remoteParticipants.clear(), this.sidToIdentity.clear(), this.bufferedEvents = [], this.maybeCreateEngine();
  }
  onTrackAdded(e, t, n) {
    if (this.state === H.Connecting || this.state === H.Reconnecting) {
      const u = () => {
        this.onTrackAdded(e, t, n), l();
      }, l = () => {
        this.off(S.Reconnected, u), this.off(S.Connected, u), this.off(S.Disconnected, l);
      };
      this.once(S.Reconnected, u), this.once(S.Connected, u), this.once(S.Disconnected, l);
      return;
    }
    if (this.state === H.Disconnected) {
      this.log.warn("skipping incoming track after Room disconnected", this.logContext);
      return;
    }
    if (e.readyState === "ended") {
      this.log.info("skipping incoming track as it already ended", this.logContext);
      return;
    }
    const r = gu(t.id), s = r[0];
    let a = r[1], o = e.id;
    if (a && a.startsWith("TR") && (o = a), s === this.localParticipant.sid) {
      this.log.warn("tried to create RemoteParticipant for local participant", this.logContext);
      return;
    }
    const c = Array.from(this.remoteParticipants.values()).find((u) => u.sid === s);
    if (!c) {
      this.log.error("Tried to add a track for a participant, that's not present. Sid: ".concat(s), this.logContext);
      return;
    }
    let d;
    this.options.adaptiveStream && (typeof this.options.adaptiveStream == "object" ? d = this.options.adaptiveStream : d = {}), c.addSubscribedMediaTrack(e, o, t, n, d);
  }
  handleDisconnect() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, t = arguments.length > 1 ? arguments[1] : void 0;
    var n;
    if (this.clearConnectionReconcile(), this.isResuming = !1, this.bufferedEvents = [], this.transcriptionReceivedTimes.clear(), this.state !== H.Disconnected) {
      this.regionUrl = void 0;
      try {
        this.remoteParticipants.forEach((r) => {
          r.trackPublications.forEach((s) => {
            r.unpublishTrack(s.trackSid);
          });
        }), this.localParticipant.trackPublications.forEach((r) => {
          var s, a, o;
          r.track && this.localParticipant.unpublishTrack(r.track, e), e ? ((s = r.track) === null || s === void 0 || s.detach(), (a = r.track) === null || a === void 0 || a.stop()) : (o = r.track) === null || o === void 0 || o.stopMonitor();
        }), this.localParticipant.off(C.ParticipantMetadataChanged, this.onLocalParticipantMetadataChanged).off(C.ParticipantNameChanged, this.onLocalParticipantNameChanged).off(C.AttributesChanged, this.onLocalAttributesChanged).off(C.TrackMuted, this.onLocalTrackMuted).off(C.TrackUnmuted, this.onLocalTrackUnmuted).off(C.LocalTrackPublished, this.onLocalTrackPublished).off(C.LocalTrackUnpublished, this.onLocalTrackUnpublished).off(C.ConnectionQualityChanged, this.onLocalConnectionQualityChanged).off(C.MediaDevicesError, this.onMediaDevicesError).off(C.AudioStreamAcquired, this.startAudio).off(C.ChatMessage, this.onLocalChatMessageSent).off(C.ParticipantPermissionsChanged, this.onLocalParticipantPermissionsChanged), this.localParticipant.trackPublications.clear(), this.localParticipant.videoTrackPublications.clear(), this.localParticipant.audioTrackPublications.clear(), this.remoteParticipants.clear(), this.sidToIdentity.clear(), this.activeSpeakers = [], this.audioContext && typeof this.options.webAudioMix == "boolean" && (this.audioContext.close(), this.audioContext = void 0), Se() && (window.removeEventListener("beforeunload", this.onPageLeave), window.removeEventListener("pagehide", this.onPageLeave), window.removeEventListener("freeze", this.onPageLeave), (n = navigator.mediaDevices) === null || n === void 0 || n.removeEventListener("devicechange", this.handleDeviceChange));
      } finally {
        this.setAndEmitConnectionState(H.Disconnected), this.emit(S.Disconnected, t);
      }
    }
  }
  handleParticipantDisconnected(e, t) {
    var n;
    this.remoteParticipants.delete(e), t && (t.trackPublications.forEach((r) => {
      t.unpublishTrack(r.trackSid, !0);
    }), this.emit(S.ParticipantDisconnected, t), t.setDisconnected(), (n = this.localParticipant) === null || n === void 0 || n.handleParticipantDisconnected(t.identity));
  }
  handleStreamHeader(e, t) {
    return m(this, void 0, void 0, function* () {
      var n;
      if (e.contentHeader.case === "byteHeader") {
        const r = this.byteStreamHandlers.get(e.topic);
        if (!r) {
          this.log.debug("ignoring incoming byte stream due to no handler for topic", e.topic);
          return;
        }
        let s;
        const a = {
          id: e.streamId,
          name: (n = e.contentHeader.value.name) !== null && n !== void 0 ? n : "unknown",
          mimeType: e.mimeType,
          size: e.totalLength ? Number(e.totalLength) : void 0,
          topic: e.topic,
          timestamp: _i(e.timestamp),
          attributes: e.attributes
        }, o = new ReadableStream({
          start: (c) => {
            s = c, this.byteStreamControllers.set(e.streamId, {
              info: a,
              controller: s,
              startTime: Date.now()
            });
          }
        });
        r(new _l(a, o, _i(e.totalLength)), {
          identity: t
        });
      } else if (e.contentHeader.case === "textHeader") {
        const r = this.textStreamHandlers.get(e.topic);
        if (!r) {
          this.log.debug("ignoring incoming text stream due to no handler for topic", e.topic);
          return;
        }
        let s;
        const a = {
          id: e.streamId,
          mimeType: e.mimeType,
          size: e.totalLength ? Number(e.totalLength) : void 0,
          topic: e.topic,
          timestamp: Number(e.timestamp),
          attributes: e.attributes
        }, o = new ReadableStream({
          start: (c) => {
            s = c, this.textStreamControllers.set(e.streamId, {
              info: a,
              controller: s,
              startTime: Date.now()
            });
          }
        });
        r(new Il(a, o, _i(e.totalLength)), {
          identity: t
        });
      }
    });
  }
  handleStreamChunk(e) {
    const t = this.byteStreamControllers.get(e.streamId);
    t && e.content.length > 0 && t.controller.enqueue(e);
    const n = this.textStreamControllers.get(e.streamId);
    n && e.content.length > 0 && n.controller.enqueue(e);
  }
  handleStreamTrailer(e) {
    const t = this.textStreamControllers.get(e.streamId);
    t && (t.info.attributes = Object.assign(Object.assign({}, t.info.attributes), e.attributes), t.controller.close(), this.textStreamControllers.delete(e.streamId));
    const n = this.byteStreamControllers.get(e.streamId);
    n && (n.info.attributes = Object.assign(Object.assign({}, n.info.attributes), e.attributes), n.controller.close(), this.byteStreamControllers.delete(e.streamId));
  }
  /**
   * attempt to select the default devices if the previously selected devices are no longer available after a device change event
   */
  selectDefaultDevices() {
    return m(this, void 0, void 0, function* () {
      var e, t, n;
      const r = he.getInstance().previousDevices, s = yield he.getInstance().getDevices(void 0, !1), a = Re();
      if ((a == null ? void 0 : a.name) === "Chrome" && a.os !== "iOS")
        for (let c of s) {
          const d = r.find((u) => u.deviceId === c.deviceId);
          d && d.label !== "" && d.kind === c.kind && d.label !== c.label && this.getActiveDevice(c.kind) === "default" && this.emit(S.ActiveDeviceChanged, c.kind, c.deviceId);
        }
      const o = ["audiooutput", "audioinput", "videoinput"];
      for (let c of o) {
        const d = Du(c), u = this.localParticipant.getTrackPublication(d);
        if (u && (!((e = u.track) === null || e === void 0) && e.isUserProvided))
          continue;
        const l = s.filter((p) => p.kind === c), h = this.getActiveDevice(c);
        if (h === ((t = r.filter((p) => p.kind === c)[0]) === null || t === void 0 ? void 0 : t.deviceId) && l.length > 0 && ((n = l[0]) === null || n === void 0 ? void 0 : n.deviceId) !== h) {
          yield this.switchActiveDevice(c, l[0].deviceId);
          continue;
        }
        c === "audioinput" && !Wn() || c === "videoinput" || l.length > 0 && !l.find((p) => p.deviceId === this.getActiveDevice(c)) && // avoid switching audio output on safari without explicit user action as it leads to slowed down audio playback
        (c !== "audiooutput" || !Wn()) && (yield this.switchActiveDevice(c, l[0].deviceId));
      }
    });
  }
  acquireAudioContext() {
    return m(this, void 0, void 0, function* () {
      var e, t;
      if (typeof this.options.webAudioMix != "boolean" && this.options.webAudioMix.audioContext ? this.audioContext = this.options.webAudioMix.audioContext : (!this.audioContext || this.audioContext.state === "closed") && (this.audioContext = (e = Co()) !== null && e !== void 0 ? e : void 0), this.options.webAudioMix && this.remoteParticipants.forEach((r) => r.setAudioContext(this.audioContext)), this.localParticipant.setAudioContext(this.audioContext), this.audioContext && this.audioContext.state === "suspended")
        try {
          yield Promise.race([this.audioContext.resume(), Ce(200)]);
        } catch (r) {
          this.log.warn("Could not resume audio context", Object.assign(Object.assign({}, this.logContext), {
            error: r
          }));
        }
      const n = ((t = this.audioContext) === null || t === void 0 ? void 0 : t.state) === "running";
      n !== this.canPlaybackAudio && (this.audioEnabled = n, this.emit(S.AudioPlaybackStatusChanged, n));
    });
  }
  createParticipant(e, t) {
    var n;
    let r;
    return t ? r = ji.fromParticipantInfo(this.engine.client, t, {
      loggerContextCb: () => this.logContext,
      loggerName: this.options.loggerName
    }) : r = new ji(this.engine.client, "", e, void 0, void 0, void 0, {
      loggerContextCb: () => this.logContext,
      loggerName: this.options.loggerName
    }), this.options.webAudioMix && r.setAudioContext(this.audioContext), !((n = this.options.audioOutput) === null || n === void 0) && n.deviceId && r.setAudioOutput(this.options.audioOutput).catch((s) => this.log.warn("Could not set audio output: ".concat(s.message), this.logContext)), r;
  }
  getOrCreateParticipant(e, t) {
    if (this.remoteParticipants.has(e)) {
      const r = this.remoteParticipants.get(e);
      return t && r.updateInfo(t) && this.sidToIdentity.set(t.sid, t.identity), r;
    }
    const n = this.createParticipant(e, t);
    return this.remoteParticipants.set(e, n), this.sidToIdentity.set(t.sid, t.identity), this.emitWhenConnected(S.ParticipantConnected, n), n.on(C.TrackPublished, (r) => {
      this.emitWhenConnected(S.TrackPublished, r, n);
    }).on(C.TrackSubscribed, (r, s) => {
      r.kind === E.Kind.Audio ? (r.on(I.AudioPlaybackStarted, this.handleAudioPlaybackStarted), r.on(I.AudioPlaybackFailed, this.handleAudioPlaybackFailed)) : r.kind === E.Kind.Video && (r.on(I.VideoPlaybackFailed, this.handleVideoPlaybackFailed), r.on(I.VideoPlaybackStarted, this.handleVideoPlaybackStarted)), this.emit(S.TrackSubscribed, r, s, n);
    }).on(C.TrackUnpublished, (r) => {
      this.emit(S.TrackUnpublished, r, n);
    }).on(C.TrackUnsubscribed, (r, s) => {
      this.emit(S.TrackUnsubscribed, r, s, n);
    }).on(C.TrackMuted, (r) => {
      this.emitWhenConnected(S.TrackMuted, r, n);
    }).on(C.TrackUnmuted, (r) => {
      this.emitWhenConnected(S.TrackUnmuted, r, n);
    }).on(C.ParticipantMetadataChanged, (r) => {
      this.emitWhenConnected(S.ParticipantMetadataChanged, r, n);
    }).on(C.ParticipantNameChanged, (r) => {
      this.emitWhenConnected(S.ParticipantNameChanged, r, n);
    }).on(C.AttributesChanged, (r) => {
      this.emitWhenConnected(S.ParticipantAttributesChanged, r, n);
    }).on(C.ConnectionQualityChanged, (r) => {
      this.emitWhenConnected(S.ConnectionQualityChanged, r, n);
    }).on(C.ParticipantPermissionsChanged, (r) => {
      this.emitWhenConnected(S.ParticipantPermissionsChanged, r, n);
    }).on(C.TrackSubscriptionStatusChanged, (r, s) => {
      this.emitWhenConnected(S.TrackSubscriptionStatusChanged, r, s, n);
    }).on(C.TrackSubscriptionFailed, (r, s) => {
      this.emit(S.TrackSubscriptionFailed, r, n, s);
    }).on(C.TrackSubscriptionPermissionChanged, (r, s) => {
      this.emitWhenConnected(S.TrackSubscriptionPermissionChanged, r, s, n);
    }).on(C.Active, () => {
      this.emitWhenConnected(S.ParticipantActive, n), n.kind === oi.AGENT && this.localParticipant.setActiveAgent(n);
    }), t && n.updateInfo(t), n;
  }
  sendSyncState() {
    const e = Array.from(this.remoteParticipants.values()).reduce((n, r) => (n.push(...r.getTrackPublications()), n), []), t = this.localParticipant.getTrackPublications();
    this.engine.sendSyncState(e, t);
  }
  /**
   * After resuming, we'll need to notify the server of the current
   * subscription settings.
   */
  updateSubscriptions() {
    for (const e of this.remoteParticipants.values())
      for (const t of e.videoTrackPublications.values())
        t.isSubscribed && Ou(t) && t.emitTrackUpdate();
  }
  getRemoteParticipantBySid(e) {
    const t = this.sidToIdentity.get(e);
    if (t)
      return this.remoteParticipants.get(t);
  }
  registerConnectionReconcile() {
    this.clearConnectionReconcile();
    let e = 0;
    this.connectionReconcileInterval = pe.setInterval(() => {
      // ensure we didn't tear it down
      !this.engine || // engine detected close, but Room missed it
      this.engine.isClosed || // transports failed without notifying engine
      !this.engine.verifyTransport() ? (e++, this.log.warn("detected connection state mismatch", Object.assign(Object.assign({}, this.logContext), {
        numFailures: e,
        engine: this.engine ? {
          closed: this.engine.isClosed,
          transportsConnected: this.engine.verifyTransport()
        } : void 0
      })), e >= 3 && (this.recreateEngine(), this.handleDisconnect(this.options.stopLocalTrackOnUnpublish, Le.STATE_MISMATCH))) : e = 0;
    }, Vl);
  }
  clearConnectionReconcile() {
    this.connectionReconcileInterval && pe.clearInterval(this.connectionReconcileInterval);
  }
  setAndEmitConnectionState(e) {
    return e === this.state ? !1 : (this.state = e, this.emit(S.ConnectionStateChanged, this.state), !0);
  }
  emitBufferedEvents() {
    this.bufferedEvents.forEach((e) => {
      let [t, n] = e;
      this.emit(t, ...n);
    }), this.bufferedEvents = [];
  }
  emitWhenConnected(e) {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
      n[r - 1] = arguments[r];
    if (this.state === H.Reconnecting || this.isResuming || !this.engine || this.engine.pendingReconnect)
      this.bufferedEvents.push([e, n]);
    else if (this.state === H.Connected)
      return this.emit(e, ...n);
    return !1;
  }
  /**
   * Allows to populate a room with simulated participants.
   * No actual connection to a server will be established, all state is
   * @experimental
   */
  simulateParticipants(e) {
    return m(this, void 0, void 0, function* () {
      var t, n;
      const r = Object.assign({
        audio: !0,
        video: !0,
        useRealTracks: !1
      }, e.publish), s = Object.assign({
        count: 9,
        audio: !1,
        video: !0,
        aspectRatios: [1.66, 1.7, 1.3]
      }, e.participants);
      if (this.handleDisconnect(), this.roomInfo = new Wi({
        sid: "RM_SIMULATED",
        name: "simulated-room",
        emptyTimeout: 0,
        maxParticipants: 0,
        creationTime: Z.parse((/* @__PURE__ */ new Date()).getTime()),
        metadata: "",
        numParticipants: 1,
        numPublishers: 1,
        turnPassword: "",
        enabledCodecs: [],
        activeRecording: !1
      }), this.localParticipant.updateInfo(new Tt({
        identity: "simulated-local",
        name: "local-name"
      })), this.setupLocalParticipantEvents(), this.emit(S.SignalConnected), this.emit(S.Connected), this.setAndEmitConnectionState(H.Connected), r.video) {
        const a = new er(E.Kind.Video, new It({
          source: ae.CAMERA,
          sid: Math.floor(Math.random() * 1e4).toString(),
          type: De.AUDIO,
          name: "video-dummy"
        }), new Fi(r.useRealTracks ? (yield window.navigator.mediaDevices.getUserMedia({
          video: !0
        })).getVideoTracks()[0] : ks(160 * ((t = s.aspectRatios[0]) !== null && t !== void 0 ? t : 1), 160, !0, !0), void 0, !1, {
          loggerName: this.options.loggerName,
          loggerContextCb: () => this.logContext
        }), {
          loggerName: this.options.loggerName,
          loggerContextCb: () => this.logContext
        });
        this.localParticipant.addTrackPublication(a), this.localParticipant.emit(C.LocalTrackPublished, a);
      }
      if (r.audio) {
        const a = new er(E.Kind.Audio, new It({
          source: ae.MICROPHONE,
          sid: Math.floor(Math.random() * 1e4).toString(),
          type: De.AUDIO
        }), new Ui(r.useRealTracks ? (yield navigator.mediaDevices.getUserMedia({
          audio: !0
        })).getAudioTracks()[0] : dn(), void 0, !1, this.audioContext, {
          loggerName: this.options.loggerName,
          loggerContextCb: () => this.logContext
        }), {
          loggerName: this.options.loggerName,
          loggerContextCb: () => this.logContext
        });
        this.localParticipant.addTrackPublication(a), this.localParticipant.emit(C.LocalTrackPublished, a);
      }
      for (let a = 0; a < s.count - 1; a += 1) {
        let o = new Tt({
          sid: Math.floor(Math.random() * 1e4).toString(),
          identity: "simulated-".concat(a),
          state: Mt.ACTIVE,
          tracks: [],
          joinedAt: Z.parse(Date.now())
        });
        const c = this.getOrCreateParticipant(o.identity, o);
        if (s.video) {
          const d = ks(160 * ((n = s.aspectRatios[a % s.aspectRatios.length]) !== null && n !== void 0 ? n : 1), 160, !1, !0), u = new It({
            source: ae.CAMERA,
            sid: Math.floor(Math.random() * 1e4).toString(),
            type: De.AUDIO
          });
          c.addSubscribedMediaTrack(d, u.sid, new MediaStream([d]), new RTCRtpReceiver()), o.tracks = [...o.tracks, u];
        }
        if (s.audio) {
          const d = dn(), u = new It({
            source: ae.MICROPHONE,
            sid: Math.floor(Math.random() * 1e4).toString(),
            type: De.AUDIO
          });
          c.addSubscribedMediaTrack(d, u.sid, new MediaStream([d]), new RTCRtpReceiver()), o.tracks = [...o.tracks, u];
        }
        c.updateInfo(o);
      }
    });
  }
  // /** @internal */
  emit(e) {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
      n[r - 1] = arguments[r];
    if (e !== S.ActiveSpeakersChanged && e !== S.TranscriptionReceived) {
      const s = No(n).filter((a) => a !== void 0);
      this.log.debug("room event ".concat(e), Object.assign(Object.assign({}, this.logContext), {
        event: e,
        args: s
      }));
    }
    return super.emit(e, ...n);
  }
}
di.cleanupRegistry = typeof FinalizationRegistry != "undefined" && new FinalizationRegistry((i) => {
  i();
});
function No(i) {
  return i.map((e) => {
    if (e)
      return Array.isArray(e) ? No(e) : typeof e == "object" ? "logContext" in e ? e.logContext : void 0 : e;
  });
}
var Me;
(function(i) {
  i[i.IDLE = 0] = "IDLE", i[i.RUNNING = 1] = "RUNNING", i[i.SKIPPED = 2] = "SKIPPED", i[i.SUCCESS = 3] = "SUCCESS", i[i.FAILED = 4] = "FAILED";
})(Me || (Me = {}));
class pt extends He.EventEmitter {
  constructor(e, t) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    super(), this.status = Me.IDLE, this.logs = [], this.options = {}, this.url = e, this.token = t, this.name = this.constructor.name, this.room = new di(n.roomOptions), this.connectOptions = n.connectOptions, this.options = n;
  }
  run(e) {
    return m(this, void 0, void 0, function* () {
      if (this.status !== Me.IDLE)
        throw Error("check is running already");
      this.setStatus(Me.RUNNING);
      try {
        yield this.perform();
      } catch (t) {
        t instanceof Error && (this.options.errorsAsWarnings ? this.appendWarning(t.message) : this.appendError(t.message));
      }
      return yield this.disconnect(), yield new Promise((t) => setTimeout(t, 500)), this.status !== Me.SKIPPED && this.setStatus(this.isSuccess() ? Me.SUCCESS : Me.FAILED), e && e(), this.getInfo();
    });
  }
  isSuccess() {
    return !this.logs.some((e) => e.level === "error");
  }
  connect(e) {
    return m(this, void 0, void 0, function* () {
      return this.room.state === H.Connected ? this.room : (e || (e = this.url), yield this.room.connect(e, this.token, this.connectOptions), this.room);
    });
  }
  disconnect() {
    return m(this, void 0, void 0, function* () {
      this.room && this.room.state !== H.Disconnected && (yield this.room.disconnect(), yield new Promise((e) => setTimeout(e, 500)));
    });
  }
  skip() {
    this.setStatus(Me.SKIPPED);
  }
  switchProtocol(e) {
    return m(this, void 0, void 0, function* () {
      let t = !1, n = !1;
      if (this.room.on(S.Reconnecting, () => {
        t = !0;
      }), this.room.once(S.Reconnected, () => {
        n = !0;
      }), this.room.simulateScenario("force-".concat(e)), yield new Promise((s) => setTimeout(s, 1e3)), !t)
        return;
      const r = Date.now() + 1e4;
      for (; Date.now() < r; ) {
        if (n)
          return;
        yield Ce(100);
      }
      throw new Error("Could not reconnect using ".concat(e, " protocol after 10 seconds"));
    });
  }
  appendMessage(e) {
    this.logs.push({
      level: "info",
      message: e
    }), this.emit("update", this.getInfo());
  }
  appendWarning(e) {
    this.logs.push({
      level: "warning",
      message: e
    }), this.emit("update", this.getInfo());
  }
  appendError(e) {
    this.logs.push({
      level: "error",
      message: e
    }), this.emit("update", this.getInfo());
  }
  setStatus(e) {
    this.status = e, this.emit("update", this.getInfo());
  }
  get engine() {
    var e;
    return (e = this.room) === null || e === void 0 ? void 0 : e.engine;
  }
  getInfo() {
    return {
      logs: this.logs,
      name: this.name,
      status: this.status,
      description: this.description
    };
  }
}
class ql extends pt {
  get description() {
    return "Cloud regions";
  }
  perform() {
    return m(this, void 0, void 0, function* () {
      const e = new $n(this.url, this.token);
      if (!e.isCloud()) {
        this.skip();
        return;
      }
      const t = [], n = /* @__PURE__ */ new Set();
      for (let s = 0; s < 3; s++) {
        const a = yield e.getNextBestRegionUrl();
        if (!a)
          break;
        if (n.has(a))
          continue;
        n.add(a);
        const o = yield this.checkCloudRegion(a);
        this.appendMessage("".concat(o.region, " RTT: ").concat(o.rtt, "ms, duration: ").concat(o.duration, "ms")), t.push(o);
      }
      t.sort((s, a) => (s.duration - a.duration) * 0.5 + (s.rtt - a.rtt) * 0.5);
      const r = t[0];
      this.bestStats = r, this.appendMessage("best Cloud region: ".concat(r.region));
    });
  }
  getInfo() {
    const e = super.getInfo();
    return e.data = this.bestStats, e;
  }
  checkCloudRegion(e) {
    return m(this, void 0, void 0, function* () {
      var t, n;
      yield this.connect(e), this.options.protocol === "tcp" && (yield this.switchProtocol("tcp"));
      const r = (t = this.room.serverInfo) === null || t === void 0 ? void 0 : t.region;
      if (!r)
        throw new Error("Region not found");
      const s = yield this.room.localParticipant.streamText({
        topic: "test"
      }), a = 1e3, c = 1e6 / a, d = "A".repeat(a), u = Date.now();
      for (let v = 0; v < c; v++)
        yield s.write(d);
      yield s.close();
      const l = Date.now(), h = yield (n = this.room.engine.pcManager) === null || n === void 0 ? void 0 : n.publisher.getStats(), p = {
        region: r,
        rtt: 1e4,
        duration: l - u
      };
      return h == null || h.forEach((v) => {
        v.type === "candidate-pair" && v.nominated && (p.rtt = v.currentRoundTripTime * 1e3);
      }), yield this.disconnect(), p;
    });
  }
}
const bn = 1e4;
class Wl extends pt {
  get description() {
    return "Connection via UDP vs TCP";
  }
  perform() {
    return m(this, void 0, void 0, function* () {
      const e = yield this.checkConnectionProtocol("udp"), t = yield this.checkConnectionProtocol("tcp");
      this.bestStats = e, e.qualityLimitationDurations.bandwidth - t.qualityLimitationDurations.bandwidth > 0.5 || (e.packetsLost - t.packetsLost) / e.packetsSent > 0.01 ? (this.appendMessage("best connection quality via tcp"), this.bestStats = t) : this.appendMessage("best connection quality via udp");
      const n = this.bestStats;
      this.appendMessage("upstream bitrate: ".concat((n.bitrateTotal / n.count / 1e3 / 1e3).toFixed(2), " mbps")), this.appendMessage("RTT: ".concat((n.rttTotal / n.count * 1e3).toFixed(2), " ms")), this.appendMessage("jitter: ".concat((n.jitterTotal / n.count * 1e3).toFixed(2), " ms")), n.packetsLost > 0 && this.appendWarning("packets lost: ".concat((n.packetsLost / n.packetsSent * 100).toFixed(2), "%")), n.qualityLimitationDurations.bandwidth > 1 && this.appendWarning("bandwidth limited ".concat((n.qualityLimitationDurations.bandwidth / (bn / 1e3) * 100).toFixed(2), "%")), n.qualityLimitationDurations.cpu > 0 && this.appendWarning("cpu limited ".concat((n.qualityLimitationDurations.cpu / (bn / 1e3) * 100).toFixed(2), "%"));
    });
  }
  getInfo() {
    const e = super.getInfo();
    return e.data = this.bestStats, e;
  }
  checkConnectionProtocol(e) {
    return m(this, void 0, void 0, function* () {
      yield this.connect(), e === "tcp" ? yield this.switchProtocol("tcp") : yield this.switchProtocol("udp");
      const t = document.createElement("canvas");
      t.width = 1280, t.height = 720;
      const n = t.getContext("2d");
      if (!n)
        throw new Error("Could not get canvas context");
      let r = 0;
      const s = () => {
        r = (r + 1) % 360, n.fillStyle = "hsl(".concat(r, ", 100%, 50%)"), n.fillRect(0, 0, t.width, t.height), requestAnimationFrame(s);
      };
      s();
      const o = t.captureStream(30).getVideoTracks()[0], d = (yield this.room.localParticipant.publishTrack(o, {
        simulcast: !1,
        degradationPreference: "maintain-resolution",
        videoEncoding: {
          maxBitrate: 2e6
        }
      })).track, u = {
        protocol: e,
        packetsLost: 0,
        packetsSent: 0,
        qualityLimitationDurations: {},
        rttTotal: 0,
        jitterTotal: 0,
        bitrateTotal: 0,
        count: 0
      }, l = setInterval(() => m(this, void 0, void 0, function* () {
        const h = yield d.getRTCStatsReport();
        h == null || h.forEach((p) => {
          p.type === "outbound-rtp" ? (u.packetsSent = p.packetsSent, u.qualityLimitationDurations = p.qualityLimitationDurations, u.bitrateTotal += p.targetBitrate, u.count++) : p.type === "remote-inbound-rtp" && (u.packetsLost = p.packetsLost, u.rttTotal += p.roundTripTime, u.jitterTotal += p.jitter);
        });
      }), 1e3);
      return yield new Promise((h) => setTimeout(h, bn)), clearInterval(l), o.stop(), t.remove(), yield this.disconnect(), u;
    });
  }
}
class Gl extends pt {
  get description() {
    return "Can publish audio";
  }
  perform() {
    return m(this, void 0, void 0, function* () {
      var e;
      const t = yield this.connect(), n = yield Nl();
      if (yield So(n, 1e3))
        throw new Error("unable to detect audio from microphone");
      this.appendMessage("detected audio from microphone"), t.localParticipant.publishTrack(n), yield new Promise((o) => setTimeout(o, 3e3));
      const s = yield (e = n.sender) === null || e === void 0 ? void 0 : e.getStats();
      if (!s)
        throw new Error("Could not get RTCStats");
      let a = 0;
      if (s.forEach((o) => {
        o.type === "outbound-rtp" && (o.kind === "audio" || !o.kind && o.mediaType === "audio") && (a = o.packetsSent);
      }), a === 0)
        throw new Error("Could not determine packets are sent");
      this.appendMessage("published ".concat(a, " audio packets"));
    });
  }
}
class Kl extends pt {
  get description() {
    return "Can publish video";
  }
  perform() {
    return m(this, void 0, void 0, function* () {
      var e;
      const t = yield this.connect(), n = yield Ll();
      yield this.checkForVideo(n.mediaStreamTrack), t.localParticipant.publishTrack(n), yield new Promise((a) => setTimeout(a, 5e3));
      const r = yield (e = n.sender) === null || e === void 0 ? void 0 : e.getStats();
      if (!r)
        throw new Error("Could not get RTCStats");
      let s = 0;
      if (r.forEach((a) => {
        a.type === "outbound-rtp" && (a.kind === "video" || !a.kind && a.mediaType === "video") && (s += a.packetsSent);
      }), s === 0)
        throw new Error("Could not determine packets are sent");
      this.appendMessage("published ".concat(s, " video packets"));
    });
  }
  checkForVideo(e) {
    return m(this, void 0, void 0, function* () {
      const t = new MediaStream();
      t.addTrack(e.clone());
      const n = document.createElement("video");
      n.srcObject = t, n.muted = !0, yield new Promise((r) => {
        n.onplay = () => {
          setTimeout(() => {
            var s, a, o, c;
            const d = document.createElement("canvas"), u = e.getSettings(), l = (a = (s = u.width) !== null && s !== void 0 ? s : n.videoWidth) !== null && a !== void 0 ? a : 1280, h = (c = (o = u.height) !== null && o !== void 0 ? o : n.videoHeight) !== null && c !== void 0 ? c : 720;
            d.width = l, d.height = h;
            const p = d.getContext("2d");
            p.drawImage(n, 0, 0);
            const f = p.getImageData(0, 0, d.width, d.height).data;
            let T = !0;
            for (let g = 0; g < f.length; g += 4)
              if (f[g] !== 0 || f[g + 1] !== 0 || f[g + 2] !== 0) {
                T = !1;
                break;
              }
            T ? this.appendError("camera appears to be producing only black frames") : this.appendMessage("received video frames"), r();
          }, 1e3);
        }, n.play();
      }), t.getTracks().forEach((r) => r.stop()), n.remove();
    });
  }
}
class Hl extends pt {
  get description() {
    return "Resuming connection after interruption";
  }
  perform() {
    return m(this, void 0, void 0, function* () {
      var e;
      const t = yield this.connect();
      let n = !1, r = !1, s;
      const a = new Promise((d) => {
        setTimeout(d, 5e3), s = d;
      }), o = () => {
        n = !0;
      };
      t.on(S.SignalReconnecting, o).on(S.Reconnecting, o).on(S.Reconnected, () => {
        r = !0, s(!0);
      }), (e = t.engine.client.ws) === null || e === void 0 || e.close();
      const c = t.engine.client.onClose;
      if (c && c(""), yield a, n) {
        if (!r || t.state !== H.Connected)
          throw this.appendWarning("reconnection is only possible in Redis-based configurations"), new Error("Not able to reconnect");
      } else throw new Error("Did not attempt to reconnect");
    });
  }
}
class zl extends pt {
  get description() {
    return "Can connect via TURN";
  }
  perform() {
    return m(this, void 0, void 0, function* () {
      var e, t;
      const n = new mr(), r = yield n.join(this.url, this.token, {
        autoSubscribe: !0,
        maxRetries: 0,
        e2eeEnabled: !1,
        websocketTimeout: 15e3
      });
      let s = !1, a = !1, o = !1;
      for (let c of r.iceServers)
        for (let d of c.urls)
          d.startsWith("turn:") ? (a = !0, o = !0) : d.startsWith("turns:") && (a = !0, o = !0, s = !0), d.startsWith("stun:") && (o = !0);
      o ? a && !s && this.appendWarning("TURN is configured server side, but TURN/TLS is unavailable.") : this.appendWarning("No STUN servers configured on server side."), yield n.close(), !((t = (e = this.connectOptions) === null || e === void 0 ? void 0 : e.rtcConfig) === null || t === void 0) && t.iceServers || a ? yield this.room.connect(this.url, this.token, {
        rtcConfig: {
          iceTransportPolicy: "relay"
        }
      }) : (this.appendWarning("No TURN servers configured."), this.skip(), yield new Promise((c) => setTimeout(c, 0)));
    });
  }
}
class Jl extends pt {
  get description() {
    return "Establishing WebRTC connection";
  }
  perform() {
    return m(this, void 0, void 0, function* () {
      let e = !1, t = !1;
      this.room.on(S.SignalConnected, () => {
        const n = this.room.engine.client.onTrickle;
        this.room.engine.client.onTrickle = (r, s) => {
          if (r.candidate) {
            const a = new RTCIceCandidate(r);
            let o = "".concat(a.protocol, " ").concat(a.address, ":").concat(a.port, " ").concat(a.type);
            a.address && (Ql(a.address) ? o += " (private)" : a.protocol === "tcp" && a.tcpType === "passive" ? (e = !0, o += " (passive)") : a.protocol === "udp" && (t = !0)), this.appendMessage(o);
          }
          n && n(r, s);
        }, this.room.engine.pcManager && (this.room.engine.pcManager.subscriber.onIceCandidateError = (r) => {
          r instanceof RTCPeerConnectionIceErrorEvent && this.appendWarning("error with ICE candidate: ".concat(r.errorCode, " ").concat(r.errorText, " ").concat(r.url));
        });
      });
      try {
        yield this.connect(), G.info("now the room is connected");
      } catch (n) {
        throw this.appendWarning("ports need to be open on firewall in order to connect."), n;
      }
      e || this.appendWarning("Server is not configured for ICE/TCP"), t || this.appendWarning("No public IPv4 UDP candidates were found. Your server is likely not configured correctly");
    });
  }
}
function Ql(i) {
  const e = i.split(".");
  if (e.length === 4) {
    if (e[0] === "10")
      return !0;
    if (e[0] === "192" && e[1] === "168")
      return !0;
    if (e[0] === "172") {
      const t = parseInt(e[1], 10);
      if (t >= 16 && t <= 31)
        return !0;
    }
  }
  return !1;
}
class Yl extends pt {
  get description() {
    return "Connecting to signal connection via WebSocket";
  }
  perform() {
    return m(this, void 0, void 0, function* () {
      var e, t, n;
      (this.url.startsWith("ws:") || this.url.startsWith("http:")) && this.appendWarning("Server is insecure, clients may block connections to it");
      let r = new mr();
      const s = yield r.join(this.url, this.token, {
        autoSubscribe: !0,
        maxRetries: 0,
        e2eeEnabled: !1,
        websocketTimeout: 15e3
      });
      this.appendMessage("Connected to server, version ".concat(s.serverVersion, ".")), ((e = s.serverInfo) === null || e === void 0 ? void 0 : e.edition) === Ca.Cloud && (!((t = s.serverInfo) === null || t === void 0) && t.region) && this.appendMessage("LiveKit Cloud: ".concat((n = s.serverInfo) === null || n === void 0 ? void 0 : n.region)), yield r.close();
    });
  }
}
class Qh extends He.EventEmitter {
  constructor(e, t) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    super(), this.options = {}, this.checkResults = /* @__PURE__ */ new Map(), this.url = e, this.token = t, this.options = n;
  }
  getNextCheckId() {
    const e = this.checkResults.size;
    return this.checkResults.set(e, {
      logs: [],
      status: Me.IDLE,
      name: "",
      description: ""
    }), e;
  }
  updateCheck(e, t) {
    this.checkResults.set(e, t), this.emit("checkUpdate", e, t);
  }
  isSuccess() {
    return Array.from(this.checkResults.values()).every((e) => e.status !== Me.FAILED);
  }
  getResults() {
    return Array.from(this.checkResults.values());
  }
  createAndRunCheck(e) {
    return m(this, void 0, void 0, function* () {
      const t = this.getNextCheckId(), n = new e(this.url, this.token, this.options), r = (a) => {
        this.updateCheck(t, a);
      };
      n.on("update", r);
      const s = yield n.run();
      return n.off("update", r), s;
    });
  }
  checkWebsocket() {
    return m(this, void 0, void 0, function* () {
      return this.createAndRunCheck(Yl);
    });
  }
  checkWebRTC() {
    return m(this, void 0, void 0, function* () {
      return this.createAndRunCheck(Jl);
    });
  }
  checkTURN() {
    return m(this, void 0, void 0, function* () {
      return this.createAndRunCheck(zl);
    });
  }
  checkReconnect() {
    return m(this, void 0, void 0, function* () {
      return this.createAndRunCheck(Hl);
    });
  }
  checkPublishAudio() {
    return m(this, void 0, void 0, function* () {
      return this.createAndRunCheck(Gl);
    });
  }
  checkPublishVideo() {
    return m(this, void 0, void 0, function* () {
      return this.createAndRunCheck(Kl);
    });
  }
  checkConnectionProtocol() {
    return m(this, void 0, void 0, function* () {
      const e = yield this.createAndRunCheck(Wl);
      if (e.data && "protocol" in e.data) {
        const t = e.data;
        this.options.protocol = t.protocol;
      }
      return e;
    });
  }
  checkCloudRegion() {
    return m(this, void 0, void 0, function* () {
      return this.createAndRunCheck(ql);
    });
  }
}
function Xl(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
var Oi = { exports: {} }, $l = Oi.exports, Bs;
function Zl() {
  return Bs || (Bs = 1, function(i) {
    (function(e, t) {
      i.exports ? i.exports = t() : e.log = t();
    })($l, function() {
      var e = function() {
      }, t = "undefined", n = typeof window !== t && typeof window.navigator !== t && /Trident\/|MSIE /.test(window.navigator.userAgent), r = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
      ], s = {}, a = null;
      function o(f, T) {
        var g = f[T];
        if (typeof g.bind == "function")
          return g.bind(f);
        try {
          return Function.prototype.bind.call(g, f);
        } catch (O) {
          return function() {
            return Function.prototype.apply.apply(g, [f, arguments]);
          };
        }
      }
      function c() {
        console.log && (console.log.apply || Function.prototype.apply.apply(console.log, [console, arguments]));
      }
      function d(f) {
        return f === "debug" && (f = "log"), typeof console === t ? !1 : f === "trace" && n ? c : console[f] !== void 0 ? o(console, f) : console.log !== void 0 ? o(console, "log") : e;
      }
      function u() {
        for (var f = this.getLevel(), T = 0; T < r.length; T++) {
          var g = r[T];
          this[g] = T < f ? e : this.methodFactory(g, f, this.name);
        }
        if (this.log = this.debug, typeof console === t && f < this.levels.SILENT)
          return "No console available for logging";
      }
      function l(f) {
        return function() {
          typeof console !== t && (u.call(this), this[f].apply(this, arguments));
        };
      }
      function h(f, T, g) {
        return d(f) || l.apply(this, arguments);
      }
      function p(f, T) {
        var g = this, O, w, b, y = "loglevel";
        typeof f == "string" ? y += ":" + f : typeof f == "symbol" && (y = void 0);
        function P(_) {
          var U = (r[_] || "silent").toUpperCase();
          if (!(typeof window === t || !y)) {
            try {
              window.localStorage[y] = U;
              return;
            } catch (V) {
            }
            try {
              window.document.cookie = encodeURIComponent(y) + "=" + U + ";";
            } catch (V) {
            }
          }
        }
        function D() {
          var _;
          if (!(typeof window === t || !y)) {
            try {
              _ = window.localStorage[y];
            } catch (N) {
            }
            if (typeof _ === t)
              try {
                var U = window.document.cookie, V = encodeURIComponent(y), oe = U.indexOf(V + "=");
                oe !== -1 && (_ = /^([^;]+)/.exec(
                  U.slice(oe + V.length + 1)
                )[1]);
              } catch (N) {
              }
            return g.levels[_] === void 0 && (_ = void 0), _;
          }
        }
        function A() {
          if (!(typeof window === t || !y)) {
            try {
              window.localStorage.removeItem(y);
            } catch (_) {
            }
            try {
              window.document.cookie = encodeURIComponent(y) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch (_) {
            }
          }
        }
        function x(_) {
          var U = _;
          if (typeof U == "string" && g.levels[U.toUpperCase()] !== void 0 && (U = g.levels[U.toUpperCase()]), typeof U == "number" && U >= 0 && U <= g.levels.SILENT)
            return U;
          throw new TypeError("log.setLevel() called with invalid level: " + _);
        }
        g.name = f, g.levels = {
          TRACE: 0,
          DEBUG: 1,
          INFO: 2,
          WARN: 3,
          ERROR: 4,
          SILENT: 5
        }, g.methodFactory = T || h, g.getLevel = function() {
          return b != null ? b : w != null ? w : O;
        }, g.setLevel = function(_, U) {
          return b = x(_), U !== !1 && P(b), u.call(g);
        }, g.setDefaultLevel = function(_) {
          w = x(_), D() || g.setLevel(_, !1);
        }, g.resetLevel = function() {
          b = null, A(), u.call(g);
        }, g.enableAll = function(_) {
          g.setLevel(g.levels.TRACE, _);
        }, g.disableAll = function(_) {
          g.setLevel(g.levels.SILENT, _);
        }, g.rebuild = function() {
          if (a !== g && (O = x(a.getLevel())), u.call(g), a === g)
            for (var _ in s)
              s[_].rebuild();
        }, O = x(
          a ? a.getLevel() : "WARN"
        );
        var L = D();
        L != null && (b = x(L)), u.call(g);
      }
      a = new p(), a.getLogger = function(T) {
        if (typeof T != "symbol" && typeof T != "string" || T === "")
          throw new TypeError("You must supply a name when creating a logger.");
        var g = s[T];
        return g || (g = s[T] = new p(
          T,
          a.methodFactory
        )), g;
      };
      var v = typeof window !== t ? window.log : void 0;
      return a.noConflict = function() {
        return typeof window !== t && window.log === a && (window.log = v), a;
      }, a.getLoggers = function() {
        return s;
      }, a.default = a, a;
    });
  }(Oi)), Oi.exports;
}
var eh = Zl();
const th = /* @__PURE__ */ Xl(eh);
var tr = function(i, e) {
  return tr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
    t.__proto__ = n;
  } || function(t, n) {
    for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }, tr(i, e);
};
function Vt(i, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  tr(i, e);
  function t() {
    this.constructor = i;
  }
  i.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
function ih(i, e, t, n) {
  function r(s) {
    return s instanceof t ? s : new t(function(a) {
      a(s);
    });
  }
  return new (t || (t = Promise))(function(s, a) {
    function o(u) {
      try {
        d(n.next(u));
      } catch (l) {
        a(l);
      }
    }
    function c(u) {
      try {
        d(n.throw(u));
      } catch (l) {
        a(l);
      }
    }
    function d(u) {
      u.done ? s(u.value) : r(u.value).then(o, c);
    }
    d((n = n.apply(i, e || [])).next());
  });
}
function Uo(i, e) {
  var t = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, r, s, a = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return a.next = o(0), a.throw = o(1), a.return = o(2), typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function o(d) {
    return function(u) {
      return c([d, u]);
    };
  }
  function c(d) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, d[0] && (t = 0)), t; ) try {
      if (n = 1, r && (s = d[0] & 2 ? r.return : d[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, d[1])).done) return s;
      switch (r = 0, s && (d = [d[0] & 2, s.value]), d[0]) {
        case 0:
        case 1:
          s = d;
          break;
        case 4:
          return t.label++, { value: d[1], done: !1 };
        case 5:
          t.label++, r = d[1], d = [0];
          continue;
        case 7:
          d = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (s = t.trys, !(s = s.length > 0 && s[s.length - 1]) && (d[0] === 6 || d[0] === 2)) {
            t = 0;
            continue;
          }
          if (d[0] === 3 && (!s || d[1] > s[0] && d[1] < s[3])) {
            t.label = d[1];
            break;
          }
          if (d[0] === 6 && t.label < s[1]) {
            t.label = s[1], s = d;
            break;
          }
          if (s && t.label < s[2]) {
            t.label = s[2], t.ops.push(d);
            break;
          }
          s[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      d = e.call(i, t);
    } catch (u) {
      d = [6, u], r = 0;
    } finally {
      n = s = 0;
    }
    if (d[0] & 5) throw d[1];
    return { value: d[0] ? d[1] : void 0, done: !0 };
  }
}
function ui(i) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && i[e], n = 0;
  if (t) return t.call(i);
  if (i && typeof i.length == "number") return {
    next: function() {
      return i && n >= i.length && (i = void 0), { value: i && i[n++], done: !i };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Bi(i, e) {
  var t = typeof Symbol == "function" && i[Symbol.iterator];
  if (!t) return i;
  var n = t.call(i), r, s = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(r = n.next()).done; ) s.push(r.value);
  } catch (o) {
    a = { error: o };
  } finally {
    try {
      r && !r.done && (t = n.return) && t.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return s;
}
function Vi(i, e, t) {
  if (t || arguments.length === 2) for (var n = 0, r = e.length, s; n < r; n++)
    (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return i.concat(s || Array.prototype.slice.call(e));
}
function Ft(i) {
  return this instanceof Ft ? (this.v = i, this) : new Ft(i);
}
function nh(i, e, t) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = t.apply(i, e || []), r, s = [];
  return r = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), o("next"), o("throw"), o("return", a), r[Symbol.asyncIterator] = function() {
    return this;
  }, r;
  function a(p) {
    return function(v) {
      return Promise.resolve(v).then(p, l);
    };
  }
  function o(p, v) {
    n[p] && (r[p] = function(f) {
      return new Promise(function(T, g) {
        s.push([p, f, T, g]) > 1 || c(p, f);
      });
    }, v && (r[p] = v(r[p])));
  }
  function c(p, v) {
    try {
      d(n[p](v));
    } catch (f) {
      h(s[0][3], f);
    }
  }
  function d(p) {
    p.value instanceof Ft ? Promise.resolve(p.value.v).then(u, l) : h(s[0][2], p);
  }
  function u(p) {
    c("next", p);
  }
  function l(p) {
    c("throw", p);
  }
  function h(p, v) {
    p(v), s.shift(), s.length && c(s[0][0], s[0][1]);
  }
}
function rh(i) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = i[Symbol.asyncIterator], t;
  return e ? e.call(i) : (i = typeof ui == "function" ? ui(i) : i[Symbol.iterator](), t = {}, n("next"), n("throw"), n("return"), t[Symbol.asyncIterator] = function() {
    return this;
  }, t);
  function n(s) {
    t[s] = i[s] && function(a) {
      return new Promise(function(o, c) {
        a = i[s](a), r(o, c, a.done, a.value);
      });
    };
  }
  function r(s, a, o, c) {
    Promise.resolve(c).then(function(d) {
      s({ value: d, done: o });
    }, a);
  }
}
function de(i) {
  return typeof i == "function";
}
function sh(i) {
  var e = function(n) {
    Error.call(n), n.stack = new Error().stack;
  }, t = i(e);
  return t.prototype = Object.create(Error.prototype), t.prototype.constructor = t, t;
}
var yn = sh(function(i) {
  return function(t) {
    i(this), this.message = t ? t.length + ` errors occurred during unsubscription:
` + t.map(function(n, r) {
      return r + 1 + ") " + n.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = t;
  };
});
function ir(i, e) {
  if (i) {
    var t = i.indexOf(e);
    0 <= t && i.splice(t, 1);
  }
}
var Qi = function() {
  function i(e) {
    this.initialTeardown = e, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return i.prototype.unsubscribe = function() {
    var e, t, n, r, s;
    if (!this.closed) {
      this.closed = !0;
      var a = this._parentage;
      if (a)
        if (this._parentage = null, Array.isArray(a))
          try {
            for (var o = ui(a), c = o.next(); !c.done; c = o.next()) {
              var d = c.value;
              d.remove(this);
            }
          } catch (f) {
            e = { error: f };
          } finally {
            try {
              c && !c.done && (t = o.return) && t.call(o);
            } finally {
              if (e) throw e.error;
            }
          }
        else
          a.remove(this);
      var u = this.initialTeardown;
      if (de(u))
        try {
          u();
        } catch (f) {
          s = f instanceof yn ? f.errors : [f];
        }
      var l = this._finalizers;
      if (l) {
        this._finalizers = null;
        try {
          for (var h = ui(l), p = h.next(); !p.done; p = h.next()) {
            var v = p.value;
            try {
              Vs(v);
            } catch (f) {
              s = s != null ? s : [], f instanceof yn ? s = Vi(Vi([], Bi(s)), Bi(f.errors)) : s.push(f);
            }
          }
        } catch (f) {
          n = { error: f };
        } finally {
          try {
            p && !p.done && (r = h.return) && r.call(h);
          } finally {
            if (n) throw n.error;
          }
        }
      }
      if (s)
        throw new yn(s);
    }
  }, i.prototype.add = function(e) {
    var t;
    if (e && e !== this)
      if (this.closed)
        Vs(e);
      else {
        if (e instanceof i) {
          if (e.closed || e._hasParent(this))
            return;
          e._addParent(this);
        }
        (this._finalizers = (t = this._finalizers) !== null && t !== void 0 ? t : []).push(e);
      }
  }, i.prototype._hasParent = function(e) {
    var t = this._parentage;
    return t === e || Array.isArray(t) && t.includes(e);
  }, i.prototype._addParent = function(e) {
    var t = this._parentage;
    this._parentage = Array.isArray(t) ? (t.push(e), t) : t ? [t, e] : e;
  }, i.prototype._removeParent = function(e) {
    var t = this._parentage;
    t === e ? this._parentage = null : Array.isArray(t) && ir(t, e);
  }, i.prototype.remove = function(e) {
    var t = this._finalizers;
    t && ir(t, e), e instanceof i && e._removeParent(this);
  }, i.EMPTY = function() {
    var e = new i();
    return e.closed = !0, e;
  }(), i;
}();
Qi.EMPTY;
function Fo(i) {
  return i instanceof Qi || i && "closed" in i && de(i.remove) && de(i.add) && de(i.unsubscribe);
}
function Vs(i) {
  de(i) ? i() : i.unsubscribe();
}
var ah = {
  Promise: void 0
}, oh = {
  setTimeout: function(i, e) {
    for (var t = [], n = 2; n < arguments.length; n++)
      t[n - 2] = arguments[n];
    return setTimeout.apply(void 0, Vi([i, e], Bi(t)));
  },
  clearTimeout: function(i) {
    return clearTimeout(i);
  },
  delegate: void 0
};
function jo(i) {
  oh.setTimeout(function() {
    throw i;
  });
}
function qs() {
}
function ch(i) {
  i();
}
var Sr = function(i) {
  Vt(e, i);
  function e(t) {
    var n = i.call(this) || this;
    return n.isStopped = !1, t ? (n.destination = t, Fo(t) && t.add(n)) : n.destination = lh, n;
  }
  return e.create = function(t, n, r) {
    return new nr(t, n, r);
  }, e.prototype.next = function(t) {
    this.isStopped || this._next(t);
  }, e.prototype.error = function(t) {
    this.isStopped || (this.isStopped = !0, this._error(t));
  }, e.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, e.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, i.prototype.unsubscribe.call(this), this.destination = null);
  }, e.prototype._next = function(t) {
    this.destination.next(t);
  }, e.prototype._error = function(t) {
    try {
      this.destination.error(t);
    } finally {
      this.unsubscribe();
    }
  }, e.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, e;
}(Qi), dh = function() {
  function i(e) {
    this.partialObserver = e;
  }
  return i.prototype.next = function(e) {
    var t = this.partialObserver;
    if (t.next)
      try {
        t.next(e);
      } catch (n) {
        mi(n);
      }
  }, i.prototype.error = function(e) {
    var t = this.partialObserver;
    if (t.error)
      try {
        t.error(e);
      } catch (n) {
        mi(n);
      }
    else
      mi(e);
  }, i.prototype.complete = function() {
    var e = this.partialObserver;
    if (e.complete)
      try {
        e.complete();
      } catch (t) {
        mi(t);
      }
  }, i;
}(), nr = function(i) {
  Vt(e, i);
  function e(t, n, r) {
    var s = i.call(this) || this, a;
    return de(t) || !t ? a = {
      next: t != null ? t : void 0,
      error: n != null ? n : void 0,
      complete: r != null ? r : void 0
    } : a = t, s.destination = new dh(a), s;
  }
  return e;
}(Sr);
function mi(i) {
  jo(i);
}
function uh(i) {
  throw i;
}
var lh = {
  closed: !0,
  next: qs,
  error: uh,
  complete: qs
}, Cr = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function Bo(i) {
  return i;
}
function hh(i) {
  return i.length === 0 ? Bo : i.length === 1 ? i[0] : function(t) {
    return i.reduce(function(n, r) {
      return r(n);
    }, t);
  };
}
var we = function() {
  function i(e) {
    e && (this._subscribe = e);
  }
  return i.prototype.lift = function(e) {
    var t = new i();
    return t.source = this, t.operator = e, t;
  }, i.prototype.subscribe = function(e, t, n) {
    var r = this, s = ph(e) ? e : new nr(e, t, n);
    return ch(function() {
      var a = r, o = a.operator, c = a.source;
      s.add(o ? o.call(s, c) : c ? r._subscribe(s) : r._trySubscribe(s));
    }), s;
  }, i.prototype._trySubscribe = function(e) {
    try {
      return this._subscribe(e);
    } catch (t) {
      e.error(t);
    }
  }, i.prototype.forEach = function(e, t) {
    var n = this;
    return t = Ws(t), new t(function(r, s) {
      var a = new nr({
        next: function(o) {
          try {
            e(o);
          } catch (c) {
            s(c), a.unsubscribe();
          }
        },
        error: s,
        complete: r
      });
      n.subscribe(a);
    });
  }, i.prototype._subscribe = function(e) {
    var t;
    return (t = this.source) === null || t === void 0 ? void 0 : t.subscribe(e);
  }, i.prototype[Cr] = function() {
    return this;
  }, i.prototype.pipe = function() {
    for (var e = [], t = 0; t < arguments.length; t++)
      e[t] = arguments[t];
    return hh(e)(this);
  }, i.prototype.toPromise = function(e) {
    var t = this;
    return e = Ws(e), new e(function(n, r) {
      var s;
      t.subscribe(function(a) {
        return s = a;
      }, function(a) {
        return r(a);
      }, function() {
        return n(s);
      });
    });
  }, i.create = function(e) {
    return new i(e);
  }, i;
}();
function Ws(i) {
  var e;
  return (e = i != null ? i : ah.Promise) !== null && e !== void 0 ? e : Promise;
}
function fh(i) {
  return i && de(i.next) && de(i.error) && de(i.complete);
}
function ph(i) {
  return i && i instanceof Sr || fh(i) && Fo(i);
}
function mh(i) {
  return de(i == null ? void 0 : i.lift);
}
function qt(i) {
  return function(e) {
    if (mh(e))
      return e.lift(function(t) {
        try {
          return i(t, this);
        } catch (n) {
          this.error(n);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function li(i, e, t, n, r) {
  return new gh(i, e, t, n, r);
}
var gh = function(i) {
  Vt(e, i);
  function e(t, n, r, s, a, o) {
    var c = i.call(this, t) || this;
    return c.onFinalize = a, c.shouldUnsubscribe = o, c._next = n ? function(d) {
      try {
        n(d);
      } catch (u) {
        t.error(u);
      }
    } : i.prototype._next, c._error = s ? function(d) {
      try {
        s(d);
      } catch (u) {
        t.error(u);
      } finally {
        this.unsubscribe();
      }
    } : i.prototype._error, c._complete = r ? function() {
      try {
        r();
      } catch (d) {
        t.error(d);
      } finally {
        this.unsubscribe();
      }
    } : i.prototype._complete, c;
  }
  return e.prototype.unsubscribe = function() {
    var t;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var n = this.closed;
      i.prototype.unsubscribe.call(this), !n && ((t = this.onFinalize) === null || t === void 0 || t.call(this));
    }
  }, e;
}(Sr), vh = {
  now: function() {
    return Date.now();
  }
}, bh = function(i) {
  Vt(e, i);
  function e(t, n) {
    return i.call(this) || this;
  }
  return e.prototype.schedule = function(t, n) {
    return this;
  }, e;
}(Qi), Gs = {
  setInterval: function(i, e) {
    for (var t = [], n = 2; n < arguments.length; n++)
      t[n - 2] = arguments[n];
    return setInterval.apply(void 0, Vi([i, e], Bi(t)));
  },
  clearInterval: function(i) {
    return clearInterval(i);
  },
  delegate: void 0
}, yh = function(i) {
  Vt(e, i);
  function e(t, n) {
    var r = i.call(this, t, n) || this;
    return r.scheduler = t, r.work = n, r.pending = !1, r;
  }
  return e.prototype.schedule = function(t, n) {
    var r;
    if (n === void 0 && (n = 0), this.closed)
      return this;
    this.state = t;
    var s = this.id, a = this.scheduler;
    return s != null && (this.id = this.recycleAsyncId(a, s, n)), this.pending = !0, this.delay = n, this.id = (r = this.id) !== null && r !== void 0 ? r : this.requestAsyncId(a, this.id, n), this;
  }, e.prototype.requestAsyncId = function(t, n, r) {
    return r === void 0 && (r = 0), Gs.setInterval(t.flush.bind(t, this), r);
  }, e.prototype.recycleAsyncId = function(t, n, r) {
    if (r === void 0 && (r = 0), r != null && this.delay === r && this.pending === !1)
      return n;
    n != null && Gs.clearInterval(n);
  }, e.prototype.execute = function(t, n) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var r = this._execute(t, n);
    if (r)
      return r;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, e.prototype._execute = function(t, n) {
    var r = !1, s;
    try {
      this.work(t);
    } catch (a) {
      r = !0, s = a || new Error("Scheduled action threw falsy error");
    }
    if (r)
      return this.unsubscribe(), s;
  }, e.prototype.unsubscribe = function() {
    if (!this.closed) {
      var t = this, n = t.id, r = t.scheduler, s = r.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, ir(s, this), n != null && (this.id = this.recycleAsyncId(r, n, null)), this.delay = null, i.prototype.unsubscribe.call(this);
    }
  }, e;
}(bh), Ks = function() {
  function i(e, t) {
    t === void 0 && (t = i.now), this.schedulerActionCtor = e, this.now = t;
  }
  return i.prototype.schedule = function(e, t, n) {
    return t === void 0 && (t = 0), new this.schedulerActionCtor(this, e).schedule(n, t);
  }, i.now = vh.now, i;
}(), kh = function(i) {
  Vt(e, i);
  function e(t, n) {
    n === void 0 && (n = Ks.now);
    var r = i.call(this, t, n) || this;
    return r.actions = [], r._active = !1, r;
  }
  return e.prototype.flush = function(t) {
    var n = this.actions;
    if (this._active) {
      n.push(t);
      return;
    }
    var r;
    this._active = !0;
    do
      if (r = t.execute(t.state, t.delay))
        break;
    while (t = n.shift());
    if (this._active = !1, r) {
      for (; t = n.shift(); )
        t.unsubscribe();
      throw r;
    }
  }, e;
}(Ks), Th = new kh(yh);
function Sh(i) {
  return i && de(i.schedule);
}
function Ch(i) {
  return i[i.length - 1];
}
function Vo(i) {
  return Sh(Ch(i)) ? i.pop() : void 0;
}
var qo = function(i) {
  return i && typeof i.length == "number" && typeof i != "function";
};
function Wo(i) {
  return de(i == null ? void 0 : i.then);
}
function Go(i) {
  return de(i[Cr]);
}
function Ko(i) {
  return Symbol.asyncIterator && de(i == null ? void 0 : i[Symbol.asyncIterator]);
}
function Ho(i) {
  return new TypeError("You provided " + (i !== null && typeof i == "object" ? "an invalid object" : "'" + i + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function Ph() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var zo = Ph();
function Jo(i) {
  return de(i == null ? void 0 : i[zo]);
}
function Qo(i) {
  return nh(this, arguments, function() {
    var t, n, r, s;
    return Uo(this, function(a) {
      switch (a.label) {
        case 0:
          t = i.getReader(), a.label = 1;
        case 1:
          a.trys.push([1, , 9, 10]), a.label = 2;
        case 2:
          return [4, Ft(t.read())];
        case 3:
          return n = a.sent(), r = n.value, s = n.done, s ? [4, Ft(void 0)] : [3, 5];
        case 4:
          return [2, a.sent()];
        case 5:
          return [4, Ft(r)];
        case 6:
          return [4, a.sent()];
        case 7:
          return a.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return t.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function Yo(i) {
  return de(i == null ? void 0 : i.getReader);
}
function hi(i) {
  if (i instanceof we)
    return i;
  if (i != null) {
    if (Go(i))
      return Eh(i);
    if (qo(i))
      return Rh(i);
    if (Wo(i))
      return wh(i);
    if (Ko(i))
      return Xo(i);
    if (Jo(i))
      return _h(i);
    if (Yo(i))
      return Ih(i);
  }
  throw Ho(i);
}
function Eh(i) {
  return new we(function(e) {
    var t = i[Cr]();
    if (de(t.subscribe))
      return t.subscribe(e);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function Rh(i) {
  return new we(function(e) {
    for (var t = 0; t < i.length && !e.closed; t++)
      e.next(i[t]);
    e.complete();
  });
}
function wh(i) {
  return new we(function(e) {
    i.then(function(t) {
      e.closed || (e.next(t), e.complete());
    }, function(t) {
      return e.error(t);
    }).then(null, jo);
  });
}
function _h(i) {
  return new we(function(e) {
    var t, n;
    try {
      for (var r = ui(i), s = r.next(); !s.done; s = r.next()) {
        var a = s.value;
        if (e.next(a), e.closed)
          return;
      }
    } catch (o) {
      t = { error: o };
    } finally {
      try {
        s && !s.done && (n = r.return) && n.call(r);
      } finally {
        if (t) throw t.error;
      }
    }
    e.complete();
  });
}
function Xo(i) {
  return new we(function(e) {
    Oh(i, e).catch(function(t) {
      return e.error(t);
    });
  });
}
function Ih(i) {
  return Xo(Qo(i));
}
function Oh(i, e) {
  var t, n, r, s;
  return ih(this, void 0, void 0, function() {
    var a, o;
    return Uo(this, function(c) {
      switch (c.label) {
        case 0:
          c.trys.push([0, 5, 6, 11]), t = rh(i), c.label = 1;
        case 1:
          return [4, t.next()];
        case 2:
          if (n = c.sent(), !!n.done) return [3, 4];
          if (a = n.value, e.next(a), e.closed)
            return [2];
          c.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return o = c.sent(), r = { error: o }, [3, 11];
        case 6:
          return c.trys.push([6, , 9, 10]), n && !n.done && (s = t.return) ? [4, s.call(t)] : [3, 8];
        case 7:
          c.sent(), c.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (r) throw r.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return e.complete(), [2];
      }
    });
  });
}
function kt(i, e, t, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = !1);
  var s = e.schedule(function() {
    t(), r ? i.add(this.schedule(null, n)) : this.unsubscribe();
  }, n);
  if (i.add(s), !r)
    return s;
}
function $o(i, e) {
  return e === void 0 && (e = 0), qt(function(t, n) {
    t.subscribe(li(n, function(r) {
      return kt(n, i, function() {
        return n.next(r);
      }, e);
    }, function() {
      return kt(n, i, function() {
        return n.complete();
      }, e);
    }, function(r) {
      return kt(n, i, function() {
        return n.error(r);
      }, e);
    }));
  });
}
function Zo(i, e) {
  return e === void 0 && (e = 0), qt(function(t, n) {
    n.add(i.schedule(function() {
      return t.subscribe(n);
    }, e));
  });
}
function xh(i, e) {
  return hi(i).pipe(Zo(e), $o(e));
}
function Mh(i, e) {
  return hi(i).pipe(Zo(e), $o(e));
}
function Dh(i, e) {
  return new we(function(t) {
    var n = 0;
    return e.schedule(function() {
      n === i.length ? t.complete() : (t.next(i[n++]), t.closed || this.schedule());
    });
  });
}
function Ah(i, e) {
  return new we(function(t) {
    var n;
    return kt(t, e, function() {
      n = i[zo](), kt(t, e, function() {
        var r, s, a;
        try {
          r = n.next(), s = r.value, a = r.done;
        } catch (o) {
          t.error(o);
          return;
        }
        a ? t.complete() : t.next(s);
      }, 0, !0);
    }), function() {
      return de(n == null ? void 0 : n.return) && n.return();
    };
  });
}
function ec(i, e) {
  if (!i)
    throw new Error("Iterable cannot be null");
  return new we(function(t) {
    kt(t, e, function() {
      var n = i[Symbol.asyncIterator]();
      kt(t, e, function() {
        n.next().then(function(r) {
          r.done ? t.complete() : t.next(r.value);
        });
      }, 0, !0);
    });
  });
}
function Lh(i, e) {
  return ec(Qo(i), e);
}
function Nh(i, e) {
  if (i != null) {
    if (Go(i))
      return xh(i, e);
    if (qo(i))
      return Dh(i, e);
    if (Wo(i))
      return Mh(i, e);
    if (Ko(i))
      return ec(i, e);
    if (Jo(i))
      return Ah(i, e);
    if (Yo(i))
      return Lh(i, e);
  }
  throw Ho(i);
}
function Uh(i, e) {
  return e ? Nh(i, e) : hi(i);
}
function Wt(i, e) {
  return qt(function(t, n) {
    var r = 0;
    t.subscribe(li(n, function(s) {
      n.next(i.call(e, s, r++));
    }));
  });
}
function Fh(i, e, t, n, r, s, a, o) {
  var c = [], d = 0, u = 0, l = !1, h = function() {
    l && !c.length && !d && e.complete();
  }, p = function(f) {
    return d < n ? v(f) : c.push(f);
  }, v = function(f) {
    d++;
    var T = !1;
    hi(t(f, u++)).subscribe(li(e, function(g) {
      e.next(g);
    }, function() {
      T = !0;
    }, void 0, function() {
      if (T)
        try {
          d--;
          for (var g = function() {
            var O = c.shift();
            a || v(O);
          }; c.length && d < n; )
            g();
          h();
        } catch (O) {
          e.error(O);
        }
    }));
  };
  return i.subscribe(li(e, p, function() {
    l = !0, h();
  })), function() {
  };
}
function tc(i, e, t) {
  return t === void 0 && (t = 1 / 0), de(e) ? tc(function(n, r) {
    return Wt(function(s, a) {
      return e(n, s, r, a);
    })(hi(i(n, r)));
  }, t) : (typeof e == "number" && (t = e), qt(function(n, r) {
    return Fh(n, r, i, t);
  }));
}
function jh(i) {
  return tc(Bo, i);
}
function Bh() {
  return jh(1);
}
function Hs() {
  for (var i = [], e = 0; e < arguments.length; e++)
    i[e] = arguments[e];
  return Bh()(Uh(i, Vo(i)));
}
function Yh(i, e) {
  return e === void 0 && (e = Th), qt(function(t, n) {
    var r = null, s = null, a = null, o = function() {
      if (r) {
        r.unsubscribe(), r = null;
        var d = s;
        s = null, n.next(d);
      }
    };
    function c() {
      var d = a + i, u = e.now();
      if (u < d) {
        r = this.schedule(void 0, d - u), n.add(r);
        return;
      }
      o();
    }
    t.subscribe(li(n, function(d) {
      s = d, a = e.now(), r || (r = e.schedule(c, i), n.add(r));
    }, function() {
      o(), n.complete();
    }, void 0, function() {
      s = r = null;
    }));
  });
}
function Pr() {
  for (var i = [], e = 0; e < arguments.length; e++)
    i[e] = arguments[e];
  var t = Vo(i);
  return qt(function(n, r) {
    (t ? Hs(i, n, t) : Hs(i, n)).subscribe(r);
  });
}
var Vh = [
  S.ConnectionStateChanged,
  S.RoomMetadataChanged,
  S.ActiveSpeakersChanged,
  S.ConnectionQualityChanged,
  S.ParticipantConnected,
  S.ParticipantDisconnected,
  S.ParticipantPermissionsChanged,
  S.ParticipantMetadataChanged,
  S.ParticipantNameChanged,
  S.ParticipantAttributesChanged,
  S.TrackMuted,
  S.TrackUnmuted,
  S.TrackPublished,
  S.TrackUnpublished,
  S.TrackStreamStateChanged,
  S.TrackSubscriptionFailed,
  S.TrackSubscriptionPermissionChanged,
  S.TrackSubscriptionStatusChanged
], qh = [
  ...Vh,
  S.LocalTrackPublished,
  S.LocalTrackUnpublished
];
C.TrackPublished, C.TrackUnpublished, C.TrackMuted, C.TrackUnmuted, C.TrackStreamStateChanged, C.TrackSubscribed, C.TrackUnsubscribed, C.TrackSubscriptionPermissionChanged, C.TrackSubscriptionFailed, C.LocalTrackPublished, C.LocalTrackUnpublished;
var Wh = [
  C.ConnectionQualityChanged,
  C.IsSpeakingChanged,
  C.ParticipantMetadataChanged,
  C.ParticipantPermissionsChanged,
  C.TrackMuted,
  C.TrackUnmuted,
  C.TrackPublished,
  C.TrackUnpublished,
  C.TrackStreamStateChanged,
  C.TrackSubscriptionFailed,
  C.TrackSubscriptionPermissionChanged,
  C.TrackSubscriptionStatusChanged
];
[
  ...Wh,
  C.LocalTrackPublished,
  C.LocalTrackUnpublished
];
var ic = th.getLogger("lk-components-js");
ic.setDefaultLevel("WARN");
function nc(i, ...e) {
  return new we((n) => {
    const r = () => {
      n.next(i);
    };
    return e.forEach((a) => {
      i.on(a, r);
    }), () => {
      e.forEach((a) => {
        i.off(a, r);
      });
    };
  }).pipe(Pr(i));
}
function Gh(i, e) {
  return new we((n) => {
    const r = (...a) => {
      n.next(a);
    };
    return i.on(e, r), () => {
      i.off(e, r);
    };
  });
}
function Xh(i) {
  return nc(
    i,
    S.RoomMetadataChanged,
    S.ConnectionStateChanged
  ).pipe(
    Wt((t) => ({ name: t.name, metadata: t.metadata }))
  );
}
function $h(i) {
  return Gh(i, S.ActiveSpeakersChanged).pipe(
    Wt(([e]) => e)
  );
}
function Kh(i, ...e) {
  return new we((n) => {
    const r = () => {
      n.next(i);
    };
    return e.forEach((a) => {
      i.on(a, r);
    }), () => {
      e.forEach((a) => {
        i.off(a, r);
      });
    };
  }).pipe(Pr(i));
}
function Zh(i) {
  return Kh(
    i,
    C.TrackMuted,
    C.TrackUnmuted,
    C.ParticipantPermissionsChanged,
    // ParticipantEvent.IsSpeakingChanged,
    C.TrackPublished,
    C.TrackUnpublished,
    C.LocalTrackPublished,
    C.LocalTrackUnpublished,
    C.MediaDevicesError,
    C.TrackSubscriptionStatusChanged
    // ParticipantEvent.ConnectionQualityChanged,
  ).pipe(
    Wt((t) => {
      const { isMicrophoneEnabled: n, isCameraEnabled: r, isScreenShareEnabled: s } = t, a = t.getTrackPublication(E.Source.Microphone), o = t.getTrackPublication(E.Source.Camera);
      return {
        isCameraEnabled: r,
        isMicrophoneEnabled: n,
        isScreenShareEnabled: s,
        cameraTrack: o,
        microphoneTrack: a,
        participant: t
      };
    })
  );
}
function Hh(i, e) {
  return new we((n) => {
    const r = (...a) => {
      n.next(a);
    };
    return i.on(e, r), () => {
      i.off(e, r);
    };
  });
}
function ef(i) {
  return Hh(i, C.IsSpeakingChanged).pipe(
    Wt(([e]) => e)
  );
}
function zs(i, e, t = !0) {
  const r = [i.localParticipant, ...Array.from(i.remoteParticipants.values())], s = [];
  return r.forEach((a) => {
    e.forEach((o) => {
      const c = Array.from(
        a.trackPublications.values()
      ).filter(
        (d) => d.source === o && // either return all or only the ones that are subscribed
        (!t || d.track)
      ).map((d) => ({
        participant: a,
        publication: d,
        source: d.source
      }));
      s.push(...c);
    });
  }), { trackReferences: s, participants: r };
}
function tf(i, e, t) {
  var n, r;
  const s = (n = t.additionalRoomEvents) != null ? n : qh, a = (r = t.onlySubscribed) != null ? r : !0, o = Array.from(
    (/* @__PURE__ */ new Set([
      S.ParticipantConnected,
      S.ParticipantDisconnected,
      S.ConnectionStateChanged,
      S.LocalTrackPublished,
      S.LocalTrackUnpublished,
      S.TrackPublished,
      S.TrackUnpublished,
      S.TrackSubscriptionStatusChanged,
      ...s
    ])).values()
  );
  return nc(i, ...o).pipe(
    Wt((d) => {
      const u = zs(d, e, a);
      return ic.debug(`TrackReference[] was updated. (length ${u.trackReferences.length})`, u), u;
    }),
    Pr(zs(i, e, a))
  );
}
var xi = { exports: {} }, zh = xi.exports, Js;
function nf() {
  return Js || (Js = 1, function(i, e) {
    (function(n, r) {
      i.exports = r();
    })(typeof self != "undefined" ? self : zh, function() {
      return (
        /******/
        function(t) {
          var n = {};
          function r(s) {
            if (n[s])
              return n[s].exports;
            var a = n[s] = {
              /******/
              i: s,
              /******/
              l: !1,
              /******/
              exports: {}
              /******/
            };
            return t[s].call(a.exports, a, a.exports, r), a.l = !0, a.exports;
          }
          return r.m = t, r.c = n, r.d = function(s, a, o) {
            r.o(s, a) || Object.defineProperty(s, a, { enumerable: !0, get: o });
          }, r.r = function(s) {
            typeof Symbol != "undefined" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
          }, r.t = function(s, a) {
            if (a & 1 && (s = r(s)), a & 8 || a & 4 && typeof s == "object" && s && s.__esModule) return s;
            var o = /* @__PURE__ */ Object.create(null);
            if (r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: s }), a & 2 && typeof s != "string") for (var c in s) r.d(o, c, function(d) {
              return s[d];
            }.bind(null, c));
            return o;
          }, r.n = function(s) {
            var a = s && s.__esModule ? (
              /******/
              function() {
                return s.default;
              }
            ) : (
              /******/
              function() {
                return s;
              }
            );
            return r.d(a, "a", a), a;
          }, r.o = function(s, a) {
            return Object.prototype.hasOwnProperty.call(s, a);
          }, r.p = "", r(r.s = 1);
        }([
          /* 0 */
          /***/
          function(t, n, r) {
            n.__esModule = !0;
            var s = function(c, d, u, l, h, p, v, f) {
              for (var T, g, O, w, b, y, P, D, A = 1; A <= h; A += 1) {
                var x = A, L = Math.ceil(h / x);
                P = Math.floor(l / L), y = Math.floor(u / x), D = P / y, D > d ? (D = d, P = y * D) : D < c && (D = c, y = P / D), y = Math.min(p, y), P = Math.min(v, P);
                var _ = y * P * h;
                if (T === void 0 || _ >= T) {
                  if (f && _ === T && x * L % h > O * g % h)
                    continue;
                  T = _, w = P, b = y, g = x, O = L;
                }
              }
              return {
                maxArea: T,
                targetCols: g,
                targetRows: O,
                targetHeight: w,
                targetWidth: b,
                ratio: w / b
              };
            }, a = function(c, d) {
              var u = c.maxRatio, l = c.minRatio, h = c.fixedRatio, p = c.containerWidth, v = c.containerHeight, f = c.offsetLeft, T = f === void 0 ? 0 : f, g = c.offsetTop, O = g === void 0 ? 0 : g, w = c.alignItems, b = w === void 0 ? "center" : w, y = c.maxWidth, P = y === void 0 ? 1 / 0 : y, D = c.maxHeight, A = D === void 0 ? 1 / 0 : D, x = c.scaleLastRow, L = x === void 0 ? !0 : x, _ = c.evenRows, U = _ === void 0 ? !0 : _, V = d.map(function(Gt) {
                return Gt.height / Gt.width;
              }), oe = V.length, N;
              if (!h)
                N = s(l, u, p, v, oe, P, A, U);
              else {
                var B = V.length > 0 ? V[0] : null;
                N = s(B, B, p, v, oe, P, A, U);
              }
              for (var j = 0, ee = 0, X = [], F, ve = [], z = 0; z < V.length; z += 1) {
                z % N.targetCols === 0 && (F = {
                  ratios: [],
                  elements: [],
                  width: 0,
                  height: 0
                }, X.push(F));
                var B = V[z], Ue = d[z];
                F.elements.push(Ue), F.ratios.push(B);
                var fe = N.targetWidth, ue = N.targetHeight;
                (h || Ue.fixedRatio) && (fe = ue / B), F.width += fe, F.height = ue;
              }
              for (var me = 0, ze = 0, z = 0; z < X.length; z += 1)
                F = X[z], F.width > p ? (F.height = Math.floor(F.height * (p / F.width)), F.width = p) : F.width < p && F.height < A && (ze += 1), me += F.height;
              if (L && me < v && ze > 0) {
                var Fe = v - me;
                me = 0;
                for (var z = 0; z < X.length; z += 1) {
                  if (F = X[z], F.width < p) {
                    var Ie = Fe / ze;
                    Ie / F.height > (p - F.width) / F.width && (Ie = Math.floor((p - F.width) / F.width * F.height)), F.width += Math.floor(Ie / F.height * F.width), F.height += Ie, Fe -= Ie, ze -= 1;
                  }
                  me += F.height;
                }
              }
              switch (b) {
                case "start":
                  ee = 0;
                  break;
                case "end":
                  ee = v - me;
                  break;
                case "center":
                default:
                  ee = (v - me) / 2;
                  break;
              }
              for (var z = 0; z < X.length; z += 1) {
                F = X[z];
                var mt = void 0;
                switch (b) {
                  case "start":
                    mt = 0;
                    break;
                  case "end":
                    mt = p - F.width;
                    break;
                  case "center":
                  default:
                    mt = (p - F.width) / 2;
                    break;
                }
                j = mt;
                for (var ue = void 0, je = 0; je < F.ratios.length; je += 1) {
                  var B = F.ratios[je], Ue = F.elements[je], fe = N.targetWidth;
                  ue = F.height, h || Ue.fixedRatio ? fe = Math.floor(ue / B) : ue / fe !== N.targetHeight / N.targetWidth && (fe = Math.floor(N.targetWidth / N.targetHeight * ue)), ve.push({
                    left: j + T,
                    top: ee + O,
                    width: fe,
                    height: ue
                  }), j += fe;
                }
                ee += ue;
              }
              return ve;
            }, o = function(c) {
              return c.height / c.width;
            };
            n.default = function(c, d) {
              var u = c.maxRatio, l = u === void 0 ? 3 / 2 : u, h = c.minRatio, p = h === void 0 ? 9 / 16 : h, v = c.fixedRatio, f = v === void 0 ? !1 : v, T = c.bigPercentage, g = T === void 0 ? 0.8 : T, O = c.minBigPercentage, w = O === void 0 ? 0 : O, b = c.bigFixedRatio, y = b === void 0 ? !1 : b, P = c.bigMaxRatio, D = P === void 0 ? 3 / 2 : P, A = c.bigMinRatio, x = A === void 0 ? 9 / 16 : A, L = c.bigFirst, _ = L === void 0 ? !0 : L, U = c.containerWidth, V = U === void 0 ? 640 : U, oe = c.containerHeight, N = oe === void 0 ? 480 : oe, B = c.alignItems, j = B === void 0 ? "center" : B, ee = c.bigAlignItems, X = ee === void 0 ? "center" : ee, F = c.smallAlignItems, ve = F === void 0 ? "center" : F, z = c.maxWidth, Ue = z === void 0 ? 1 / 0 : z, fe = c.maxHeight, ue = fe === void 0 ? 1 / 0 : fe, me = c.smallMaxWidth, ze = me === void 0 ? 1 / 0 : me, Fe = c.smallMaxHeight, Ie = Fe === void 0 ? 1 / 0 : Fe, mt = c.bigMaxWidth, je = mt === void 0 ? 1 / 0 : mt, Gt = c.bigMaxHeight, Kt = Gt === void 0 ? 1 / 0 : Gt, Er = c.scaleLastRow, Yi = Er === void 0 ? !0 : Er, Rr = c.bigScaleLastRow, rc = Rr === void 0 ? !0 : Rr, wr = c.evenRows, nt = wr === void 0 ? !0 : wr, sc = N / V, gt = 0, vt = 0, _r = 0, Ir = 0, Or = [], _e = d.filter(function(rt, Qe) {
                return rt.big ? (Or.push(Qe), !0) : !1;
              }), Ht = d.filter(function(rt) {
                return !rt.big;
              }), xr = [], Mr = [], se = {};
              if (_e.length > 0 && Ht.length > 0) {
                var be = void 0, ye = void 0, zt = _ === !0;
                if (sc > o(_e[0])) {
                  if (be = V, ye = Math.floor(N * g), w > 0) {
                    var Je = void 0;
                    if (!y)
                      Je = s(x, D, be, ye, _e.length, je, Kt, nt);
                    else {
                      var Jt = _e[0].height / _e[0].width;
                      Je = s(Jt, Jt, be, ye, _e.length, je, Kt, nt);
                    }
                    ye = Math.max(N * w, Math.min(ye, Je.targetHeight * Je.targetRows));
                    var ac = a({
                      containerWidth: V,
                      containerHeight: N - ye,
                      offsetLeft: 0,
                      offsetTop: 0,
                      fixedRatio: f,
                      minRatio: p,
                      maxRatio: l,
                      alignItems: ve,
                      maxWidth: ze,
                      maxHeight: Ie,
                      scaleLastRow: Yi,
                      evenRows: nt
                    }, Ht), Dr = 0, Ar = void 0;
                    ac.forEach(function(rt) {
                      Ar !== rt.top && (Ar = rt.top, Dr += rt.height);
                    }), ye = Math.max(ye, N - Dr);
                  }
                  vt = ye, _r = N - vt, _ === "column" ? zt = !1 : _ === "row" && (zt = !0);
                } else {
                  if (ye = N, be = Math.floor(V * g), w > 0) {
                    var Je = void 0;
                    if (!y)
                      Je = s(x, D, be, ye, _e.length, je, Kt, nt);
                    else {
                      var Jt = _e[0].height / _e[0].width;
                      Je = s(Jt, Jt, be, ye, _e.length, je, Kt, nt);
                    }
                    be = Math.max(V * w, Math.min(be, Je.targetWidth * Je.targetCols));
                    var oc = a({
                      containerWidth: V - be,
                      containerHeight: N,
                      offsetLeft: 0,
                      offsetTop: 0,
                      fixedRatio: f,
                      minRatio: p,
                      maxRatio: l,
                      alignItems: ve,
                      maxWidth: ze,
                      maxHeight: Ie,
                      scaleLastRow: Yi,
                      evenRows: nt
                    }, Ht), Xi = 0, $i = 0, Lr = 0;
                    oc.forEach(function(Qe) {
                      Qe.top !== Lr && ($i = 0, Lr = Qe.top), $i += Qe.width, Xi = Math.max(Xi, $i);
                    }), be = Math.max(be, V - Xi);
                  }
                  gt = be, Ir = V - gt, _ === "column" ? zt = !0 : _ === "row" && (zt = !1);
                }
                zt ? (se.big = {
                  top: 0,
                  left: 0,
                  width: be,
                  height: ye
                }, se.small = {
                  top: vt,
                  left: gt,
                  width: V - gt,
                  height: N - vt
                }) : (se.big = {
                  left: Ir,
                  top: _r,
                  width: be,
                  height: ye
                }, se.small = {
                  top: 0,
                  left: 0,
                  width: V - gt,
                  height: N - vt
                });
              } else _e.length > 0 && Ht.length === 0 ? se.big = {
                top: 0,
                left: 0,
                width: V,
                height: N
              } : se.small = {
                top: vt,
                left: gt,
                width: V - gt,
                height: N - vt
              };
              se.big && (xr = a({
                containerWidth: se.big.width,
                containerHeight: se.big.height,
                offsetLeft: se.big.left,
                offsetTop: se.big.top,
                fixedRatio: y,
                minRatio: x,
                maxRatio: D,
                alignItems: X,
                maxWidth: je,
                maxHeight: Kt,
                scaleLastRow: rc,
                evenRows: nt
              }, _e)), se.small && (Mr = a({
                containerWidth: se.small.width,
                containerHeight: se.small.height,
                offsetLeft: se.small.left,
                offsetTop: se.small.top,
                fixedRatio: f,
                minRatio: p,
                maxRatio: l,
                alignItems: se.big ? ve : j,
                maxWidth: se.big ? ze : Ue,
                maxHeight: se.big ? Ie : ue,
                scaleLastRow: Yi,
                evenRows: nt
              }, Ht));
              var Zi = [], Nr = 0, Ur = 0;
              return d.forEach(function(rt, Qe) {
                Or.indexOf(Qe) > -1 ? (Zi[Qe] = xr[Nr], Nr += 1) : (Zi[Qe] = Mr[Ur], Ur += 1);
              }), { boxes: Zi, areas: se };
            };
          },
          /* 1 */
          /***/
          function(t, n, r) {
            /*!
             *  opentok-layout-js (http://github.com/aullman/opentok-layout-js)
             *
             *  Automatic layout of video elements (publisher and subscriber) minimising
             *  white-space for the OpenTok on WebRTC API.
             *
             *  @Author: Adam Ullman (http://github.com/aullman)
             *  @Copyright (c) 2014 Adam Ullman
             *  @License: Released under the MIT license (http://opensource.org/licenses/MIT)
             * */
            var s = this && this.__spreadArray || function(c, d, u) {
              if (u || arguments.length === 2) for (var l = 0, h = d.length, p; l < h; l++)
                (p || !(l in d)) && (p || (p = Array.prototype.slice.call(d, 0, l)), p[l] = d[l]);
              return c.concat(p || Array.prototype.slice.call(d));
            };
            n.__esModule = !0;
            var a = r(0), o = r(2);
            t.exports = function(d, u) {
              var l = this, h = u, p = h && h.window || (typeof window == "undefined" ? void 0 : window);
              d = typeof d == "string" ? p.document.querySelector(d) : d, !(typeof (p && p.HTMLElement) == "undefined" || d instanceof p.HTMLElement) && !h ? h = d : h || (h = {});
              var v = function(f) {
                h = f;
              };
              return {
                layout: function() {
                  return o.default.apply(l, [d, h]);
                },
                getLayout: function() {
                  for (var f = [], T = 0; T < arguments.length; T++)
                    f[T] = arguments[T];
                  return a.default.apply(l, s([h], f, !0));
                },
                setOptions: v
              };
            };
          },
          /* 2 */
          /***/
          function(t, n, r) {
            var s = this && this.__assign || function() {
              return s = Object.assign || function(o) {
                for (var c, d = 1, u = arguments.length; d < u; d++) {
                  c = arguments[d];
                  for (var l in c) Object.prototype.hasOwnProperty.call(c, l) && (o[l] = c[l]);
                }
                return o;
              }, s.apply(this, arguments);
            };
            n.__esModule = !0;
            var a = r(0);
            n.default = function(o, c) {
              function d(N, B, j) {
                if (typeof B == "string" && j)
                  return N.style[B] = j, NaN;
                if (typeof B == "object")
                  return Object.keys(B).forEach(function(F) {
                    d(N, F, B[F]);
                  }), NaN;
                var ee = (c && c.window || window).getComputedStyle(N), X = ee.getPropertyValue(B);
                return X === "" && (X = N.style[B]), X;
              }
              var u = function(N) {
                return d(N, "display") !== "none";
              };
              function l(N) {
                return N.offsetHeight > 0 ? "".concat(N.offsetHeight, "px") : d(N, "height");
              }
              function h(N) {
                return N.offsetWidth > 0 ? "".concat(N.offsetWidth, "px") : d(N, "width");
              }
              var p = function(B, j, ee, X, F, ve, z) {
                var Ue = this, fe = {
                  left: "".concat(j, "px"),
                  top: "".concat(ee, "px"),
                  width: "".concat(X, "px"),
                  height: "".concat(F, "px")
                }, ue = function() {
                  var Fe = B.querySelector(".OT_root");
                  if (Fe) {
                    var Ie = Fe.style.width;
                    Fe.style.width = "".concat(X, "px"), Fe.style.width = Ie || "";
                  }
                };
                if (ve && typeof $ != "undefined") {
                  $(B).stop();
                  var me = typeof ve == "boolean" ? { duration: 200, easing: "swing" } : ve;
                  $(B).animate(fe, me.duration, me.easing, function() {
                    ue(), me.complete && me.complete.call(Ue), z && z(B, {
                      left: j,
                      top: ee,
                      width: X,
                      height: F
                    });
                  });
                } else
                  d(B, fe), B.classList.contains("ot-layout") || B.classList.add("ot-layout"), z && z(B, {
                    left: j,
                    top: ee,
                    width: X,
                    height: F
                  });
                ue();
              }, v = function(B) {
                if (B) {
                  if (B.videoHeight && B.videoWidth)
                    return {
                      height: B.videoHeight,
                      width: B.videoWidth
                    };
                  var j = B.querySelector("video");
                  if (j && j.videoHeight && j.videoWidth)
                    return {
                      height: j.videoHeight,
                      width: j.videoWidth
                    };
                }
                return {
                  height: 480,
                  width: 640
                };
              }, f = function(B, j) {
                var ee = d(B, j);
                return ee ? parseInt(ee, 10) : 0;
              }, T = function() {
                return (Math.random() * 1e8).toFixed(0);
              }, g = function(B) {
                var j = l(B);
                return j ? parseInt(j, 10) : 0;
              }, O = function(B) {
                var j = h(B);
                return j ? parseInt(j, 10) : 0;
              }, w = c.animate, b = w === void 0 ? !1 : w, y = c.bigClass, P = y === void 0 ? "OT_big" : y, D = c.ignoreClass, A = D === void 0 ? "OT_ignore" : D, x = c.fixedRatioClass, L = x === void 0 ? "OT_fixedRatio" : x;
              if (d(o, "display") !== "none") {
                var _ = o.getAttribute("id");
                _ || (_ = "OT_".concat(T()), o.setAttribute("id", _)), c.containerHeight = g(o) - f(o, "border-top") - f(o, "border-bottom"), c.containerWidth = O(o) - f(o, "border-left") - f(o, "border-right");
                var U = Array.prototype.filter.call(o.querySelectorAll("#".concat(_, ">*:not(.").concat(A, ")")), u), V = U.map(function(N) {
                  return s(s({}, v(N)), { big: N.classList.contains(P), fixedRatio: N.classList.contains(L) });
                }), oe = (0, a.default)(c, V);
                oe.boxes.forEach(function(N, B) {
                  var j = U[B];
                  d(j, "position", "absolute");
                  var ee = N.width - f(j, "margin-left") - f(j, "margin-right") - (d(j, "box-sizing") !== "border-box" ? f(j, "padding-left") + f(j, "padding-right") + f(j, "border-left") + f(j, "border-right") : 0), X = N.height - f(j, "margin-top") - f(j, "margin-bottom") - (d(j, "box-sizing") !== "border-box" ? f(j, "padding-top") + f(j, "padding-bottom") + f(j, "border-top") + f(j, "border-bottom") : 0);
                  p(j, N.left, N.top, ee, X, b, c.onLayout);
                });
              }
            };
          }
          /******/
        ])
      );
    });
  }(xi)), xi.exports;
}
export {
  Fn as A,
  ct as C,
  Le as D,
  Ui as L,
  C as P,
  S as R,
  fr as S,
  E as T,
  ci as V,
  di as a,
  Xh as b,
  $h as c,
  Yh as d,
  ef as e,
  Xl as g,
  Zh as o,
  nf as r,
  tf as t
};
